(function () {
  'use strict';

  angular
    .module('app.core',
      [
        'ngAnimate',
        'ngAria',
        'ngCookies',
        'ngMessages',
        'ngResource',
        'ngSanitize',
        'ngMaterial',
        'pascalprecht.translate',
        'ui.router',
        'app.orHashen',
        'vcRecaptcha',
        'nvd3',
        'ngFileUpload',
        'imageViewer',
        'gridshore.c3js.chart'

      ]);
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('CopyInsuraceDialogController', CopyInsuraceDialogController);

  /** @ngInject */
  function CopyInsuraceDialogController($mdDialog, Copy, ListCopys, TAX, msUtils, $filter) {
    var vm = this;

    vm.title = 'EDIT_CONTACT';


    vm.newContact = false;
    vm.allFields = false;
    vm.copy = Copy;
    vm.ListCopys = ListCopys;
    vm.default_avatar = 'assets/images/avatars/profile.jpg';


    // Methods


    //////////


    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    function submit() {
      vm.copy.active = true;

      var item = $filter('filter')(ListCopys, {PhotoListID: vm.copy.CopyID}, true)[0];

      vm.copy.Name = item.Name;
      $mdDialog.hide(vm.copy);
    }

    function sumupdate(afterTax) {
      if (afterTax) {
        if (!vm.copy.sumInclude) {
          vm.copy.sum = 0;
          return;
        }
      //  var TAX = msUtils.TAX;

        vm.copy.sum= ((vm.copy.sumInclude  * 100)/(100+TAX)).toFixed(2);
      } else {
        if (!vm.copy.sum) {
          vm.copy.sumInclude = 0;
          return;
        }
       // var TAX = msUtils.TAX / 100 + 1;
        vm.copy.sumInclude = (parseFloat(vm.copy.sum) * (1 + (TAX * 0.01))).toFixed(2);//(vm.copy.sum * TAX).toFixed(2);
      }
    }

    vm.closeDialog = closeDialog;
    vm.submit = submit;
    vm.sumupdate = sumupdate;

  }
})();

(function () {
  'use strict';

  /**
   * Main module of the Fuse
   */
  angular
    .module('fuse', [

      // Core
      'app.core',

      // Navigation
      'app.navigation',

      // Toolbar
      'app.toolbar',

      // Quick panel
      'app.quick-panel',

      // Sample
      'app.sample',
      'app.contacts',
      'app.profile',
      'app.admin',
      'app.support',
      'app.pages',
      //'app.invoice',
      // 'app.notes',
      'app.insurance',
      'app.reports',
      'app.doctors',
      'app.doctors_group',
      'app.employess',
      'app.all_reports',
      'app.compare_reports',
      'app.claims',
      'app.bookkeeping',
      'app.advanced_settings',
      'app.inventories',
      'app.users'
      //'app.calendar'
    ]);
})();

/**
 * Created by itzik on 23/11/2017.
 */

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('UploadController', UploadController);

  /** @ngInject */
  function UploadController($mdDialog, orContacts, Profile, Upload, $timeout, $filter) {
    var vm = this;
    vm.profile = Profile;
    vm.photoID = 0;

    vm.upload = function (file) {
      vm.uploadProccess = 'טוען';
      var filename = '';
      if (vm.photoID > 0) {
        filename = $filter('filter')(vm.profile.PhotosArr, {PhotoID: vm.photoID}, true)[0];
        if (filename)
          filename = filename.Name;
      } else if (vm.photoID == -1) {
        filename = 'הפניה'
      }
      else if (vm.photoID == -2) {
        filename = 'אחר'
      }
      Upload.upload({
        url: 'http://pano-api.azurewebsites.net/documents/upload/' + Profile.ClientID + '?photo_id=' + vm.photoID + '&filename=' + filename,
        // url: 'http://localhost:4900/documents/upload/' + Profile.ClientID + '?photo_id=' + vm.photoID + '&filename=' + filename,
        data: {
          file: file,
          'username': '$scope.username',
          filename: filename
        }
      }).then(function (resp) {
        console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
        vm.uploadProccess = 'טעינת קובץ הושלמה. אנא המתן...';
        clearProccessUpload();
        /*$timeout(function () {
         vm.uploadProccess = 'מעדכן נתונים...';
         clearProccessUpload();
         }, 1200)*/
        $timeout(function () {

          vm.uploadProccess = 'מעדכן נתונים...';
          reloadDocuments(vm.profile.Documents.length);
        }, 5000)

      }, function (resp) {
        console.log('Error status: ' + resp.status);
        vm.uploadProccess = 'ארעה שגיאה בטעינת קובץ';
        clearProccessUpload();
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
        vm.uploadProccess = 'מעלה ' + progressPercentage + '% ';
      });
    };

    var clearProccessUpload = function () {
      $timeout(function () {
        vm.uploadProccess = undefined;
      }, 3000)
    }
    var reloadDocuments = function (lastLength) {
      console.log('reloadDocuments');
      console.log(lastLength);
      orContacts.LoadDocuments(Profile).then(function (r) {
        /* if (lastLength == vm.profile.Documents.length) {
         $timeout(function () {
         vm.uploadProccess = 'מעדכן נתונים...';
         reloadDocuments(vm.profile.Documents.length)
         });
         } else {*/
        vm.uploadProccess = 'הושלם!';
        clearProccessUpload()
        $timeout(function () {
          $mdDialog.hide(true);
        }, 3000)
        //}

      });

    }

    vm.close = function () {
      $mdDialog.hide(vm.date)
    }
    vm.print = function () {
      window.print();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.profile', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.profile', {
      url: '/profile/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/profile/profile.html',
          controller: 'ProfileController as vm'
        }
      },
      resolve: {
        Profile: function ($stateParams, orPlacesService) {
         return orPlacesService.Client($stateParams.id);
        }
      },
      bodyClass: 'profile'
    }).state('app.profile.allowedit', {
      url: '/:allowedit'
    })
    ;


    // Translation
   /* $translatePartialLoaderProvider.addPart('app/main/profile');

    // Api
    msApiProvider.register('profile.timeline', ['app/data/profile/timeline.json']);
    msApiProvider.register('profile.about', ['app/data/profile/about.json']);
    msApiProvider.register('profile.photosVideos', ['app/data/profile/photos-videos.json']);
*/
    // Navigation
    msNavigationServiceProvider.saveItem('fuse.profile', {
      title: 'כרטיס לקוח',
      icon: 'icon-account-box',
      state: 'app.profile',
      weight: 6,
      rule: 1

    });
  }

})();

(function () {
  'use strict';

  angular
    .module('app.profile')
    .controller('TransferDialogController', TransferDialogController);

  /** @ngInject */
  function TransferDialogController($mdDialog, max, transferData) {
    var vm = this;


    /**
     * Close dialog
     */
    vm.closeDialog = closeDialog;
    vm.cancel = cancel;
    vm.transfer = transferData;
    vm.addCheck = function () {
      if (vm.checksArr.length < 4) {
        var Ac = vm.checksArr[vm.checksArr.length - 1];
        var d = new Date(Ac.date);
        d.setMonth(parseInt(d.getMonth()) + 1)
        var newCheck = {
          date: d,
          bank: Ac.bank,
          branch: Ac.branch,
          account: Ac.account,
          number: parseInt(Ac.number) + 1,
          amount: Ac.amount
        }
        vm.checksArr.push(newCheck);
      }

    }
    vm.removeCheck = function (check, index) {
      vm.checksArr.splice(index, 1);
      var sum = 0;
      vm.checksArr.forEach(function (element) {
        if (element.amount)
          sum += parseFloat(element.amount);
      });

    }
    function closeDialog() {

      if (parseFloat(transferData.amount) > max)
        alert('סכום מקסימלי לתשלום: ' + max);
      else {
        $mdDialog.hide(transferData);
      }
    }

    function cancel() {
      $mdDialog.hide();
      //$state.go('app.contacts')

    }


  }
})();

/**
 * Created by itzik on 23/11/2017.
 */

(function () {
  'use strict';

  angular
    .module('app.profile')
    .controller('SippingDetailsController', SippingDetailsController)
    .controller('MultySippingDetailsController', MultySippingDetailsController);

  /** @ngInject */
  function SippingDetailsController($mdDialog, client, Place, Doctor) {
    var vm = this;
    vm.client = client;
    vm.place = Place;
    if (typeof Doctor === "function")
      Doctor().then(function (result) {
        vm.doctor = result
      });
    else
      vm.doctor = Doctor
    console.log('Doctor')
    console.log(Doctor)
    vm.dateNow = new Date();
    vm.close = function () {
      $mdDialog.hide(vm.date)
    }
    vm.print = function () {
      window.print();
    }

  }

  /** @ngInject */
  function MultySippingDetailsController($mdDialog, client, Place, Doctor) {
    var vm = this;
    vm.client = client;
    vm.place = Place;
    Doctor().then(function (result) {
      vm.doctor = result
    });
    console.log('Doctor')
    console.log(Doctor)
    vm.dateNow = new Date();
    vm.close = function () {
      $mdDialog.hide(vm.date)
    }
    vm.print = function () {
      window.print();
    }

  }
})();

/**
 * Created by itzik on 12/12/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.profile')
    .controller('EditCopiesController', EditCopiesController);

  /** @ngInject */
  function EditCopiesController(Doctor, Copies, $mdDialog) {
    var vm = this;
    vm.copies = Copies;
    var OldCopies = [];
    vm.countCopies = {count: 0, sum: 0}
    angular.copy(Copies, OldCopies);
    // if (typeof Doctor === "function")
    //   Doctor().then(function (result) {
    //     vm.doctor = result
    //   });
    // else
    vm.doctor = Doctor;

    var updateDoctorPrices = function () {

      $mdDialog.hide({copies: vm.copies, doctor: vm.doctor,countCopies:vm.countCopies});
    }
    var close = function () {

      vm.copies.splice(0, vm.copies.length);
      for (var ind in OldCopies) {
        vm.copies.push(OldCopies[ind]);
      }

      $mdDialog.hide();
    }
    vm.updateDoctorPrices = updateDoctorPrices;
    vm.close = close;

  }
})();

/**
 * Created by itzik on 14/01/2018.
 */


(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('ShowDocumentController', ShowDocumentController);

  /** @ngInject */
  function ShowDocumentController($mdDialog, $sce,orContacts, Doc) {
    var vm = this;
    vm.doc = Doc;

    vm.close = function () {
      $mdDialog.hide()
    }
    // orContacts.DownloadDocument(Doc.docName).then(function (result) {
    //
    //   vm.filesrc=result;
    // })
   vm.filesrc = $sce.trustAsResourceUrl(orContacts.LinkUrlDownloadDocument(Doc.docName));

    vm.print = function () {
      window.print();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.profile')
    .controller('CreditDialogController', CreditDialogController);

  /** @ngInject */
  function CreditDialogController($mdDialog, $rootScope, $timeout, max, lastcach, Client, IsRefund, orContacts) {
    var vm = this;
    vm.cardauto = '';

    focusAutoCard();
    /**
     * Close dialog
     */
    vm.closeDialog = closeDialog;
    vm.cancel = cancel;
    vm.updateAmount = updateAmount;
    vm.manualPay = manualPay;
    vm.IsRefund = IsRefund;
    vm.sumByCredit = lastcach || max;


    vm.cardLeft = cardLeft;
    vm.strstatus = 'העבר כרטיס אשראי';
    vm.paymentsNumber = 1;
    vm.statusOK = false;
    var today = new Date();
    vm.year = today.getFullYear();
    vm.card = {expired: {month: 1, year: vm.year}}
//TEMP:
//     vm.card.number = 455744041004812;
//     vm.card.expired.month = 5;
//     vm.card.expired.year = 2019;
    function updateAmount(ev) {
      vm.sumByCredit = parseInt(vm.sumByCredit);
      if (isNaN(vm.sumByCredit) || vm.sumByCredit > max) {
        $mdDialog.show(
          $mdDialog.alert()
            .clickOutsideToClose(true)
            .title('שגיאה')
            .textContent('מחיר לא תקין! - סכום מקסימלי ' + max)
            .ariaLabel('Alert Dialog Demo')
            .ok('סגור')
            .targetEvent(ev)
        );
      } else {


        vm.editamount = false;
        focusAutoCard();
      }
    }

    function cancel() {
      $mdDialog.hide();
      //$state.go('app.contacts')

    }

    function focusAutoCard() {
      setTimeout(function () {
        $("#cardAuto").focus();
      }, 1000);
    }

    var intervalCheck;

    function cardLeft() {
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(autoPay, 500);
    }

    var pelecardDetails;

    function autoPay() {
      if (IsRefund){
        vm.sumByCredit *= -1;
        if(vm.sumByCredit>0)
        {
          alert("err");
          return;
        }
      }
      console.log(vm.cardauto)
      console.log('------')
      vm.strstatus = 'בודק'
      if (vm.cardauto && vm.cardauto.length > 4) {
        orContacts.pelecardPay(Client, {
          auto: true,
          value: vm.cardauto,
          amount: vm.sumByCredit,
          paymentsNumber: vm.paymentsNumber
        }).then(function (result) {
          vm.strstatus = result.pelecard.ErrorMessage + ' (' + result.pelecard.StatusCode + ')';
          pelecardDetails = result.pelecard;
          vm.cardauto = '';

          if (result.status) {
            vm.statusOK = result.pelecard.StatusCode == '000';//true;
            if (vm.statusOK) {
              vm.strstatus = 'אושר! אנא המתן...';
              $timeout(closeDialog, 1000);
            }
            // $mdDialog.hide(result.pelecard);
          }
        })
      }
      else {
        vm.strstatus = 'לא תקין - העבר שנית';
        vm.cardauto = '';
        $rootScope.$$phase || $rootScope.$apply();
      }
    }

    function manualPay() {
      if (IsRefund){
        vm.sumByCredit *= -1;
        if(vm.sumByCredit>0)
        {
          alert("err");
          return;
        }
      }
      vm.proccessManual = true;
      orContacts.pelecardPay(Client, {
        auto: false,
        value: vm.card,
        amount: vm.sumByCredit,
        paymentsNumber: vm.paymentsNumber
      }).then(function (result) {
        vm.proccessManual = false;
        vm.strstatus = result.pelecard.ErrorMessage + ' (' + result.pelecard.StatusCode + ')';
        pelecardDetails = result.pelecard;
        vm.cardauto = '';

        if (result.status) {
          vm.statusOK = result.pelecard.StatusCode == '000';//true;
          if (vm.statusOK) {
            vm.strstatus = 'אושר! אנא המתן...';
            $timeout(closeDialog, 1000);
          }
          // $mdDialog.hide(result.pelecard);
        }
      })
    }

    function closeDialog() {
      if (pelecardDetails)
        $mdDialog.hide(pelecardDetails);

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.profile')
    .controller('ChecksDialogController', ChecksDialogController);

  /** @ngInject */
  function ChecksDialogController($mdDialog, max, checksArr) {
    var vm = this;


    /**
     * Close dialog
     */
    vm.closeDialog = closeDialog;
    vm.cancel = cancel;
    vm.checksArr = checksArr;
    vm.addCheck = function () {
      if (vm.checksArr.length < 4) {
        var Ac = vm.checksArr[vm.checksArr.length - 1];
        var d = new Date(Ac.date);
        d.setMonth(parseInt(d.getMonth()) + 1)
        var newCheck = {
          date: d,
          bank: Ac.bank,
          branch: Ac.branch,
          account: Ac.account,
          number: parseInt(Ac.number) + 1,
          amount: Ac.amount
        }
        vm.checksArr.push(newCheck);
      }

    }
    vm.removeCheck = function (check, index) {
      vm.checksArr.splice(index, 1);
      var sum = 0;
      vm.checksArr.forEach(function (element) {
        if (element.amount)
          sum += parseFloat(element.amount);
      });

    }
    function closeDialog() {
      var sum = 0;
      vm.checksArr.forEach(function (element) {
        if (element.amount)
          sum += parseFloat(element.amount);
      });

      if (!vm.checksArr.length)
        alert('לא הוזנו שיקים')
      else if (parseFloat(sum) <= 0)
        alert('לא הזון סכום');
      else if (parseFloat(sum) > max)
        alert('סכום לתשלום: ' + max);
      else {
        $mdDialog.hide(vm.checksArr);
      }
    }

    function cancel() {
      $mdDialog.hide();
      //$state.go('app.contacts')

    }


  }
})();

/**
 * Created by itzik on 23/11/2017.
 */

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('ClientDetailsController', ClientDetailsController);

  /** @ngInject */
  function ClientDetailsController($mdDialog, client, Place) {
    var vm = this;
    vm.client = client;
    vm.place = Place;
    // Doctor().then(function (result) {
    //   vm.doctor=result
    // });

    vm.dateNow = new Date();
    if (client.ClientBirthDate && typeof client.ClientBirthDate === 'string')
      client.ClientBirthDate = new Date(client.ClientBirthDate);
    vm.close = function () {
      $mdDialog.hide(vm.date)
    }
    vm.print = function () {
      window.print();
    }

  }
})();

/**
 * Created by itzik on 23/11/2017.
 */

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('AcceptVisitController', AcceptVisitController);

  /** @ngInject */
  function AcceptVisitController($mdDialog, client, Place) {
    var vm = this;
    vm.client = client;
    vm.place = Place;
    vm.dateNow = new Date();
    vm.close = function () {
      $mdDialog.hide(vm.date)
    }
    vm.print=function () {
      window.print();
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-500', {
            url      : '/pages/errors/error-500',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-500': {
                    templateUrl: 'app/main/pages/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: 'error-500'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/500');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors.error-500', {
            title : '500',
            state : 'app.pages_errors_error-500',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-404', {
            url      : '/pages/errors/error-404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-404': {
                    templateUrl: 'app/main/pages/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/404');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors', {
            title : 'Errors',
            icon  : 'icon-alert',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('pages.errors.error-404', {
            title : '404',
            state : 'app.pages_errors_error-404',
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function () {
  'use strict';

  angular
    .module('app.pages.auth.login-v2', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {
    // State
    $stateProvider.state('app.pages_auth_login-v2', {
      url: '/pages/auth/login-v2',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.pages_auth_login-v2': {
          templateUrl: 'app/main/pages/auth/login-v2/login-v2.html',
          controller: 'LoginV2Controller as vm'
        }
      },
      bodyClass: 'login-v2'
    }).state('app.pages_auth_login-v2.logout', {
      url: '/:logout'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/pages/auth/login-v2');
    // Navigation
    // msNavigationServiceProvider.saveItem('pages.auth.login-v2', {
    //     title : 'Login v2',
    //     state : 'app.pages_auth_login-v2',
    //     weight: 2
    // });
  }

})();

(function () {
  'use strict';

  angular
    .module('app.pages.auth.login-v2')
    .controller('LoginV2Controller', LoginV2Controller);

  /** @ngInject */
  function LoginV2Controller($state, $rootScope, $timeout, $location, orUserAccount, orContacts) {
    // Data
    var vm = this;
    vm.proccess=false;
    vm.form = {};
    // Methods
    if ($state.params.logout) {
      // alert('Log out');
      orUserAccount.LogOut();
      orContacts.clearContacts();
    }

    vm.login = function () {
      console.log(vm.form);
      vm.proccess=true;
      vm.error = '';
      // $state.go('app.contacts', {});
      orUserAccount.Login(vm.form).then(function (result) {
        console.log(result);
        // window.href = 'contacts';
        $state.go('app.report_places', {}, {reload: true});
        // $state.go('app.notes', {}, { reload: true });

        // $location.url('contacts');
        // $rootScope.$$phase || $rootScope.$apply();
        $timeout(function () {
          // $state.reload();
          //  console.log('reload')
          //  $state.go('app.contacts', {}, { reload: true });
        }, 1500)


      }, function (err) {
        vm.proccess=false;
        vm.error = err.err.code == 401 ? 'הזיהוי נכשל' : err.err;
        setTimeout(function () {
          grecaptcha.reset();
        }, 1)
      });

    }
    //////////
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url      : '/pages/auth/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/pages/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth', {
            title : 'Authentication',
            icon  : 'icon-lock',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('pages.auth.login', {
            title : 'Login',
            state : 'app.pages_auth_login',
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_lock', {
            url      : '/pages/auth/lock',
            views    : {
                'main@'                      : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_lock': {
                    templateUrl: 'app/main/pages/auth/lock/lock.html',
                    controller : 'LockController as vm'
                }
            },
            bodyClass: 'lock'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/lock');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.lock', {
            title : 'Lock Screen',
            state : 'app.pages_auth_lock',
            weight: 7
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock')
        .controller('LockController', LockController);

    /** @ngInject */
    function LockController()
    {
        var vm = this;

        // Data
        vm.form = {
            username: 'Jane Doe'
        };

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.notes', {
            url    : '/notes',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/notes/notes.html',
                    controller : 'NotesController as vm'
                }
            },
            resolve: {
                Notes : function (NotesService)
                {
                    return NotesService.getData();
                },
                Labels: function (LabelsService)
                {
                    return LabelsService.getData();
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/notes');

        // Api
        msApiProvider.register('notes.notes', ['app/data/notes/notes.json']);
        msApiProvider.register('notes.labels', ['app/data/notes/labels.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('fuse.notes', {
            title : 'לוח הערות',
            icon  : 'icon-lightbulb',
            state : 'app.notes',
            weight: 11
        });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNoteItemController', msNoteItemController)
        .directive('msNoteItem', msNoteItemDirective);

    /** @ngInject */
    function msNoteItemController($document)
    {
        var vm = this;
        var fontSizes = {
            '1': {
                fontSize  : 14,
                lineHeight: 19
            },
            '2': {
                fontSize  : 18,
                lineHeight: 28
            },
            '3': {
                fontSize  : 24,
                lineHeight: 36
            },
            '4': {
                fontSize  : 36,
                lineHeight: 48
            },
            '5': {
                fontSize  : 48,
                lineHeight: 60
            }
        };

        vm.element = [];
        vm.noFontResize = false;

        // Methods
        vm.updateDescriptionFontSize = updateDescriptionFontSize;

        //////

        function updateDescriptionFontSize()
        {
            if ( vm.noFontResize || !vm.note.description || vm.note.description === '' )
            {
                return;
            }

            var fontSize = '';
            var descWidth = Math.floor(vm.columnWidth - 52); // 48px paddings, + 4px tolerance
            var tmp = angular.element('<div style="visibility:hidden; font-size:10px;line-height: 10px;position:absolute;z-index:-1;white-space:pre-wrap;word-wrap: break-word;"></div>');
            tmp.appendTo($document.find('body'));

            fontSize = checkLineCount(sizeFromMaxWordCount());

            angular.element(vm.element).find('md-description').attr('font-size', fontSize);

            tmp.remove();

            function sizeFromMaxWordCount()
            {
                var words = vm.note.description.split(' ');

                var wordLengths = words.map(function (word)
                {
                    return tmp.text(word)[0].clientWidth;
                });

                var maxWordLength = Math.max.apply(Math, wordLengths);

                var maxPx = Math.floor((descWidth * 10) / maxWordLength);

                if ( maxPx < 18 )
                {
                    fontSize = 1;
                }
                else if ( 18 <= maxPx && maxPx < 24 )
                {
                    fontSize = 2;
                }
                else if ( 24 <= maxPx && maxPx < 36 )
                {
                    fontSize = 3;
                }
                else if ( 36 <= maxPx && maxPx < 48 )
                {
                    fontSize = 4;

                }
                else if ( maxPx >= 48 )
                {
                    fontSize = 5;
                }
                return fontSize;
            }

            function checkLineCount(sizeFromMaxWord)
            {
                var size = fontSizes[sizeFromMaxWord];
                var result;

                tmp.text(vm.note.description);
                tmp.width(descWidth);
                tmp.css({
                    'line-height': size.lineHeight + 'px',
                    'font-size'  : size.fontSize + 'px'
                });

                var lineCount = tmp[0].clientHeight / size.lineHeight;

                if ( 4 < lineCount && lineCount < 6 )
                {
                    result = 4;
                }
                else if ( 6 <= lineCount && lineCount < 9 )
                {
                    result = 3;
                }
                else if ( 9 <= lineCount && lineCount < 11 )
                {
                    result = 2;
                }
                else if ( 11 <= lineCount )
                {
                    result = 1;
                }
                else
                {
                    result = sizeFromMaxWord;
                }
                return result;
            }
        }
    }

    /** @ngInject */
    function msNoteItemDirective()
    {
        return {
            restrict        : 'A',
            controller      : 'msNoteItemController as MsNoteItem',
            templateUrl     : 'app/main/notes/directives/ms-note-item/ms-note-item.html',
            require         : ['msNoteItem', '^msMasonry'],
            bindToController: {
                msNoteItem: '='
            },
            link            : function (scope, element, attributes, controllers)
            {

                var MsNoteItem = controllers[0];
                var msMasonry = controllers[1];

                MsNoteItem.element = element;
                MsNoteItem.note = MsNoteItem.msNoteItem;


                if ( angular.isDefined(attributes.noFontResize) )
                {
                    MsNoteItem.noFontResize = true;
                }

                scope.$watch('MsNoteItem.msNoteItem', function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        MsNoteItem.note = newVal;
                    }
                });

                scope.$on('msMasonryItem:startReLayout', function ()
                {
                    if ( MsNoteItem.noFontResize || MsNoteItem.columnWidth === msMasonry.columnWidth )
                    {
                        return;
                    }

                    MsNoteItem.columnWidth = msMasonry.columnWidth;

                    MsNoteItem.updateDescriptionFontSize();
                });
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNoteFormController', msNoteFormController)
        .directive('msNoteForm', msNoteFormDirective);

    /** @ngInject */
    function msNoteFormController($scope, NotesService, msUtils, $mdDialog, $timeout, LabelsService)
    {
        var MsNoteForm = this;
        var notes = NotesService.data;

        //Data
        MsNoteForm.type = '';
        MsNoteForm.defaultNote = {
            'id'         : '',
            'title'      : '',
            'description': '',
            'archive'    : false,
            'image'      : '',
            'color'      : '',
            'time'       : new Date().toISOString(),
            'reminder'   : null,
            'checklist'  : [],
            'labels'     : []
        };
        MsNoteForm.noteId = '';
        MsNoteForm.editNode = {};
        MsNoteForm.newCheckListItem = '';
        MsNoteForm.checkListForm = false;
        MsNoteForm.labels = LabelsService.data;

        MsNoteForm.ngFlowOptions = {
            singleFile: true
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        MsNoteForm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };

        //Methods
        MsNoteForm.init = init;
        MsNoteForm.submit = submit;
        MsNoteForm.isNotValid = isNotValid;
        MsNoteForm.deleteNote = deleteNote;
        MsNoteForm.deleteImage = deleteImage;
        MsNoteForm.addChecklistItem = addChecklistItem;
        MsNoteForm.checklistFormToggle = checklistFormToggle;
        MsNoteForm.deleteCheckItem = deleteCheckItem;
        MsNoteForm.toggleArchive = toggleArchive;
        MsNoteForm.toggleInArray = msUtils.toggleInArray;
        MsNoteForm.exists = msUtils.exists;
        MsNoteForm.upload = upload;
        MsNoteForm.imageSuccess = imageSuccess;

        //////

        /**
         * Initialize
         */
        function init()
        {
            // If form type edit
            if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.editNode = notes.getById(MsNoteForm.noteId);
                MsNoteForm.note = angular.copy(MsNoteForm.editNode);
            }
            // If form type new
            else
            {
                resetForm();
            }
        }

        /**
         * Watch New Note Form, reset form if it is closed
         */
        $scope.$on('MsNewNote:closed', function ()
        {
            resetForm();
        });

        /**
         * Reset Form
         */
        function resetForm()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);
                MsNoteForm.checkListForm = false;
            });
        }

        /**
         * Submit Form
         */
        function submit()
        {
            if ( MsNoteForm.type === 'new' )
            {
                add();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                save();
            }
        }

        /**
         * Add new note
         */
        function add()
        {
            if ( isNotValid() )
            {
                return;
            }

            MsNoteForm.note.id = msUtils.guidGenerator();
            MsNoteForm.note.time = new Date().toISOString();

            NotesService.addNote(angular.copy(MsNoteForm.note));

            MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);

            $scope.$emit('MsNewNote:close');
        }

        /**
         * Save Note
         */
        function save()
        {
            if ( isNotValid() )
            {
                return;
            }
            NotesService.updateNote(MsNoteForm.note);
            $mdDialog.hide();
        }

        /**
         * Delete Note Image
         */
        function deleteImage()
        {
            MsNoteForm.note.image = '';
        }

        /**
         * Toggle Archive State
         */
        function toggleArchive()
        {
            if ( MsNoteForm.type === 'new' )
            {
                MsNoteForm.note.archive = true;
                submit();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.note.archive = !MsNoteForm.note.archive;
                save();
            }
        }

        /**
         * One of the image, title, description, checklist inputs are should be exist.
         * @returns {boolean}
         */
        function isNotValid()
        {
            return MsNoteForm.note.image === '' && MsNoteForm.note.title === '' && MsNoteForm.note.description === '' && MsNoteForm.note.checklist.length === 0;
        }

        /**
         * Delete Note
         * @param ev
         */
        function deleteNote(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the note?')
                .htmlContent('the note will be deleted permanently.')
                .ariaLabel('delete note')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                NotesService.deleteNote(MsNoteForm.note);
            });
        }

        /**
         * Add Checklist Item
         */
        function addChecklistItem()
        {
            if ( MsNoteForm.newCheckListItem === '' )
            {
                return;
            }

            MsNoteForm.note.checklist.push({
                checked: false,
                text   : MsNoteForm.newCheckListItem
            });

            MsNoteForm.newCheckListItem = '';

            focusChecklistInput();
        }

        /**
         * Checklist form toggle
         */
        function checklistFormToggle()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.checkListForm = !MsNoteForm.checkListForm;

                $timeout(function ()
                {
                    focusChecklistInput();
                });
            });
        }

        /**
         * Delete check item
         * @param item
         */
        function deleteCheckItem(item)
        {
            MsNoteForm.note.checklist.splice(MsNoteForm.note.checklist.indexOf(item), 1);
            focusChecklistInput();
        }

        /**
         * Focus checklist input
         */
        function focusChecklistInput()
        {
            angular.element('#new-checklist-item-input').focus();
        }

        /**
         * Upload
         */
        function upload()
        {
            // Set headers
            MsNoteForm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            MsNoteForm.ngFlow.flow.upload();
        }

        /**
         * Image Success
         * @param file
         * @param message
         */
        function imageSuccess(file, message)
        {
            var fileReader = new FileReader();

            fileReader.readAsDataURL(file.file);

            fileReader.onload = function (event)
            {
                file.url = event.target.result;

                $scope.$evalAsync(function ()
                {
                    MsNoteForm.note.image = file.url;
                });
            };

            file.type = 'image';
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }

    /** @ngInject */
    function msNoteFormDirective()
    {
        return {
            restrict    : 'EA',
            controller  : 'msNoteFormController',
            controllerAs: 'MsNoteForm',
            scope       : {
                noteType: '=',
                noteId  : '='
            },
            templateUrl : 'app/main/notes/directives/ms-note-form/ms-note-form.html',
            link        : function (scope, element, attributes, MsNoteForm)
            {
                // Type
                MsNoteForm.type = scope.noteType;

                // Note id
                if ( angular.isDefined(scope.noteId) )
                {
                    MsNoteForm.noteId = scope.noteId;
                }

                MsNoteForm.init();

            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNewNoteController', msNewNoteController)
        .directive('msNewNoteButton', msNewNoteButtonDirective)
        .directive('msNewNote', msNewNoteDirective);

    /** @ngInject */
    function msNewNoteController($scope, $document)
    {
        var MsNewNote = this;

        //Data
        MsNewNote.formVisible = false;
        MsNewNote.form = {
            title      : '',
            description: ''
        };

        //Methods
        MsNewNote.open = open;
        MsNewNote.close = close;
        MsNewNote.element = [];

        //////

        /**
         * Close Trigger
         */
        $scope.$on('MsNewNote:close', function ()
        {
            close();
        });

        /**
         * Open new note form
         */
        function open()
        {
            MsNewNote.element.addClass('form-visible');
            MsNewNote.element.find('textarea').focus();
            $document.on('click', outSideClick);
        }

        /**
         * Close new note form
         */
        function close()
        {
            MsNewNote.element.removeClass('form-visible');
            $scope.$broadcast('MsNewNote:closed');

            $document.off('click', outSideClick);
        }

        /**
         * Click Outside Event Handler
         * @param event
         */
        function outSideClick(event)
        {
            var isChild = MsNewNote.element.has(event.target).length > 0;
            var isSelf = MsNewNote.element[0] === event.target;
            var isMenu = angular.element(event.target).closest('md-menu-content').length > 0;
            var isCalendar = angular.element(event.target).closest('md-calendar').length > 0 || angular.element(event.target).closest('.md-datepicker-calendar-pane').length > 0 || angular.element(event.target).hasClass('md-scroll-mask');

            var isInside = isChild || isSelf || isMenu || isCalendar;

            if ( !isInside )
            {
                close();
            }
        }
    }

    /** @ngInject */
    function msNewNoteDirective()
    {
        return {
            restrict    : 'E',
            controller  : 'msNewNoteController',
            controllerAs: 'MsNewNote',
            templateUrl : 'app/main/notes/directives/ms-new-note/ms-new-note.html',
            link        : function (scope, element, attributes, MsNewNote)
            {
                MsNewNote.element = element;
            }
        };
    }

    /** @ngInject */
    function msNewNoteButtonDirective()
    {
        return {
            restrict: 'EA',
            require : '^msNewNote',
            link    : function (scope, element, attributes, msNewNote)
            {
                element.on('click', function ()
                {
                    msNewNote.open();
                });
            }
        };
    }
})();

/**
 * Created by itzik on 23/11/2017.
 */

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('UploadController', UploadController);

  /** @ngInject */
  function UploadController($mdDialog, orContacts, Profile, Upload, $timeout, $filter) {
    var vm = this;
    vm.profile = Profile;
    vm.photoID = 0;

    vm.upload = function (file) {
      vm.uploadProccess = 'טוען';
      var filename = 'import';
      console.log('file', file);
      if(!file.length){
        vm.uploadProccess = 'קובץ לא תקין';
        clearProccessUpload();
        return;
      }
      Upload.upload({
        url: 'https://or-admin-api.azurewebsites.net/documents/uploadexcel/?filename=' + filename,
        //url: 'http://localhost:4900/documents/uploadexcel/?filename=' + filename,
        data: {
          file: file,
          'username': '$scope.username',
          filename: filename
        }
      }).then(function (resp) {
        console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
        vm.uploadProccess = 'טעינת קובץ הושלמה. אנא המתן...';
        clearProccessUpload();
        /*$timeout(function () {
         vm.uploadProccess = 'מעדכן נתונים...';
         clearProccessUpload();
         }, 1200)*/
        $timeout(function () {

          vm.uploadProccess = 'מעדכן נתונים...';
          reloadDocuments();
        }, 5000)

      }, function (resp) {
        console.log('Error status: ' + resp.status);
        vm.uploadProccess = 'ארעה שגיאה בטעינת קובץ';
        clearProccessUpload();
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
        vm.uploadProccess = 'מעלה ' + progressPercentage + '% ';
      });
    };
    vm.validate = function (file) {
      vm.error_image = false;
      console.log(file);
      return file ? true : false;
      return false;

    }
    var clearProccessUpload = function () {
      $timeout(function () {
        vm.uploadProccess = undefined;
      }, 3000)
    }
    var reloadDocuments = function (lastLength) {
      console.log('reloadDocuments');
      //console.log(lastLength);

      vm.uploadProccess = 'הושלם!';
      clearProccessUpload()
      $timeout(function () {
        $mdDialog.hide(true);
      }, 3000)


    }

    vm.close = function () {
      $mdDialog.hide(vm.date)
    }
    vm.print = function () {
      window.print();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.doctors', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.doctors', {
      url: '/doctors',
      views: {
        'content@app': {
          templateUrl: 'app/main/doctors/doctors.html',
          controller: 'DoctorsController as vm'
        }
      },
      resolve: {
        Doctors:function (orAdminService) {
          return orAdminService.GetDoctorsList();
        }
      }
    });
    $stateProvider.state('app.doctors_card', {
      url: '/doctors/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/doctors/doctor-card/doctor-card.html',
          controller: 'DoctorCardController as vm'
        }
      },
      resolve: {
        Doctor:function (orAdminService,$stateParams,$cookies) {
          var doctorID = $stateParams.id || $cookies.get('doctorID') || 5;
          $cookies.put('doctorID', doctorID);
          return orAdminService.GetDoctor(doctorID);
        },
        // DashboardData: function (msApi)
        // {
        //   return msApi.resolve('dashboard.project@get');
        // }
      }
    });
    // msApiProvider.register('dashboard.project', ['app/data/dashboard/project/data.json']);

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/contacts');
    msNavigationServiceProvider.saveItem('doctorsG', {
      title: 'דוחות ותרשימים',
      group: true,
      weight: 2,
      rule: 3
    });
    msNavigationServiceProvider.saveItem('doctors', {
      title: 'רופאים',
      icon: 'icon-pharmacy',
      group: false,
      weight: 3,
      rule: 3,
      permission: "doctors"
    });
    msNavigationServiceProvider.saveItem('doctors.doctors', {
      title: 'רשימת רופאים',
      state: 'app.doctors',
      weight: 1,
      permission: "doctors"
    });
    msNavigationServiceProvider.saveItem('doctors.doctors_card', {
      title: 'כרטיס רופא',
     // icon: 'icon-account-multiple',
      state: 'app.doctors_card',
      weight: 1,
      permission: "doctors"
    });

    // Api




  }

})();

/**
 * Created by itzik on 11/07/2018.
 */
(function () {
  'use strict';

  angular
    .module('app.doctors')
    .controller('DoctorInboxController', DoctorInboxController);

  /** @ngInject */
  function DoctorInboxController(Message, Doctor, orAdminService, $mdDialog) {
    var vm = this;
    vm.message = Message;
    Message.adminUnread = 0;
    vm.reply = function (e) {
      var newMess = {
        content: vm.replyMessage,
        date: new Date(),
        in_mess: true
      };
      // Message.messages.push();
      vm.replyMessage = '';
      orAdminService.PostMessageToDoctor(Message, newMess, Doctor);
      $mdDialog.hide();
    };
    vm.closeDialog = function() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.contacts', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.contacts', {
      url: '/contacts',
      views: {
        'content@app': {
          templateUrl: 'app/main/contacts/contacts.html',
          controller: 'ContactsController as vm'
        }
      },
      resolve: {

        // orClients: function (msApi, orContacts) {
        //   return orContacts.resolveClients();
        // },
        Clients: function (msApi, orPlacesService, $stateParams,$cookies) {

          return  orPlacesService.GetClientsPlace();
        }

      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/contacts');

    msNavigationServiceProvider.saveItem('fuse.contacts', {
      title: 'פציינטים',
      icon: 'icon-account-multiple',
      state: 'app.contacts',
      rule: 1,
      /*stateParams: {
       'param1': 'page'
       },*/
      // translate: 'SAMPLE.CONTACTS',
      weight: 2
    });

    // Api





  }

})();

(function () {
  'use strict';
  angular
    .module('app.contacts')
    .directive('onReadFile', function ($parse) {
      return {
        restrict: 'A',
        scope: false,
        link: function (scope, element, attrs) {
          var fn = $parse(attrs.onReadFile);

          element.on('change', function (onChangeEvent) {
            var reader = new FileReader();

            reader.onload = function (onLoadEvent) {
              scope.$apply(function () {
                fn(scope, {$fileContent: onLoadEvent.target.result});
              });
            };

            reader.readAsText((onChangeEvent.srcElement || onChangeEvent.target).files[0]);
          });
        }
      };
    })
    .directive('ngCsvImport', function () {
      return {
        restrict: 'E',
        transclude: true,
        replace: true,
        scope: {
          content: '=?',
          header: '=?',
          headerVisible: '=?',
          separator: '=?',
          separatorVisible: '=?',
          result: '=?',
          encoding: '=?',
          encodingVisible: '=?',
          accept: '=?',
          acceptSize: '=?',
          acceptSizeExceedCallback: '=?',
          callback: '=?',
          mdButtonClass: '@?',
          mdInputClass: '@?',
          mdButtonTitle: '@?',
          mdSvgIcon: '@?',
          uploadButtonLabel: '='
        },
        template: function (element, attrs) {
          var material = angular.isDefined(attrs.material);
          var multiple = angular.isDefined(attrs.multiple);
          return '<div  class="ng-csv-import">' +
            '<div ng-show="headerVisible"><div class="label">Header</div>' +
            (material ? '<input type="checkbox" ng-model="header"></div>' :
              '<md-switch class="ng-csv-import-header-switch" ng-model="header"></md-switch>') +
            '<div ng-show="encodingVisible"><div class="label">Encoding</div><span>{{encoding}}</span></div>' +
            '<div ng-show="separatorVisible">' +
            '<div class="label">Seperator</div>' +
            '<span><input class="separator-input ' + (material ? '_md md-input' : '') + ' " type="text" ng-change="changeSeparator" ng-model="separator"><span>' +
            '</div>' +
            '<div>' +
            '<input ng-show="false" class="btn cta gray" upload-button-label="{{uploadButtonLabel}}" type="file" ' + (multiple ? 'multiple' : '') + ' accept=".csv"/>' +
            (material ? '<md-button  ng-click="onClick($event)" class="_md md-button md-primary {{mdButtonClass}}">' +
            '<img src="assets/images/crm/csv.png"/>' +
            ' </md-button>' +
            '<md-input-container ng-show="false">' +
            '<input type="text" class="_md md-input-readable md-input {{mdInputClass}}" ng-click="onClick($event)" ng-model="filename"></md-input-container>' : '') +
            '</div>' +
            '</div>';
        },
        link: function (scope, element, attrs) {
          scope.separatorVisible = !!scope.separatorVisible;
          scope.headerVisible = !!scope.headerVisible;
          scope.acceptSize = scope.acceptSize || Number.POSITIVE_INFINITY;
          scope.material = angular.isDefined(attrs.material);
          scope.multiple = angular.isDefined(attrs.multiple);
          if (scope.multiple) {
            throw new Error("Multiple attribute is not supported yet.");
          }
          var input = angular.element(element[0].querySelector('input[type="file"]'));
          var inputContainer = angular.element(element[0].querySelector('md-input-container'));

          if (scope.material && input) {
            input.removeClass("ng-show");
            input.addClass("ng-hide");
            if (inputContainer) {
              var errorSpacer = angular.element(inputContainer[0].querySelector('div.md-errors-spacer'));
              if (errorSpacer) {
                errorSpacer.remove();
              }
            }
            scope.onClick = function () {
              input.click();
            };
          }

          angular.element(element[0].querySelector('.separator-input')).on('keyup', function (e) {
            if (scope.content != null) {
              var content = {
                csv: scope.content,
                header: scope.header,
                separator: e.target.value,
                encoding: scope.encoding
              };
              scope.result = csvToJSON(content);
              scope.$apply();
              if (typeof scope.callback === 'function') {
                if (scope.callback != null) {
                  scope.callback(e);
                }
              }
            }
          });

          element.on('change', function (onChangeEvent) {
            if (!onChangeEvent.target.files.length) {
              return;
            }

            if (onChangeEvent.target.files[0].size > scope.acceptSize) {
              if (typeof scope.acceptSizeExceedCallback === 'function') {
                scope.acceptSizeExceedCallback(onChangeEvent.target.files[0]);
              }
              return;
            }
            if ("application/vnd.ms-excel" != onChangeEvent.target.files[0].type && "text/plain" != onChangeEvent.target.files[0].type)
              return;
            scope.filename = onChangeEvent.target.files[0].name;

            var reader = new FileReader();
            reader.onload = function (onLoadEvent) {
              scope.$apply(function () {
                var content = {
                  csv: onLoadEvent.target.result.replace(/\r\n|\r/g, '\n'),
                  header: scope.header,
                  separator: scope.separator
                };
                scope.content = content.csv;
                scope.result = csvToJSON(content);
                scope.result.filename = scope.filename;
                scope.$$postDigest(function () {
                  if (typeof scope.callback === 'function') {
                    if (scope.callback != null) {
                      scope.callback(onChangeEvent);
                    }
                  }
                });
              });
            };

            if ((onChangeEvent.target.type === "file") && (onChangeEvent.target.files != null || onChangeEvent.srcElement.files != null)) {
              reader.readAsText((onChangeEvent.srcElement || onChangeEvent.target).files[0], scope.encoding);
            } else {
              if (scope.content != null) {
                var content = {
                  csv: scope.content,
                  header: !scope.header,
                  separator: scope.separator
                };
                scope.result = csvToJSON(content);
                scope.$$postDigest(function () {
                  if (typeof scope.callback === 'function') {
                    if (scope.callback != null) {
                      scope.callback(onChangeEvent);
                    }
                  }
                });
              }
            }
          });

          var csvToJSON = function (content) {
            var lines = content.csv.split(new RegExp('\n(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)'));
            var result = [];
            var start = 0;
            var columnCount = lines[0].split(content.separator).length;

            var headers = [];
            if (content.header) {
              headers = lines[0].split(content.separator);
              start = 1;
            }

            for (var i = start; i < lines.length; i++) {
              var obj = {};
              var currentline = lines[i].split(new RegExp(content.separator + '(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)'));
              if (currentline.length === columnCount) {
                if (content.header) {
                  for (var j = 0; j < headers.length; j++) {
                    obj[headers[j]] = cleanCsvValue(currentline[j]);
                  }
                } else {
                  for (var k = 0; k < currentline.length; k++) {
                    obj[k] = cleanCsvValue(currentline[k]);
                  }
                }
                result.push(obj);
              }
            }
            return result;
          };

          var cleanCsvValue = function (value) {
            return value
              .replace(/^\s*|\s*$/g, "") // remove leading & trailing space
              .replace(/^"|"$/g, "") // remove " on the beginning and end
              .replace(/""/g, '"'); // replace "" with "
          };
        }
      };
    })
    .controller('importContacts', importContacts);

  function importContacts($mdDialog, bon_Contacts, msUtils, $filter, Subscription, $scope, DTOptionsBuilder, $mdToast, IntegrationsSer, agent, msApi, key) {
    var vm = this;
    vm.seperator = ',';
    vm.fields = [];
    vm.contactsArray = [];
    vm.isLoading = true;
    vm.fielsConvert = {
      fnameField: "",
      lnameField: '',
      emailField: "",
      phoneField: "",
      companyField: "",
      notesField: ""
    };
    vm.steps = ['load', 'fields', 'validate'];
    vm.step = 'load';
    vm.integrationTypes;
    vm.contactsDemo = [
      {name: "", last_name: "", email: "", phone: "", notes: ""},
      {name: "", last_name: "", email: "", phone: "", notes: ""},
      {name: "", last_name: "", email: "", phone: "", notes: ""},
      {name: "", last_name: "", email: "", phone: "", notes: ""}
    ];

    //shopify
    agent.getShopByCustomer(function (res) {
      vm.shopName = res;
    });
    if (key) {
      bon_Contacts.shopifyContacts(key).then(function (res) {
        vm.isIntegration = true;
        vm.initShopifyContacts(res.customers);
      })
      if (key == 'error') {
        var message =  $filter('translate')('GLOBAL.ACTION_ERROR');
        //toast
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
          hideDelay: 5000,
          position: 'top right',
          parent: '#contactslist'
        });
      }
    }
    //ZOHO
    IntegrationsSer.Integrations().then(function (result) {
        vm.integrationTypes = result;
        var Zoho = $filter('filter')(vm.integrationTypes, {name: 'zoho'});
        vm.isZoho = Zoho[0] && Zoho[0].isAdded;
      }
    );
    //FUNCTIONS
    vm.initFields = function (res) {
      vm.contactsArray = [];
      vm.fields=[];
      vm.fielsConvert = {
        fnameField: "",
        lnameField: '',
        emailField: "",
        phoneField: "",
        companyField: "",
        notesField: ""
      };
      vm.isIntegration = false;
      if (!vm.resultCsv.length || !vm.resultCsv[0])
        return;
      vm.fields = Object.keys(vm.resultCsv[0]);
      vm.step = vm.fields.length ? 'fields' : 'load';
      vm.isLoading = false;
      $('input[type="file"]').val(null);
    }
    vm.initContactsArray = function () {
      vm.contactsArray = [];
      vm.resultCsv.forEach(function (obj) {
        var contactJson = {};
        //first name
        contactJson.name = vm.fielsConvert.fnameField ? obj[vm.fielsConvert.fnameField] : "";
        //last name
        contactJson.last_name = vm.fielsConvert.lnameField ? (obj[vm.fielsConvert.lnameField]) : "";
        //email
        contactJson.email = vm.fielsConvert.emailField ? (obj[vm.fielsConvert.emailField]) : "";
        //phone
        contactJson.phone = vm.fielsConvert.phoneField ? (obj[vm.fielsConvert.phoneField]) : "";
        //company
        contactJson.company = vm.fielsConvert.companyField ? (obj[vm.fielsConvert.companyField]) : "";
        //company
        contactJson.notes = vm.fielsConvert.notesField ? (obj[vm.fielsConvert.notesField]) : "";
        //contactJson.isAdd=true;
        vm.contactsArray.push(contactJson);
      });
    }
    vm.validateData = function () {
      vm.step = 'validate';
      if (!vm.contactsArray || !vm.contactsArray.length)
        return;
      vm.contactsArray.forEach(function (obj) {
        var ponePattern = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
        var emailPattern = /^.+@.+\..+$/;
        obj.status = true;
        if (obj.phone && !ponePattern.test(obj.phone))
          obj.status = false;
        if (!obj.email || (obj.email && !emailPattern.test(obj.email)))
          obj.status = false;
        obj.isAdd = obj.status;
      });
      vm.sumValid = $filter('filter')(vm.contactsArray, {status: true}).length;
      vm.sumNotValid = vm.contactsArray.length - vm.sumValid;
    }
    vm.importZohoContacts = function () {
      vm.contactsArray = [];
      bon_Contacts.importIntegrationContacts('zoho').then(function (res) {
        console.log(res)
        if (!res.status)
          return;
        res.data.forEach(function (obj) {
          if (!obj || !obj.Email)
            return;
          var contactJson = {};
          //first name
          contactJson.name = obj["First Name"]
          //last name
          contactJson.last_name = obj["Last Name"];
          //email
          contactJson.email = obj.Email;
          //phone
          contactJson.phone = obj.Phone ? (obj.Phone) : "";
          //notes
          contactJson.notes = obj.Note? (obj.Note) : "";
          vm.contactsArray.push(contactJson);
        })
        vm.isLoading = false;
        vm.validateData();
      });

    }
    vm.initShopifyContacts = function (customers) {
      vm.contactsArray = [];
      if(!customers)
        return;
      customers.forEach(function (obj) {
        if (!obj || !obj.email)
          return;
        var contactJson = {};
        //first name
        contactJson.name = obj.first_name ? obj.first_name : ""
        //last name
        contactJson.last_name = obj.last_name ? obj.last_name : "";
        //email
        contactJson.email = obj.email ? obj.email : "";
        //phone
        contactJson.phone = obj.phone ? (obj.phone) : "";
        //note
        contactJson.notes = obj.note ? (obj.note) : "";
        vm.contactsArray.push(contactJson);
      });
      vm.isLoading = false;
      vm.validateData();

    }
    vm.importContacts = function (name) {
      vm.isIntegration = true;
      switch (name) {
        case 'zoho':
          vm.importZohoContacts();
          break;


      }
    }
    vm.addContacts = function () {
      var validContacts = $filter('filter')(vm.contactsArray, {status: true, isAdd: true});
      bon_Contacts.addContactsList(validContacts).then(function (res) {
        //close
        $mdDialog.hide();
        var message = res.status ? "Contacts were successfully saved" : $filter('translate')('GLOBAL.ACTION_ERROR');
        //toast
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
          hideDelay: 5000,
          position: 'top right',
          parent: '#contactslist'
        });
      })
    }
    vm.getSumValid = function () {
      if (!vm.contactsArray || !vm.contactsArray.length)
        return "";
      var validContacts = $filter('filter')(vm.contactsArray, {status: true, isAdd: true});
      return validContacts.length ? validContacts.length : "";
    }
    vm.closeDialog = function () {
      $mdDialog.hide();
    }
    vm.getShopifyUrl = function () {
      if (key || !vm.shopName)
        return "";
      return bontactServers.shopify_api + 'getContactsList?shop=' + vm.shopName;
    }
    vm.toastNotIntegrate=function (name) {
      var message =  name=="zoho"?"Integration to Zoho was not detected":"Shopify client was not detected";
      //toast
      $mdToast.show({
        template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
        hideDelay: 5000,
        position: 'top right',
        parent: '#importContacts'
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.contacts')
    .controller('ContactDialogController', ContactDialogController);

  /** @ngInject */
  function ContactDialogController($mdDialog, msUtils, $filter) {
    var vm = this;

    vm.title = 'EDIT_CONTACT';


    vm.newContact = false;
    vm.allFields = false;
    vm.default_avatar = 'assets/images/avatars/profile.jpg';


    // Methods
    if (!vm.contact)
      vm.contact = {};
    vm.contact.allPlaces = true;

    //////////


    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    function submit() {
      $mdDialog.hide(vm.contact);
    }

    vm.closeDialog = closeDialog;
    vm.submit = submit;

  }
})();

(function () {
  'use strict';

  angular
    .module('app.contacts')
    .controller('ContactDialogController', ContactDialogController);

  /** @ngInject */
  function ContactDialogController($mdDialog, msUtils, $filter) {
    var vm = this;

    vm.title = 'EDIT_CONTACT';


    vm.newContact = false;
    vm.allFields = false;
    vm.default_avatar = 'assets/images/avatars/profile.jpg';


    // Methods
    if (!vm.contact)
      vm.contact = {};

    //////////


    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    function submit() {
      $mdDialog.hide(vm.contact);
    }

    vm.closeDialog = closeDialog;
    vm.submit = submit;

  }
})();

/**
 * Created by itzik on 07/01/2018.
 */
(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('tableReportEditDialogController', tableReportEditDialogController);

  /** @ngInject */
  function tableReportEditDialogController(Item, Feilds, AllowRemove, isNew,isGroup, $mdDialog, msUtils, $timeout) {
    var vm = this;

    vm.title = 'EDIT_CONTACT';
    vm.item = angular.copy(Item);
    vm.keys = Feilds;//Object.keys(Feilds);
    vm.isNew = isNew;
    vm.isGroup = isGroup;

    vm.AllowRemove = AllowRemove;//Object.keys(Feilds);

    vm.newContact = false;
    vm.allFields = false;
    vm.default_avatar = 'assets/images/avatars/profile.jpg';
    vm.keys.map(function (item) {
      if (item.type == 'date')
        vm.item[item.key] = new Date(vm.item[item.key]);
      if (item.type == 'time'&&vm.item[item.key]) {
        var ite = new Date(vm.item[item.key]);
        // vm.item[item.key] = moment(ite).add(-2,'hour').second(0).millisecond(0).toDate();
        vm.item[item.key] = moment(ite).second(0).millisecond(0).toDate();
        //item.type = date;
      }
    })

    // Methods


    //////////


    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    function submit() {
      $mdDialog.hide(vm.item);
    }

    vm.closeDialog = closeDialog;
    vm.submit = submit;
    vm.remove = function () {
      vm.item._action = 'remove';
      $mdDialog.hide(vm.item);
    }
    vm.focusSearch = function () {
      $timeout(function () {
        $('#s_search').focus();
      }, 500);
    }
    window.mdSelectOnKeyDownOverride = function (event) {
      event.stopPropagation();
      // NOTE: hack until this is fixed...
    };

  }
})();

/**
 * Created by itzik on 23/11/2017.
 */

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('DateDialogController', DateDialogController);

  /** @ngInject */
  function DateDialogController($mdDialog, $filter, Dates) {
    var vm = this;
    vm.date = Dates.start ? moment(Dates.start).toDate() : new Date();
    vm.dateend = Dates.end ? moment(Dates.end).toDate() : new Date();
    vm.re_select = 0;
    vm.close = function () {

      $mdDialog.hide({start: moment(vm.date).hours(5), end: moment(vm.dateend).hours(5)})
    }
    vm.range = [];

    for (var i = 1; i <= 5; i++) {
      var datesO = {start: moment().add(-i, 'month').date(1), end: moment().add(-i, 'month').endOf('month')};
      vm.range.push({
        dates: datesO,
        name: moment().add(-i, 'month').format('MMMM - YY'),
        id: i
      })
      if (moment(vm.date).format('DDMMYY') == datesO.start.format('DDMMYY') && moment(vm.dateend).format('DDMMYY') == datesO.end.format('DDMMYY'))
        vm.re_select = i;
    }
    vm.changeMonth = function () {
      if (vm.re_select) {
        var item = $filter('filter')(vm.range, {id: vm.re_select}, true)[0];
        if (item) {
          vm.date = item.dates.start.toDate();
          vm.dateend = item.dates.end.toDate();
        }

      }
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function () {
  'use strict';

  angular
    .module('app.reports', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.report_places', {
      url: '/reports/places',
      views: {
        'content@app': {
          templateUrl: 'app/main/reports/placesReport/places_report.html',
          controller: 'Report_placesController as vm'
        }
      },
      resolve: {
        PlacesClientReport: function (orAdminService) {
          return orAdminService.PlacesClientReport();
        },
        PlacesMoneyReport: function (orAdminService) {
          return orAdminService.PlacesMoneyReport();
        }
      }
    });
    $stateProvider.state('app.place_card', {
      url: '/place/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/reports/place-card/place-card.html',
          controller: 'PlaceCardController as vm'
        }
      },
      resolve: {
        Place: function (orPlacesService, $stateParams, $cookies, orUserAccount) {
          var placeID = $stateParams.id || $cookies.get('placeID') || 51;
          var Places = orUserAccount.PermissionPlaces();
          if (orUserAccount.Admin_user.rule < 10 && Places.indexOf(placeID) == -1)
            placeID = Places[Places.length - 1];
          $cookies.put('placeID', placeID);


          return orPlacesService.Place(placeID);
        },
        Places: function (orPlacesService) {
          return orPlacesService.Places();
        }
        /*Clients: function (msApi, orPlacesService, $stateParams, $cookies,orUserAccount) {
         var placeID = $stateParams.id || $cookies.get('placeID') || 51;
         var Places = orUserAccount.PermissionPlaces();
         if (Places.indexOf(placeID) == -1)
         placeID = Places[Places.length - 1];
         return orPlacesService.GetClientsPlace(undefined, placeID);
         }*/
        // DashboardData: function (msApi)
        // {
        //   return msApi.resolve('dashboard.project@get');
        // }
      }
    });


    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/contacts');


    msNavigationServiceProvider.saveItem('places', {
      title: 'סניפים',
      group: false,
      icon: 'icon-bank',
      weight: 4,
      rule: 5
    });
    msNavigationServiceProvider.saveItem('places.places', {
      title: 'מעקב סניפים',
      //icon: 'icon-account-multiple',
      state: 'app.report_places',
      weight: 1,
      rule: 5
    });
    msNavigationServiceProvider.saveItem('places.place_card', {
      title: 'כרטיס סניף',
      //icon: 'icon-account-multiple',
      state: 'app.place_card',
      weight: 1,
      rule: 5
    });


    // Api


  }

})();

(function () {
  'use strict';

  angular
    .module('app.reports')
    .controller('Report_placesController', Report_placesController);

  /** @ngInject */
  function Report_placesController(PlacesClientReport, PlacesMoneyReport, $scope, $mdSidenav, msUtils, $mdDialog, $mdToast, $document, $state, $filter,
                                   orAdminService, orUserAccount, $mdMedia) {

    var vm = this;
    // data
    if (orUserAccount.Admin_user.rule < 5) {
      $state.go('app.contacts');
      return;
    }
    vm.dates = {start: new Date()};
    vm.reportType = 0;

    vm.ClientsReports = {
      feilds: [
        {key: 'adminName', name: 'מנהל', filter: true},
        {key: 'Name', name: 'סניף', filter: true},
        // {key: 'adminName', name: 'מנהל', filter: true},
        {key: 'countClients', name: 'פציינטים'},
        {key: 'sumPay', name: 'לתש` פציינט', type: 'customCurrency'},
        {key: 'sumIncludeInsurance', name: 'כולל ביטוחים', type: 'customCurrency'},
        //  {key: 'countInvoices', name: 'חשבוניות'},
        {key: 'sumPaid', name: 'הכנסות בפועל', type: 'customCurrency', show: 'gt-md'}
      ],
      feildsAdmin: [
        {key: 'Name', name: 'מנהל'},
        {key: 'description', name: 'איזור', show: 'gt-xm'},
        {key: 'countClients', name: 'פציינטים'},
        {key: 'sumPay', name: 'לתש` פציינט', type: 'customCurrency'},
        {key: 'sumIncludeInsurance', name: 'כולל ביטוחים', type: 'customCurrency'},
        //  {key: 'countInvoices', name: 'חשבוניות'},
        {key: 'sumPaid', name: 'הכנסות בפועל', type: 'customCurrency', show: 'gt-xs'}
      ],
      data: PlacesClientReport,
      config: {
        title: 'דוח הכנסות סניף',
        rowClick: {type: 'ref', ui_serf: 'app.place_card', params: [{key: 'id', value: 'PlaceID'}]},
        classFunc: function (item) {
          return (item.isMax ? 'text-bold green-fg' : '');
        }
      },
      configAdmin: {
        title: 'דוח מנהלים',
        classFunc: function (item) {
          return (item.isMax ? 'text-bold green-fg' : '');
        }
      }
    }

    vm.MoneyReports = {
      feilds: [
        {key: 'Name', name: 'סניף', filter: true},
        {key: 'CashPrice', name: 'מזומן', type: 'customCurrency'},
        {key: 'CreditCardPrice', name: 'אשראי', type: 'customCurrency'},
        {key: 'BankChekPrice', name: 'שיקים', type: 'customCurrency'},
        {key: 'sumAll', name: 'ס"ה', type: 'customCurrency', show: 'gt-xs'}
      ],
      data: PlacesMoneyReport
    }
    vm.refresh = function (dates) {
      vm.proccess = true;
      var finish1 = false, finish2 = false;
      orAdminService.PlacesClientReport(dates).then(function () {
        finish1 = true;

        vm.proccess = false;
      });
      orAdminService.PlacesMoneyReport(dates).then(function () {
        finish2 = true;
        if (finish1 && finish2)
          vm.proccess = false;
      });
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.reports')
    .controller('PlaceCardController', PlaceCardController);

  /** @ngInject */
  function PlaceCardController(Place, $scope, $mdSidenav, msUtils, $mdDialog, $mdToast, $timeout, $state, $filter,
                               orAdminService, orPlacesService, Places, Compare_reportsService, orUserAccount) {

    var vm = this;
    // data
    vm.Places = Places;

    vm.dates = {
      start: moment().toDate(),
      end: moment().toDate()
    };
    vm.compare = {start: new Date(), end: moment().add('1', 'day').toDate()};
    vm.place = Place;
    if (orUserAccount.Admin_user.rule >= 6 && !Place.Prices) {
      orAdminService.PricesPlace(Place);
    }
    vm.PricesPlace = {
      feilds: [
        {key: 'Name', name: 'צילום'},
        {key: 'basePrice', type: 'customCurrency', name: 'מחירון'},
        {key: 'placePrice', type: 'customCurrency', name: 'מחיר סניף'},
      ],
      edit: [
        {key: 'Name', name: 'צילום', readOnly: true},
        {key: 'basePrice', name: 'מחירון', readOnly: true},
        {key: 'placePrice', name: 'מחיר סניף', required: true, min: 1, max: 2000, type: 'number'},
      ],
      config: {
        title: 'מחירון סניף',
        hideFotter: true
//        rowClick: {type: 'ref', ui_serf: 'app.doctors_card', params: [{key: 'id', value: 'DoctorID'}]}
      }

    }
    vm.placeSelected = Place.PlaceID;
    vm.changePlace = function (place) {
      $state.go('app.place_card', {id: vm.placeSelected});
    }
    vm.widget1 = {currentRange: "DT"};

    vm.editPricePlace = function (item) {
      console.log('editPriceDoctor');
      if (!item.PlaceID)
        item.PlaceID = Place.PlaceID;
      console.log(item);
      vm.proccess = true;
      orAdminService.UpdatePricesPlace(item).then(function (result) {
        if (result.status)
          orAdminService.PricesPlace(Place);
        vm.proccess = false;
      });
    };
    vm.deletePricePlace = function (item) {
      console.log('deletePricePlace');
      item.placePrice = 0;
      console.log(item);
      vm.proccess = true;
      orAdminService.UpdatePricesPlace(item).then(function (result) {
        if (result.status)
          orAdminService.PricesPlace(Place);
        vm.proccess = false;
      });

    }
    vm.feilds = [
      {key: 'doctorName', name: 'רופא', filter: true},
      {key: 'ClientID', name: 'מזהה'},
      {key: 'TZ', name: 'ת.ז.'},
      {key: 'ClientName', name: 'שם פציינט'},
      {key: 'KDate', name: 'תאריך', type: 'date'},
      {key: 'photoName', name: 'צילום', filter: true},
      {key: 'categoryName', name: 'קטגוריה', filter: true},
      {key: 'Price', name: 'מחיר', type: 'customCurrency'},
      {key: 'Deductible', name: 'השתתפות', type: 'customCurrency'},
      {key: 'InsuranceName', name: 'משלם', filter: true},
    ];
    vm.feildsDoctors = [
      {key: 'Name', name: 'רופא'},
      {key: 'countClients', name: 'פצייניטים', filter: true},
      {key: 'countPhotos', name: 'צילומים', "show": "gt-sm"},
      {key: 'Price', name: 'מחיר', type: 'customCurrency', "show": "gt-sm"},
      {key: 'Deductible', name: 'השתתפות', type: 'customCurrency'}
    ];
    vm.feildsInsurance = [
      {key: 'Name', name: 'ביטוח'},
      {key: 'countClients', name: 'פצייניטים'},
      {key: 'countPhotos', name: 'צילומים'},
      {key: 'Price', name: 'מחיר', type: 'customCurrency'},
      {key: 'Deductible', name: 'השתתפות', type: 'customCurrency'}
    ];
    vm.feildsByCategory = [
      {key: 'CategoryName', name: 'קטגוריה'},
      {key: 'countPhotos', name: 'כמות'}
    ];

    vm.config = {
      summarybycategory: {
        title: 'פירוט קטגוריות לסניף ' + Place.PlaceName,
        classFunc: ColorCategory
      },
      summarybyinsurance: {title: 'פירוט לפי גורם משלם עבור סניף ' + Place.PlaceName},
      clients: {title: 'פירוט פציינטים וצילומים לסניף ' + Place.PlaceName, classFunc: ColorCategory},
      summarybydoctors: {title: 'פירוט רופאים לסניף ' + Place.PlaceName},
      //rowClick: {type: 'ref', ui_serf: 'app.profile', params: [{key: 'id', value: 'ClientID'}]}
    }
    function ColorCategory(item) {
      switch (item.CategoryID) {
        case 1:
        default:
          return '';
        case 2:
          return 'blue-fg';
        case 3:
          return 'green-fg';
        case 4:
          return 'purple-fg';
        case 5:
          return 'red-fg';
      }
    }

    //vm.clients = Clients;
    var LoadDataPlace = function () {
      //Place.ClientsData
      vm.proccess = true;
      vm.compare.start = moment(vm.dates.start).add(-1, 'year').toDate();//.format('DD-MM-YY');
      vm.compare.end = moment(vm.dates.end).add(-1, 'year').toDate();//.format('DD-MM-YY');
      //vm.compare.isEqual=moment(vm.compare.start).format("MMM Do YY") ==moment(vm.compare.end).format("MMM Do YY");
      orPlacesService.GetDataPlace(vm.dates, Place).then(function (result) {
        vm.proccess = false;
      })
    }
    var GetStatusNow = function () {
      vm.proccess = true;
      orPlacesService.GetStatusNow(Place).then(function (result) {
        vm.statusNow = result[0];
        vm.proccess = false;
      })
    }
    vm.refreshStatusNow = function () {
      GetStatusNow();
    }
    vm.refresh = function () {
      LoadDataPlace();
    }
    vm.refresh();
    GetStatusNow();
    vm.refreshCompare = function () {
      vm.proccess = true;
      orAdminService.ComparePlace(Place, vm.dates, vm.compare).then(function (e) {
        vm.proccess = false;
      });
    }

    var LoadClientsPlace = function () {
      vm.proccess = true;
      orPlacesService.GetClientsPlace(vm.dates, Place.PlaceID).then(function (result) {
        vm.proccess = false;
      })
    }

    var LoadChartPlace = function () {
      vm.proccess = true;
      orAdminService.LoadChartPlace(Place).then(function () {
        vm.proccess = false;
        setDataWidget1();
      });
    }
    // if (!Place.ChartData)
    //   LoadChartPlace();

    function setDataWidget1() {
      var dateFilter = {};

      switch (vm.widget1.currentRange) {
        case "DY":
        default:
          dateFilter.start = moment().subtract(1, 'day');
          dateFilter.end = moment().subtract(1, 'day');
          break;
        case "DT":
          dateFilter.start = moment();
          dateFilter.end = moment();
          break;
        case "DW":
          dateFilter.start = moment().subtract(7, 'day');
          dateFilter.end = moment();
          break;
        case "DFM":
          dateFilter.start = moment().date(1);
          dateFilter.end = moment();
          break;
        case "DM":
          dateFilter.start = moment().subtract(1, 'month');
          dateFilter.end = moment();
          break;
        case "DYE":
          dateFilter.start = moment().subtract(1, 'year');
          dateFilter.end = moment();
          break;


      }

      var items = $filter('dateBetween')(Place.ChartData, 'dateWork', dateFilter.start, dateFilter.end)
      console.log(items);
      vm.widget1.countClients = 0;
      vm.widget1.countPhotos = 0;
      vm.widget1.Price = 0;
      vm.widget1.Deductible = 0;

      vm.widget1.ranges = {
        "DY": "אתמול",
        "DT": "היום",
        "DW": "שבוע",
        "DFM": "מתחילת החודש",
        "DM": "חודש",
        "DYE": "שנה"
      };

      items.map(function (item) {
        vm.widget1.countClients += item.countClients;
        vm.widget1.countPhotos += item.countPhotos;
        vm.widget1.Price += item.Price;
        vm.widget1.Deductible += item.Deductible;
      })


      vm.ChartWidget = {
        ranges: {
          "DAY": "יומי",
          "WEEK": "שבועי",
          "MONTH": "חודשי",
          "YEAR": "שנתי"
        },
        config: {
          refreshDataOnly: true,
          deepWatchData: true
        },
        options: {
          chart: {
            type: 'multiBarChart',
            color: ['#03a9f4', '#b3e5fc'],
            height: 420,
            margin: {
              top: 8,
              right: 16,
              bottom: 32,
              left: 32
            },
            clipEdge: true,
            groupSpacing: 0.3,
            reduceXTicks: false,
            stacked: true,
            duration: 250,
            x: function (d) {

              return d.x;
            },
            y: function (d) {
              return d.y;
            },
            yAxis: {
              tickFormat: function (d) {
                return d;
              }
            },
            legend: {
              margin: {
                top: 8,
                bottom: 32
              }
            },
            controls: {
              margin: {
                top: 8,
                bottom: 32
              }
            },
            tooltip: {
              gravity: 's',
              classes: 'gravity-s'
            }
          }
        },
        data: Place.ChartDataX[0].WEEK,
        changeRange: function (range) {
          vm.ChartWidget.currentRange = range;
          vm.ChartWidget.data = Place.ChartDataX[0][range];
          vm.ChartWidget.data2 = [Place.ChartDataX[1][range][0]];

          /**
           * Update main chart data by iterating through the
           * chart dataset and separately adding every single
           * dataset by hand.
           *
           * You MUST NOT swap the entire data object by doing
           * something similar to this:
           * vm.widget.mainChart.data = chartData
           *
           * It would be easier but it won't work with the
           * live updating / animated charts due to how d3
           * works.
           *
           * If you don't need animated / live updating charts,
           * you can simplify these greatly.
           */


        },
        init: function () {
          // Run this function once to initialize widget

          /**
           * Update the range for the first time
           */
          vm.ChartWidget.changeRange('WEEK');
        }
      }
      vm.ChartData2 = {
        "supporting": {
          widgets: {
            created: {
              data: [],//vm.dashboardData.widget5.supporting.created,
              chart: {
                data: []
              }
            },
            closed: {
              //data: vm.dashboardData.widget5.supporting.closed,
              chart: {
                data: []
              }
            }
          },
          "created": {
            "label": "Price",
            "count": 54,
            "chart": {
              "key": "Created",
              "values": [
                {"x": 0, "y": 5},
                {"x": 1, "y": 8},
                {"x": 2, "y": 5},
                {"x": 3, "y": 6},
                {"x": 4, "y": 7},
                {"x": 5, "y": 8},
                {"x": 6, "y": 7}
              ]
            }
          },
          "closed": {
            "label": "Copies",
            "count": 26,
            "chart": {
              "key": "Closed",
              "values": [
                {"x": 0, "y": 3},
                {"x": 1, "y": 2},
                {"x": 2, "y": 1},
                {"x": 3, "y": 4},
                {"x": 4, "y": 8},
                {"x": 5, "y": 8},
                {"x": 6, "y": 4}
              ]
            }
          },

        }
      }
      vm.ChartWidget.changeRange('WEEK');
    }

    vm.cahnge = function () {
      setDataWidget1();
      //alert(vm.widget1.currentRange);
    }

    vm.compareReport = function (report) {
      console.log(vm.dates);
      switch (report) {
        case "sumbydoctor":
          Compare_reportsService.SetDataSettings({
            date_A: vm.dates,
            date_B: vm.compare,
            doctor: {DoctorID: 0, Name: 'כל הרופאים'},
            place: Place,
            reportType: 1
          });

          break;
        case "summarybycategory":
          Compare_reportsService.SetDataSettings({
            date_A: vm.dates,
            date_B: vm.compare,
            category: {CategoryID: 0, CategoryName: 'כל הקטגוריות'},
            place: Place,
            reportType: 2
          });
          break;
        case "summarybyinsurance":
          Compare_reportsService.SetDataSettings({
            date_A: vm.dates,
            date_B: vm.compare,
            insuranse: {BituahID: 0, BituahName: 'הכל'},
            place: Place,
            reportType: 3
          });
          break;
      }
      $state.go('app.compare_reports');
    }
    vm.focusSearch = function () {
      $timeout(function () {
        $('#s_search').focus();
      }, 500);
    }
    window.mdSelectOnKeyDownOverride = function (event) {
      event.stopPropagation();
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('app.profile')
    .controller('ProfileDialogController', ProfileDialogController);

  /** @ngInject */
  function ProfileDialogController($mdDialog, $state, copyrators, employee) {
    var vm = this;


    /**
     * Close dialog
     */
   // vm.closeDialog = closeDialog;
    vm.cancel = cancel;
    vm.copyrators = copyrators;
    vm.copyratorselect = copyrators[0].id;
    // function closeDialog() {
    //   $mdDialog.hide(vm.copyratorselect);
    // }

    vm.selectEmployee = function (employeeId) {
      $mdDialog.hide(employeeId);
    }
    function cancel() {
      $mdDialog.hide();
      // if (!employee)
      //   $state.go('app.contacts')

    }


  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.timeline', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages_timeline', {
                url      : '/pages/timeline',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline'
            })
            .state('app.pages_timeline_left', {
                url      : '/pages/timeline-left',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline-left.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline-left'
            })
            .state('app.pages_timeline_right', {
                url      : '/pages/timeline-right',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline-right.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline-right'
            });

        // API
        msApiProvider.register('timeline.page1', ['app/data/timeline/page-1.json']);
        msApiProvider.register('timeline.page2', ['app/data/timeline/page-2.json']);
        msApiProvider.register('timeline.page3', ['app/data/timeline/page-3.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.timeline', {
            title : 'Timeline',
            icon  : 'icon-view-stream',
            weight: 8
        });

        msNavigationServiceProvider.saveItem('pages.timeline.default', {
            title: 'Default',
            state: 'app.pages_timeline'
        });

        msNavigationServiceProvider.saveItem('pages.timeline.left-aligned', {
            title: 'Left Aligned',
            state: 'app.pages_timeline_left'
        });

        msNavigationServiceProvider.saveItem('pages.timeline.right-aligned', {
            title: 'Right Aligned',
            state: 'app.pages_timeline_right'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.timeline')
        .controller('TimelineController', TimelineController);

    /** @ngInject */
    function TimelineController($q, msApi, Timeline)
    {
        var vm = this;

        // Data
        vm.timeline = Timeline.data;
        vm.timelineOptions = {
            scrollEl: '#content'
        };
        vm.currentPage = 1;
        vm.totalPages = 3;
        vm.pauseScroll = false;

        // Methods
        vm.loadNextPage = loadNextPage;

        //////////

        /**
         * Load next page
         * @returns promise
         */
        function loadNextPage()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Increase the current page number
            vm.currentPage = vm.currentPage + 1;

            // Check if we still have pages that we can load
            if ( vm.currentPage > vm.totalPages )
            {
                // Reject the promise
                deferred.reject('No more pages');
            }
            else
            {
                // Emulate the api call and load new timeline items in
                var pageName = 'timeline.page' + vm.currentPage + '@get';

                msApi.request(pageName, {},

                    // SUCCESS
                    function (response)
                    {
                        for ( var i = 0; i < response.data.length; i++ )
                        {
                            vm.timeline.push(response.data[i]);
                        }

                        // Resolve the promise
                        deferred.resolve(response);
                    },

                    // ERROR
                    function (response)
                    {
                        // Reject the promise
                        deferred.reject(response);
                    }
                );
            }

            return deferred.promise;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.search', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_search', {
            url      : '/pages/search',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/search/search.html',
                    controller : 'SearchController as vm'
                }
            },
            resolve  : {
                Classic : function (msApi)
                {
                    return msApi.resolve('search.classic@get');
                },
                Mails   : function (msApi)
                {
                    return msApi.resolve('search.mails@get');
                },
                Users   : function (msApi)
                {
                    return msApi.resolve('search.users@get');
                },
                Contacts: function (msApi)
                {
                    return msApi.resolve('search.contacts@get');
                }
            },
            bodyClass: 'search'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/search');

        // Api
        msApiProvider.register('search.classic', ['app/data/search/classic.json']);
        msApiProvider.register('search.mails', ['app/data/search/mails.json']);
        msApiProvider.register('search.users', ['app/data/search/users.json']);
        msApiProvider.register('search.contacts', ['app/data/search/contacts.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.search', {
            title : 'Search',
            icon  : 'icon-magnify',
            state : 'app.pages_search',
            weight: 7
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.search')
        .controller('SearchController', SearchController);

    /** @ngInject */
    function SearchController(Classic, Mails, Users, Contacts)
    {
        var vm = this;

        // Data
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.classic = Classic.data;
        vm.mails = Mails.data;
        vm.users = Users.data;
        vm.contacts = Contacts.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_maintenance', {
            url      : '/pages/maintenance',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_maintenance': {
                    templateUrl: 'app/main/pages/maintenance/maintenance.html',
                    controller : 'MaintenanceController as vm'
                }
            },
            bodyClass: 'maintenance'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/maintenance');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.maintenance', {
            title : 'Maintenance',
            icon  : 'icon-oil',
            state : 'app.pages_maintenance',
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance')
        .controller('MaintenanceController', MaintenanceController);

    /** @ngInject */
    function MaintenanceController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages_invoice_modern', {
                url      : '/pages/invoice/modern',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/invoice/views/modern/modern.html',
                        controller : 'InvoiceController as vm'
                    }
                },
                resolve  : {
                    Invoice: function (msApi)
                    {
                        return msApi.resolve('invoice@get');
                    }
                },
                bodyClass: 'invoice printable'
            })
            .state('app.pages_invoice_compact', {
                url      : '/pages/invoice/compact',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/invoice/views/compact/compact.html',
                        controller : 'InvoiceController as vm'
                    }
                },
                resolve  : {
                    Invoice: function (msApi)
                    {
                        return msApi.resolve('invoice@get');
                    }
                },
                bodyClass: 'invoice printable'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/invoice');

        // Api
        msApiProvider.register('invoice', ['app/data/invoice/invoice.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.invoice', {
            title : 'Invoice',
            icon  : 'icon-receipt',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('pages.invoice.modern', {
            title : 'Modern',
            state : 'app.pages_invoice_modern'
        });

        msNavigationServiceProvider.saveItem('pages.invoice.compact', {
            title : 'Compact',
            state : 'app.pages_invoice_compact'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice')
        .controller('InvoiceController', InvoiceController);

    /** @ngInject */
    function InvoiceController(Invoice)
    {
        var vm = this;

        // Data
        vm.invoice = Invoice.data;

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_coming-soon', {
            url      : '/pages/coming-soon',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_coming-soon': {
                    templateUrl: 'app/main/pages/coming-soon/coming-soon.html',
                    controller : 'ComingSoonController as vm'
                }
            },
            bodyClass: 'coming-soon'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/coming-soon');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.coming-soon', {
            title : 'Coming Soon',
            icon  : 'icon-alarm-check',
            state : 'app.pages_coming-soon',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon')
        .controller('ComingSoonController', ComingSoonController);

    /** @ngInject */
    function ComingSoonController()
    {
        var vm = this;

        // Data
        vm.endTime = 1472975790000;

        // Methods

        //////////
    }
})();
(function () {
  'use strict';

  angular
    .module('app.notes')
    .factory('NotesService', NotesService);

  /** @ngInject */
  function NotesService(msApi, $q) {
    var service = {
      data: [],
      addNote: addNote,
      updateNote: updateNote,
      deleteNote: deleteNote,
      getData: getData
    };

    /**
     * Add Note
     * @param note
     */
    function addNote(note) {
      service.data.push(note);
      saveLocal();
    }

    /**
     * Update Note
     * @param note
     */
    function updateNote(note) {
      for (var i = 0; i < service.data.length; i++) {
        if (service.data[i].id === note.id) {
          service.data[i] = note;
        }
      }
      saveLocal();
    }

    /**
     * Delete Note
     * @param note
     */
    function deleteNote(note) {
      for (var i = 0; i < service.data.length; i++) {
        if (service.data[i].id === note.id) {
          service.data.splice(i, 1);
        }
      }
      saveLocal();
    }

    /**
     * Get service data
     * @returns {Array}
     */
    function getData() {
      // Create a new deferred object
      var deferred = $q.defer();

      if (window.localStorage["notes"] !== undefined) {
        service.data = JSON.parse(window.localStorage["notes"]);
        deferred.resolve(service);
      } else {
        msApi.request('notes.notes@get', {},
          // SUCCESS
          function (response) {
            // Attach the data
            service.data = response.data;
            saveLocal();
            // Resolve the promise
            deferred.resolve(response);
          },

          // ERROR
          function (response) {
            // Reject the promise
            deferred.reject(response);
          }
        );
      }
      return deferred.promise;
    }

    var saveLocal = function () {
      window.localStorage["notes"] = JSON.stringify(service.data);
    }

    return service;

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .factory('LabelsService', LabelsService);

    /** @ngInject */
    function LabelsService(msUtils, NotesService, msApi, $q)
    {
        var service = {
            data       : [],
            addLabel   : addLabel,
            updateLabel: updateLabel,
            deleteLabel: deleteLabel,
            getData    : getData
        };

        /**
         * Add label
         * @param newLabel
         */
        function addLabel(newLabel)
        {
            if ( newLabel.name === '' )
            {
                return;
            }

            service.data.push({
                id   : msUtils.guidGenerator(),
                name : newLabel.name,
                color: newLabel.color || ''
            });
        }

        /**
         * Update Label
         * @param note
         */
        function updateLabel(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data[i] = note;
                }
            }
        }

        /**
         * Delete Label
         * @param label
         */
        function deleteLabel(label)
        {
            var notes = NotesService.data;

            // Look for all notes if they have the labels
            for ( var j = 0; j < notes.length; j++ )
            {
                if ( notes[j].labels.indexOf(label.id) > -1 )
                {
                    notes[j].labels.splice(notes[j].labels.indexOf(label.id), 1);
                }
            }

            // Delete label from service data
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === label.id )
                {
                    service.data.splice(i, 1);
                }
            }

        }

        /**
         * Get service data
         * @returns {Array}
         */
        function getData()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('notes.labels@get', {},
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        return service;

    }
})();
(function () {
  'use strict';

  angular
    .module('app.inventories', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.inventories', {
      url: '/inventories',
      views: {
        'content@app': {
          templateUrl: 'app/main/inventories/inventories.html',
          controller: 'InventoriesController as vm'
        }
      },
      resolve: {

        Inventories: function (inventoriesService) {
          return inventoriesService.Orders();
        },
        Title: function () {
          return "הזמנות חדשות";
        }

      }
    });
    $stateProvider.state('app.inventories_archived', {
      url: '/inventories_archived',
      views: {
        'content@app': {
          templateUrl: 'app/main/inventories/inventories.html',
          controller: 'InventoriesController as vm'
        }
      },
      resolve: {

        Inventories: function (inventoriesService) {
          return inventoriesService.ArchivedOrders();
        },
        Title: function () {
          return "ארכיון הזמנות";
        }

      }
    });

    $stateProvider.state('app.inventories_order', {
      url: '/inventories/order/:order',
      views: {
        'content@app': {
          templateUrl: 'app/main/inventories/order/inventories_order.html',
          controller: 'InventoriesOrderController as vm'
        }
      },
      resolve: {

        Order: function ($stateParams, inventoriesService) {
          return inventoriesService.OrderDetails($stateParams.order || 0);
        },
        Statuses: function (inventoriesService) {
          return inventoriesService.Statuses_option();
        }
        // Products: function (inventoriesService) {
        //   return inventoriesService.GetAllItemsProducts();
        // }

      }
    });
    $stateProvider.state('app.inventories_tracking', {
      url: '/inventories/tracking',
      views: {
        'content@app': {
          templateUrl: 'app/main/inventories/tracking/inventories_tracking.html',
          controller: 'InventoriesTrackingController as vm'
        }
      },
      resolve: {

        TrackingData: function (inventoriesService) {
          return inventoriesService.GetInventoriesTracking();
        }
      }
    });
    $stateProvider.state('app.inventories_tracking_history', {
      url: '/inventories/tracking_history',
      views: {
        'content@app': {
          templateUrl: 'app/main/inventories/tracking_history/tracking_history.html',
          controller: 'InventoriesTrackingHistoryController as vm'
        }
      },
      resolve: {

        TrackingData: function (inventoriesService) {
          return inventoriesService.GetInventoriesHistoryTracking();
        },
        Places: function (orPlacesService) {
          return orPlacesService.Places();
        },
        Items: function (inventoriesService) {
          return inventoriesService.GetAllItemsProducts();
        }
      }
    });

    $stateProvider.state('app.inventories_edit_order', {
      url: '/inventories/order/edit/:order',
      views: {
        'content@app': {
          templateUrl: 'app/main/inventories/edit_order/edit_order.html',
          controller: 'Edit_orderController as vm'
        }
      },
      resolve: {

        Order: function ($stateParams, inventoriesService) {
          if ($stateParams.order && $stateParams.order != 0)
            return inventoriesService.Order($stateParams.order);
          return {isnew: true}
        },
        Items: function ($stateParams, inventoriesService) {
          return inventoriesService.GetOrderDetailsForEdit($stateParams.order);
        }

      }
    });

    $stateProvider.state('app.inventories_items', {
      url: '/inventories/items',
      views: {
        'content@app': {
          templateUrl: 'app/main/inventories/items/items.html',
          controller: 'InventoriesItemsController as vm'
        }
      },
      resolve: {
        Suppliers:function (inventoriesService) {
          return inventoriesService.GetSuppliers();
        },
        Items: function (inventoriesService) {
          return inventoriesService.GetAllItemsProducts();
        }
      }
    });

    $stateProvider.state('app.inventories_suppliers', {
      url: '/inventories/suppliers',
      views: {
        'content@app': {
          templateUrl: 'app/main/inventories/suppliers/suppliers.html',
          controller: 'InventoriesSuppliersController as vm'
        }
      },
      resolve: {
        Suppliers:function (inventoriesService) {
          return inventoriesService.GetSuppliers();
        }
      }
    });

    msNavigationServiceProvider.saveItem('storage', {
      title : 'מחסן',
      group : true,
      weight: 1,
      permission: "storage",
    });
    msNavigationServiceProvider.saveItem('storage.investory', {
      title: 'מלאי',
      icon: 'icon-barcode',
      weight: 2,
      permission: "storage",
    });
    msNavigationServiceProvider.saveItem('storage.investory.inventories', {
      title: 'הזמנות חדשות',
      state: 'app.inventories',
      weight: 1,
      permission: "storage",
      badge:{
        content:0
      }
    });
    msNavigationServiceProvider.saveItem('storage.investory.inventories_tracking', {
      title: 'מלאי סניפים',
      state: 'app.inventories_tracking',
      weight: 2,
      permission: "storage",
    });
    msNavigationServiceProvider.saveItem('storage.investory.inventories_tracking_history', {
      title: 'מעקב תנועות',
      state: 'app.inventories_tracking_history',
      weight: 3,
      permission: "storage",
    });
    msNavigationServiceProvider.saveItem('storage.investory.inventories_edit_order', {
      title: 'הצג הזמנה',
      state: 'app.inventories_order',
      weight: 4,
      permission: "storage",
    });
    msNavigationServiceProvider.saveItem('storage.investory.inventories_archived', {
      title: 'ארכיון הזמנות',
      state: 'app.inventories_archived',
      weight: 5,
      permission: "storage",
    });

    msNavigationServiceProvider.saveItem('storage.manage', {
      title: 'ניהול מחסן',
      icon: 'icon-cart',
      weight: 3,
      permission: "storage",
    });
    msNavigationServiceProvider.saveItem('storage.manage.inventories_items', {
      title: 'ניהול מוצרים',
      state: 'app.inventories_items',
      weight: 6,
      permission: "storage",
    });
    msNavigationServiceProvider.saveItem('storage.manage.inventories_suppliers', {
      title: 'ספקים',
      state: 'app.inventories_suppliers',
      weight: 7,
      permission: "storage",
    });

//Inventories
    msApiProvider.register('or.inventories.orders', ['inventories/orders']);
    msApiProvider.register('or.inventories.orderdetails', ['inventories/orders/:orderid']);
    msApiProvider.register('or.inventories.editorderdetails', ['inventories/orders/edit/:orderid']);
    msApiProvider.register('or.inventories.edit_status', ['inventories/orders/status/update']);
    msApiProvider.register('or.inventories.item.edit_status', ['inventories/order_item/status/update']);
    msApiProvider.register('or.inventories.items', ['inventories/items']);
    msApiProvider.register('or.inventories.suppliers', ['inventories/suppliers']);
    msApiProvider.register('or.inventories.statuses', ['inventories/statuses']);
    msApiProvider.register('or.inventories.tracking', ['inventories/tracking']);
    msApiProvider.register('or.inventories.tracking.history', ['inventories/tracking_history']);

  }

})();

(function () {
  'use strict';

  angular
    .module('app.inventories')
    .controller('InventoriesTrackingHistoryController', InventoriesTrackingHistoryController);

  /** @ngInject */
  function InventoriesTrackingHistoryController(TrackingData, Places, Items, inventoriesService, orUserAccount, $filter, $state, $mdDialog) {

    var vm = this;
    // data

    vm.selectedIndex = 0;
    vm.clientsSearch;
    vm.data = TrackingData;
    vm.feilds = [
      {key: 'date', name: 'תאריך', type: "date"},
      {key: 'item_name', name: 'שם מוצר'},
      {key: 'count', name: 'כמות'},
      {key: 'employee_name', name: 'עובד'},
      {key: 'admin_name', name: 'מחסן'},
      {key: 'place_name', name: 'סניף', filter: true}
    ];
    vm.editfeilds = [
      // {key: 'item_name', name: 'שם מוצר'},
      // {key: 'place_name', name: 'סניף'},
      {key: 'item_id', name: 'מוצר', required: true, select: {data: Items, key: 'ID', value: 'nameWithSupplier'}},
      {key: 'place_id', name: 'סניף', required: true, select: {data: Places, key: 'PlaceID', value: 'Name'}},
      {key: 'count', name: 'כמות', type: "number"},

    ]

    vm.InsertRow = function (item) {
      console.log("vm.InsertRow..")
      console.log(item)
      vm.proccess = true;
      inventoriesService.UpdateTrackingData(item).then(function () {
        vm.proccess = false;
      });
    }

    vm.config2 = {
      "title": "מצב מלאי סניפים ליום #" + moment().format()
    }
    vm.config = {
      default_Item: {
        count: 1,
        item_id:2,
        place_id: 61
      }
      // rowClick: {
      //   type: 'click',
      //   func: function (item) {
      //     if (Order.status < 4) {
      //       var confirm = $mdDialog.confirm()
      //         .title('אישור פריט')
      //         .textContent('לחץ על אישור כדי לאשר פריט זה להזמנה')
      //         //.placeholder('הקש קוד מנהל')
      //         .ariaLabel('Dog name')
      //         //.initialValue()
      //         //  .targetEvent(ev)
      //         //.required(true)
      //         .ok('מאושר')
      //         .cancel('לא מאושר');
      //
      //       $mdDialog.show(confirm).then(function (result) {
      //         if (!item.status) {
      //           item.status = true;
      //           item.adminConfirmation = orUserAccount.Admin_user.nameHE;
      //           inventoriesService.itemEdit_status(item);
      //         }
      //       }, function () {
      //         if (item.status) {
      //           item.status = false;
      //           item.adminConfirmation = undefined;
      //           inventoriesService.itemEdit_status(item);
      //         }
      //       });
      //     }
      //     else {
      //       $mdDialog.show(
      //         $mdDialog.alert()
      //           .clickOutsideToClose(true)
      //           .title("סטטוס הזמנה: " + Order.status_name)
      //           .textContent("לא ניתן לערוך פריטים")
      //           .ariaLabel('Alert Dialog Demo')
      //           .ok('סגור')
      //         // .targetEvent(ev)
      //       );
      //     }
      //   }
      // }
    }


  }

})();

(function () {
  'use strict';

  angular
    .module('app.inventories')
    .controller('InventoriesTrackingController', InventoriesTrackingController);

  /** @ngInject */
  function InventoriesTrackingController(TrackingData, inventoriesService, orUserAccount, $filter, $state, $mdDialog) {

    var vm = this;
    // data

    vm.selectedIndex = 0;
    vm.clientsSearch;
    vm.data = TrackingData;
    vm.feilds = [
      //{key: 'ClientID', name: 'קוד לקוח'},
      // {key: 'ID', name: 'מספר'},
      {key: 'item_id', name: 'מזהה מוצר'},
      {key: 'product_name', name: 'שם מוצר',filter:true},
      {key: 'balance', name: 'יתרה'},
      {key: 'place_name', name: 'סניף',filter:true}
    ];


    vm.config2 = {
      "title": "מצב מלאי סניפים ליום #" + moment().format()
    }
    vm.config = {
      rowClick: {
        type: 'click',
        func: function (item) {
          if (Order.status < 4) {
            var confirm = $mdDialog.confirm()
              .title('אישור פריט')
              .textContent('לחץ על אישור כדי לאשר פריט זה להזמנה')
              //.placeholder('הקש קוד מנהל')
              .ariaLabel('Dog name')
              //.initialValue()
              //  .targetEvent(ev)
              //.required(true)
              .ok('מאושר')
              .cancel('לא מאושר');

            $mdDialog.show(confirm).then(function (result) {
              if (!item.status) {
                item.status = true;
                item.adminConfirmation = orUserAccount.Admin_user.nameHE;
                inventoriesService.itemEdit_status(item);
              }
            }, function () {
              if (item.status) {
                item.status = false;
                item.adminConfirmation = undefined;
                inventoriesService.itemEdit_status(item);
              }
            });
          }
          else {
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .title("סטטוס הזמנה: " + Order.status_name)
                .textContent("לא ניתן לערוך פריטים")
                .ariaLabel('Alert Dialog Demo')
                .ok('סגור')
              // .targetEvent(ev)
            );
          }
        }
      }
    }

    vm.UpdateStatus = function (statusVar) {
      var content = 'לחץ על אישור כדי לאשר הזמנה'
      if (statusVar && statusVar == 5)
        content = "האם להפיק כעת תעודת משלוח?"
      else
        content += " (" + vm.items_ship.length + " מתוך " + vm.order.items.length + " אושרו)"
      var confirm = $mdDialog.confirm()
        .title('אישור ביצוע פעולה בהזמנה')
        .textContent(content)
        //.placeholder('הקש קוד מנהל')
        .ariaLabel('Dog name')
        //.initialValue()
        //  .targetEvent(ev)
        //.required(true)
        .ok('מאושר')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        vm.proccess = true;
        Order.status_old = Order.status;
        Order.status_name_old = Order.status_name;
        var options;
        if (statusVar && statusVar == 5)
          options = {toship: statusVar == 5};
        inventoriesService.ChangeStatusInventory(Order, options).then(function (result) {
          vm.proccess = false;
          var content = '';
          var msg = 'הזמנה אושרה';
          if (options.toship) {
            msg = 'תעודת משלוח נוצרה';
            vm.selectedIndex = 2;
          }
          console.log("status status", result);
          if (!result.status) {
            msg = 'ארעה שגיאה', content = 'נסה שנית';
            Order.status = Order.status_old;//Send
            Order.status_name = Order.status_name_old;
          }

          $mdDialog.show(
            $mdDialog.alert()
              .clickOutsideToClose(true)
              .title(msg)
              .textContent(content)
              .ariaLabel('Alert Dialog Demo')
              .ok('סגור')
            // .targetEvent(ev)
          );
        });
      }, function () {

      });
    }
    vm.sendOrder = function (cancel) {


    }
    vm.disabledStatus = function (status) {
      if (status > 5)
        return true;
      return false;
    }
    vm.selectStatus = function (status) {
      vm.order.status = status;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.inventories')
    .controller('InventoriesSuppliersController', InventoriesSuppliersController);

  /** @ngInject */
  function InventoriesSuppliersController(Suppliers, inventoriesService, orUserAccount, $filter, $state, $mdDialog) {

    var vm = this;
    // data

    vm.selectedIndex = 0;
    vm.clientsSearch;
    vm.data = Suppliers;
    vm.feilds = [
      {key: 'ID', name: 'מזהה'},
      {key: 'name', name: 'שם ספק'},
      {key: 'address', name: 'כתובת'},
      {key: 'phone', name: 'טלפון'},
      {key: 'email', name: 'אימייל'},
      {key: 'comments', name: 'הערות'}
    ];
    vm.editfeilds = [
      {key: 'name', name: 'שם ספק', required: true},
      {key: 'address', name: 'כתובת'},
      {key: 'phone', name: 'טלפון'},
      {key: 'email', name: 'אימייל'},
      {key: 'comments', name: 'הערות'}
      // {key: 'place_id', name: 'סניף', required: true, select: {data: Places, key: 'PlaceID', value: 'Name'}},

    ]

    vm.InsertRow = function (item) {
      console.log("vm.InsertRow..")
      console.log(item)
      vm.proccess = true;
      item.isNew = true;
      inventoriesService.UpdateSuppliers(item).then(function () {
        vm.proccess = false;
      });
    }
    vm.EditRow = function (item) {
      console.log("vm.EditRow..")
      console.log(item)
      vm.proccess = true;
      inventoriesService.UpdateSuppliers(item).then(function () {
        vm.proccess = false;
      });
    }

    vm.config2 = {
      "title": "מצב מלאי סניפים ליום #" + moment().format()
    }
    vm.config = {
      default_Item: {
        count: 1,
        item_id: 2,
        place_id: 61
      }
      // rowClick: {
      //   type: 'click',
      //   func: function (item) {
      //     if (Order.status < 4) {
      //       var confirm = $mdDialog.confirm()
      //         .title('אישור פריט')
      //         .textContent('לחץ על אישור כדי לאשר פריט זה להזמנה')
      //         //.placeholder('הקש קוד מנהל')
      //         .ariaLabel('Dog name')
      //         //.initialValue()
      //         //  .targetEvent(ev)
      //         //.required(true)
      //         .ok('מאושר')
      //         .cancel('לא מאושר');
      //
      //       $mdDialog.show(confirm).then(function (result) {
      //         if (!item.status) {
      //           item.status = true;
      //           item.adminConfirmation = orUserAccount.Admin_user.nameHE;
      //           inventoriesService.itemEdit_status(item);
      //         }
      //       }, function () {
      //         if (item.status) {
      //           item.status = false;
      //           item.adminConfirmation = undefined;
      //           inventoriesService.itemEdit_status(item);
      //         }
      //       });
      //     }
      //     else {
      //       $mdDialog.show(
      //         $mdDialog.alert()
      //           .clickOutsideToClose(true)
      //           .title("סטטוס הזמנה: " + Order.status_name)
      //           .textContent("לא ניתן לערוך פריטים")
      //           .ariaLabel('Alert Dialog Demo')
      //           .ok('סגור')
      //         // .targetEvent(ev)
      //       );
      //     }
      //   }
      // }
    }


  }

})();

(function () {
  'use strict';

  angular
    .module('app.inventories')
    .controller('InventoriesOrderController', InventoriesOrderController);

  /** @ngInject */
  function InventoriesOrderController(Order, Statuses, inventoriesService, orUserAccount, $filter, $state, $mdDialog) {

    var vm = this;
    // data
    vm.order = Order;
    Order.date_created = new Date(Order.date_created);
    if (!Order) {
      $state.go('app.inventories');
      return;
    }
    vm.selectedIndex = 0;
    vm.clientsSearch;

    vm.feilds = [
      //{key: 'ClientID', name: 'קוד לקוח'},
      // {key: 'ID', name: 'מספר'},
      {key: 'itemName', name: 'מוצר'},
      {key: 'count', name: 'כמות להזמנה'},
      {key: 'count_in_package', name: 'יחידות באריזה'},
      {key: 'itemComments', name: 'הערות'},
      {key: 'status', name: 'סטאטוס', type: 'bool'},
      {key: 'adminConfirmation', name: 'מנהל מאשר'}
    ];

    vm.feilds_ship = [
      {key: 'itemName', name: 'מוצר'},
      {key: 'count', name: 'כמות להזמנה'},
      {key: 'itemComments', name: 'הערות'},
      {key: 'adminConfirmation', name: 'מנהל מאשר'}
    ];
    vm.items_ship = $filter('filter')(vm.order.items, {status: true});

    vm.statuses_option = Statuses;
    // vm.feildsedit = [
    //   {key: 'itemName', name: 'מוצר', readOnly: true},
    //   {key: 'count', name: 'כמות', type: "number", required: true, min: "min_per_order", max: "max_per_order"},
    //   {
    //     key: 'item_id', name: 'בחר מוצר', required: true, showgroup: true,
    //     select: {
    //       data: Products, key: 'ID', value: 'nameWithSupplier'
    //     }
    //   }
    // ],
    vm.config2 = {
      "title": "תעודת משלוח מספר #" + vm.order.ID,
      description: "סניף: " + vm.order.placeName + ". [" + vm.order.comments_place ? vm.order.comments_place : "" + "]"
    }
    vm.config = {
      "title": "פירוט הזמנה מס #" + vm.order.ID,
      //description: "סניף: ששש" + vm.order.placeName + ". [" + vm.order.comments_place ? vm.order.comments_place : "" + "]",
      description: "סניף: " + vm.order.placeName + ". [" + (vm.order.comments_place ? vm.order.comments_place : "") + "]",

      rowClick: {
        type: 'click',
        func: function (item) {
          if (Order.status < 4) {
            var confirm = $mdDialog.confirm()
              .title('אישור פריט')
              .textContent('לחץ על אישור כדי לאשר פריט זה להזמנה')
              //.placeholder('הקש קוד מנהל')
              .ariaLabel('Dog name')
              //.initialValue()
              //  .targetEvent(ev)
              //.required(true)
              .ok('מאושר')
              .cancel('לא מאושר');

            $mdDialog.show(confirm).then(function (result) {
              if (!item.status) {
                item.status = true;
                item.adminConfirmation = orUserAccount.Admin_user.nameHE;
                inventoriesService.itemEdit_status(item);
              }
            }, function () {
              if (item.status) {
                item.status = false;
                item.adminConfirmation = undefined;
                inventoriesService.itemEdit_status(item);
              }
            });
          }
          else {
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .title("סטטוס הזמנה: " + Order.status_name)
                .textContent("לא ניתן לערוך פריטים")
                .ariaLabel('Alert Dialog Demo')
                .ok('סגור')
              // .targetEvent(ev)
            );
          }
        }
      }
    }
    // vm.edit = function (item) {
    //   item.status = true;
    //   console.log("item to remove", item);
    // }

    // vm.refresh = function () {
    //   vm.clientsSearch = undefined;
    //   vm.proccess = true;
    //   inventoriesService.Orders(vm.search).then(function () {
    //     vm.proccess = false;
    //     vm.search = '';
    //     vm.inventories = Inventories;
    //   });
    //   vm.isCustomSearch = false;
    //
    // }
    vm.UpdateStatus = function (statusVar) {
      vm.items_ship = $filter('filter')(vm.order.items, {status: true});
      var content = 'לחץ על אישור כדי לאשר הזמנה'
      if (statusVar && statusVar == 5)
        content = "האם להפיק כעת תעודת משלוח?"
      else if (statusVar && statusVar == 6)
        content = "האם להוציא משלוח כעת? מלאי המחסן יתעדכן בהתאם"
      else if (!vm.items_ship.length)
        content = "כל המוצרים טרם אושרו - האם לאשר את כולם?"
      else
        content += " (" + vm.items_ship.length + " מתוך " + vm.order.items.length + " אושרו)"

      var confirm = $mdDialog.confirm()
        .title('אישור ביצוע פעולה בהזמנה')
        .textContent(content)
        //.placeholder('הקש קוד מנהל')
        .ariaLabel('Dog name')
        //.initialValue()
        //  .targetEvent(ev)
        //.required(true)
        .ok('מאושר')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        vm.proccess = true;
        Order.status_old = Order.status;
        Order.status_name_old = Order.status_name;
        var options = {};
        if (statusVar && statusVar == 5)
          options.toship = true;
        if (statusVar && statusVar == 6)
          options.shipped = true;
        if (!vm.items_ship.length) {
          angular.forEach(vm.order.items, function (item) {
            console.log(item);
            item.status = true;
            item.adminConfirmation = orUserAccount.Admin_user.nameHE;
            inventoriesService.itemEdit_status(item);
          });
        }
        inventoriesService.ChangeStatusInventory(Order, options).then(function (result) {
          vm.proccess = false;
          var content = '';
          var msg = 'הזמנה אושרה';
          if (options.toship) {
            msg = 'תעודת משלוח נוצרה';
            vm.selectedIndex = 2;
          }
          if (options.shipped) {
            msg = 'מלאי המחסן; התעדכן. מלאי הסניף יתעדכן לאחר אישור אספקה';
          }
          console.log("status status", result);
          if (!result.status) {
            msg = 'ארעה שגיאה', content = 'נסה שנית';
            Order.status = Order.status_old;//Send
            Order.status_name = Order.status_name_old;
          }

          $mdDialog.show(
            $mdDialog.alert()
              .clickOutsideToClose(true)
              .title(msg)
              .textContent(content)
              .ariaLabel('Alert Dialog Demo')
              .ok('סגור')
            // .targetEvent(ev)
          );
        });
      }, function () {

      });
    }
    vm.sendOrder = function (cancel) {


    }
    vm.disabledStatus = function (status) {
      if (status > 5)
        return true;
      return false;
    }
    vm.selectStatus = function (status) {
      vm.order.status = status;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.inventories')
    .controller('InventoriesItemsController', InventoriesItemsController);

  /** @ngInject */
  function InventoriesItemsController(Items, Suppliers, inventoriesService, orUserAccount, $filter, $state, $mdDialog) {

    var vm = this;
    // data

    vm.selectedIndex = 0;
    vm.clientsSearch;
    vm.data = Items;
    vm.feilds = [
      {key: 'ID', name: 'מזהה'},
      {key: 'name', name: 'שם מוצר'},
      {key: 'supplierName', name: 'ספק'},
      {key: 'price', name: 'מחיר', type: "customCurrency"},
      {key: 'count_in_package', name: 'כמות'},
      {key: 'min_per_order', name: 'מינימום'},
      {key: 'max_per_order', name: 'מקסימום'},
      {key: 'permission', name: 'נדרש אישור', type: "bool"},
      {key: 'comments', name: 'הערות'}

    ];
    vm.editfeilds = [
      {key: 'name', name: 'שם מוצר', required: true},
      // {key: 'supplierName', name: 'ספק',required: true},
      {key: 'price', name: 'מחיר', type: "customCurrency", required: true},
      {key: 'count_in_package', name: 'כמות', type: "number", required: true},
      {key: 'min_per_order', name: 'מינימום', type: "number", required: true},
      {key: 'max_per_order', name: 'מקסימום', type: "number", required: true},
      {key: 'supplier_id', name: 'ספק', required: true, select: {data: Suppliers, key: 'ID', value: 'name'}},
      {
        key: 'permission',
        name: 'נדרש אישור מיוחד',
        required: true,
        select: {data: [{key: 1, value: 'כן'}, {key: 0, value: 'לא'}], key: 'key', value: 'value'}
      },
      {key: 'comments', name: 'הערות'}

      // {key: 'place_id', name: 'סניף', required: true, select: {data: Places, key: 'PlaceID', value: 'Name'}},

    ]

    vm.InsertRow = function (item) {
      console.log("vm.InsertRow..")
      console.log(item)
      vm.proccess = true;
      item.isNew = true;
      inventoriesService.UpdateItemProduct(item).then(function () {
        vm.proccess = false;
      });
    }
    vm.EditRow = function (item) {
      console.log("vm.InsertRow..")
      console.log(item)
      vm.proccess = true;
      inventoriesService.UpdateItemProduct(item).then(function () {
        vm.proccess = false;
      });
    }

    vm.config2 = {
      "title": "מצב מלאי סניפים ליום #" + moment().format()
    }
    vm.config = {
      default_Item: {
        count: 1,
        item_id: 2,
        place_id: 61
      }
      // rowClick: {
      //   type: 'click',
      //   func: function (item) {
      //     if (Order.status < 4) {
      //       var confirm = $mdDialog.confirm()
      //         .title('אישור פריט')
      //         .textContent('לחץ על אישור כדי לאשר פריט זה להזמנה')
      //         //.placeholder('הקש קוד מנהל')
      //         .ariaLabel('Dog name')
      //         //.initialValue()
      //         //  .targetEvent(ev)
      //         //.required(true)
      //         .ok('מאושר')
      //         .cancel('לא מאושר');
      //
      //       $mdDialog.show(confirm).then(function (result) {
      //         if (!item.status) {
      //           item.status = true;
      //           item.adminConfirmation = orUserAccount.Admin_user.nameHE;
      //           inventoriesService.itemEdit_status(item);
      //         }
      //       }, function () {
      //         if (item.status) {
      //           item.status = false;
      //           item.adminConfirmation = undefined;
      //           inventoriesService.itemEdit_status(item);
      //         }
      //       });
      //     }
      //     else {
      //       $mdDialog.show(
      //         $mdDialog.alert()
      //           .clickOutsideToClose(true)
      //           .title("סטטוס הזמנה: " + Order.status_name)
      //           .textContent("לא ניתן לערוך פריטים")
      //           .ariaLabel('Alert Dialog Demo')
      //           .ok('סגור')
      //         // .targetEvent(ev)
      //       );
      //     }
      //   }
      // }
    }


  }

})();

(function () {
  'use strict';

  angular
    .module('app.insurance', [])
    .config(config)
    .filter('ReportInsuranseFilter', ReportInsuranseFilter);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.insurance_price', {
      url: '/insurance/prices',
      views: {
        'content@app': {
          templateUrl: 'app/main/insurance/prices/prices.html',
          controller: 'InsurancePriceController as vm'
        }
      },
      resolve: {
        InsurancePrices: function ($stateParams, insuranceService) {
          return insuranceService.InsurancePrices();
        }
      },
      bodyClass: 'profile'
    });

    $stateProvider.state('app.insurance_summary', {
      url: '/insurance/summary',
      views: {
        'content@app': {
          templateUrl: 'app/main/insurance/summary/summary.html',
          controller: 'InsuranceSummaryController as vm'
        }
      },
      resolve: {
        InsuranceSummary: function ($stateParams, insuranceService) {
          return insuranceService.InsuranceSummary();
        }
      },
      bodyClass: 'profile'
    });

    $stateProvider.state('app.insurance_reports', {
      url: '/insurance/reports',
      views: {
        'content@app': {
          templateUrl: 'app/main/insurance/reports/reports.html',
          controller: 'InsuranceReportController as vm'
        }
      },
      resolve: {
        InsuranceReport: function ($stateParams, insuranceService) {
          return insuranceService.InsuranceReport(undefined,3);
        }
      },
      bodyClass: 'profile'
    });

    $stateProvider.state('app.insurance_klalit_reports', {
      url: '/insurance/klalit-reports',
      views: {
        'content@app': {
          templateUrl: 'app/main/insurance/klalit-report/klalit-report.html',
          controller: 'InsuranceKlalitReportsController as vm'
        }
      },
      resolve: {
        InsuranceReport: function ($stateParams, insuranceService) {
          return insuranceService.InsuranceReport(undefined,14);
        }
      },
      bodyClass: 'profile'
    })


    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/profile');

    // Api

    // Navigation
    msNavigationServiceProvider.saveItem('reports', {
      title: 'ביטוחים',
      group: false,
      icon: 'icon-flag',
      rule: 1,
      weight: 2
    });
    msNavigationServiceProvider.saveItem('reports.insurance_price', {
      title: 'מחירון',
      rule: 2,
      state: 'app.insurance_price',
      weight: 1
    });
    msNavigationServiceProvider.saveItem('reports.insurance_summary', {
      title: 'סיכום',
      // icon: 'icon-account-box',
      state: 'app.insurance_summary',
      weight: 1,
      rule: 1
    });
    msNavigationServiceProvider.saveItem('reports.insurance_reports', {
      title: 'פירוט צילומים',
      // icon: 'icon-account-box',
      state: 'app.insurance_reports',
      weight: 1,
      rule: 1
    });
    msNavigationServiceProvider.saveItem('reports.insurance_klalit_reports', {
      title: 'כללית - הפניות',
      // icon: 'icon-account-box',
      state: 'app.insurance_klalit_reports',
      weight: 1,
      rule: 1
    });
  };

  function ReportInsuranseFilter() {
    return function (input, option, InsuranceID) {

      var output = [];

      // Do filter work here
      if ((!option || option == 0) && InsuranceID == 0)
        return input;
      else {
        for (var idx in input) {

          var item = input[idx];
          if (option == '0') {
            if (!InsuranceID || item.InsuranceID == InsuranceID)
              output.push(item);
          }
          else if (option == '1' && item.status == 10) {
            if (!InsuranceID || (item.InsuranceID == InsuranceID))
              output.push(item);
          }

          else if (option == 2 && item.status != 10) {
            if (!InsuranceID || (item.InsuranceID == InsuranceID))
              output.push(item);
          }
          else if (option == 3 && item.Price - item.Deductible == 0) {
            if (!InsuranceID || (item.InsuranceID == InsuranceID))
              output.push(item);
          }
        }
      }
      return output;

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.insurance')
    .controller('InsuranceSummaryController', InsuranceSummaryController);

  /** @ngInject */
  function InsuranceSummaryController(InsuranceSummary, insuranceService) {
    var vm = this;
    vm.reportType = 0;
    vm.dates = {start: new Date()};
    vm.data = InsuranceSummary;


    vm.InsuranceReports = {
      feilds: [
        {key: 'InsuranceID', name: 'מזהה'},
        {key: 'Name', name: 'ביטוח'},
        {key: 'countCopies', name: 'כמות צילומים'},
        {key: 'sumToPay', name: 'סכום', type: 'customCurrency'}
      ],
      data1: InsuranceSummary[0],
      data2: InsuranceSummary[1],
      configTbl: {
        title: 'דוח ביטוחים'
      }
    }
    vm.refresh = function (dates) {
      console.log(dates);
      vm.InsuranceReports.configTbl.title='דוח ביטוחים לתאריכים '+moment(vm.dates.start).format('DD/MM/YY')+' - '+moment(vm.dates.end).format('DD/MM/YY')
      vm.proccess = true;
      insuranceService.InsuranceSummary(dates).then(function (res) {
        vm.proccess = false;
      });
      //alert(dates.start);
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.insurance')
    .controller('InsuranceReportController', InsuranceReportsController);

  /** @ngInject */
  function InsuranceReportsController(InsuranceReport, $filter, $timeout, insuranceService, orContacts) {
    var vm = this;
    vm.reportType = 0;
    vm.dates = {start: new Date()};
    vm.data = InsuranceReport;
    vm.InsuranceID = 0;
    vm.feilds = [
      {key: 'KDate', name: 'תאריך', type: 'date', show: 'gt-lg'},
      {key: 'ClientID', name: 'קוד לקוח', show: 'gt-lg'},
      {key: 'TZ', name: 'ת.ז', show: 'gt-md'},
      {key: 'ClientName', name: 'שם פציינט'},
      {key: 'PhotoName', name: 'צילום', show: 'gt-md'},
      {key: 'DoctorName', name: 'רופא', filter: true, show: 'gt-xs'},
      {key: 'placeName', name: 'סניף', filter: true},
      {key: 'InsuranceName', name: 'ביטוח', filter: true},
      {key: 'reference', name: 'אסמכתא', show: 'gt-md'},
      {key: 'Price', name: 'מחיר', type: 'customCurrency'},
      {key: 'Deductible', name: 'השתתפות', type: 'customCurrency'},
      {key: 'mkt', name: 'מק"ט'},
      {key: 'HafnayaNumber', name: 'הפניה'},
      //{key: 'sum', name: 'הכנסות בפועל', type: 'customCurrency'},
      {key: 'status', name: 'סטאטוס', filter: true, show: 'gt-lg'}
    ]
    vm.factorPays = [];

    orContacts.GetFactorPays().then(function (factorPays) {
      console.log(factorPays);
      vm.factorPays = factorPays;
      vm.selectedItem = vm.factorPays[1];
      vm.insuranceid = vm.factorPays[1].BituahID;

    });
    vm.factorPaysFilter = function (text) {
      return $filter('filter')(vm.factorPays, text);
    }
    vm.searchTextChange = function (text) {

      // if (!$filter('filter')(vm.factorPays, text,true).length)
      //   vm.selectedItem = {BituahID: -1}
    }

    vm.refresh = function () {
      console.log(vm.dates);
      vm.proccess = true;
      insuranceService.InsuranceReport(vm.dates, vm.insuranceid).then(function (res) {
        vm.proccess = false;
      });
    }
    vm.focusSearch = function () {
      console.log('a')
      $timeout(function () {
        console.log('aaa')
        $('#s_search').focus();
      }, 500);
    }
    window.mdSelectOnKeyDownOverride = function (event) {
      event.stopPropagation();
      // NOTE: hack until this is fixed...
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.insurance')
    .controller('InsurancePriceController', InsurancePriceController);

  /** @ngInject */
  function InsurancePriceController(InsurancePrices, $mdToast, orContacts, $mdDialog, $document, insuranceService, $timeout, $filter, $state, orUserAccount) {
    var vm = this;
    vm.insuranceid = 3;
    vm.allowPage = true;// orUserAccount.Admin_user.rule == 10;
    vm.InsurancePrices = InsurancePrices;
    orContacts.GetFactorPays().then(function (factorPays) {
      console.log(factorPays);
      vm.factorPays = factorPays;
    });
    vm.addAgreement = function () {

      $mdDialog.show({
        controller: 'NewAgreementController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insurance/new_agreement/new_agreement.html',
        parent: angular.element($document.find('#content-container')),
        // targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {}
      }).then(function (insurance) {
        console.log(insurance);

        insuranceService.CreateAgreement(insurance).then(function (res) {
          console.log(res);
          var message = 'אירעה שגיאה';
          if (res.status) {
            message = 'הסכם נוסף בהצלחה';
            insuranceService.InsurancePrices(true);
            var newItem=res.data;
            vm.factorPays.push({BituahID: newItem.BituahID, Name: newItem.Name});
          }

          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
            hideDelay: 3000,
            position: 'top right',
            parent: '#content'
          });
        });


      });
      return;

    }
    vm.focusSearch = function () {
      console.log('a')
      $timeout(function () {
        console.log('aaa')
        $('#s_search').focus();
      }, 500);
    }
    window.mdSelectOnKeyDownOverride = function (event) {
      event.stopPropagation();
      // NOTE: hack until this is fixed...
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.insurance')
    .controller('NewAgreementController', NewAgreementController);

  /** @ngInject */
  function NewAgreementController($mdDialog,orContacts, msUtils, $filter) {
    var vm = this;

    vm.title = 'EDIT_CONTACT';

    vm.insurance = {photoprice:true}
    //vm.doctors = [{name: 'aaaaa'}, {name: 'bbbb'}, {name: 'aaaaa'}, {name: 'aacaa'}]
    //////////
    if (!vm.doctors) {
      orContacts.GetDoctors().then(function (doctors) {
        vm.doctors = doctors;
      });
    }
    var intervalCheck;
    vm.searchDoctor = function () {
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(deepSearch, 500);
    };

    var deepSearch = function (dates) {
      if (!vm.search||vm.search.length < 4 || vm.proccess)
        return;
      vm.proccess = true;

      orContacts.GetDoctors(vm.search).then(function () {
        vm.proccess = false;
      });

    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    function submit() {
      $mdDialog.hide(vm.insurance);
    }

    vm.closeDialog = closeDialog;
    vm.submit = submit;

  }
})();

(function () {
  'use strict';

  angular
    .module('app.insurance')
    .controller('InsuranceKlalitReportsController', InsuranceKlalitReportsController);

  /** @ngInject */
  function InsuranceKlalitReportsController(InsuranceReport, $filter, $timeout, $mdDialog, $mdToast,$document, insuranceService, orContacts) {
    var vm = this;
    vm.reportType = 0;
    vm.dates = {start: new Date()};
    vm.data = InsuranceReport;
    vm.insuranceid = 14;
    vm.feilds = [
      {key: 'KDate', name: 'תאריך', type: 'date', show: 'gt-lg'},
      {key: 'ClientID', name: 'קוד לקוח', show: 'gt-lg'},
      {key: 'TZ', name: 'ת.ז', show: 'gt-md'},
      {key: 'ClientName', name: 'שם פציינט'},
      {key: 'PhotoName', name: 'צילום', show: 'gt-md'},
      {key: 'DoctorName', name: 'רופא', filter: true, show: 'gt-xs'},
      {key: 'placeName', name: 'סניף', filter: true},
      //{key: 'InsuranceName', name: 'ביטוח', filter: true},
      {key: 'reference', name: 'אסמכתא', show: 'gt-md'},
      {key: 'Price', name: 'מחיר', type: 'customCurrency'},
      // {key: 'Deductible', name: 'השתתפות', type: 'customCurrency'},
      // {key: 'mkt', name: 'מק"ט'},
      {key: 'orderNumber', name: 'הפניה'},
      //{key: 'sum', name: 'הכנסות בפועל', type: 'customCurrency'},
      {key: 'status', name: 'סטאטוס', filter: true, show: 'gt-lg'},
      {
        key: '', name: '', type: 'button', onclick: function () {
        alert('clock');
      }
      },
    ];
    vm.config = {
      rowClick: {
        type: 'click',
        func: function (item) {
          item.isNew = item.orderNumber == undefined;
          var confirm = $mdDialog.prompt()
            .title('הזן מספר הזמנת רכש')
            .textContent('עבור קוד הפניה: ' + item.reference)
            .placeholder('PO2')
            .ariaLabel('Dog name')
            .initialValue(item.orderNumber)
            //.targetEvent(ev)
            .ok('אישור')
            .cancel('ביטול');
          $mdDialog.show(confirm).then(function (result) {
            // if (result && result.length === 13 && result.toUpperCase().indexOf('PO2') === 0) {
            if (result && result.length ) {
              item.orderNumber = result.toUpperCase();
              //save in db
              insuranceService.shelaSetOrderNumber(item).then(function (res) {
                console.log(res);
                var message = res.status ? 'Success' : 'Error';
                $mdToast.show({
                  template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                  hideDelay: 3000,
                  position: 'top right',
                  parent: '#content'
                });
              });
            } else {
              alert('מספר שגוי')
            }
          }, function () {
            //cancel
          })
        }
      }
    }
    vm.factorPays = [];


    vm.factorPaysFilter = function (text) {
      return $filter('filter')(vm.factorPays, text);
    }
    vm.searchTextChange = function (text) {

      // if (!$filter('filter')(vm.factorPays, text,true).length)
      //   vm.selectedItem = {BituahID: -1}
    }

    vm.refresh = function () {
      console.log(vm.dates);
      vm.proccess = true;
      //alert(vm.insuranceid)
      insuranceService.InsuranceReport(vm.dates, vm.insuranceid).then(function (res) {
        vm.proccess = false;
      });
    }
    vm.focusSearch = function () {
      console.log('a')
      $timeout(function () {
        console.log('aaa')
        $('#s_search').focus();
      }, 500);
    }
    window.mdSelectOnKeyDownOverride = function (event) {
      event.stopPropagation();
      // NOTE: hack until this is fixed...
    };

    vm.OpenUploadDialog = function (ev) {

      $mdDialog.show({
        controller: 'UploadController',
        controllerAs: 'vm',
        templateUrl: 'app/main/insurance/klalit-report/upload/upload.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        fullscreen: true,
        locals: {
          Profile: {}
        }
      }).then(function (status) {

      });

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.doctors')
    .controller('EmployeeCardController', EmployeeCardController);

  /** @ngInject */
  function EmployeeCardController(Employee, Employees, Places, $scope, $mdSidenav, msUtils, $mdDialog, $mdToast, $document, $state, $filter,
                                  orAdminService, orUserAccount) {

    var vm = this;
    // data

    vm.dates = {start: new Date()};
    vm.table = {
      feilds: [
        {key: 'Dates', name: 'יום', type: 'day'},
        {key: 'Dates', name: 'תאריך', type: 'date'},
        {key: 'TimeIN', name: 'כניסה', type: 'time'},
        {key: 'TimeOut', name: 'יציאה', type: 'time'},
        {key: 'duration_regular', name: 'ש. בסיס', type: 'number'},
        {key: 'duration_extra', name: 'ש. נוספות', type: 'number'},
        {key: 'durationH', name: 'סך שעות', type: 'number'},
        {key: 'PlaceCity', name: 'סניף'},
        {key: 'Notes', name: 'הערות'},
      ],
      edit: [
        {key: 'Dates', name: 'תאריך', type: 'date', required: true, icon: 'icon-account', readOnly: 'update'},
        {key: 'TimeIN', name: 'כניסה', type: 'time'},
        {key: 'TimeOut', name: 'יציאה', type: 'time'},
        {key: 'PlaceID', name: 'סניף', required: true, select: {data: Places, key: 'PlaceID', value: 'Name'}},
        {key: 'Notes', name: 'הערות', icon: 'icon-comment'}
      ],
      data: Employee,
      // config: {
      //   rowClick: {type: 'ref', ui_serf: 'app.employee_card', params: [{key: 'id', value: 'OvedID'}]}
      // }
    }
    if (!Employee) {
      Employee = {Name: 'All employees', OvedID: 0}
      vm.table.feilds.unshift({key: 'Name', name: 'שם'})
      vm.table.edit.unshift({key: 'Name', name: 'שם', readOnly: true});
      vm.table.data = Employee;
    }
    vm.employee = Employee;

    vm.removeItem = function (item) {
      item._action = 'remove';
      return vm.editItem(item);
    }
    function NoPermisssion() {
      if (orUserAccount.Admin_user.rule != 10) {
        var msg = 'הרשאה חסומה! נא לפנות למנהל כללי לצורך עריכת פרטים'
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + msg + '</div></md-toast>',
          hideDelay: 3000,
          position: 'top right',
          parent: '#content'
        });
        return;
      }
    }

    vm.editItem = (orUserAccount.Admin_user.rule != 10) ? NoPermisssion : function (item) {
      console.log('editItem');
      console.log(item);
      vm.proccess = true;

      var momDate = moment(item.Dates);
      if (item.TimeIN)
        item.TimeIN = moment(item.TimeIN).date(momDate.date()).month(momDate.month()).year(momDate.year()).toDate();
      if (item.TimeOut)
        item.TimeOut = moment(item.TimeOut).date(momDate.date()).month(momDate.month()).year(momDate.year()).toDate();
      orAdminService.UpdateEmployeeTimeWork(item).then(function (res) {
        vm.proccess = false;
        vm.refresh();
        console.log(res)
      })
    }
    vm.addEmployee = (orUserAccount.Admin_user.rule != 10) ? NoPermisssion : function (item) {
      console.log('addEmployee');
      console.log(item);
      item.Dates = moment(item.Dates).hours(10).toDate();
      var momDate = moment(item.Dates);
      if (item.TimeIN)
        item.TimeIN = moment(item.TimeIN).date(momDate.date()).month(momDate.month()).year(momDate.year()).toDate();
      if (item.TimeOut)
        item.TimeOut = moment(item.TimeOut).date(momDate.date()).month(momDate.month()).year(momDate.year()).toDate();
      item.OvedID = Employee.OvedID;
      vm.proccess = true;
      orAdminService.UpdateEmployeeTimeWork(item).then(function (res) {
        vm.proccess = false;
        vm.refresh();
        console.log(res)
      })
    }
    vm.removeEmployee = (orUserAccount.Admin_user.rule != 10) ? NoPermisssion : function (item) {
      console.log('removeEmployee');
      console.log(item);
      vm.proccess = true;
      orAdminService.UpdateEmployeeTimeWork(item).then(function (res) {
        vm.proccess = false;
        vm.refresh();
        console.log(res)
      })
    }

    vm.refresh = function () {
      vm.proccess = true;
      orAdminService.EmployeeTimeWork(Employee, vm.dates).then(function () {
        vm.proccess = false;
        console.log(Employee.timework);
      });
    }
    if (!Employee.timework) {
      vm.refresh();
    }
    vm.CurEmployee;
    vm.AllEmployees = Employees;
    vm.selectedItem = function (item) {
      console.log(item);
      if (item)
        orAdminService.GetEmployee(item.OvedID).then(function (data) {
          msUtils.setJsonObj(Employee, data);
          vm.refresh();
        });
    }
    vm.searchEmployee = function (search) {
      vm.AllEmployees = $filter('filter')(Employees, {Name: search});
      if (search.length < 2 || vm.proccess) {
        return vm.AllEmployees;
      }
      vm.proccess = true;
      orAdminService.GetEmployessList(search).then(function (data) {
        console.log(Employees.length);
        console.log(vm.AllEmployees.length);
        vm.AllEmployees = $filter('filter')(Employees, search);
        vm.proccess = false;
      });
      return vm.AllEmployees;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.doctors')
    .controller('DoctorCardController', DoctorCardController);

  /** @ngInject */
  function DoctorCardController(Doctor, $scope, $rootScope, $mdMedia, msUtils, $mdDialog, $mdToast, $document, $state, $interval, $filter,
                                orAdminService, Compare_reportsService) {

    var vm = this;
    // data
    $scope.$mdMedia = function (data) {
      if (!data)
        return true;
      return $mdMedia(data)
    };
    vm.dates = {start: new Date(), end: new Date()};
    vm.compare = {start: new Date(), end: new Date()};
    vm.doctor = Doctor;
    if (!Doctor.Prices) {
      orAdminService.PricesDoctor(Doctor);

    }
    if (!Doctor.Inbox) {
      orAdminService.InboxDoctor(Doctor);

    }
    vm.widget1 = {currentRange: "DT"};
    vm.changeDetails = changeDetails;
    vm.createPassword = createPassword;
    vm.cancelDoctorPermission = cancelDoctorPermission;
    vm.loginNewForm = {
      username: Doctor.username || angular.copy(Doctor.Email1)
    }
    vm.widget17 = {
      title: 'תרשים פציינטים',
      subtitle: 'שנה אחרונה / חודשי',
      chart1: vm.chart1,
      chart2: vm.chart2,
      chartDEMO: {
        columns: [
          {
            id: 'x',
            values: "09/01,10/01,11/01,12/01,13/01,14/01,15/01,16/01,17/01,18/01,19/01,20/01"
          },
          {
            id: 'Input',
            name: 'Patient',
            color: 'green',
            values: '2,4,0,3,1,6,0,0,2,1,3,4',
            type: 'spline'
          },
          {
            id: 'CT',
            name: 'CT',
            color: 'blue',
            values: '1,1,0,1,0,0,0,0,1,1,2,1',
            type: 'spline'
          }
          ,
          {
            id: 'Panu',
            name: 'Panoramic',
            color: 'orange',
            values: '0,4,0,2,1,2,0,1,1,1,2,0',
            type: 'spline'
          },
          {
            id: 'Other',
            name: 'Others',
            color: 'red',
            values: '0,0,3,1,1,0,0,1,0,1,2,0',
            type: 'spline'
          }
        ]
      }
    };
    vm.tabstatus = 1;

    var LoadClientsDoctor = function () {
      vm.proccess = true;

      vm.compare.start = moment(vm.dates.start).add(-1, 'year').toDate();//.format('DD-MM-YY');
      vm.compare.end = moment(vm.dates.end).add(-1, 'year').toDate();//.format('DD-MM-YY');
      //vm.compare.isEqual=moment(vm.compare.start).format("MMM Do YY") ==moment(vm.compare.end).format("MMM Do YY");
      orAdminService.LoadClientsDoctor(Doctor, vm.dates).then(function () {
        vm.proccess = false;
        //setChart();
      })
    }
    /*var LoadPhotosDoctor = function () {
     vm.proccess = true;
     orAdminService.LoadPhotosDoctor(Doctor, vm.dates).then(function () {
     vm.proccess = false;
     });
     }*/
    var LoadChartDoctor = function () {
      vm.proccess = true;
      orAdminService.LoadChartDoctor(Doctor).then(function () {
        vm.proccess = false;
        setDataWidget1();
      });
    }
    if (vm.doctor.NoteOUT)
      vm.doctor.NoteOUT = vm.doctor.NoteOUT.replace(/\\n/g, '\n');
    if (!Doctor.ClientsData)
      LoadClientsDoctor();
    // if (!Doctor.Photos)
    //   LoadPhotosDoctor();
    //if (!Doctor.ChartData)
    //  LoadChartDoctor()

    vm.refresh = function () {
      LoadClientsDoctor();
      //LoadPhotosDoctor();
    }
    vm.reportType = 0;
    vm.PhotosTable = {
      feilds: [
        {key: 'ClientID', name: 'מזהה'},
      ]
    }
    vm.ClientsReports = {
      feilds: [
        {key: 'ClientID', name: 'מזהה'},
        {key: 'TZ', name: 'ת.ז.'},
        {key: 'ClientName', name: 'שם פציינט'},
        {key: 'KDate', name: 'תאריך', type: 'date'},
        {key: 'photoName', name: 'צילום', filter: true},
        {key: 'placeName', name: 'מכון', filter: true},
        {key: 'Price', name: 'מחיר', type: 'customCurrency'},
        {key: 'Deductible', name: 'השתתפות', type: 'customCurrency'},
        {key: 'InsuranceName', name: 'משלם', filter: true},
      ],
      edit: [
        {key: 'Name', name: 'רופא/מרפאה', required: true, icon: 'icon-account'},
        {key: 'Address', name: 'כתובת'},
        {key: 'Tel1', name: 'טלפון', minlength: 6, icon: 'icon-phone'},
        {key: 'Email1', name: 'אימייל', icon: 'icon-email'},
        {key: 'BirthDate', name: 'ת. לידה', type: 'date'},
        {key: 'NoteIN', name: 'הערות פנימיות', icon: 'icon-comment'},
        {key: 'NoteOUT', name: 'הערות למרפאה', icon: 'icon-comment'},
        {
          key: 'Sale',
          name: 'אחוזי הנחה כללי',
          icon: 'icon-percent',
          max: 100,
          min: 0,
          type: 'number',
          pattern: "/^[0-9]*$/"
        },
      ],
      //data: Doctor.ClientsData
    }

    vm.feildsPlaces = [
      {key: 'Name', name: 'סניף'},
      {key: 'countClients', name: 'פצייניטים'},
      {key: 'countPhotos', name: 'צילומים'},
      {key: 'Price', name: 'מחיר', type: 'customCurrency'},
      {key: 'Deductible', name: 'השתתפות', type: 'customCurrency'}
    ];
    vm.feildsInsurance = [
      {key: 'Name', name: 'ביטוח'},
      {key: 'countClients', name: 'פצייניטים'},
      {key: 'countPhotos', name: 'צילומים'},
      {key: 'Price', name: 'מחיר', type: 'customCurrency'},
      {key: 'Deductible', name: 'השתתפות', type: 'customCurrency'}
    ];
    vm.feildsByCategory = [
      {key: 'CategoryName', name: 'קטגוריה'},
      {key: 'countPhotos', name: 'כמות'}
    ];

    vm.config = {
      summarybycategory: {title: 'פירוט קטגוריות לרופא/מרפאה ' + Doctor.Name},
      summarybyinsurance: {title: 'פירוט לפי גורם משלם עבור רופא/מרפאה ' + Doctor.Name},
      clients: {title: 'פירוט פציינטים וצילומים לרופא/מרפאה ' + Doctor.Name},
      summarybyplaces: {title: 'פירוט סניפים לרופא/מרפאה ' + Doctor.Name},
      //rowClick: {type: 'ref', ui_serf: 'app.profile', params: [{key: 'id', value: 'ClientID'}]}
    }
    /*var d = {
     PhotoListID: 6,
     Name: "CT לסת שלמה עליונה",
     AdminID: 20,
     basePrice: 670,
     DoctorID: 8,
     doctorPrice: 250,
     priceFor: "doctor"
     };*/
    var openDialogMessage = function (message) {
      //alert(message.title);
      $mdDialog.show({
        controller: 'DoctorInboxController',
        controllerAs: 'vm',
        templateUrl: 'app/main/doctors/doctor-card/inbox/inbox.html',
        parent: angular.element($document.body),
        fullscreen: true,
        //targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          Message: message,
          Doctor: Doctor
        }
      }).then(function () {

      });
    }
    vm.sendNewMessage = function () {
      openDialogMessage({isnew: true, doctor_id: Doctor.DoctorID, messages: []});
    }
    vm.PricesDoctors = {
      feilds: [
        {key: 'Name', name: 'צילום'},
        {key: 'basePrice', type: 'customCurrency', name: 'מחירון'},
        {key: 'doctorPrice', type: 'customCurrency', name: 'מחיר רופא'},
      ],
      edit: [
        {key: 'Name', name: 'צילום', readOnly: true},
        {key: 'basePrice', name: 'מחירון', readOnly: true},
        {key: 'doctorPrice', name: 'מחיר רופא', required: true, min: 1, max: 2000, type: 'number'},
      ],
      config: {
        title: 'מחירון רופא',
        hideFotter: true
//        rowClick: {type: 'ref', ui_serf: 'app.doctors_card', params: [{key: 'id', value: 'DoctorID'}]}
      }

    }
    /*
     id: 2,
     title: "הודעה חשובה",
     date: "2018-07-10T11:59:03.970Z",
     archived: false,
     doctor_id: 840,
     lastMessage: "שלום שוב",
     lastDate: "2018-07-10T12:09:14.806Z",
     messageId: 2,
     total: 2,
     unread: 2,
     read: 0,
     mesContentID: 4,
     */
    vm.addressEncode = function (address) {
      return encodeURIComponent(address);
    }
    vm.InboxDoctors = {
      feilds: [
        {key: 'title', name: 'נושא'},
        {key: 'lastDate', type: 'datetime', name: 'תאריך'},
        {key: 'lastMessage', name: 'הודעה', show: 'gt-sm'},
        {
          key: 'unread', name: 'התקבל', type: 'icon', icon: 'icon-check-all', class: 'blue-fg', hideIf: function (item) {
          //console.log(item);
          return item.unread > 0;
        }
        },

      ],
      config: {
        title: 'תיבת הודעות',
        hideFotter: true,
        rowClick: {type: 'click', func: openDialogMessage},
        classFunc: function (item) {
          return (item.adminUnread > 0 ? 'text-bold' : '');
        }
      }

    }
    console.log('$mdMedia', $mdMedia('gt-sm'));
    var intervalCheck;

    function setDataWidget1() {
      var dateFilter = {};

      switch (vm.widget1.currentRange) {
        case "DY":
        default:
          dateFilter.start = moment().subtract(1, 'day');
          dateFilter.end = moment().subtract(1, 'day');
          break;
        case "DT":
          dateFilter.start = moment();
          dateFilter.end = moment();
          break;
        case "DW":
          dateFilter.start = moment().subtract(7, 'day');
          dateFilter.end = moment();
          break;
        case "DFM":
          dateFilter.start = moment().date(1);
          dateFilter.end = moment();
          break;
        case "DM":
          dateFilter.start = moment().subtract(1, 'month');
          dateFilter.end = moment();
          break;
        case "DYE":
          dateFilter.start = moment().subtract(1, 'year');
          dateFilter.end = moment();
          break;


      }

      var items = $filter('dateBetween')(Doctor.ChartData[0], 'dateWork', dateFilter.start, dateFilter.end)
      console.log(items);
      vm.widget1.countClients = 0;
      vm.widget1.countPhotos = 0;
      vm.widget1.Price = 0;
      vm.widget1.Deductible = 0;

      vm.widget1.ranges = {
        "DY": "אתמול",
        "DT": "היום",
        "DW": "שבוע",
        "DFM": "מתחילת החודש",
        "DM": "חודש",
        "DYE": "שנה"
      };

      items.map(function (item) {
        vm.widget1.countClients += item.countClients;
        vm.widget1.countPhotos += item.countPhotos;
        vm.widget1.Price += item.Price;
        vm.widget1.Deductible += item.Deductible;
      })


      vm.ChartWidget = {
        ranges: {
          "DAY": "יומי",
          "WEEK": "שבועי",
          "MONTH": "חודשי",
          "YEAR": "שנתי"
        },
        config: {
          refreshDataOnly: true,
          deepWatchData: true
        },
        options: {
          chart: {
            type: 'multiBarChart',
            color: ['#03a9f4', '#b3e5fc'],
            height: 420,
            margin: {
              top: 8,
              right: 16,
              bottom: 32,
              left: 32
            },
            clipEdge: true,
            groupSpacing: 0.3,
            reduceXTicks: false,
            stacked: true,
            duration: 250,
            x: function (d) {

              return d.x;
            },
            y: function (d) {
              return d.y;
            },
            yAxis: {
              tickFormat: function (d) {
                return d;
              }
            },
            legend: {
              margin: {
                top: 8,
                bottom: 32
              }
            },
            controls: {
              margin: {
                top: 8,
                bottom: 32
              }
            },
            tooltip: {
              gravity: 's',
              classes: 'gravity-s'
            }
          }
        },
        data: Doctor.ChartDataX[0].WEEK,
        changeRange: function (range) {
          vm.ChartWidget.currentRange = range;
          vm.ChartWidget.data = Doctor.ChartDataX[0][range];
          vm.ChartWidget.data2 = [Doctor.ChartDataX[1][range][0]];

          /**
           * Update main chart data by iterating through the
           * chart dataset and separately adding every single
           * dataset by hand.
           *
           * You MUST NOT swap the entire data object by doing
           * something similar to this:
           * vm.widget.mainChart.data = chartData
           *
           * It would be easier but it won't work with the
           * live updating / animated charts due to how d3
           * works.
           *
           * If you don't need animated / live updating charts,
           * you can simplify these greatly.
           */


        },
        init: function () {
          // Run this function once to initialize widget

          /**
           * Update the range for the first time
           */
          vm.ChartWidget.changeRange('WEEK');
        }
      }
      vm.ChartData2 = {
        "supporting": {
          widgets: {
            created: {
              data: [],//vm.dashboardData.widget5.supporting.created,
              chart: {
                data: []
              }
            },
            closed: {
              //data: vm.dashboardData.widget5.supporting.closed,
              chart: {
                data: []
              }
            }
          },
          "created": {
            "label": "Price",
            "count": 54,
            "chart": {
              "key": "Created",
              "values": [
                {"x": 0, "y": 5},
                {"x": 1, "y": 8},
                {"x": 2, "y": 5},
                {"x": 3, "y": 6},
                {"x": 4, "y": 7},
                {"x": 5, "y": 8},
                {"x": 6, "y": 7}
              ]
            }
          },
          "closed": {
            "label": "Copies",
            "count": 26,
            "chart": {
              "key": "Closed",
              "values": [
                {"x": 0, "y": 3},
                {"x": 1, "y": 2},
                {"x": 2, "y": 1},
                {"x": 3, "y": 4},
                {"x": 4, "y": 8},
                {"x": 5, "y": 8},
                {"x": 6, "y": 4}
              ]
            }
          },

        }
      }
      vm.ChartWidget.changeRange('WEEK');
    }


    vm.cahnge = function () {
      setDataWidget1();
      //alert(vm.widget1.currentRange);
    }
    vm.editPriceDoctor = function (item) {
      console.log('editPriceDoctor');
      if (!item.DoctorID)
        item.DoctorID = Doctor.DoctorID;
      console.log(item);
      vm.proccess = true;
      orAdminService.UpdatePricesDoctor(item).then(function (result) {
        if (result.status)
          orAdminService.PricesDoctor(Doctor);
        vm.proccess = false;
      });
    };
    vm.deletePriceDoctor = function (item) {
      console.log('deletePriceDoctor');
      item.doctorPrice = 0;
      console.log(item);
      vm.proccess = true;
      orAdminService.UpdatePricesDoctor(item).then(function (result) {
        if (result.status)
          orAdminService.PricesDoctor(Doctor);
        vm.proccess = false;
      });

    }
    vm.refreshCompare = function () {
      vm.proccess = true;
      orAdminService.CompareDoctors(Doctor, vm.dates, vm.compare).then(function (e) {
        vm.proccess = false;
      });
    }
    var deepSearch = function (dates) {
      if (vm.search.length < 3 || vm.proccess)
        return;
      vm.proccess = true;

      orAdminService.GetDoctorsList(vm.search).then(function () {
        vm.proccess = false;
      });

    }


    vm.compareReport = function (report) {
      console.log(vm.dates);
      switch (report) {
        case "sumbyplace":
          Compare_reportsService.SetDataSettings({
            date_A: vm.dates,
            date_B: vm.compare,
            doctor: Doctor,
            place: {PlaceID: 0, Name: 'כל הסניפים'}
          });

          break;
        case "summarybycategory":
          Compare_reportsService.SetDataSettings({
            date_A: vm.dates,
            date_B: vm.compare,
            category: {CategoryID: 0, CategoryName: 'כל הקטגוריות'},
            doctor: Doctor,
            reportType: 4
          });
          break;
        case "summarybyinsurance":
          Compare_reportsService.SetDataSettings({
            date_A: vm.dates,
            date_B: vm.compare,
            insuranse: {BituahID: 0, BituahName: 'הכל'},
            doctor: Doctor,
            reportType: 5
          });
          break;
      }
      $state.go('app.compare_reports');
    }
    /*From Template*/
    // Data
    //vm.dashboardData = DashboardData;
    // vm.projects = vm.dashboardData.projects;

    // Widget 1
    //vm.widget1 = vm.dashboardData.widget1;

    // Widget 2
    // vm.widget2 = vm.dashboardData.widget2;

    // Widget 3
    //vm.widget3 = vm.dashboardData.widget3;

    // Widget 4
    //vm.widget4 = vm.dashboardData.widget4;

    // Widget 5
    vm.widget5 = {
      //title: vm.dashboardData.widget5.title,
      mainChart: {
        config: {
          refreshDataOnly: true,
          deepWatchData: true
        },
        options: {
          chart: {
            type: 'multiBarChart',
            color: ['#03a9f4', '#b3e5fc'],
            height: 420,
            margin: {
              top: 8,
              right: 16,
              bottom: 32,
              left: 32
            },
            clipEdge: true,
            groupSpacing: 0.3,
            reduceXTicks: false,
            stacked: true,
            duration: 250,
            x: function (d) {
              return d.x;
            },
            y: function (d) {
              return d.y;
            },
            yAxis: {
              tickFormat: function (d) {
                return d;
              }
            },
            legend: {
              margin: {
                top: 8,
                bottom: 32
              }
            },
            controls: {
              margin: {
                top: 8,
                bottom: 32
              }
            },
            tooltip: {
              gravity: 's',
              classes: 'gravity-s'
            }
          }
        },
        data: []
      },
      // supporting: {
      //   widgets: {
      //     created: {
      //       data: vm.dashboardData.widget5.supporting.created,
      //       chart: {
      //         data: []
      //       }
      //     },
      //     closed: {
      //       data: vm.dashboardData.widget5.supporting.closed,
      //       chart: {
      //         data: []
      //       }
      //     },
      //     reOpened: {
      //       data: vm.dashboardData.widget5.supporting.reOpened,
      //       chart: {
      //         data: []
      //       }
      //     },
      //     wontFix: {
      //       data: vm.dashboardData.widget5.supporting.wontFix,
      //       chart: {
      //         data: []
      //       }
      //     },
      //     needsTest: {
      //       data: vm.dashboardData.widget5.supporting.needsTest,
      //       chart: {
      //         data: []
      //       }
      //     },
      //     fixed: {
      //       data: vm.dashboardData.widget5.supporting.fixed,
      //       chart: {
      //         data: []
      //       }
      //     }
      //   },
      //   chart: {
      //     config: {
      //       refreshDataOnly: true,
      //       deepWatchData: true
      //     },
      //     options: {
      //       chart: {
      //         type: 'lineChart',
      //         color: ['#03A9F4'],
      //         height: 420,
      //         margin: {
      //           top: 8,
      //           right: 0,
      //           bottom: 0,
      //           left: 0
      //         },
      //         isArea: true,
      //         interpolate: 'cardinal',
      //         clipEdge: true,
      //         duration: 250,
      //         showXAxis: false,
      //         showYAxis: false,
      //         showLegend: false,
      //         useInteractiveGuideline: true,
      //         x: function (d) {
      //           return d.x;
      //         },
      //         y: function (d) {
      //           return d.y;
      //         },
      //         yDomain: [0, 9],
      //         xAxis: {
      //           tickFormat: function (d) {
      //             return d.x;
      //           }
      //         },
      //         interactiveLayer: {
      //           tooltip: {
      //             gravity: 'e',
      //             classes: 'gravity-e'
      //           }
      //         }
      //       }
      //     },
      //     data: []
      //   }
      // },
      days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      // ranges: vm.dashboardData.widget5.ranges,
      currentRange: '',
      changeRange: function (range) {
        vm.widget5.currentRange = range;

        /**
         * Update main chart data by iterating through the
         * chart dataset and separately adding every single
         * dataset by hand.
         *
         * You MUST NOT swap the entire data object by doing
         * something similar to this:
         * vm.widget.mainChart.data = chartData
         *
         * It would be easier but it won't work with the
         * live updating / animated charts due to how d3
         * works.
         *
         * If you don't need animated / live updating charts,
         * you can simplify these greatly.
         */
        angular.forEach(vm.dashboardData.widget5.mainChart, function (chartData, index) {
          vm.widget5.mainChart.data[index] = {
            key: chartData.key,
            values: chartData.values[range]
          };
        });

        /**
         * Do the same thing for the supporting widgets but they
         * only have 1 dataset so we can do [0] without needing to
         * iterate through in their data arrays
         */
        angular.forEach(vm.dashboardData.widget5.supporting, function (widget, name) {
          /* vm.widget5.supporting.widgets[name].chart.data[0] = {
           key: widget.chart.key,
           values: widget.chart.values[range]
           };*/
        });
      },
      init: function () {
        // Run this function once to initialize widget

        /**
         * Update the range for the first time
         */
        //vm.widget5.changeRange('TW');
      }
    };

    // Widget 6
    // vm.widget6 = {
    //   title: vm.dashboardData.widget6.title,
    //   mainChart: {
    //     config: {
    //       refreshDataOnly: true,
    //       deepWatchData: true
    //     },
    //     options: {
    //       chart: {
    //         type: 'pieChart',
    //         color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
    //         height: 400,
    //         margin: {
    //           top: 0,
    //           right: 0,
    //           bottom: 0,
    //           left: 0
    //         },
    //         donut: true,
    //         clipEdge: true,
    //         cornerRadius: 0,
    //         labelType: 'percent',
    //         padAngle: 0.02,
    //         x: function (d) {
    //           return d.label;
    //         },
    //         y: function (d) {
    //           return d.value;
    //         },
    //         tooltip: {
    //           gravity: 's',
    //           classes: 'gravity-s'
    //         }
    //       }
    //     },
    //     data: []
    //   },
    //   footerLeft: vm.dashboardData.widget6.footerLeft,
    //   footerRight: vm.dashboardData.widget6.footerRight,
    //   ranges: vm.dashboardData.widget6.ranges,
    //   currentRange: '',
    //   changeRange: function (range) {
    //     vm.widget6.currentRange = range;
    //
    //     /**
    //      * Update main chart data by iterating through the
    //      * chart dataset and separately adding every single
    //      * dataset by hand.
    //      *
    //      * You MUST NOT swap the entire data object by doing
    //      * something similar to this:
    //      * vm.widget.mainChart.data = chartData
    //      *
    //      * It would be easier but it won't work with the
    //      * live updating / animated charts due to how d3
    //      * works.
    //      *
    //      * If you don't need animated / live updating charts,
    //      * you can simplify these greatly.
    //      */
    //     angular.forEach(vm.dashboardData.widget6.mainChart, function (data, index) {
    //       vm.widget6.mainChart.data[index] = {
    //         label: data.label,
    //         value: data.values[range]
    //       };
    //     });
    //   },
    //   init: function () {
    //     // Run this function once to initialize widget
    //
    //     /**
    //      * Update the range for the first time
    //      */
    //     vm.widget6.changeRange('TW');
    //   }
    // };


    $scope.options = {
      chart: {
        type: 'lineChart',
        height: 450,
        margin: {
          top: 20,
          right: 20,
          bottom: 40,
          left: 55
        },
        x: function (d) {
          return d.x;
        },
        y: function (d) {
          return d.y;
        },
        useInteractiveGuideline: true,
        dispatch: {
          stateChange: function (e) {
            console.log("stateChange");
          },
          changeState: function (e) {
            console.log("changeState");
          },
          tooltipShow: function (e) {
            console.log("tooltipShow");
          },
          tooltipHide: function (e) {
            console.log("tooltipHide");
          }
        },
        xAxis: {
          axisLabel: 'Time (ms)',

        },
        yAxis: {
          axisLabel: 'SUM - Shekel',
          tickFormat: function (d) {
            return d3.format('.02f')(d);
          },
          axisLabelDistance: -10
        },
        callback: function (chart) {
          console.log("!!! lineChart callback !!!");
        }
      },
      title: {
        enable: true,
        text: 'Title for Line Chart'
      },
      // subtitle: {
      //   enable: true,
      //   text: 'Subtitle for simple line chart. Lorem ipsum dolor sit amet, at eam blandit sadipscing, vim adhuc sanctus disputando ex, cu usu affert alienum urbanitas.',
      //   css: {
      //     'text-align': 'center',
      //     'margin': '10px 13px 0px 7px'
      //   }
      // },
      // caption: {
      //   enable: true,
      //   html: '<b>Figure 1.</b> Lorem ipsum dolor sit amet, at eam blandit sadipscing, <span style="text-decoration: underline;">vim adhuc sanctus disputando ex</span>, cu usu affert alienum urbanitas. <i>Cum in purto erat, mea ne nominavi persecuti reformidans.</i> Docendi blandit abhorreant ea has, minim tantas alterum pro eu. <span style="color: darkred;">Exerci graeci ad vix, elit tacimates ea duo</span>. Id mel eruditi fuisset. Stet vidit patrioque in pro, eum ex veri verterem abhorreant, id unum oportere intellegam nec<sup>[1, <a href="https://github.com/krispo/angular-nvd3" target="_blank">2</a>, 3]</sup>.',
      //   css: {
      //     'text-align': 'justify',
      //     'margin': '10px 13px 0px 7px'
      //   }
      // }
    };

    $scope.data = sinAndCos();

    /*Random Data Generator */
    function sinAndCos() {
      var sin = [], sin2 = [],
        cos = [];

      //Data is represented as an array of {x,y} pairs.
      for (var i = 0; i < 100; i++) {
        sin.push({x: i, y: Math.sin(i / 10)});
        sin2.push({x: i, y: i % 10 == 5 ? null : Math.sin(i / 10) * 0.25 + 0.5});
        cos.push({x: i, y: .5 * Math.cos(i / 10 + 2) + Math.random() / 10});
      }

      //Line chart data should be sent as an array of series objects.
      return [
        {
          values: sin,      //values - represents the array of {x,y} data points
          key: 'Sine Wave', //key  - the name of the series.
          color: '#ff7f0e',  //color - optional: choose your own line color.
          strokeWidth: 2,
          classed: 'dashed'
        },
        {
          values: cos,
          key: 'Cosine Wave',
          color: '#2ca02c'
        },
        /*{
         values: sin2,
         key: 'Another sine wave',
         color: '#7777ff',
         area: true      //area - set to true if you want this line to turn into a filled area chart.
         }*/
      ];
    };


    function changeDetails() {
      orAdminService.UpdateProfileDoctor(Doctor).then(function (result) {
        var msg = 'הפרטים לא עודכנו! אחד מהערכים אינם נכונים'
        if (result.status && result.updated) {
          msg = 'עודכן בהצלחה';
        }
        toastMessage(msg);
        $mdToast.show(
          $mdToast.simple()
            .textContent(msg)
            .position('top right')
            .hideDelay(4000)
        );
      }, function (err) {
        toastMessage('שגיאה');
      })
    }

    function createPassword() {
      vm.loginNewForm.DoctorID = Doctor.DoctorID;
      orAdminService.CreatePassword(vm.loginNewForm).then(function (result) {
        vm.loginDetails = {};
        if (result.status && result.updated) {
          Doctor.username = vm.loginNewForm.username;
          //vm.loginNewForm.pass='';
          toastMessage('עודכן בהצלחה');
        }
        else
          toastMessage('הפרטים לא עודכנו! אחד מהערכים אינם נכונים');
      }, function (err) {
        vm.loginDetails = {};
        toastMessage('שגיאה');
      })
    }

    function toastMessage(msg) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(msg)
          .position('top right')
          .hideDelay(4000)
      );
    }

    function cancelDoctorPermission(ev) {
      $mdDialog.show(
        $mdDialog.confirm()
          .clickOutsideToClose(true)
          .title('הסר גישה לרופא')
          .textContent('האם ברצונך להסיר גישה לרופא/מרפאה ' + Doctor.Name + '? ')
          .ariaLabel('Alert Dialog Demo')
          .ok('אישור')
          .cancel('ביטול')
          .targetEvent(ev)
      ).then(function () {
        orAdminService.DeleteAccessUserDoctor(Doctor.DoctorID).then(function (result) {
          var msg = 'הפרטים לא עודכנו!'
          if (result.status && result.updated) {
            Doctor.username = null;
            vm.loginNewForm.pass = '';
            msg = 'עודכן בהצלחה';
          }
          toastMessage(msg);
          $mdToast.show(
            $mdToast.simple()
              .textContent(msg)
              .position('top right')
              .hideDelay(4000)
          );
        }, function (err) {
          toastMessage('שגיאה');
        })
      }, function () {
        //alert(false)
      });
    }


    function setChart() {
      if (!vm.widgetChartDayli)
        vm.widgetChartDayli = {
          title: 'תרשים פציינטים',
          subtitle: 'בתקופה שנבחרה',
          chart: ConvertChart(vm.doctor.ClientsData.summarybydate)
        };
      else
        msUtils.setJsonObj(vm.widgetChartDayli.chart, ConvertChart(vm.doctor.ClientsData.summarybydate));

      return;
      var chart = vm.widgetChartDayli.chart;
      chart.columns[0].values = '';
      chart.columns[1].values = '';
      chart.columns[2].values = '';
      vm.doctor.ClientsData.summarybydate.map(function (item, index) {
        chart.columns[0].values += moment(item.dateWork).date() + '-' + (moment(item.dateWork).month() + 1) + '-' + moment(item.dateWork).year();
        chart.columns[1].values += item.countClients;
        chart.columns[2].values += item.countPhotos;
        //chart.columns[3].values += item.Price;

        if (index != (vm.doctor.ClientsData.summarybydate.length - 1)) {
          chart.columns[0].values += ',';
          chart.columns[1].values += ',';
          chart.columns[2].values += ',';
          //chart.columns[3].values += ',';
        }
      });
      setTimeout(function () {
        $rootScope.$$phase || $rootScope.$apply();
      }, 1500)

    }


    function ConvertChart(data, groupBy) {
      var chart = {
        columns: [{
          id: 'x',
          values: ""
        }, {
          id: 'Patient',
          name: 'Patient',
          color: 'green',
          values: '',
          type: 'bar'
        }, {
          id: 'Photos',
          name: 'Photos',
          color: 'blue',
          values: '',
          type: 'bar'//spline
        }, {
          id: 'Price',
          name: 'Price',
          color: 'red',
          values: '',
          type: 'bar'//spline
        }]
      };
      //{"dateWork":"2017-01-01T00:00:00.000Z","countClients":46,"countPhotos":84}

      data.map(function (item, index) {
        if (groupBy == 'month')
          chart.columns[0].values += (moment(item.dateWork).month() + 1) + '-' + moment(item.dateWork).year();
        else
          chart.columns[0].values += moment(item.dateWork).date() + '-' + (moment(item.dateWork).month() + 1) + '-' + moment(item.dateWork).year();
        chart.columns[1].values += item.countClients;
        chart.columns[2].values += item.countPhotos;
        //chart.columns[3].values += item.Price;

        if (index != (data.length - 1)) {
          chart.columns[0].values += ',';
          chart.columns[1].values += ',';
          chart.columns[2].values += ',';
          //chart.columns[3].values += ',';
        }
      });

      return chart;
    }
  }
})();

/**
 * Created by itzik on 10/04/2018.
 */
(function () {
  'use strict';

  angular
    .module('app.claims', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.claims', {
      url: '/claims',
      views: {
        'content@app': {
          templateUrl: 'app/main/claims/create_claim/create_claim.html',
          controller: 'createClaimController as vm'
        }
      },
      resolve: {}
    }).state('app.claims_list', {
      url: '/claimsList',
      views: {
        'content@app': {
          templateUrl: 'app/main/claims/claims_list/claims_list.html',
          controller: 'ClaimListController as vm'
        }
      },
      resolve: {
        ClaimList: function (insuranceService) {
          return insuranceService.ClaimList();
        }
      }
    }).state('app.claim_data', {
      url: '/claimData/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/claims/claim_data/claim_data.html',
          controller: 'ClaimDataController as vm'
        }
      },
      resolve: {
        Claim: function (insuranceService,$stateParams) {
          return insuranceService.GetClaim($stateParams.id);
        },
        ClaimStatuses:function (insuranceService) {
          return insuranceService.ClaimStatuses();
        }
      }
    });


    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/contacts');

    msNavigationServiceProvider.saveItem('claims', {
      title: 'תביעות',
      icon: 'icon-gavel',
      group: false,
      weight: 1,
      rule: 10,
    });
    msNavigationServiceProvider.saveItem('claims.new', {
      title: 'תביעה חדשה',
      state: 'app.claims',
      weight: 1,
      rule: 10,
    });
    msNavigationServiceProvider.saveItem('claims.list', {
      title: 'רשימת תביעות',
      state: 'app.claims_list',
      weight: 2,
      rule: 10,
    });

  }

})();

/**
 * Created by itzik on 10/04/2018.
 */
(function () {
  'use strict';

  angular
    .module('app.claims')
    .controller('createClaimController', createClaimController);

  /** @ngInject */
  function createClaimController(orContacts, insuranceService, $state, $filter, $scope, msUtils, $timeout) {
    var vm = this;
    vm.claim = {
      InsuranceID: 0,
      name: '', comments: '',
      dates: {start: moment(), end: moment()}
    }
    vm.createtype = 1;
    vm.maccabi = {};
    vm.meuhedet = {};
    vm.shela = {};
    vm.selectedAll = false;
    orContacts.GetFactorPays().then(function (factorPays) {
      console.log(factorPays);
      vm.factorPays = factorPays;

      var private_a = $filter('filter')(factorPays, {BituahID: 1}, true)[0];
      vm.maccabi.main = $filter('filter')(factorPays, {BituahID: 20}, true)[0];
      vm.meuhedet.main = $filter('filter')(factorPays, {BituahID: 21}, true)[0];
      vm.shela.main = $filter('filter')(factorPays, {BituahID: 14}, true)[0];

      private_a.hide = true;
      // vm.selectedItem = vm.factorPays[1];
      // vm.insuranceid = vm.factorPays[1].BituahID;

    });
    var selectInsuranse = function () {
      if (vm.claim.InsuranceID != 20)
        vm.claim.DoctorID = 20;
      else
        vm.claim.DoctorID = undefined;
      console.log(vm.claim.DoctorID);
      var item = $filter('filter')(vm.factorPays, {BituahID: vm.claim.InsuranceID}, true)[0];
      vm.claim.comments = item.Name;
      vm.claim.name = item.Name;
      $scope.searchInsurance = '';
    }

    var submit = function () {
      console.log(vm.claim);
      vm.proccess = true;

      var HMO_name;
      if (vm.claim.InsuranceID == 22 || vm.claim.InsuranceID == 14) {
        HMO_name = $filter('filter')(vm.shela.data, {id: vm.claim.HMO_Shela}, true)[0].Name;
      }
      if (vm.claim.InsuranceID == 20) {
        HMO_name = $filter('filter')(vm.maccabi.data, {id: vm.claim.HMO_Maccabi}, true)[0].Name;
      }
      if (vm.claim.InsuranceID == 21) {
        HMO_name = $filter('filter')(vm.meuhedet.data, {id: vm.claim.HMO_Meuhedte}, true)[0].Name;
      }
      var msgTitle = 'הנך עומד ליצור תביעה: ' + vm.claim.name + (HMO_name ? ' / ' + HMO_name : '');
      var msgContent = 'לטווח תאריכים ' + moment(vm.claim.dates.start).format('DD/MM/YY') + ' - ' + moment(vm.claim.dates.end).format('DD/MM/YY');


      msUtils.Prompt(msgTitle, msgContent, 'נא להזן קוד אבטחה').then(function (code) {
        if (!msUtils.CheckClaimCode(code)) {
          msUtils.Alert('קוד אבטחה שגוי', 'תביעות לא נוצרו');
          vm.proccess = false;
          return
        }
        insuranceService.CreateClaim(vm.claim).then(function (res) {
          console.log(res);

          vm.proccess = false;
          if (res.status) {
            if (res.data.len) {
              insuranceService.ClaimList(true);
              $state.go('app.claims_list');
            } else {
              msUtils.Alert('תביעה חדשה', 'לא נמצאו נתונים לתביעה')
            }
          } else {
            msUtils.Alert('תביעה חדשה', 'ארעה שגיאה')
          }
        });
      }, function () {
        vm.proccess = false;
      });
    }
    var submitGroup = function () {
      console.log(vm.claim);

      vm.proccess = true;
      var Insuranse = $filter('filter')(vm.factorPays, {selected: true}, true);
      var maccabi = $filter('filter')(vm.maccabi.data, {selected: true}, true);
      var meuhedet = $filter('filter')(vm.meuhedet.data, {selected: true}, true);
      var shela = $filter('filter')(vm.shela.data, {selected: true}, true);

      var countCl = Insuranse.length;
      if (maccabi.length)
        countCl += (maccabi.length - 1);
      if (meuhedet.length)
        countCl += (meuhedet.length - 1);
      if (shela.length)
        countCl += (shela.length - 1);
      var msgTitle = 'הנך עומד ליצור ' + countCl + ' תביעות. ';
      var msgContent = 'לטווח תאריכים ' + moment(vm.claim.dates.start).format('DD/MM/YY') + ' - ' + moment(vm.claim.dates.end).format('DD/MM/YY');
      msUtils.Prompt(msgTitle, msgContent, 'נא להזן קוד אבטחה').then(function (code) {
        if (!msUtils.CheckClaimCode(code)) {
          msUtils.Alert('קוד אבטחה שגוי', 'תביעות לא נוצרו');
          vm.proccess = false;
          return
        }
        insuranceService.CreateGroupClaim({
          dates: vm.claim.dates,
          factorPays: Insuranse,
          maccabi: maccabi,
          meuhedet: meuhedet,
          shela: shela,

        }).then(function (res) {
          console.log(res);

          vm.proccess = false;
          if (res.status) {
            insuranceService.ClaimList(true);
            $state.go('app.claims_list');
          }
        });

      });
    }
    var shortcutsClaim = function (HMO) {
      switch (HMO) {
        case 20:
          vm.maccabi.main.selected = !vm.maccabi.main.selected;
          vm.maccabi.main.selectedall = vm.maccabi.main.selected;

          vm.meuhedet.main.selected = false;
          vm.meuhedet.main.selectedall = false;
          vm.shela.main.selected = false;
          vm.shela.main.selectedall = false;
          break;
        case 21:
          vm.meuhedet.main.selected = !vm.meuhedet.main.selected;
          vm.meuhedet.main.selectedall = vm.meuhedet.main.selected;

          vm.maccabi.main.selected = false;
          vm.maccabi.main.selectedall = false;
          vm.shela.main.selected = false;
          vm.shela.main.selectedall = false;
          break;
        case 14:
          vm.shela.main.selected = !vm.shela.main.selected;
          vm.shela.main.selectedall = vm.shela.main.selected;

          vm.meuhedet.main.selected = false;
          vm.meuhedet.main.selectedall = false;
          vm.maccabi.main.selected = false;
          vm.maccabi.main.selectedall = false;
          break;
      }
    }
    insuranceService.GetDoctorsInsurance(20).then(function (res) {
      vm.maccabi.data = res.data;
    })
    insuranceService.GetDoctorsInsurance(21).then(function (res) {
      vm.meuhedet.data = res.data;
    })
    insuranceService.GetDoctorsInsurance(22).then(function (res) {
      vm.shela.data = res.data;
    });
    $scope.$watch('vm.selectedAll', function (newI, old) {
      if (newI !== 'undefined' && vm.maccabi.main) {
        vm.maccabi.main.selectedall = newI;
        vm.meuhedet.main.selectedall = newI;
        vm.shela.main.selectedall = newI;
        vm.factorPays.map(function (item) {
          item.selected = newI;
        });
        vm.factorPays[0].selected = false;
      }
    })
    $scope.$watch('vm.maccabi.main.selectedall', function (newI, old) {
      console.log('vm.maccabi.main.selectedall')
      console.log(newI)

      if (newI !== undefined && vm.maccabi.data) {
        vm.maccabi.data.map(function (item) {
          item.selected = newI;
        })
      }
    })
    $scope.$watch('vm.meuhedet.main.selectedall', function (newI, old) {
      console.log('vm.meuhedet.main.selectedall')
      console.log(newI)

      if (newI !== undefined && vm.meuhedet.data) {
        vm.meuhedet.data.map(function (item) {
          item.selected = newI;
        })
      }
    })
    $scope.$watch('vm.shela.main.selectedall', function (newI, old) {
      console.log('vm.shela.main.selectedall')
      console.log(newI)

      if (newI !== undefined && vm.shela.data) {
        vm.shela.data.map(function (item) {
          item.selected = newI;
        })
      }
    })
    vm.selectInsuranse = selectInsuranse;
    vm.submit = submit;
    vm.submitGroup = submitGroup;
    vm.shortcutsClaim = shortcutsClaim;

    window.mdSelectOnKeyDownOverride = function (event) {
      event.stopPropagation();
      // NOTE: hack until this is fixed...
    };
    vm.focusSearch = function (idx) {
      switch (idx) {
        case 1:
          $timeout(function () {
            $('#s_searchInsurance').focus();
          }, 500);

          break;
        case 2:
          $timeout(function () {
            $('#s_searchMaccabi').focus();
          }, 500);
          break;
        case 3:
          $timeout(function () {
            $('#s_searchMeuhedet').focus();
          }, 500);
          break;
        case 4:
          $timeout(function () {
            $('#s_searchShela').focus();
          }, 500);
          break;
      }
    }
  }
})();

/**
 * Created by itzik on 10/04/2018.
 */
(function () {
  'use strict';

  angular
    .module('app.claims')
    .controller('ClaimListController', ClaimListController);

  /** @ngInject */
  function ClaimListController(ClaimList, orContacts, insuranceService, $state) {
    var vm = this;
    vm.ClaimList = ClaimList;
    vm.feilds = [
      // {key: 'name', name: 'שם'},
      {key: 'ID', name: 'מספר'},
      {key: 'InsuranceName', name: 'ביטוח/מרפאה', filter: true},
      {key: 'date_created', name: 'תאריך', type: 'date'},
      //{key: 'date_closed', name: 'תאריך סגירה', type: 'date', show: 'gt-sm'},
      {key: 'range_start', name: 'טווח', type: 'date', show: 'gt-sm'},
      {key: 'range_end', name: 'עד לתאריך', type: 'date', show: 'gt-sm'},
      {key: 'name', name: 'הערות'},
      {key: 'statusName', name: 'סטאטוס', filter: true},
      {key: 'priceA', name: 'סכום',"type": "customCurrency"},
      {key: 'sumPaid', name: 'סך ששולם',"type": "customCurrency"}
    ];

    vm.configTbl= {title:'רשימת תביעות',rowClick: {type: 'ref', ui_serf: 'app.claim_data', params: [{key: 'id', value: 'ID'}]}}
  }
})();

/**
 * Created by itzik on 10/04/2018.
 */
(function () {
  'use strict';

  angular
    .module('app.claims')
    .controller('ClaimDataController', ClaimDataController);

  /** @ngInject */
  function ClaimDataController(Claim, ClaimStatuses, msUtils, insuranceService, $filter, $state) {
    var vm = this;
    vm.Claim = Claim;
    vm.ClaimStatuses = ClaimStatuses;

    vm.feilds = [
      {key: 'orderNumber', name: 'מ.רכש', show: 'gt-md'},
      {key: 'KDate', name: 'תאריך', type: 'date', show: 'gt-lg'},
      {key: 'HafnayaNumber', name: 'הפניה', show: 'gt-md'},
      {key: 'ClientName', name: 'שם פציינט'},
      {key: 'TZ', name: 'ת.ז', show: 'gt-md'},
      {key: 'mkt', name: 'מק"ט', show: 'gt-md'},
      {key: 'Deductible', name: 'השתתפות', type: 'customCurrency'},
      {key: 'PhotoName', name: 'צילום', show: 'gt-md'},
      {key: 'priceBefore', name: 'מחירון ללא מעמ', show: 'gt-md'},
      {key: 'Price', name: 'מחיר', type: 'customCurrency'},
      {key: 'reference', name: 'אסמכתא', show: 'gt-md'},

      {key: 'ClientID', name: 'קוד לקוח', show: 'gt-md'},
      {key: 'DoctorName', name: 'רופא', filter: true, show: 'gt-md'},
      {key: 'placeName', name: 'סניף', filter: true},
      {key: 'InsuranceName', name: 'ביטוח', filter: true},
      {key: 'sum_clain', name: 'סך תביעה', type: 'customCurrency', class: 'red-fg'},


      //{key: 'sum', name: 'הכנסות בפועל', type: 'customCurrency'},
      {key: 'statusName', name: 'סטאטוס', filter: true, show: 'gt-sm'}
    ]
    vm.feildsedit = [
      {key: 'ClientName', name: 'שם פציינט', readOnly: true, icon: 'icon-account'},
      {key: 'Price', name: 'מחיר', readOnly: true, type: 'customCurrency', icon: 'icon-currency-usd'},
      {
        key: 'claimStatus', name: 'סטאטוס', required: true, showgroup: true,
        select: {
          data: ClaimStatuses, key: 'ID', value: 'status'
        }
      },

    ],
      vm.configTbl = {
        title: 'רשימת צילומים לבקשה מס #' + Claim.ID,
        selectBox: true,
        // rowClick: {type: 'ref', ui_serf: 'app.claim_data', params: [{key: 'id', value: 'ID'}]}
      }
    vm.editItem = function (item) {
      console.log('editItem');
      console.log(item);
      var status = item.claimStatus;
      vm.proccess = true;


      if (Array.isArray(item)) {
        status = item[0].claimStatus;
        insuranceService.UpdateClaimPhotos(status, item).then(function (items) {

          vm.proccess = false;
        })
      } else {
        var mainItem = $filter('filter')(Claim.data, {ClientID: item.ClientID, PhotoID: item.PhotoID}, true)[0];
        insuranceService.UpdateClaimPhotos(status, [mainItem]).then(function (items) {
          vm.proccess = false;
        })
      }

    }
    vm.removeItem = function (item, isGroup) {
      var msgTitle = 'הסרת רשומה מתביעה';

      var msgContent = 'האם להמשיך?'

      msUtils.Prompt(msgTitle, msgContent, 'נא להזן קוד אבטחה').then(function (code) {
        if (!msUtils.CheckClaimCode(code)) {
          msUtils.Alert('קוד אבטחה שגוי', '');
          vm.proccess = false;
          return
        }
        vm.proccess = true;
        if (isGroup) {
          insuranceService.RemoveClaimPhotos(item).then(function (items) {
            vm.proccess = false;
            LoadDataClaim();
          })
        }
        else {
          var mainItem = $filter('filter')(Claim.data, {ClientID: item.ClientID, PhotoID: item.PhotoID}, true)[0];
          insuranceService.RemoveClaimPhotos([mainItem]).then(function (items) {
            vm.proccess = false;
            LoadDataClaim();
          })
        }
      });

    }

    var UpdateClaim = function () {
      vm.editMode = false;
      vm.proccess = true;

      insuranceService.UpdateClaim(Claim).then(function (res) {
        msUtils.Toast(res.status ? 'עודכן' : 'שגיאה');
        insuranceService.ClaimList(true);
        vm.proccess = false;
      })
    }
    var DeleteClaim = function () {
      //  msUtils.Confirm('מחיקה', 'האם אתה בטוח שברצונך למחוק תביעה זו?').then(function (e) {
      var msgTitle = 'מחיקת תביעה: ' + Claim.name;

      var msgContent = 'האם להמשיך?'
      console.log(Claim);
      msUtils.Prompt(msgTitle, msgContent, 'נא להזן קוד אבטחה').then(function (code) {
        if (!msUtils.CheckClaimCode(code)) {
          msUtils.Alert('קוד אבטחה שגוי', 'התביעה לא תימחק');
          vm.proccess = false;
          return
        }
        vm.editMode = false;


        vm.proccess = true;
        insuranceService.DeleteClaim(Claim).then(function (res) {
          vm.proccess = false;
          if (res.status) {
            insuranceService.ClaimList(true);
            $state.go('app.claims_list');
          }
        })
      })

    }
    if (!Claim.data) {
      LoadDataClaim();
    }
    function LoadDataClaim() {
      vm.proccess = true;
      insuranceService.LoadDataClaim(Claim).then(function () {
        vm.proccess = false;
      });
    }

    vm.UpdateClaim = UpdateClaim;
    vm.DeleteClaim = DeleteClaim;
  }
})();

/**
 * Created by itzik on 18/04/2018.
 */
/**
 * Created by itzik on 10/04/2018.
 */
(function () {
  'use strict';

  angular
    .module('app.bookkeeping', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.bookkeeping_new', {
      url: '/bookkeeping/new',
      views: {
        'content@app': {
          templateUrl: 'app/main/bookkeeping/create_doc/create_doc.html',
          controller: 'CreateDocsController as vm'
        }
      },
      resolve: {
        TAX: function (orSettinsgService) {
          return orSettinsgService.TAX();
        }
      }
    }).state('app.bookkeeping_new.receipt', {
      url: '/:type/:invoiceid',
      views: {
        'content@app': {
          templateUrl: 'app/main/bookkeeping/create_doc/create_doc.html',
          controller: 'CreateDocsController as vm'
        }
      }
    }).state('app.bookkeeping_list', {
      url: '/bookkeeping/docs_list',
      views: {
        'content@app': {
          templateUrl: 'app/main/bookkeeping/docs_list/docs_list.html',
          controller: 'DocsListController as vm'
        }
      },
      resolve: {

        Invoices: function (bookkeepingService) {
          return bookkeepingService.InvoicesList();
        },
        AccountStatus: function () {
          return {};
        }
      }
    }).state('app.bookkeeping_list.client', {
      url: '/:client',
      views: {
        'content@app': {
          templateUrl: 'app/main/bookkeeping/docs_list/docs_list.html',
          controller: 'DocsListController as vm'
        }
      },
      resolve: {

        Invoices: function (bookkeepingService, $stateParams) {
          return bookkeepingService.SearchInvoices({client_id: $stateParams.client});
        },
        AccountStatus: function (bookkeepingService, $stateParams) {
          return bookkeepingService.ClientAccountStatus($stateParams.client);
        }
      }
    }).state('app.bookkeeping_doc', {
      url: '/bookkeeping/doc/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/bookkeeping/doc/doc.html',
          // controller: 'DocController as vm'
        }
      },
      resolve: {}
    }).state('app.bookkeeping_clients', {
      url: '/bookkeeping/clients',
      views: {
        'content@app': {
          templateUrl: 'app/main/bookkeeping/clients/clients.html',
          controller: 'ClientsController as vm'
        }
      },
      resolve: {

        Clients: function (bookkeepingService) {
          return bookkeepingService.SearchClients();
        }
      }
    }).state('app.invoice_client', {
      url: '/bookkeeping/invoice/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/bookkeeping/invoice/views/solid/solid.html',
          controller: 'InvoiceController as vm'
        }
      },
      resolve: {
        Invoice: function (bookkeepingService, $stateParams) {
          return bookkeepingService.getInvoiceDoc($stateParams.id)
          //return {data:{number:5012354,date:moment().format('DD/MM/YYYY'),total:5401.50,client:{address:'הלוחמים 17'},title:'MR'}};//orContacts.getInvoice($stateParams.id)//84078139 msApi.resolve('invoice@get');
        }
      },
      bodyClass: 'invoice printable'
    })
      .state('app.invoice_client.original', {
        url: '/:original'
      });
    ;


    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/contacts');

    msNavigationServiceProvider.saveItem('bookkeeping', {
      title: 'הנהלת חשבונות',
      icon: 'icon-receipt',
      group: false,
      weight: 2,
      rule: 10,
    });
    msNavigationServiceProvider.saveItem('bookkeeping.new', {
      title: 'צור',
      state: 'app.bookkeeping_new',
      weight: 1,
      rule: 10,
    });
    msNavigationServiceProvider.saveItem('bookkeeping.list', {
      title: 'חשבוניות',
      state: 'app.bookkeeping_list',
      weight: 2,
      rule: 10,
    });
    msNavigationServiceProvider.saveItem('bookkeeping.clients', {
      title: 'לקוחות',
      state: 'app.bookkeeping_clients',
      weight: 3,
      rule: 10,
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('app.bookkeeping')
    .controller('InvoiceController', InvoiceController);

  /** @ngInject */
  function InvoiceController(Invoice, bookkeepingService, $state) {
    var vm = this;

    // Data
    Invoice.from = {
      title: 'סיטי צומת בע"מ',
      address: 'שבט לוי 23, פתח תקוה',
      phone: '1700-500-866',
      email: 'dudi@ct-zomet.co.il',
      website: 'https://or-hashen.co.il'
    }
    vm.invoice = Invoice;
    console.log(Invoice);

    // vm.invoice.original = $state.params.original == 'true';
    // Methods
    vm.print = function () {
      bookkeepingService.PrintDocument(Invoice);
      window.print();
    }
    //////////
  }
})();

/**
 * Created by itzik on 10/04/2018.
 */
(function () {
  'use strict';

  angular
    .module('app.bookkeeping')
    .controller('DocsListController', DocsListController);

  /** @ngInject */
  function DocsListController(Invoices, AccountStatus, $mdDialog, $document, msUtils, bookkeepingService) {
    var vm = this;
    vm.Invoices = Invoices;
    vm.feilds = [
      // {key: 'name', name: 'שם'},
      {key: 'doc_id', name: 'מספר'},
      {key: 'ClientName', name: 'לקוח'},
      {key: 'type', name: 'סוג מסמך', filter: true},
      {key: 'date', name: 'תאריך', type: 'date'},
      {key: 'amount', name: 'סכום', "type": "customCurrency"},
      {key: 'amountTax', name: 'מע"מ', "type": "customCurrency", hideNull: true},
      {key: 'amountIncluded', name: 'סך כולל', "type": "customCurrency", hideNull: true},
      {key: 'topay', name: 'יתרה לתש`', "type": "customCurrency", nghide: '0'},
      {
        key: 'closed', name: 'מצב', type: 'click', icon: 'icon-close-circle', value: 'תשלום וקבלה',
        onclick: {
          type: 'ref',
          ui_serf: 'app.bookkeeping_new.receipt',
          params: [{key: 'type', value: 'receipt', type: 'fixed'}, {key: 'invoiceid', value: 'doc_id'}]
        },
        ngshow: {value: 0}
      },
      {
        key: 'closed', name: 'זיכוי', type: 'click', icon: 'icon-close-circle', value: 'זיכוי',
        onclick: {
          type: 'ref',
          ui_serf: 'app.bookkeeping_new.receipt',
          params: [{key: 'type', value: 'credit', type: 'fixed'}, {key: 'invoiceid', value: 'doc_id'}]
        },
        ngshow: {value: 0},
        showFunc: function (item) {

          return item.doc_type == 2 && item.doc_id != '100010005';
        }
      },
      {key: 'copy', name: 'העתק', type: 'icon', icon: 'icon-content-copy', value: '1', class: 'red-fg'},

    ];

    vm.configTbl = {
      title: 'רשימת חשבוניות',
      rowClick: {type: 'ref', ui_serf: 'app.invoice_client', params: [{key: 'id', value: 'doc_id'}]}
    }

    vm.AccountStatus = AccountStatus.data;

    vm.SearchInvoice = function (ev) {



//321321
      $mdDialog.show({
        controller: 'ContactDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/bookkeeping/dialogs/contact/contact-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          client: {},
          Place: {}
        }
      }).then(function (dataSearch) {
        if (!dataSearch)
          return;
        if (!dataSearch.TZ && !dataSearch.ClientName && !dataSearch.amount && !dataSearch.KDate && !dataSearch.HeshbonitID) {
          var message = 'לא ניתן לבצע חיפוש. השלם לפחות שדה אחת';
          msUtils.Alert('שגיאה', message)
        } else {
          vm.proccess = true;

          bookkeepingService.SearchInvoices(dataSearch).then(function (result) {
            if (result.length)
              msUtils.setJsonObj(Invoices, result);
            else

              msUtils.Alert('חיפוש', 'לא נמצאו נתונים')
            console.log(result);
            vm.proccess = false;
          });
        }

      });

    }
  }
})();

/**
 * Created by itzik on 18/04/2018.
 */

/**
 * Created by itzik on 18/04/2018.
 */

(function () {
  'use strict';

  angular
    .module('app.bookkeeping')
    .controller('CreateDocsController', CreateDocsController);

  /** @ngInject */
  function CreateDocsController(bookkeepingService, TAX, $mdDialog, $state, msUtils, $scope, $document) {
    var vm = this;
    vm.bookkeepingClients = [];
    vm.invoice = {date: moment().format('DD-MM-YYYY'), amount: 250}
    console.log($state.params.invoiceid);
    vm.sumisIncluded = 1;
    var Invoice = {
      from: {
        title: 'סיטי צומת',
        address: 'כתובת ',
        phone: '03666555',
        email: 'email@or-hashen.co.il',
        website: 'or-hashen.co.il'
      },
      data: {doc_type: 2, date: moment().format('DD-MM-YYYY'), tax: TAX, description: ''},
      description: [{description: ''}],
      receipt: {typeOfReceipt: 1, checks: [], cash: {}}
    };
    if ($state.params && $state.params.invoiceid) {
      vm.proccess = true;
      Invoice.locked = true;
      bookkeepingService.getInvoiceDoc($state.params.invoiceid).then(function (result) {
        console.log('result invoice')
        console.log(result);
        Invoice.client = result.client;
        //amountIncluded-receiptAmount
        if ($state.params.type == 'receipt') {
          Invoice.receipt.amount = (parseFloat(result.data.amountIncluded) - parseFloat(result.data.receiptAmount || 0)).toFixed(2)
          Invoice.receipt.operation_id = result.data.operation_id;
          Invoice.receipt.invoiceid = result.data.doc_id;
          if (Invoice.receipt.amount <= 0) {
            msUtils.Alert('חשבונית סגורה', 'חשבונית זו שולמה במלואה');
            vm.blockedAction = true;

          }
          Invoice.data.doc_type = 6
          Invoice.description[0].description = 'תשלום חשבונית #' + $state.params.invoiceid;
          Invoice.data.amountIncluded = Invoice.receipt.amount;
        } else if ($state.params.type == 'credit') {
          Invoice.data.InvoiceID = $state.params.invoiceid;
          Invoice.data.doc_id = null;
          Invoice.data.doc_type = 5;
          Invoice.description[0].description = 'זיכוי חשבונית #' + $state.params.invoiceid;
          Invoice.data.amountIncluded = (parseFloat(result.data.amountIncluded) - parseFloat(result.data.receiptAmount || 0)).toFixed(2);
        }
        vm.proccess = false;
      })

    }

    vm.invoice = Invoice;
    vm.openCashDialog = openCashDialog;
    vm.openChecksDialog = openChecksDialog;
    vm.openTransferDialog = openTransferDialog;
    vm.openCreditCardDialog = openCreditCardDialog;
    vm.spliceDescription = spliceDescription;
    vm.addDescription = addDescription;
    $scope.$watch('vm.invoice.data.doc_type', function (newval) {
      var type = '';
      vm.showreceiptForm = false;
      vm.showInvoiceForm = false;
      switch (newval) {
        case 1:
          type = 'חשבונית מס קבלה';
          vm.showreceiptForm = true;
          vm.showInvoiceForm = true;
          break;
        case 2:
          type = 'חשבונית מס';
          vm.showInvoiceForm = true;
          break;
        case 3:
          type = 'חשבונית עסקה';
          vm.showInvoiceForm = true;
          break;
        case 4:
          type = 'חשבונית זיכוי קבלה';
          vm.showreceiptForm = true;
          break;
        case 5:
          type = 'חשבונית זיכוי מס';
          vm.showInvoiceForm = true;
          break;
        case 6:
          type = 'קבלה';
          vm.showreceiptForm = true;
          break;
      }
      vm.invoice.data.type = type;
    })
    $scope.$watch('vm.invoice.data.amount', function (newval) {
      if (vm.sumisIncluded == 1)
        return;

      if (newval) {
        /* if (typeof newval == 'string') {
         vm.invoice.data.amount = parseFloat(vm.invoice.data.amount);
         return;
         }*/
        console.log('$watch amount')
        vm.invoice.data.amountIncluded = (parseFloat(vm.invoice.data.amount) * (1 + (TAX * 0.01))).toFixed(2);
        vm.invoice.data.amountTax = (vm.invoice.data.amountIncluded - parseFloat(vm.invoice.data.amount)).toFixed(2);
        vm.invoice.receipt.amount = vm.invoice.data.amountIncluded;
      } else {
        vm.invoice.data.amountIncluded = 0;
        vm.invoice.receipt.amount = 0;
      }
    });
    $scope.$watch('vm.invoice.data.amountIncluded', function (newval) {
      if (vm.sumisIncluded == 2)
        return;
      if (newval) {

        console.log('$watch amountIncluded')
        vm.invoice.data.amount = (parseFloat(vm.invoice.data.amountIncluded) / (1 + (TAX * 0.01))).toFixed(3);
        vm.invoice.data.amountTax = (parseFloat(vm.invoice.data.amountIncluded) - vm.invoice.data.amount).toFixed(2);
        vm.invoice.receipt.amount = parseFloat(vm.invoice.data.amountIncluded);
      } else {
        vm.invoice.data.amount = 0;
        vm.invoice.receipt.amount = 0;
      }
    });
    $scope.$watch('vm.invoice.receipt.cash.amount', function (newval, oldval) {
      if (validateAmount(newval)) {
        vm.invoice.receipt.checks[0].amount = '';
        vm.invoice.receipt.transfer.amount = '';
      }
    });
    $scope.$watch('vm.invoice.receipt.checks[0].amount', function (newval, oldval) {
      if (validateAmount(newval)) {
        vm.invoice.receipt.cash.amount = '';
        vm.invoice.receipt.transfer.amount = '';
      }
    });
    $scope.$watch('vm.invoice.receipt.transfer.amount', function (newval, oldval) {
      if (validateAmount(newval)) {
        vm.invoice.receipt.checks[0].amount = '';
        vm.invoice.receipt.cash.amount = '';
      }


    });
    var validateAmount = function (amount) {
      if (!amount)
        return;
      vm.invoice.receipt.status = false;
      var amountFloat = parseFloat(amount);
      if (isNaN(amount)) {
        vm.invoice.err == 'נא להקיש ספרות בלבד'
        vm.invoice.receipt.checks[0].amount = '';
        vm.invoice.receipt.cash.amount = '';
      }
      if (isNaN(amountFloat)) {
        vm.invoice.receipt.checks[0].amount = '';
        vm.invoice.receipt.cash.amount = '';
      }
      if (parseInt(vm.invoice.data.doc_type) == 6 && amountFloat > vm.invoice.receipt.amount) {
        vm.invoice.err = 'סכום מקסימלי ' + vm.invoice.receipt.amount + ' ש"ח';
      } else if (parseInt(vm.invoice.data.doc_type) != 6 && amountFloat != vm.invoice.receipt.amount) {
        vm.invoice.err = 'סכום חייב להיות :  ' + vm.invoice.receipt.amount + ' ש"ח';
      } else {
        vm.invoice.receipt.status = true;
        return true;
      }
      return false;
    }
    vm.selectedItem = function (item) {
      console.log(item);
      vm.cl = item;
      vm.invoice.client = item;
      //vm.cl.date = moment().format('DD-MM-YYYY')
    }
    vm.search = function (search) {
      bookkeepingService.SearchClients(search).then(function (result) {
        console.log('search ' + search);
        console.log(result);
        msUtils.setJsonObj(vm.bookkeepingClients, result);
      })
      // return vm.bookkeepingClients;
    }
    vm.submit = function () {
      vm.proccess = true;
      vm.invoice.payments = vm.payments;
      console.log(vm.invoice);

      bookkeepingService.createInvoiceDoc(vm.invoice).then(function (result) {
        console.log(result.result);
        vm.proccess = false;
        if (result.status)
          $state.go('app.invoice_client', {id: result.result});
        else
          msUtils.Alert('שגיאה', 'מסמך לא נוצר. נסה שנית')
      });
    }

    function spliceDescription(index) {
      Invoice.description.splice(index, 1);
    }

    function addDescription(index) {
      Invoice.description.push({decription: ''});
    }

    vm.payments = {sumCashPrice: 0, sumChekPrice: 0, sumCreditCardPrice: 0, sumTransferPrice: 0};
    vm.checksArr = [{date: new Date()}];
    function openCashDialog(ev) {
      calculateReceipt();

      var max = (vm.invoice.data.doc_type == 1 ? vm.invoice.data.amountIncluded : vm.invoice.receipt.amount) - vm.payments.sumAllRecepts + vm.payments.sumCashPrice;

      var confirm = $mdDialog.prompt()
        .title('קבלת מזומן')
        .textContent('הקש סכום שנתקבל במזומן ולחץ על אישור')
        .placeholder('הזן מחיר')
        .ariaLabel('Dog name')
        .initialValue(max)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        if (isNaN(parseInt(result))) {
          $mdDialog.show(
            $mdDialog.alert()
            //.parent(angular.element(document.querySelector('#popupContainer')))
              .clickOutsideToClose(true)
              .title('שגיאה')
              .textContent('מחיר לא תקין! - ניתן להזין מספר בלבד')
              .ariaLabel('Alert Dialog Demo')
              .ok('סגור')
              .targetEvent(ev)
          );
        } else {
          //Profile.Receipts.sumCashPrice = parseInt(result);
          var resultParse = parseFloat(result);
          if (resultParse > max) {
            msUtils.Alert('סכום לא תקין', 'סכום גבוה מידי')
            return;
          }
          vm.payments.sumCashPrice = resultParse;
          if (vm.refund)
            vm.payments.sumCashPrice *= -1;
          calculateReceipt();
        }
      }, function () {
//        $scope.status = 'You didn\'t name your dog.';
      });
    }

    function calculateReceipt() {
      //Profile.Receipts.sumAllRecepts = Profile.Receipts.sumCashPrice + Profile.Receipts.sumChekPrice + Profile.Receipts.sumCreditCardPrice;
      vm.payments.sumAllRecepts = vm.payments.sumCashPrice + vm.payments.sumChekPrice + vm.payments.sumCreditCardPrice + vm.payments.sumTransferPrice;
    }

    function openChecksDialog(ev) {
      var max = (vm.invoice.data.doc_type == 1 ? vm.invoice.data.amountIncluded : vm.invoice.receipt.amount) - vm.payments.sumAllRecepts + vm.payments.sumChekPrice;

      calculateReceipt();
      $mdDialog.show({
        controller: 'ChecksDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/checks/checks.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          max: max,
          checksArr: vm.checksArr
        }
      }).then(function (checks) {
        if (checks) {
          vm.checksArr = checks;
          vm.payments.checks = checks
        }
        //Profile.Receipts.sumChekPrice = 0;
        var sumChecks = 0;
        for (var check in vm.payments.checks) {
          // Profile.Receipts.sumChekPrice += parseInt(vm.payments.checks[check].amount);
          sumChecks += parseInt(vm.payments.checks[check].amount);
        }
        if (sumChecks > max) {
          msUtils.Alert('סכום לא תקין', 'סכום גבוה מידי')
          return;
        }
        vm.payments.sumChekPrice = sumChecks;
        if (vm.refund)
          vm.payments.sumChekPrice *= -1;
        calculateReceipt();

      });
    }

    function openTransferDialog(ev) {

      calculateReceipt();
      var max = (vm.invoice.data.doc_type == 1 ? vm.invoice.data.amountIncluded : vm.invoice.receipt.amount) - vm.payments.sumAllRecepts + vm.payments.sumTransferPrice;

      if (!vm.payments.transfer) {
        vm.payments.transfer = {amount: max};
      }
      $mdDialog.show({
        controller: 'TransferDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/transfer/transfer.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          max: max,
          transferData: vm.payments.transfer
        }
      }).then(function (transfer) {
        if (transfer) {
          //vm.checksArr = checks;


          //Profile.Receipts.sumChekPrice = 0;

          if (transfer.amount > max) {
            msUtils.Alert('סכום לא תקין', 'סכום גבוה מידי')
            return;
          }
          vm.payments.sumTransferPrice = parseFloat(transfer.amount);
          vm.payments.transfer = transfer
        }
        if (vm.refund)
          vm.payments.sumChekPrice *= -1;
        calculateReceipt();

      });
    }

    function openCreditCardDialog(ev) {
      calculateReceipt();
      var max = (vm.invoice.data.doc_type == 1 ? vm.invoice.data.amountIncluded : vm.invoice.receipt.amount) - vm.payments.sumAllRecepts + vm.payments.sumCreditCardPrice;
      ;

      $mdDialog.show({
        controller: 'CreditDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/creditcard/creditcard.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          max: max,
          lastcach: vm.payments.creditcard,
          Client: {},
          IsRefund: vm.refund
        }
      }).then(function (pelecardDetails) {
        if (pelecardDetails) {
          vm.payments.pelecardDetails = pelecardDetails;
          // Profile.Receipts.sumCreditCardPrice = parseFloat(pelecardDetails.ResultData.DebitTotal) / 100;
          vm.payments.sumCreditCardPrice = parseFloat(pelecardDetails.ResultData.DebitTotal) / 100;
          if (vm.refund)
            vm.payments.sumCreditCardPrice *= -1;
          calculateReceipt();

          //if (vm.payments.sumAllRecepts == Profile.Receipts.firstToPay) {
          createInvoice();
          //}

        }
      });
    }
  }
})();

/**
 * Created by itzik on 10/04/2018.
 */
(function () {
  'use strict';

  angular
    .module('app.bookkeeping')
    .controller('ClientsController', ClientsController);

  /** @ngInject */
  function ClientsController(Clients, orContacts, $mdDialog, $document, msUtils, bookkeepingService) {
    var vm = this;
    vm.Clients = Clients;
    vm.factorPays = [];
    console.log(Clients);
    orContacts.GetFactorPays().then(function (factorPays) {
      console.log(factorPays);
      msUtils.setJsonObj(vm.factorPays, factorPays)

    });
    vm.table = {
      data: Clients,
      feilds: [
        // {key: 'name', name: 'שם'},
        {key: 'id', name: 'מספר'},
        {key: 'name', name: 'לקוח'},
        {key: 'contactName', name: 'איש קשר', filter: true},
        {key: 'email', name: 'אימייל'},
        {key: 'phone', name: 'טלפון'},
      ],
      edit: [
        {key: 'name', name: 'שם ', required: true, icon: 'icon-account'},
        {key: 'phone', name: 'טלפון', minlength: 6, icon: 'icon-phone'},
        {key: 'mobile', name: 'נייד', minlength: 6, icon: 'icon-cellphone-android'},
        {key: 'email', name: 'אימייל'},
        {key: 'contactName', name: 'איש קשר', icon: 'icon-credit-card'},
        {key: 'address', name: 'כתובת', icon: 'icon-home'},
        {key: 'city', name: 'עיר', icon: 'icon-comment'},
        {key: 'companyNumber', name: 'ח.פ', icon: 'icon-numeric'},
        {key: 'bituahID', name: 'הסכם קיים - אופציונלי', select: {data: vm.factorPays, key: 'BituahID', value: 'Name'}},

      ],
      configTbl: {
        title: 'רשימת לקוחות',
        rowClick: {type: 'ref', ui_serf: 'app.bookkeeping_list.client', params: [{key: 'client', value: 'id'}]}
      }
    }
    vm.editItem = function (item) {
      console.log(item);
      vm.proccess = true;
      bookkeepingService.ClientAction('edit', item).then(function (e) {
        bookkeepingService.SearchClients().then(function (result) {
          msUtils.setJsonObj(Clients,result);
          vm.proccess = false;
        });
      })
    }
    vm.addItem = function (item) {
      console.log(item);
      bookkeepingService.ClientAction('add', item).then(function (r) {
        bookkeepingService.SearchClients().then(function (result) {
          msUtils.setJsonObj(Clients,result);
          vm.proccess = false;
        });
      })
    }

    vm.SearchInvoice = function (ev) {



//321321
      $mdDialog.show({
        controller: 'ContactDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/bookkeeping/dialogs/contact/contact-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          client: {},
          Place: {}
        }
      }).then(function (dataSearch) {
        if (!dataSearch)
          return;
        if (!dataSearch.TZ && !dataSearch.ClientName && !dataSearch.amount && !dataSearch.KDate && !dataSearch.HeshbonitID) {
          var message = 'לא ניתן לבצע חיפוש. השלם לפחות שדה אחת';
          msUtils.Alert('שגיאה', message)
        } else {
          vm.proccess = true;

          bookkeepingService.SearchInvoices(dataSearch).then(function (result) {
            if (result.length)
              msUtils.setJsonObj(Invoices, result);
            else

              msUtils.Alert('חיפוש', 'לא נמצאו נתונים')
            console.log(result);
            vm.proccess = false;
          });
        }

      });

    }
  }
})();

/**
 * Created by itzik on 27/06/2018.
 */
(function () {
  'use strict';

  angular
    .module('app.advanced_settings', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.advanced_settings', {
      url: '/advanced_settings',
      views: {
        'content@app': {
          templateUrl: 'app/main/advanced_settings/advanced_settings.html',
          controller: 'Advanced_settingsController as vm'
        }
      },
      resolve: {
        hasPermission: function (orUserAccount) {
          return orUserAccount.Admin_user.rule === 10;
        }
      }
    });


  }

})();

/**
 * Created by itzik on 27/06/2018.
 */
(function () {
  'use strict';

  angular
    .module('app.advanced_settings')
    .controller('Advanced_taxDialogController', Advanced_taxDialogController);

  /** @ngInject */
  function Advanced_taxDialogController($state, orSettinsgService, $mdDialog, msUtils, $filter) {
    var vm = this;
    orSettinsgService.TAXList().then(function (taxResult) {
      angular.forEach(taxResult, function (value, key) {
        if (!value.isFuture)
          vm.currentTax = value.tax;
        else
          vm.futureTax = value;
        vm.newTax = angular.copy(vm.currentTax);

      })
    });


    vm.newTaxDate = new Date();
    vm.closeDialog = function () {
      $mdDialog.hide();
    }
    vm.submit = function () {
      console.log('submit..')
      var xx = moment(vm.newTaxDate).diff(moment());
      if (xx > 0) {
        msUtils.Toast('אנא המתן');
        orSettinsgService.saveNewTax({tax: vm.newTax, date_start: vm.newTaxDate}).then(function (status) {
          console.log('status', status);
          msUtils.Toast('עודכן בהצלחה');
          $mdDialog.hide();
        });
      }
      else {
        msUtils.Toast('תאריך שגוי');

      }
    }
  }
})();

/**
 * Created by itzik on 27/06/2018.
 */
(function () {
  'use strict';

  angular
    .module('app.advanced_settings')
    .controller('Advanced_passPlaceDialogController', Advanced_passPlaceDialogController);

  /** @ngInject */
  function Advanced_passPlaceDialogController($state, orSettinsgService, orUserAccount, orPlacesService, $mdDialog, msUtils, Admin, $filter) {
    var vm = this;
    vm.username = orUserAccount.Admin_user.nameHE;
    vm.form = {};
    if (!Admin) {
      orPlacesService.Places().then(function (results) {
        vm.places = results;
        vm.form.placeID = "0";
      });
    }
    vm.isAdmin = Admin;
    vm.form.adminpass = Admin;
    // orSettinsgService.TAXList().then(function (taxResult) {
    //   angular.forEach(taxResult, function (value, key) {
    //     if (!value.isFuture)
    //       vm.currentTax = value.tax;
    //     else
    //       vm.futureTax = value;
    //     vm.newTax = angular.copy(vm.currentTax);
    //
    //   })
    // });

    vm.isValid = function () {
      if (vm.isAdmin) {
        return vm.form.oldPass && vm.form.newPass && vm.form.newPass == vm.form.newPassConfirm;

      } else
        return vm.form.placeID && vm.form.placeID != "0" && vm.form.placeID > 0 && vm.form.newPass && vm.form.newPass == vm.form.newPassConfirm;
    }
    //vm.newTaxDate = new Date();
    vm.closeDialog = function () {
      $mdDialog.hide();
    }
    vm.submit = function () {
      console.log('submit..')
      msUtils.Toast('אנא המתן');
      orSettinsgService.changePasswordPlace(vm.form).then(function (response) {
        console.log('status', status);
        if (response.status)
          msUtils.Toast('עודכן בהצלחה');
        else
          msUtils.Toast(response.err || 'ארעה שגיאה');
        $mdDialog.hide();
      });
    }
    window.mdSelectOnKeyDownOverride = function (event) {
      event.stopPropagation();
      // NOTE: hack until this is fixed...
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('tableReport', tableReportDirective)
    .directive('tableCompareReport', tableCompareReportDirective)
    .controller('orTableReportController', orTableReportController)
    .filter('orTableFilter', orTableFilter)
    .filter('sumByKey', sumByKey);

  /** @ngInject */
  function tableReportDirective($document) {
    return {
      restrict: 'E',
      scope: {
        feilds: '=',
        editfeilds: '=?',
        data: '=',
        orderDefault: '@',
        filter: '=?',
        config: '=?',
        filterInput: '=?',
        dateReport: '=?',
        onEditItem: '=',
        onInsertItem: '=',
        onRemoveItem: '='
      },
      //transclude: true,
      templateUrl: 'app/core/directives/or-table-report/table-report.html',
      controller: 'orTableReportController as vm',
      link: function (scope, iElement) {
        // console.log(scope.data);
        // console.log(scope.insuranceId);

        /**
         * Remove the info bar
         */


      }
    };
  }

  /** @ngInject */
  function tableCompareReportDirective($document) {
    return {
      restrict: 'E',
      scope: {
        feilds: '=',
        editfeilds: '=?',
        data: '=',
        orderDefault: '@',
        filter: '=?',
        config: '=?',
        filterInput: '=?',
        dateReport: '=?',
        onEditItem: '=',
        onInsertItem: '=',
        onRemoveItem: '='
      },
      //transclude: true,
      templateUrl: 'app/core/directives/or-table-report/table-compare-report.html',
      controller: 'orTableReportController as vm',
      link: function (scope, iElement) {
        // console.log(scope.data);
        // console.log(scope.insuranceId);

        /**
         * Remove the info bar
         */


      }
    };
  }

  function orTableReportController(orUserAccount, orContacts, insuranceService, $mdToast, $element, $mdDialog, $state, $filter, $scope, $document, $mdMedia) {
    var vm = this;
    vm._selectedAll = false;
    console.log('$scope.data');
    console.log($scope.data);
    console.log($scope.feilds);
    $scope.$mdMedia = function (data) {
      if (!data)
        return true;
      return $mdMedia(data)
    };
    vm.hideIf = function (feild, item) {
      if (!feild.hideIf)
        return false;
      return feild.hideIf(item);
    }
    if (typeof ($scope.filterInput) === 'object')
      $scope.filterCustom = $scope.filterInput;
    $scope.$watch('filterInput', function (old, newval) {
      //console.log(old);
      if (typeof ($scope.filterInput) === 'object')
        $scope.filterCustom = $scope.filterInput;
    });
    $scope.$watch('vm._selectedAll', function (newval, old) {
      console.log(newval);
      if (!$scope.data)
        return;
      $scope.data.map(function (item) {
        item._selected = newval;
      })
    });
    $scope.enabledGroupAction = function () {
      if (!$scope.data)
        return false;
      if ($filter('filter')($scope.data, {_selected: true}, true).length)
        return true;
      vm._selectedAll = false;
      return false;
    }
    $scope.asFilter = function (item) {
      return item[feild.type]
    }
    vm.changeSort = function (feild) {
      if ($scope.orderDefault == feild) {
        if ($scope.orderDefault.indexOf('-') == 0)
          $scope.orderDefault = feild;
        else {
          $scope.orderDefault = '-' + feild;
        }
      } else {
        $scope.orderDefault = feild;
      }
    }
    vm.filterParams = [];
    vm.setFilter = function (key, value) {
      var exsist = $filter('filter')(vm.filterParams, {key: key}, true)[0];
      var feild = $filter('filter')($scope.feilds, {key: key}, true)[0];
      if (value && value != '') {
        if (exsist)
          exsist.value = value;
        else
          vm.filterParams.push({key: key, value: value});
        feild.filtered = true;
      } else if (exsist) {
        var ind;
        vm.filterParams.map(function (item, indx) {
          if (item.key == key)
            ind = indx;
        })
        if (ind !== 'undefined')
          vm.filterParams.splice(ind, 1);
        feild.filtered = false;
      }
      console.log(vm.filterParams);
    }
    vm.clickRow = function (item) {
      if ($scope.config.rowClick) {
        var it = $scope.config.rowClick;
        if (it.type == 'ref') {
          var params = {};
          it.params.map(function (quer) {
            var key = it.params[0].key;
            var value = item[it.params[0].value];
            params[key] = value;
          })

          $state.go(it.ui_serf, params);
        }
        else if (it.type == 'click') {
          it.func(item);
        }
      }
    }
    vm.convertData = function (data) {
      if (data && data.length && data[0].percent) {
        console.log("convertData!!")
        var printContents = "<table dir='rtl'><thead>" +
          "<td>Title</td>" +
          "<td>רופא</td>" +
          "<td>פציינטים - קודם</td>" +
          "<td>אחוז</td>" +
          "<td>פציינטים - נוכחי</td>" +
          "<td>צילומים - קודם</td>" +
          "<td>אחוז</td>" +
          "<td>צילומים - נוכחי</td>" +
          "<td>מחיר - קודם</td>" +
          "<td>אחוז</td>" +
          "<td>מחיר - נוכחי</td>" +
          "<td>השתתפות - קודם</td>" +
          "<td>אחוז</td>" +
          "<td>השתתפות - נוכחי</td>" +
          "</thead>";
        for (var i = 0; i < $scope.data.length; i++) {
          const item = $scope.data[i];
          printContents += "<tr>" +
            "<td>" + (item.a ? item.a.Name : item.b ? item.b.Name : "--") + "</td>" +
            "<td>" + (item.a ? item.a.doctorName : item.b ? item.b.doctorName : "--") + "</td>" +
            "<td>" + (item.b ? item.b.countClients : 0) + "</td>" +
            "<td>" + parseInt(item.percent.countClients).toFixed(1) + "</td>" +
            "<td>" + (item.a ? item.a.countClients : 0) + "</td>" +

            "<td>" + (item.b ? item.b.countPhotos : 0) + "</td>" +
            "<td>" + parseInt(item.percent.countPhotos).toFixed(1) + "</td>" +
            "<td>" + (item.a ? item.a.countPhotos : 0) + "</td>" +

            "<td>" + (item.b ? parseInt(item.b.Price).toFixed(1) : 0) + "</td>" +
            "<td>" + parseInt(item.percent.Price).toFixed(1) + "</td>" +
            "<td>" + (item.a ? parseInt(item.a.Price).toFixed(1) : 0) + "</td>" +

            "<td>" + (item.b ? item.b.Deductible : 0) + "</td>" +
            "<td>" + parseInt(item.percent.Deductible).toFixed(1) + "</td>" +
            "<td>" + (item.a ? item.a.Deductible : 0) + "</td>" +
            "</tr>"
        }
        printContents += "</thead></table>";
        var newData = [];
        for (var i = 0; i < $scope.data.length; i++) {
          const item = $scope.data[i];
          newData.push({
            name: (item.a ? item.a.Name : item.b ? item.b.Name : "--"),
            countClientsB: item.b ? item.b.countClients : 0,
            countClientsP: item.percent.countClients,
            countClientsA: item.a ? item.a.countClients : 0,
            countPhotosB: item.b ? item.b.countPhotos : 0,
            countPhotosP: item.percent.countPhotos,
            countPhotosA: item.a ? item.a.countPhotos : 0,
            PriceB: item.b ? item.b.Price : 0,
            PriceP: item.percent.Price,
            PriceA: item.a ? item.a.Price : 0,
            DeductibleB: item.b ? item.b.Deductible : 0,
            DeductibleP: item.percent.Deductible,
            DeductibleA: item.a ? item.a.Deductible : 0
          });
        }
        vm.exportData = printContents;
        return printContents;
      }

    }
    //vm.exportData = vm.convertData($scope.data);
    vm.clickFeild = function (clickConfig, item, e) {
      console.log(clickConfig)
      console.log(item)
      // ui-sref="{{feild.onclick.ui_serf}} (  {{feild.onclick.params[0].key}}:{{item[feild.onclick.params[0].value]}}  )"
      var params = {};
      clickConfig.params.map(function (quer, idx) {
        var key = clickConfig.params[idx].key;
        var value = (clickConfig.params[idx].type == 'fixed' ? clickConfig.params[idx].value : item[clickConfig.params[idx].value]);
        params[key] = value;
      })

      $state.go(clickConfig.ui_serf, params);
      e.stopPropagation();
    }
    vm.editItem = function (ev, item, isNew) {
      console.log($scope.editfeilds)
      if (!$scope.editfeilds || (!$scope.onEditItem && !isNew))
        return;

      $mdDialog.show({
        controller: 'tableReportEditDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/core/directives/or-table-report/dialog/edit-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          Item: item,
          Feilds: $scope.editfeilds,
          isNew: isNew,
          AllowRemove: $scope.onRemoveItem !== undefined,
          isGroup: false
        }
      }).then(function (itemEdited) {
        if (itemEdited) {
          if (itemEdited._action == 'remove' && $scope.onRemoveItem)
            $scope.onRemoveItem(itemEdited);
          else if (isNew && $scope.onInsertItem)
            $scope.onInsertItem(itemEdited)
          else if (!isNew && $scope.onEditItem)
            $scope.onEditItem(itemEdited)
        }

      });
    }
    vm.editGroup = function (ev) {
      console.log($scope.editfeilds)
      if (!$scope.editfeilds)
        return;
      var items = $filter('filter')($scope.data, {_selected: true}, true);
      var feilds = $filter('filter')($scope.editfeilds, {showgroup: true}, true);
      $mdDialog.show({
        controller: 'tableReportEditDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/core/directives/or-table-report/dialog/edit-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          Item: items[0],
          Feilds: $scope.editfeilds,
          isNew: false,
          AllowRemove: false,
          isGroup: true
        }
      }).then(function (itemEdited) {
        if (itemEdited) {

          items.map(function (item) {
            feilds.map(function (feild) {
              item[feild.key] = itemEdited[feild.key];
            })
          })
          $scope.onEditItem(items)
        }

      });
    }
    vm.removeGroup = function () {
      var items = $filter('filter')($scope.data, {_selected: true}, true);
      ConfirmDialog('מחיקה', 'האם למחוק ' + items.length + ' מסומנים?').then(function () {

        $scope.onRemoveItem(items, true);
      })
    }
    vm.showFunc = function (feild, item) {
      if (feild.printOnly)
        return false;
      if (feild.showFunc) {
        return feild.showFunc(item);
      }
      return true;
    }
    $scope.print = function (divName) {
      var title = $scope.config && $scope.config.title ? $scope.config.title : 'הדפסת דוח';
      var titleDescription = title;
      if ($scope.config && $scope.config.description)
        titleDescription += "<p>" + $scope.config.description + "</p>"
      var dateReport = '';
      if ($scope.dateReport && $scope.dateReport.start) {
        dateReport = 'תאריך: ' + moment($scope.dateReport.start).format('DD/MM/YYYY');
      }
      if ($scope.dateReport && $scope.dateReport.end) {
        dateReport += ' עד תאריך: ' + moment($scope.dateReport.end).format('DD/MM/YYYY');
      }
      var printContents = document.getElementsByClassName('table-report-directive')[0].innerHTML;
      printContents = $element[0].innerHTML;
      if ($scope.data && $scope.data.length && $scope.data[0].percent) {
        printContents = "<table dir='rtl'><thead>" +
          "<td>Title</td>" +
          "<td>רופא</td>" +
          "<td>פציינטים - קודם</td>" +
          "<td>אחוז</td>" +
          "<td>פציינטים - נוכחי</td>" +
          "<td>צילומים - קודם</td>" +
          "<td>אחוז</td>" +
          "<td>צילומים - נוכחי</td>" +
          "<td>מחיר - קודם</td>" +
          "<td>אחוז</td>" +
          "<td>מחיר - נוכחי</td>" +
          "<td>השתתפות - קודם</td>" +
          "<td>אחוז</td>" +
          "<td>השתתפות - נוכחי</td>" +
          "</thead>";
        for (var i = 0; i < $scope.data.length; i++) {
          const item = $scope.data[i];
          printContents += "<tr>" +
            "<td>" + (item.a ? item.a.Name : item.b ? item.b.Name : "--") + "</td>" +
            "<td>" + (item.a ? item.a.doctorName : item.b ? item.b.doctorName : "--") + "</td>" +
            "<td>" + (item.b ? item.b.countClients : 0) + "</td>" +
            "<td>" + parseInt(item.percent.countClients).toFixed(1) + "</td>" +
            "<td>" + (item.a ? item.a.countClients : 0) + "</td>" +

            "<td>" + (item.b ? item.b.countPhotos : 0) + "</td>" +
            "<td>" + parseInt(item.percent.countPhotos).toFixed(1) + "</td>" +
            "<td>" + (item.a ? item.a.countPhotos : 0) + "</td>" +

            "<td>" + (item.b ? parseInt(item.b.Price).toFixed(1) : 0) + "</td>" +
            "<td>" + parseInt(item.percent.Price).toFixed(1) + "</td>" +
            "<td>" + (item.a ? parseInt(item.a.Price).toFixed(1) : 0) + "</td>" +

            "<td>" + (item.b ? item.b.Deductible : 0) + "</td>" +
            "<td>" + parseInt(item.percent.Deductible).toFixed(1) + "</td>" +
            "<td>" + (item.a ? item.a.Deductible : 0) + "</td>" +
            "</tr>"
        }
        printContents += "</thead></table>";
      }

      printContents = printContents.replace(/tfoot/g, 'thead');

      var popupWin = window.open('', '_blank', 'width=900; height=600');
      popupWin.document.open();
      popupWin.document.write('<html><head><style>' +
        '.body,table{width:100%}.md-button{display:none} img{width:50%}.right{text-align:right}</style></head>' +
        '<body onload="window.print()"><table class="right"><tr><td rowspan="2" width="30%"><img src="http://adm.or-hashen.co.il/assets/images/logos/logo-or.png"/></td>' +
        '<td class="right">' + titleDescription + '</td></tr><tr><td >' + dateReport + '</td></tr><tr><td colspan="2"><hr/></td> </tr> </table>' + printContents + '' +
        '<table class="right"><tr><td><hr/></td><tr><td>הודפס ב- ' + moment().format('HH:mm DD-MM-YYYY') + '</td></tr></body></html>');

      popupWin.document.close();
    }

    var confirm;

    function ConfirmDialog(title, message) {
      confirm = $mdDialog.confirm()
        .title(title)
        .textContent(message)
        .ariaLabel('Lucky day')
        //.targetEvent(ev)
        .ok('אישור')
        .cancel('ביטול');

      return $mdDialog.show(confirm);
    }
  }


  function orTableFilter() {
    return function (input, option) {

      var output = [];
      // console.log(option);
      // return input;


      // Do filter work here
      if ((!option || option == 0))
        return input;
      else {
        for (var idx in input) {

          var item = input[idx];
          var allow = true;
          for (var x in option) {
            var filt = option[x];
            if (item[filt.key] != filt.value)
              allow = false;
          }
          if (allow)
            output.push(item);
        }
      }
      return output;

    }
  }

  function sumByKey() {
    return function (data, key) {
      if (typeof(data) === 'undefined' || typeof(key) === 'undefined') {
        return 0;
      }

      var sum = 0;
      for (var i = data.length - 1; i >= 0; i--) {
        //var exsist = $filter('filter')(filterParams, {key: key}, true)[0];
        if (data[i][key])
          sum += parseFloat(data[i][key]);
      }

      return sum;
    };
  }
})
();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('orReportPrecent', orReportPrecentDirective)
    .controller('orReportPrecentController', orReportPrecentController);

  /** @ngInject */
  function orReportPrecentDirective($document) {
    return {
      restrict: 'E',
      scope: {
        data: '=',
        filter: '=',
        countCopies: '='
        //vm          : '=viewModel'
      },
      //transclude: true,
      templateUrl: 'app/core/directives/or-report-precent/or-report-precent.html',
      controller: 'orReportPrecentController as vm',
      link: function (scope, iElement) {
        // console.log(scope.data);
        // console.log(scope.insuranceId);

        /**
         * Remove the info bar
         */


      }
    };
  }

  function orReportPrecentController(orUserAccount, orContacts, insuranceService, $mdToast, $mdDialog, $document, $filter, $scope) {
    var vm = this;


    vm.classPrecent = function (num) {
      if (num > 0)
        return 'green-fg';
      else if (num < 0)
        return 'red-fg';
    }
    /*
     var Add = function (ev) {
     $mdDialog.show({
     controller: 'CopyInsuraceDialogController',
     controllerAs: 'vm',
     templateUrl: 'app/core/directives/or-insurance/dialog/copy/copy-dialog.html',
     parent: angular.element($document.find('#content-container')),
     targetEvent: ev,
     clickOutsideToClose: true,
     escapeToClose: true,
     locals: {
     Copy: {InsuranceID: vm.insuranceId},
     ListCopys: vm.copiesList,
     Place: {}
     }
     }).then(function (newCopy) {
     if (!newCopy)
     return;

     var exsist = $filter('filter')(vm.data, {CopyID: newCopy.CopyID, InsuranceID: newCopy.InsuranceID}, true)[0];
     if (exsist)
     $mdToast.show(
     $mdToast.simple()
     .textContent('צילום כבר קיים - לא ניתן להוסיף שנית')
     .position('top right')
     .hideDelay(3000)
     );
     else {
     vm.data.push(newCopy);
     console.log(exsist);
     insuranceService.InsertPrice(newCopy).then(function (success) {
     $mdToast.show(
     $mdToast.simple()
     .textContent(success ? 'בוצע' : 'שגיאה')
     .position('top right')
     .hideDelay(3000)
     );
     })
     }
     });
     };

     vm.add = Add;
     */
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('orInsurance', orInsuranceDirective)
    .controller('orInsuranceController', orInsuranceController);

  /** @ngInject */
  function orInsuranceDirective($document) {
    return {
      restrict: 'E',
      scope: {
        data: '=',
        insuranceId: '=',
        countCopies: '='
        //vm          : '=viewModel'
      },
      //transclude: true,
      templateUrl: 'app/core/directives/or-insurance/or-insurance.html',
      controller: 'orInsuranceController as vm',
      link: function (scope, iElement) {
        // console.log(scope.data);
        // console.log(scope.insuranceId);

        /**
         * Remove the info bar
         */
        function removeInfoBar() {
          //body.removeClass(bodyClass);
          iElement.remove();
          scope.$destroy();
        }

        // Expose functions
        scope.removeInfoBar = removeInfoBar;
      }
    };
  }

  function orInsuranceController(orUserAccount, orSettinsgService, insuranceService, $mdToast, $mdDialog, $document, $filter, $scope, msUtils) {
    var vm = this;
    var TAX
    orSettinsgService.TAX().then(function (tax) {
      TAX = tax;
    });
    //vm.data = $scope.data;
    //vm.insuranceId = $scope.insuranceId;
    insuranceService.GetListofCopies().then(function (copiesList) {
      vm.copiesList = copiesList;
    });
    // vm.copiesList=[
    //   {CopyID:1,Name:'aaaaaa'},
    //   {CopyID:2,Name:'bbb'},
    //   {CopyID:3,Name:'cccc'},
    //   {CopyID:4,Name:'dddd'},
    //   {CopyID:5,Name:'eee'}
    // ];
    vm.feilds = [
      {key: 'mkt', name: 'מק"ט', show: 'gt-xs'},
      {key: 'Name', name: 'שם'},
      {key: 'sum', name: 'סכום'},
      {key: 'sumInclude', name: 'כולל מע"מ'},
      //{key:'deductible',name:'השתתפות'},
      {key: 'Comment', name: 'הערות', show: 'gt-md'},
      {key: 'InsuranceName', name: 'ביטוח', show: 'gt-sm'},
    ]
    vm.feildsEdit = [
      {key: 'mkt', name: 'מק"ט'},
      {key: 'Name', name: 'שם', readOnly: true},
      //{key: 'sum', name: 'סכום'},
      {key: 'sumInclude', name: 'סכום כולל מע"מ'},
      // {key: 'deductible', name: 'השתתפות'},
      {key: 'Comment', name: 'הערות'},
    ]

    vm.editItem = function (itemEdited) {
      if (itemEdited) {
        var message = (itemEdited ? 'עודכן בהצלחה' : 'ארעה שגיאה');
        sumupdate(itemEdited);
        // orAdminService.UpdateDoctorDetail(itemEdited).then(function (result) {
        insuranceService.UpdateInsurancePrices(itemEdited).then(function (result) {
          if (!result.status)
            message = 'שגיאה';
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
            hideDelay: 3000,
            position: 'top right',
            parent: '#content'
          });
        });
      }
    }
    function sumupdate(item) {

      if (!item.sumInclude) {
        item.sum = 0;
        return;
      }
      //var TAX = msUtils.TAX;
      item.sum = ((item.sumInclude * 100) / (100 + TAX)).toFixed(2);

    }

    var Add = function (ev) {
      var titleIns = $filter('filter')($scope.data, {InsuranceID: $scope.insuranceId}, true)[0];
      titleIns = (titleIns ? titleIns.InsuranceName : 'צילום חדש');
      $mdDialog.show({
        controller: 'CopyInsuraceDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/core/directives/or-insurance/dialog/copy/copy-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          Copy: {
            InsuranceID: $scope.insuranceId,
            title:titleIns
          },
          ListCopys: vm.copiesList,
          Place: {},
          TAX: TAX
        }
      }).then(function (newCopy) {
        if (!newCopy)
          return;

        var exsist = $filter('filter')($scope.data, {
          CopyID: newCopy.CopyID,
          InsuranceID: newCopy.InsuranceID
        }, true)[0];
        if (exsist)
          $mdToast.show(
            $mdToast.simple()
              .textContent('צילום כבר קיים - לא ניתן להוסיף שנית')
              .position('top right')
              .hideDelay(3000)
          );
        else {
          //$scope.data.push(newCopy);
          console.log(exsist);
          insuranceService.InsertPrice(newCopy).then(function (success) {
            $mdToast.show(
              $mdToast.simple()
                .textContent(success ? 'בוצע' : 'שגיאה')
                .position('top right')
                .hideDelay(3000)
            );
          })
        }
      });
    };
    var Remove = function (copy) {
      console.log('copy remove')
      console.log(copy);
      var message = (copy ? 'עודכן בהצלחה' : 'ארעה שגיאה');

      insuranceService.RemoveCopie(copy).then(function (result) {
        console.log(result);
        if (!result.status)
          message = 'שגיאה';
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
          hideDelay: 3000,
          position: 'top right',
          parent: '#content'
        });
        copy.InsuranceID = -1;
        //TODO will be refresh!
      });
    }
    vm.add = Add;
    vm.remove = Remove;

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'תמיכה',
                        'icon'       : 'icon-cog',
                        'state'      : 'app.support',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'support',
                        '_path'      : 'app.support',
                        'uisref'     : 'app.support',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('msPricesDoctors', msPricesDoctorsDirective)
    .controller('msPricesDoctorsController', msPricesDoctorsController);

  /** @ngInject */
  function msPricesDoctorsDirective($document) {
    return {
      restrict: 'E',
      scope: {
        copies: '=',
        doctor: '=',
        countCopies: '=',
        hideSelect: '=',
        bituahId: '=?',
        client: '=?',
        standrdInsurances: '=?'
        //vm          : '=viewModel'
      },
      //transclude: true,
      templateUrl: 'app/core/directives/ms-prices-doctors/ms-prices-doctors.html',
      controller: 'msPricesDoctorsController as vm',
      link: function (scope, iElement) {
        console.log(scope.copies);

        /**
         * Remove the info bar
         */
        function removeInfoBar() {
          //body.removeClass(bodyClass);
          iElement.remove();
          scope.$destroy();
        }

        // Expose functions
        scope.removeInfoBar = removeInfoBar;
      }
    };
  }

  function msPricesDoctorsController(orUserAccount, orContacts, $mdDialog, $filter, $scope, $document, $timeout, msUtils) {
    var vm = this;
    console.log($scope.copies);
    console.log($scope.doctor);

    vm.copies = [];

    vm.places = [orUserAccount.Place];
    //vm.placeSelcted = orUserAccount.Place.placeId;
    $scope.$watch("bituahId", function (newValue, oldValue) {
      //This gets called when data changes.
      if (oldValue != newValue && newValue != undefined) {
        vm.formWizard.BituahID = newValue;
        selectInsurance();
      }
    });
    $scope.$watch("doctor", function (newValue, oldValue) {
      //This gets called when data changes.
      if (oldValue == undefined && newValue != undefined) {
        selectDoctor(newValue, true);
        selectInsurance();
      }

    });
    var selectInsurance = function () {
      if (vm.factorPays) {
        var item = $filter('filter')(vm.factorPays, {BituahID: vm.formWizard.BituahID}, true)[0];
        if (item) {
          $scope.bituahId = item.BituahID || 0;
          vm.formWizard.BituahName = item.Name;
          vm.formWizard.isInsurances = item.isInsurances;
        }
      }
    }
    var selectDoctor = function (doctor, autoSelect) {
      console.log('selectDoctor');
      var AllowChange = true;
      if ($scope.doctor && $scope.doctor.DoctorID == doctor.DoctorID) {
        AllowChange = false;
      }
      /* debugger
       vm.formWizard.DoctorID = doctor.DoctorID;
       vm.formWizard.doctorName = doctor.Name;
       vm.formWizard.Sale = doctor.Sale;
       return;
       }*/
      if (!$scope.doctor)
        $scope.doctor = {};
      msUtils.setJsonObj($scope.doctor, doctor);
      vm.formWizard.DoctorID = doctor.DoctorID;
      vm.formWizard.doctorName = doctor.Name;
      vm.formWizard.Sale = doctor.Sale;

      // if (doctor.KategoriaID == 2)
      //   vm.formWizard.BituahID = 2;
      if (doctor.LastAgreementID)
        doctor.agreementID = doctor.LastAgreementID;
      else
        doctor.LastAgreementID = doctor.agreementID;
      if (doctor.agreementID && vm.formWizard.isInsurances) {
        vm.formWizard.BituahID = doctor.agreementID;
        vm.standrdInsurances = false;

      } else if (AllowChange) {
        if (!vm.standrdInsurances)
          vm.formWizard.BituahID = 1;
        vm.standrdInsurances = true;
      }

      selectInsurance();
      //if (vm.formWizard.BituahID > 2)
      if (doctor.agreementID)
        doctor.agreementID = vm.formWizard.BituahID;
      $scope.standrdInsurances = vm.standrdInsurances;

      //vm.DoctorNoteIN = doctor.NoteIN
      vm.DoctorNoteOUT = doctor.NoteOUT
      LoadCopiesDoctor(doctor, autoSelect);
      setTimeout(function () {
        vm.copmiesMode = true;
        $scope.$apply();
      }, 500)


    }
    var ResetPhotoes = function () {
      var selected = $filter('filter')(vm.copies, {selected: true});
      console.log(selected.length + ' items selected');
      for (var idx in selected) {
        selected[idx].selected = false;
      }
      $scope.copies.splice(0, $scope.copies.length);
      console.log('resete....')
    }
    var ResetDoctor = function () {
      vm.formWizard.DoctorID = undefined;
      vm.formWizard.doctorName = undefined;
      vm.copmiesMode = false;
      if (!vm.standrdInsurances) {
        vm.standrdInsurances = true;
        vm.formWizard.BituahID = 0;
        selectInsurance();
      }
      orContacts.GetDoctors().then(function (doctors) {
        vm.doctors = doctors;
      });
    }
    vm.selectedCopy = function (copy) {
      //console.log(copy.selected);
      if (copy.selected) {
        $scope.copies.push(copy);
        if (copy.priceFor == 'agreement') {
          vm.editDeductible(copy);
        }

      } else {
        for (var ind in $scope.copies) {
          if ($scope.copies[ind].PhotoListID == copy.PhotoListID)
            $scope.copies.splice(ind, 1);
        }

      }
    }
    var intervalCheck;
    vm.searchDoctor = function () {
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(deepSearch, 500);
    };

    var deepSearch = function (dates) {
      if (vm.search.length < 3 || vm.proccess)
        return;
      vm.proccess = true;

      orContacts.GetDoctors(vm.search).then(function () {
        vm.proccess = false;
      });

    }
    var LoadCopiesDoctor = function (doctor, autoSelect) {
      if (!vm.formWizard.DoctorID)
        return;
      orContacts.LoadPhotosDoctor(doctor, vm.formWizard.BituahID).then(function (copies) {
        vm.copies = copies;
        if ((!autoSelect) && $scope.copies)
          $scope.copies.splice(0, $scope.copies.length);
        for (var ind in $scope.copies) {
          var x = $filter('filter')(vm.copies, {PhotoListID: $scope.copies[ind].PhotoID}, true)[0];
          if (x) {
            x.customfixprice = $scope.copies[ind].InsuranceID == 1;
            x.selected = true;
            //x.main_fixprice = x.fixprice;
            x.fixprice = $scope.copies[ind].fixprice;//321321
            x.discountAdminID = $scope.copies[ind].discountAdminID;
            if (x.priceFor == 'agreement') {
              //x.insuranceprice = $scope.copies[ind].insuranceprice;
              x.Deductible = $scope.copies[ind].Deductible;

              x.InsuranceAccept = $scope.copies[ind].InsuranceID != 1;
              $scope.copies[ind].InsuranceAccept = x.InsuranceAccept;
            }
          }
          if (!autoSelect) {
            msUtils.setJsonObj($scope.copies[ind], x);
          }
        }
      })
    }
    //vm.countCopies = {count: 0};
    if (!$scope.countCopies)
      $scope.countCopies = {count: 0, sum: 0};

    vm.countCopies = $scope.countCopies;
    vm.hideSelect = $scope.hideSelect;

    vm.standrdInsurances = true;
    vm.formWizard = {BituahID: $scope.bituahId};
    vm.countselected = function () {
      // console.log('ss')
      var fil = vm.copies.filter(function (copy) {
        // console.log(copy)
        return copy.selected;
      });
      vm.countCopies.count = fil.length;
      vm.sumPrice = 0;
      vm.countCopies.str = '';
      var sumAll = 0;
      for (var item in fil) {
        vm.sumPrice += parseFloat(fil[item].fixprice);
        if (fil[item].Deductible)
          vm.sumPrice += parseFloat(fil[item].Deductible);
        vm.countCopies.str += fil[item].Name + ', ';

        var photo = fil[item];

        //console.log(photo)
        if (photo.priceFor == "agreement" && photo.InsuranceAccept) {
          sumAll += parseFloat(photo.Deductible);
        }
        else if (photo.priceFor == "agreement") {
          sumAll += parseFloat(photo.fixprice || photo.doctorPrice || photo.basePrice);
        }
        else {
          sumAll += (photo.fixprice !== 'undefined' ? parseFloat(photo.fixprice) : parseFloat(photo.Price));
        }
      }
      vm.countCopies.sum = vm.sumPrice;
      if (!$scope.client)
        $scope.client = {};
      if (!$scope.client.sumAll)
        $scope.client.sumAll = {};
      $scope.client.sumAll.topay = sumAll;

      return fil.length;
    }


    vm.selectDoctor = selectDoctor;

    const INSURANCES = {KLALIT: 14, MACABI: 20, MEUCHEDET: 21};

    vm.editPrice = function (copy, ev) {
      //copy.fixprice -= 10;

      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.prompt()
        .title('עדכן מחיר לצילום ' + copy.Name)
        .textContent('מחיר קודם: ' + copy.fixprice)
        .placeholder('הזן מחיר')
        .ariaLabel('Dog name')
        .initialValue(copy.fixprice)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      if (vm.formWizard.BituahID == INSURANCES.MACABI || vm.formWizard.BituahID == INSURANCES.MEUCHEDET) {
        confirm = $mdDialog.confirm()
          .title('זכאות ביטוח')
          .textContent('נא לסמן האם יש זכאות לצילום זה. במידה ולא, ניתן אח"כ לעדכן מחיר')
          .ariaLabel('Lucky day')
          .targetEvent(ev)
          .ok('זכאי/ת')
          .cancel('אין זכאות');
      }
      else if (vm.formWizard.BituahID == INSURANCES.KLALIT) {
        confirm = $mdDialog.prompt()
          .title('קוד הפניה לצילום: ' + copy.Name)
          //  .textContent(textContent)
          .placeholder('הזן קוד הפניה')
          .ariaLabel('Dog name')
          .initialValue(copy.reference)
          .targetEvent(ev)
          .ok('אישור')
          .cancel('אין זכאות - תשלום פרטי');
      }
      $mdDialog.show(confirm).then(function (result) {
        if (isNaN(parseInt(result))) {
          alertDialog('מחיר לא תקין! - ניתן להזין מספר בלבד', 'שגיאה');
        }
        //Cancel for admin
        // else if (parseInt(result) <= (copy.fixprice / 2)) {
        //   promtMenagerCode(copy, parseInt(result), ev);
        //alertDialog(' שים לב, במידה ויש ביטוח, יש לבחור צילום שמוגדר בסוג תשלום "ביטוח" ולא מחיר רגיל.', 'לא ניתן לאפס מחיר.');
        // }
        else {
          if (vm.formWizard.BituahID == INSURANCES.KLALIT) {
            const codeReference = parseFloat(result);
            if (!codeReference || codeReference.toString().length < 9) {
              alertDialog('קוד הפניה שגוי!', 'שגיאה', function () {
                vm.editDeductible(copy, ev);
              })
              return
            }
            copy.reference = parseFloat(result);
            copy.Deductible = 0;
          } else {
            copy.Deductible = parseFloat(result);
          }
          copy.fixprice = parseInt(result);
          copy.Deductible = undefined;
          copy.customfixprice = true;
          var it = $filter('filter')($scope.copies, {PhotoListID: copy.PhotoListID}, true)[0];
          if (it) {
            it.fixprice = copy.fixprice;
            it.Deductible = copy.Deductible;
            it.customfixprice = copy.customfixprice;
          }

        }
      }, function () {
//        $scope.status = 'You didn\'t name your dog.';
      });

    }
    var promtMenagerCode = function (copy, newPrice, ev) {

      var confirm = $mdDialog.prompt()
        .title(' עדכון מחיר ל' + newPrice)
        .textContent('נא לפנות למנהל לצורך אישור הנחה')
        .placeholder('הקש קוד אישור מנהל')
        .ariaLabel('Dog name')
        //.initialValue(max)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        if (isNaN(parseInt(result))) {
          alertDialog('מספר אישור לא תקין!', 'שגיאה');
        } else {
          var nPermission = parseInt(result);
          orContacts.CheckDiscountPermission(nPermission).then(function (result) {
            console.log(result);
            if (result.status) {
              copy.fixprice = newPrice;
              copy.customfixprice = true;
              copy.discountAdminID = result.data.admin_user_id;
              var it = $filter('filter')($scope.copies, {PhotoListID: copy.PhotoListID}, true)[0];
              if (it) {
                it.fixprice = copy.fixprice;
                it.customfixprice = copy.customfixprice;
                it.discountAdminID = copy.discountAdminID;
              }
            } else
              alertDialog('קוד הרשאה שגוי', 'הרשאה חסומה');
          })


          //RefundStatus(Receipt);
        }
      }, function () {

      });
    }
    vm.editHasmahta = function (copy, ev) {
      //copy.fixprice -= 10;

      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.prompt()
        .title('הוסף מספר אסמכתא ' + copy.Name)
        //.textContent('מחיר קודם: ' + copy.fixprice)
        .placeholder('מספר אסמכתא')
        .ariaLabel('Dog name')
        .initialValue(copy.Hasmahta)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        if (isNaN(parseInt(result))) {
          $mdDialog.show(
            $mdDialog.alert()
            //.parent(angular.element(document.querySelector('#popupContainer')))
              .clickOutsideToClose(true)
              .title('שגיאה')
              .textContent('מספר לא תקין! - ניתן להזין מספר בלבד')
              .ariaLabel('Alert Dialog Demo')
              .ok('סגור')
              .targetEvent(ev)
          );
        } else {
          copy.Hasmahta = parseInt(result);
          copy.reference = parseInt(result);
          var it = $filter('filter')($scope.copies, {PhotoListID: copy.PhotoListID}, true)[0];
          if (it) {
            it.Hasmahta = copy.Hasmahta;
            it.reference = copy.reference;
          }
        }
      }, function () {
//        $scope.status = 'You didn\'t name your dog.';
      });

    }
    vm.editDeductible = function (copy, ev) {
      //copy.fixprice -= 10;

      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.prompt()
        .title('השתתפות עצמית לצילום: ' + copy.Name)
        //.textContent('מחיר קודם: ' + copy.fixprice)
        .placeholder('סכום - הקש 0  או אנטר במידה ואין השתתפות')
        .ariaLabel('Dog name')
        .initialValue(copy.Deductible)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('אין זכאות');
      if (vm.formWizard.BituahID == 20 || vm.formWizard.BituahID == 21) {
        confirm = $mdDialog.confirm()
          .title('זכאות ביטוח')
          .textContent('נא לסמן האם יש זכאות לצילום זה. במידה ולא, ניתן אח"כ לעדכן מחיר')
          .ariaLabel('Lucky day')
          .targetEvent(ev)
          .ok('זכאי/ת')
          .cancel('אין זכאות');
      }
      $mdDialog.show(confirm).then(function (result) {
          if (isNaN(parseFloat(result))) {
            result = 0;
            // $mdDialog.show(
            //   $mdDialog.alert()
            //   //.parent(angular.element(document.querySelector('#popupContainer')))
            //     .clickOutsideToClose(true)
            //     .title('שגיאה')
            //     .textContent('מספר לא תקין! - ניתן להזין מספר בלבד')
            //     .ariaLabel('Alert Dialog Demo')
            //     .ok('סגור')
            //     .targetEvent(ev)
            // );
          } //else {

          copy.Deductible = parseFloat(result);
          copy.InsuranceAccept = true;
          copy.customfixprice = false;
          copy.fixprice = 0;
          var it = $filter('filter')($scope.copies, {PhotoListID: copy.PhotoListID}, true)[0];
          if (it) {
            it.Deductible = copy.Deductible;
            it.InsuranceAccept = copy.InsuranceAccept;
            it.fixprice = copy.fixprice;
          }
          //}
        }, function () {
          copy.Deductible = copy.doctorPrice;
          copy.InsuranceAccept = false;
          var it = $filter('filter')($scope.copies, {PhotoListID: copy.PhotoListID}, true)[0];
          if (it) {
            it.Deductible = copy.doctorPrice || copy.basePrice;
            it.InsuranceAccept = copy.InsuranceAccept;
            //$scope.status = 'You didn\'t name your dog.';
          }
        }
      );

    }
    vm.cancelDiscount = function (copy) {
      if (copy.main_fixprice) {
        copy.fixprice = copy.main_fixprice;
        copy.discountAdminID = undefined;
        var it = $filter('filter')($scope.copies, {PhotoListID: copy.PhotoListID}, true)[0];
        if (it) {
          it.fixprice = copy.fixprice;
          it.customfixprice = false;
          it.discountAdminID = copy.discountAdminID;
        }
      }
    }
    vm.resetDoctor = ResetDoctor;
    vm.resetPhotoes = ResetPhotoes;
    vm.PriceForStr = function (copy) {
      if (copy.discountAdminID)
        return 'הנחת מנהל';
      if (copy.priceFor == 'doctor')
        return 'מחיר לרופא';
      if (copy.priceFor == 'regular')
        return 'מחיר רגיל';
      if (copy.priceFor == 'agreement') {
        if (!copy.Deductible && !copy.customfixprice)
          return 'ביטוח';
        if (copy.Deductible && copy.InsuranceAccept)
          return 'ביטוח + השתתפות';
        else
          return 'מחיר ללא זכאות'
      }

    }
    if ($scope.doctor)
      selectDoctor($scope.doctor, true);
    else {
      ResetDoctor();
    }
    orContacts.GetFactorPays().then(function (factorPays) {
      console.log(factorPays);
      vm.factorPays = factorPays;
      selectInsurance();
    });

    vm.printDetails = function (doctor, ev) {
      $mdDialog.show({
        controller: 'SippingDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/shippingDetails/shippingDetails.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          client: {},
          Doctor: doctor,
          Place: orUserAccount.Place
        }
      }).then(function (id) {

      });
    }
    vm.selectInsurance = selectInsurance;

    function alertDialog(MSG, title, cb) {
      $mdDialog.show(
        $mdDialog.alert()
        //.parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title(title || 'שגיאה')
          .textContent(MSG)
          .ariaLabel('Alert Dialog Demo')
          .ok('סגור')
        //.targetEvent(ev)
      ).then(cb);

    }

    vm.focusSearch = function () {
      $timeout(function () {
        $('#s_search').focus();
      }, 500);
    }
    window.mdSelectOnKeyDownOverride = function (event) {
      event.stopPropagation();
      // NOTE: hack until this is fixed...
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .provider('msNavigationService', msNavigationServiceProvider)
    .controller('MsNavigationController', MsNavigationController)
    // Vertical
    .directive('msNavigation', msNavigationDirective)
    .controller('MsNavigationNodeController', MsNavigationNodeController)
    .directive('msNavigationNode', msNavigationNodeDirective)
    .directive('msNavigationItem', msNavigationItemDirective)
    //Horizontal
    .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
    .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
    .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
    .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

  /** @ngInject */
  function msNavigationServiceProvider() {
    // Inject $log service
    var $log = angular.injector(['ng']).get('$log');

    // Navigation array
    var navigation = [];

    var service = this;

    // Methods
    service.saveItem = saveItem;
    service.deleteItem = deleteItem;
    service.sortByWeight = sortByWeight;

    //////////

    /**
     * Create or update the navigation item
     *
     * @param path
     * @param item
     */
    function saveItem(path, item) {
      if (!angular.isString(path)) {
        $log.error('path must be a string (eg. `dashboard.project`)');
        return;
      }

      var parts = path.split('.');

      // Generate the object id from the parts
      var id = parts[parts.length - 1];

      // Get the parent item from the parts
      var parent = _findOrCreateParent(parts);

      // Decide if we are going to update or create
      var updateItem = false;

      for (var i = 0; i < parent.length; i++) {
        if (parent[i]._id === id) {
          updateItem = parent[i];

          break;
        }
      }

      // Update
      if (updateItem) {
        angular.extend(updateItem, item);

        // Add proper ui-sref
        updateItem.uisref = _getUiSref(updateItem);
      }
      // Create
      else {
        // Create an empty children array in the item
        item.children = [];

        // Add the default weight if not provided or if it's not a number
        if (angular.isUndefined(item.weight) || !angular.isNumber(item.weight)) {
          item.weight = 1;
        }

        // Add the item id
        item._id = id;

        // Add the item path
        item._path = path;

        // Add proper ui-sref
        item.uisref = _getUiSref(item);

        // Push the item into the array
        parent.push(item);
      }
    }

    /**
     * Delete navigation item
     *
     * @param path
     */
    function deleteItem(path) {
      if (!angular.isString(path)) {
        $log.error('path must be a string (eg. `dashboard.project`)');
        return;
      }

      // Locate the item by using given path
      var item = navigation,
        parts = path.split('.');

      for (var p = 0; p < parts.length; p++) {
        var id = parts[p];

        for (var i = 0; i < item.length; i++) {
          if (item[i]._id === id) {
            // If we have a matching path,
            // we have found our object:
            // remove it.
            if (item[i]._path === path) {
              item.splice(i, 1);
              return true;
            }

            // Otherwise grab the children of
            // the current item and continue
            item = item[i].children;
            break;
          }
        }
      }

      return false;
    }

    /**
     * Sort the navigation items by their weights
     *
     * @param parent
     */
    function sortByWeight(parent) {
      // If parent not provided, sort the root items
      if (!parent) {
        parent = navigation;
        parent.sort(_byWeight);
      }

      // Sort the children
      for (var i = 0; i < parent.length; i++) {
        var children = parent[i].children;

        if (children.length > 1) {
          children.sort(_byWeight);
        }

        if (children.length > 0) {
          sortByWeight(children);
        }
      }
    }

    /* ----------------- */
    /* Private Functions */
    /* ----------------- */

    /**
     * Find or create parent
     *
     * @param parts
     * @returns {Array|Boolean}
     * @private
     */
    function _findOrCreateParent(parts) {
      // Store the main navigation
      var parent = navigation;

      // If it's going to be a root item
      // return the navigation itself
      if (parts.length === 1) {
        return parent;
      }

      // Remove the last element from the parts as
      // we don't need that to figure out the parent
      parts.pop();

      // Find and return the parent
      for (var i = 0; i < parts.length; i++) {
        var _id = parts[i],
          createParent = true;

        for (var p = 0; p < parent.length; p++) {
          if (parent[p]._id === _id) {
            parent = parent[p].children;
            createParent = false;

            break;
          }
        }

        // If there is no parent found, create one, push
        // it into the current parent and assign it as a
        // new parent
        if (createParent) {
          var item = {
            _id: _id,
            _path: parts.join('.'),
            title: _id,
            weight: 1,
            children: []
          };

          parent.push(item);
          parent = item.children;
        }
      }

      return parent;
    }

    /**
     * Sort by weight
     *
     * @param x
     * @param y
     * @returns {number}
     * @private
     */
    function _byWeight(x, y) {
      return parseInt(x.weight) - parseInt(y.weight);
    }

    /**
     * Setup the ui-sref using state & state parameters
     *
     * @param item
     * @returns {string}
     * @private
     */
    function _getUiSref(item) {
      var uisref = '';

      if (angular.isDefined(item.state)) {
        uisref = item.state;

        if (angular.isDefined(item.stateParams) && angular.isObject(item.stateParams)) {
          uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
        }
      }

      return uisref;
    }

    /* ----------------- */
    /* Service           */
    /* ----------------- */

    this.$get = function () {
      var activeItem = null,
        navigationScope = null,
        folded = null,
        foldedOpen = null;

      var service = {
        saveItem: saveItem,
        deleteItem: deleteItem,
        sort: sortByWeight,
        clearNavigation: clearNavigation,
        setActiveItem: setActiveItem,
        getActiveItem: getActiveItem,
        getNavigation: getNavigation,
        getFlatNavigation: getFlatNavigation,
        setNavigationScope: setNavigationScope,
        setFolded: setFolded,
        getFolded: getFolded,
        setFoldedOpen: setFoldedOpen,
        getFoldedOpen: getFoldedOpen,
        toggleFolded: toggleFolded
      };

      return service;

      //////////

      /**
       * Clear the entire navigation
       */
      function clearNavigation() {
        // Clear the navigation array
        navigation = [];

        // Clear the vm.navigation from main controller
        if (navigationScope) {
          navigationScope.vm.navigation = navigation;
        }
      }

      /**
       * Set active item
       *
       * @param node
       * @param scope
       */
      function setActiveItem(node, scope) {
        activeItem = {
          node: node,
          scope: scope
        };
      }

      /**
       * Return active item
       */
      function getActiveItem() {
        return activeItem;
      }

      /**
       * Return navigation array
       *
       * @param root
       * @returns Array
       */
      function getNavigation(root) {
        if (root) {
          for (var i = 0; i < navigation.length; i++) {
            if (navigation[i]._id === root) {
              return [navigation[i]];
            }
          }

          return null;
        }

        return navigation;
      }

      /**
       * Return flat navigation array
       *
       * @param root
       * @returns Array
       */
      function getFlatNavigation(root) {
        // Get the correct navigation array
        var navigation = getNavigation(root);

        // Flatten the navigation object
        return _flattenNavigation(navigation);
      }

      /**
       * Store navigation's scope for later use
       *
       * @param scope
       */
      function setNavigationScope(scope) {
        navigationScope = scope;
      }

      /**
       * Set folded status
       *
       * @param status
       */
      function setFolded(status) {
        folded = status;
      }

      /**
       * Return folded status
       *
       * @returns {*}
       */
      function getFolded() {
        return folded;
      }

      /**
       * Set folded open status
       *
       * @param status
       */
      function setFoldedOpen(status) {
        foldedOpen = status;
      }

      /**
       * Return folded open status
       *
       * @returns {*}
       */
      function getFoldedOpen() {
        return foldedOpen;
      }


      /**
       * Toggle fold on stored navigation's scope
       */
      function toggleFolded() {
        navigationScope.toggleFolded();
      }

      /**
       * Flatten the given navigation
       *
       * @param navigation
       * @private
       */
      function _flattenNavigation(navigation) {
        var flatNav = [];

        for (var x = 0; x < navigation.length; x++) {
          // Copy and clear the children of the
          // navigation that we want to push
          var navToPush = angular.copy(navigation[x]);
          navToPush.children = [];

          // Push the item
          flatNav.push(navToPush);

          // If there are child items in this navigation,
          // do some nested function magic
          if (navigation[x].children.length > 0) {
            flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
          }
        }

        return flatNav;
      }
    };
  }

  /** @ngInject */
  function MsNavigationController($scope, msNavigationService) {
    var vm = this;

    // Data
    if ($scope.root) {
      vm.navigation = msNavigationService.getNavigation($scope.root);
    }
    else {
      vm.navigation = msNavigationService.getNavigation();
    }

    // Methods
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Sort the navigation before doing anything else
      msNavigationService.sort();
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }
  }

  /** @ngInject */
  function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService) {
    return {
      restrict: 'E',
      scope: {
        folded: '=',
        root: '@'
      },
      controller: 'MsNavigationController as vm',
      templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
      transclude: true,
      compile: function (tElement) {
        tElement.addClass('ms-navigation');

        return function postLink(scope, iElement) {
          var bodyEl = angular.element('body'),
            foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
            foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
            sidenav = $mdSidenav('navigation');

          // Store the navigation in the service for public access
          msNavigationService.setNavigationScope(scope);

          // Initialize
          init();

          /**
           * Initialize
           */
          function init() {
            // Set the folded status for the first time.
            // First, we have to check if we have a folded
            // status available in the service already. This
            // will prevent navigation to act weird if we already
            // set the fold status, remove the navigation and
            // then re-initialize it, which happens if we
            // change to a view without a navigation and then
            // come back with history.back() function.

            // If the service didn't initialize before, set
            // the folded status from scope, otherwise we
            // won't touch anything because the folded status
            // already set in the service...
            if (msNavigationService.getFolded() === null) {
              msNavigationService.setFolded(scope.folded);
            }

            if (msNavigationService.getFolded()) {
              // Collapse everything.
              // This must be inside a $timeout because by the
              // time we call this, the 'msNavigation::collapse'
              // event listener is not registered yet. $timeout
              // will ensure that it will be called after it is
              // registered.
              $timeout(function () {
                $rootScope.$broadcast('msNavigation::collapse');
              });

              // Add class to the body
              bodyEl.addClass('ms-navigation-folded');

              // Set fold expander
              setFoldExpander();
            }
          }

          // Sidenav locked open status watcher
          scope.$watch(function () {
            return sidenav.isLockedOpen();
          }, function (current, old) {
            if (angular.isUndefined(current) || angular.equals(current, old)) {
              return;
            }

            var folded = msNavigationService.getFolded();

            if (folded) {
              if (current) {
                // Collapse everything
                $rootScope.$broadcast('msNavigation::collapse');
              }
              else {
                // Expand the active one and its parents
                var activeItem = msNavigationService.getActiveItem();
                if (activeItem) {
                  activeItem.scope.$emit('msNavigation::stateMatched');
                }
              }
            }
          });

          // Folded status watcher
          scope.$watch('folded', function (current, old) {
            if (angular.isUndefined(current) || angular.equals(current, old)) {
              return;
            }

            setFolded(current);
          });

          /**
           * Set folded status
           *
           * @param folded
           */
          function setFolded(folded) {
            // Store folded status on the service for global access
            msNavigationService.setFolded(folded);

            if (folded) {
              // Collapse everything
              $rootScope.$broadcast('msNavigation::collapse');

              // Add class to the body
              bodyEl.addClass('ms-navigation-folded');

              // Set fold expander
              setFoldExpander();
            }
            else {
              // Expand the active one and its parents
              var activeItem = msNavigationService.getActiveItem();
              if (activeItem) {
                activeItem.scope.$emit('msNavigation::stateMatched');
              }

              // Remove body class
              bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

              // Remove fold collapser
              removeFoldCollapser();
            }
          }

          /**
           * Set fold expander
           */
          function setFoldExpander() {
            iElement.parent().append(foldExpanderEl);

            // Let everything settle for a moment
            // before registering the event listener
            $timeout(function () {
              foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
            });
          }

          /**
           * Set fold collapser
           */
          function setFoldCollapser() {
            bodyEl.find('#main').append(foldCollapserEl);
            foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
          }

          /**
           * Remove fold collapser
           */
          function removeFoldCollapser() {
            foldCollapserEl.remove();
          }

          /**
           * onHover event of foldExpander
           */
          function onFoldExpanderHover(event) {
            if (event) {
              event.preventDefault();
            }

            // Set folded open status
            msNavigationService.setFoldedOpen(true);

            // Expand the active one and its parents
            var activeItem = msNavigationService.getActiveItem();
            if (activeItem) {
              activeItem.scope.$emit('msNavigation::stateMatched');
            }

            // Add class to the body
            bodyEl.addClass('ms-navigation-folded-open');

            // Remove the fold opener
            foldExpanderEl.remove();

            // Set fold collapser
            setFoldCollapser();
          }

          /**
           * onHover event of foldCollapser
           */
          function onFoldCollapserHover(event) {
            if (event) {
              event.preventDefault();
            }

            // Set folded open status
            msNavigationService.setFoldedOpen(false);

            // Collapse everything
            $rootScope.$broadcast('msNavigation::collapse');

            // Remove body class
            bodyEl.removeClass('ms-navigation-folded-open');

            // Remove the fold collapser
            foldCollapserEl.remove();

            // Set fold expander
            setFoldExpander();
          }

          /**
           * Public access for toggling folded status externally
           */
          scope.toggleFolded = function () {
            var folded = msNavigationService.getFolded();

            setFolded(!folded);
          };

          /**
           * On $stateChangeStart
           */
          scope.$on('$stateChangeStart', function () {
            // Close the sidenav
            sidenav.close();
          });

          // Cleanup
          scope.$on('$destroy', function () {
            foldCollapserEl.off('mouseenter touchstart');
            foldExpanderEl.off('mouseenter touchstart');
          });
        };
      }
    };
  }

  /** @ngInject */
  function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService, orUserAccount) {
    var vm = this;

    // Data
    vm.element = $element;
    vm.node = $scope.node;
    vm.hasChildren = undefined;
    vm.collapsed = undefined;
    vm.collapsable = undefined;
    vm.group = undefined;
    vm.animateHeightClass = 'animate-height';

    // Methods
    vm.toggleCollapsed = toggleCollapsed;
    vm.collapse = collapse;
    vm.expand = expand;
    vm.getClass = getClass;
    vm.isHidden = isHidden;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Setup the initial values

      // Has children?
      vm.hasChildren = vm.node.children.length > 0;

      // Is group?
      vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

      // Is collapsable?
      if (!vm.hasChildren || vm.group) {
        vm.collapsable = false;
      }
      else {
        vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
      }

      // Is collapsed?
      if (!vm.collapsable) {
        vm.collapsed = false;
      }
      else {
        vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
      }

      // Expand all parents if we have a matching state or
      // the current state is a child of the node's state
      if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
        // If state params are defined, make sure they are
        // equal, otherwise do not set the active item
        if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
          return;
        }

        $scope.$emit('msNavigation::stateMatched');

        // Also store the current active menu item
        msNavigationService.setActiveItem(vm.node, $scope);
      }

      $scope.$on('msNavigation::stateMatched', function () {
        // Expand if the current scope is collapsable and is collapsed
        if (vm.collapsable && vm.collapsed) {
          $scope.$evalAsync(function () {
            vm.collapsed = false;
          });
        }
      });

      // Listen for collapse event
      $scope.$on('msNavigation::collapse', function (event, path) {
        if (vm.collapsed || !vm.collapsable) {
          return;
        }

        // If there is no path defined, collapse
        if (angular.isUndefined(path)) {
          vm.collapse();
        }
        // If there is a path defined, do not collapse
        // the items that are inside that path. This will
        // prevent parent items from collapsing
        else {
          var givenPathParts = path.split('.'),
            activePathParts = [];

          var activeItem = msNavigationService.getActiveItem();
          if (activeItem) {
            activePathParts = activeItem.node._path.split('.');
          }

          // Test for given path
          if (givenPathParts.indexOf(vm.node._id) > -1) {
            return;
          }

          // Test for active path
          if (activePathParts.indexOf(vm.node._id) > -1) {
            return;
          }

          vm.collapse();
        }
      });

      // Listen for $stateChangeSuccess event
      $scope.$on('$stateChangeSuccess', function () {
        if (vm.node.state === $state.current.name) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
            return;
          }

          // Update active item on state change
          msNavigationService.setActiveItem(vm.node, $scope);

          // Collapse everything except the one we're using
          $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
        }

        // Expand the parents if we the current
        // state is a child of the node's state
        if ($state.includes(vm.node.state)) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
            return;
          }

          // Emit the stateMatched
          $scope.$emit('msNavigation::stateMatched');
        }
      });
    }

    /**
     * Toggle collapsed
     */
    function toggleCollapsed() {
      if (vm.collapsed) {
        vm.expand();
      }
      else {
        vm.collapse();
      }
    }

    /**
     * Collapse
     */
    function collapse() {
      // Grab the element that we are going to collapse
      var collapseEl = vm.element.children('ul');

      // Grab the height
      var height = collapseEl[0].offsetHeight;

      $scope.$evalAsync(function () {
        // Set collapsed status
        vm.collapsed = true;

        // Add collapsing class to the node
        vm.element.addClass('collapsing');

        // Animate the height
        $animate.animate(collapseEl,
          {
            'display': 'block',
            'height': height + 'px'
          },
          {
            'height': '0px'
          },
          vm.animateHeightClass
        ).then(
          function () {
            // Clear the inline styles after animation done
            collapseEl.css({
              'display': '',
              'height': ''
            });

            // Clear collapsing class from the node
            vm.element.removeClass('collapsing');
          }
        );

        // Broadcast the collapse event so child items can also be collapsed
        $scope.$broadcast('msNavigation::collapse');
      });
    }

    /**
     * Expand
     */
    function expand() {
      // Grab the element that we are going to expand
      var expandEl = vm.element.children('ul');

      // Move the element out of the dom flow and
      // make it block so we can get its height
      expandEl.css({
        'position': 'absolute',
        'visibility': 'hidden',
        'display': 'block',
        'height': 'auto'
      });

      // Grab the height
      var height = expandEl[0].offsetHeight;

      // Reset the style modifications
      expandEl.css({
        'position': '',
        'visibility': '',
        'display': '',
        'height': ''
      });

      $scope.$evalAsync(function () {
        // Set collapsed status
        vm.collapsed = false;

        // Add expanding class to the node
        vm.element.addClass('expanding');

        // Animate the height
        $animate.animate(expandEl,
          {
            'display': 'block',
            'height': '0px'
          },
          {
            'height': height + 'px'
          },
          vm.animateHeightClass
        ).then(
          function () {
            // Clear the inline styles after animation done
            expandEl.css({
              'height': ''
            });

            // Clear expanding class from the node
            vm.element.removeClass('expanding');
          }
        );

        // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
        // can be collapsed. This is necessary for keeping only one parent expanded at any time
        $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
      });
    }

    /**
     * Return the class
     *
     * @returns {*}
     */
    function getClass() {
      return vm.node.class;
    }

    /**
     * Check if node should be hidden
     *
     * @returns {boolean}
     */
    function isHidden() {
      if (angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden)) {
        return vm.node.hidden();
      }
      // console.log(orUserAccount.Admin_user.rule + ' -- ' + vm.node.rule);
      if (angular.isDefined(vm.node.permission) && orUserAccount.checkPermission(vm.node.permission)){
        return false;
      }if (angular.isDefined(vm.node.rule) && vm.node.rule > orUserAccount.Admin_user.rule)
        return true;
      if (angular.isDefined(vm.node.permission) && !orUserAccount.checkPermission(vm.node.permission)){
        return true;
      }

      return false;
    }
  }

  /** @ngInject */
  function msNavigationNodeDirective() {
    return {
      restrict: 'A',
      bindToController: {
        node: '=msNavigationNode'
      },
      controller: 'MsNavigationNodeController as vm',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-node');

        return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
          // Add custom classes
          iElement.addClass(MsNavigationNodeCtrl.getClass());

          // Add group class if it's a group
          if (MsNavigationNodeCtrl.group) {
            iElement.addClass('group');
          }
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationItemDirective() {
    return {
      restrict: 'A',
      require: '^msNavigationNode',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-item');

        return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
          // If the item is collapsable...
          if (MsNavigationNodeCtrl.collapsable) {
            iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
          }

          // Cleanup
          scope.$on('$destroy', function () {
            iElement.off('click');
          });
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationHorizontalDirective(msNavigationService) {
    return {
      restrict: 'E',
      scope: {
        root: '@'
      },
      controller: 'MsNavigationController as vm',
      templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
      transclude: true,
      compile: function (tElement) {
        tElement.addClass('ms-navigation-horizontal');

        return function postLink(scope) {
          // Store the navigation in the service for public access
          msNavigationService.setNavigationScope(scope);
        };
      }
    };
  }

  /** @ngInject */
  function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService) {
    var vm = this;

    // Data
    vm.element = $element;
    vm.node = $scope.node;
    vm.hasChildren = undefined;
    vm.group = undefined;

    // Methods
    vm.getClass = getClass;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Setup the initial values

      // Is active
      vm.isActive = false;

      // Has children?
      vm.hasChildren = vm.node.children.length > 0;

      // Is group?
      vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

      // Mark all parents as active if we have a matching state
      // or the current state is a child of the node's state
      if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
        // If state params are defined, make sure they are
        // equal, otherwise do not set the active item
        if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
          return;
        }

        $scope.$emit('msNavigation::stateMatched');

        // Also store the current active menu item
        msNavigationService.setActiveItem(vm.node, $scope);
      }

      $scope.$on('msNavigation::stateMatched', function () {
        // Mark as active if has children
        if (vm.hasChildren) {
          $scope.$evalAsync(function () {
            vm.isActive = true;
          });
        }
      });

      // Listen for clearActive event
      $scope.$on('msNavigation::clearActive', function () {
        if (!vm.hasChildren) {
          return;
        }

        var activePathParts = [];

        var activeItem = msNavigationService.getActiveItem();
        if (activeItem) {
          activePathParts = activeItem.node._path.split('.');
        }

        // Test for active path
        if (activePathParts.indexOf(vm.node._id) > -1) {
          $scope.$evalAsync(function () {
            vm.isActive = true;
          });
        }
        else {
          $scope.$evalAsync(function () {
            vm.isActive = false;
          });
        }

      });

      // Listen for $stateChangeSuccess event
      $scope.$on('$stateChangeSuccess', function () {
        if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
            return;
          }

          // Update active item on state change
          msNavigationService.setActiveItem(vm.node, $scope);

          // Clear all active states except the one we're using
          $rootScope.$broadcast('msNavigation::clearActive');
        }
      });
    }

    /**
     * Return the class
     *
     * @returns {*}
     */
    function getClass() {
      return vm.node.class;
    }
  }

  /** @ngInject */
  function msNavigationHorizontalNodeDirective() {
    return {
      restrict: 'A',
      bindToController: {
        node: '=msNavigationHorizontalNode'
      },
      controller: 'MsNavigationHorizontalNodeController as vm',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-horizontal-node');

        return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
          // Add custom classes
          iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

          // Add group class if it's a group
          if (MsNavigationHorizontalNodeCtrl.group) {
            iElement.addClass('group');
          }
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationHorizontalItemDirective($mdMedia) {
    return {
      restrict: 'A',
      require: '^msNavigationHorizontalNode',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-horizontal-item');

        return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
          iElement.on('click', onClick);

          function onClick() {
            if (!MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md')) {
              return;
            }

            iElement.toggleClass('expanded');
          }

          // Cleanup
          scope.$on('$destroy', function () {
            iElement.off('click');
          });
        };
      }
    };
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
/**
 * Created by itzik on 15/01/2018.
 */
/**
 * @Angular Image Vieer Directive
 *
 * @Author      : Ranjithprabhu K
 *
 * @Module Name  :  imageViewer
 *
 * @Directive Name  :  image-viewer [in DOM]
 *
 * @Description:  This handles the image viewer with image zoom-in, zoom-out, rotate-left, rotate-right options.
 *
 */

(function () {
  "use strict";
  angular.module('imageViewer', []).directive('imageViewer', function ($sce) {

    return {
      restrict: 'EA',
      templateUrl: 'app/core/directives/image-viewer/image-viewer.html',
      /*template: '<div style="padding:10px;">\
       <button id="girardir" class="btn btn-primary btn-lg" ng-disabled="noImage"><span class="glyphicon glyphicon-menu-left"> </span> Rotate to Left</button>\
       <button id="giraresq" class="btn btn-primary btn-lg" ng-disabled="noImage">Rotate to Right <span class="glyphicon glyphicon-menu-right"> </span></button>\
       <button id="zoomIn" class="btn btn-info btn-lg" ng-disabled="noImage"><span class="glyphicon glyphicon-zoom-in"> </span> Zoom In</button>\
       <button id="zoomOut" class="btn btn-info btn-lg" ng-disabled="noImage"><span class="glyphicon glyphicon-zoom-out"> </span> Zoom Out</button>\
       <button id="carregar" class="btn btn-warning btn-lg" ng-disabled="noImage"><span class="fa fa-arrow-left"> </span> Reset</button>\
       </div>\
       <div id="image-zoom" style="padding:10px;">\
       <h2 class="text-center text-danger" id="error-message" style="border:1px solid #000;display:none;padding:20px">Image Not Available</h2>\
       <canvas id="canvas" height="650" data-girar="0" style="border:1px solid #000;z-index:555555;cursor:grab;">sdsd</canvas>\
       <img ng-src="{{image}}" id="image" style="display:none" /> </div>',*/
      link: function (scope, element, attr) {
        scope.image = attr.src;
        scope.noImage = false;
        scope.file = $sce.trustAsResourceUrl(attr.src);
        //options for the zoom and rotate
        var canvas = document.getElementById('canvas');
        var image = document.getElementById('image');
        var element = canvas.getContext("2d");
        var angleInDegrees = 0;
        var zoomDelta = 0.1;
        var currentScale = 1;
        var currentAngle = 0;
        var canvasWidth = 600;
        var novosDadosTRBL;
        var novosDadosWH;
        var novosDadosW;
        var novosDadosH;
        var startX, startY, isDown = false;
        scope.flag = 1;


        //set the width of the canvas
        setTimeout(function () {
          // canvas.width = angular.element('#image-zoom').width();
          canvas.width = angular.element('body').width();
          angular.element('#image-viewr-pdf-file').width(canvas.width / 2);
          //append the image in canvas
          // initilize();
          //document.getElementById('carregar').click();
        }, 0);
        initilize();
        //method to reset the image to its original position
        angular.element('#carregar').click(function () {
          resetImage();
          //check the image load

          /*angular.element('#image').on('load', resetImage())

           //if the image is not loaded
           .on('error', function () {
           //hide the canvas
           angular.element('#canvas').hide();

           //disable the buttons
           scope.noImage = true;

           //display the image not loaded text
           angular.element('#error-message').show();
           console.log("error loading image");
           });*/

        });
        function initilize() {
          angular.element('#image-viewr-pdf-file').bind('load', function () {
            console.log('image-viewr-pdf-file is loaded');
            //resetImage();
          });
          angular.element('#image').bind('load', function () {
            console.log('image is loaded');
            resetImage();
          });

          angular.element('#image').bind('error', function () {
            console.log('error');
            angular.element('#canvas').hide();
            angular.element("#image-viewr-loader-message").hide();
            angular.element("#image-viewr-pdf-file").attr('src', scope.file);
            //disable the buttons
            scope.noImage = true;

            //display the image not loaded text
            angular.element('#error-message').show();
            angular.element('#image-viewr-pdf-file').show();
            console.log("error loading image");
          });

        }

        //method to reset the image
        function resetImage() {
          console.log('resetImage');
          //alert('load')
          //load the  image in canvas if the image is loaded successfully
          angular.element("#image-viewr-loader-message").hide();
          angular.element("#canvas").show();
          image = document.getElementById('image');
          element = canvas.getContext("2d");
          angleInDegrees = 0;
          currentScale = 0.2;
          currentAngle = 0;

          //for initial loading

          if (scope.flag) {
            scope.flag = 0;
            drawImage();
            element.translate(canvas.width / 2, canvas.height / 2);
            setTimeout(function () {
              angular.element('#canvas').attr('data-girar', 0);
              drawImage();
            }, 1000);
          }
          else {
            element.translate(0, 0);
            angular.element('#canvas').attr('data-girar', 0);
            drawImage();
          }
        };

        //method to rotate the image in clockwise
        angular.element('#giraresq').click(function () {
          //set the rotate angle for clockwise rotation
          angleInDegrees = 5;
          currentAngle += angleInDegrees;
          drawImage();
        });
//method to rotate the image in clockwise
        angular.element('#giraresq_90').click(function () {
          //set the rotate angle for clockwise rotation
          angleInDegrees = 90;
          currentAngle += angleInDegrees;
          drawImage();
        });

        //method to rotate the image in anti clockwise
        angular.element('#girardir').click(function () {
          //set the rotate angle for anti clockwise rotation
          angleInDegrees = -5;
          currentAngle += angleInDegrees;
          drawImage();
        });
        //method to rotate the image in anti clockwise
        angular.element('#girardir_90').click(function () {
          //set the rotate angle for anti clockwise rotation
          angleInDegrees = -90;
          currentAngle += angleInDegrees;
          drawImage();
        });


        //method to zoom in the image
        angular.element('#zoomIn').click(function () {
          currentScale += zoomDelta;
          drawImage();
        });


        //method to zoom in and zoom out the image on mouse wheel scroll
        angular.element('#canvas').bind('mousewheel DOMMouseScroll', function (event) {
          if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
            // scroll up
            currentScale += zoomDelta;
            drawImage();
          }
          else {
            // scroll down
            if (currentScale - zoomDelta - 0.1 > 0) {
              currentScale -= zoomDelta;
              drawImage();
            }
          }
        });

        //method to zoom out the image
        angular.element('#zoomOut').click(function () {
          currentScale -= zoomDelta;
          drawImage();
        });

        //method to get the mouse position when mouse button is down
        canvas.onmousedown = function (e) {
          var pos = getMousePos(canvas, e);
          startX = pos.x;
          startY = pos.y;
          isDown = true;
        }

        //method to update the image position in the canvas when it is dragged
        canvas.onmousemove = function (e) {
          if (isDown === true) {
            var pos = getMousePos(canvas, e);
            var x = pos.x;
            var y = pos.y;

            element.translate(x - startX, y - startY);
            drawImage();

            startX = x;
            startY = y;
          }
        }

        //method to detect the mouse up for image dragging
        window.onmouseup = function (e) {
          isDown = false;
        }

        //method to draw the image in the canvas from image element
        function drawImage() {
          clear();
          element.save();
          element.scale(currentScale, currentScale);
          element.rotate(currentAngle * Math.PI / 180);
          element.drawImage(image,-image.width/2,-image.height/2);
          element.restore();
          console.log(currentScale)
        }

        //method to clear the canvas
        function clear() {
          element.clearRect(-2000, -2000, 5000, 5000);
        }

        //method to get the mouse position
        function getMousePos(canvas, evt) {
          var rect = canvas.getBoundingClientRect();
          return {
            x: evt.clientX - rect.left,
            y: evt.clientY - rect.top
          };
        }


      }
    }
  });

})();

/**
 * Created by itzik on 28/01/2018.
 */

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('exportToExcel', exportToExcelDirective);

  function exportToExcelDirective() {
    return {
      restrict: 'A',
      scope: {
        data: '=',
        specialdata: '&',
        reportFields: '='
        //vm          : '=viewModel'
      },
      link: function (scope, element, attrs) {
        var el = element[0];
        //var table = $(el).next()[0]
        var table = $(el).parents('table')[0]

        element.bind('click', function (e) {
          if (scope.specialdata())
            table = scope.specialdata();
          // var table = scope.data;
          $(table).table2excel({
            exclude: ".hide-excel",
            name: "Worksheet Name",
            filename: "Or-Hashen" //do not include extension
          });

        });
        function b64EncodeUnicode(str) {
          return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode(parseInt(p1, 16))
          }))
        }
      }
    }
  }
})();

/**
 * Created by itzik on 27/12/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('orDateBetweenButtons', orDateBetweenButtonsDirective)
    .controller('orDateBetweenButtonsController', orDateBetweenButtonsController);

  /** @ngInject */
  function orDateBetweenButtonsDirective($document) {
    return {
      restrict: 'E',
      scope: {
        onChange: '&',
        dates: '=',
        rangeMode: '=?',
        currentMonth: '=?'
        //vm          : '=viewModel'
      },
      //transclude: true,
      templateUrl: 'app/core/directives/date-between-buttons/date-between-buttons.html',
      controller: 'orDateBetweenButtonsController as vm',
      link: function (scope, iElement) {
        // console.log(scope.data);
        // console.log(scope.insuranceId);

        /**
         * Remove the info bar
         */


      }
    };
  }

  function orDateBetweenButtonsController($mdDialog, $document, $filter, $timeout, $scope, $mdMedia) {
    var vm = this;
    if (!$scope.dates)
      $scope.dates = {};

    vm.currentDate = new Date();
    // alert(moment().subtract(1, 'day').format('E'))

    var convertToEH_Date = function (date, format) {
      if (format == 'MMMM') {
        var monthEn = moment(date).format('MM');
        monthEn = parseInt(monthEn);
        switch (monthEn) {
          case 1:
            return 'ינואר';
          case 2:
            return 'פברואר';
          case 3:
            return 'מרץ';
          case 4:
            return 'אפריל';
          case 5:
            return 'מאי';
          case 6:
            return 'יוני';
          case 7:
            return 'יולי';
          case 8:
            return 'אוגוסט';
          case 9:
            return 'ספטמבר';
          case 10:
            return 'אוקטובר';
          case 11:
            return 'נובמבר';
          case 12:
            return 'דצמבר';
        }
      }
      return moment(date).format(format);
    }

    vm.MODESDATE = [
      {key: 'TODAY', value: 'היום', show: 'gt-xs'},
      {key: 'YESTERDAY', value: 'אתמול', show: 'gt-xs', disable: moment().subtract(1, 'day').format('E') == 6},
      // {key: 'WEEK', value: 'שבוע', show: 'gt-xs'},
      {key: 'MONTH-1', value: convertToEH_Date(moment().add(-1, 'month'), 'MMMM'), show: 'gt-sm'},
      {key: 'MONTH-2', value: convertToEH_Date(moment().add(-2, 'month'), 'MMMM'), show: 'gt-sm'},
      {key: 'CUSTOM', value: 'מותאם אישית', show: 'gt-xs'},
      {key: 'CUSTOM', value: 'בחר תאריכים', show: 'xs'}
    ];
    if ($scope.currentMonth) {
      vm.MODESDATE = [
        {key: 'TODAY', value: 'היום', show: 'gt-xs'},
        {key: 'YESTERDAY', value: 'אתמול', show: 'gt-xs', disable: moment().subtract(1, 'day').format('E') == 6},
        // {key: 'WEEK', value: 'שבוע', show: 'gt-xs'},
        {key: 'MONTH', value: convertToEH_Date(moment(), 'MMMM'), show: 'gt-sm'},
        {key: 'MONTH-1', value: convertToEH_Date(moment().add(-1, 'month'), 'MMMM'), show: 'gt-sm'},
        //{key: 'MONTH-2', value: convertToEH_Date(moment().add(-2, 'month'),'MMMM'), show: 'gt-sm'},
        {key: 'CUSTOM', value: 'מותאם אישית', show: 'gt-xs'},
        {key: 'CUSTOM', value: 'בחר תאריכים', show: 'xs'}
      ];
    }
    $scope.$mdMedia = function (data) {
      if (!data)
        return true;
      return $mdMedia(data)
    };
    vm.MODESDATERANGE = [
      {
        key: 'THISMONTH', value: moment().format("MM/YYYY") + ' = ' + moment().subtract(1, 'year').format("MM/YYYY"),
        start: moment().day(1),
        end: moment().add('months', 1).date(0)
      },
      {
        key: 'LASTMONTH',
        value: moment().day(1).subtract(1, 'month').format("MM/YYYY") + ' = ' + moment().subtract(1, 'month').subtract(1, 'year').format("MM/YYYY"),
        start: moment().day(1).subtract(1, 'month'),
        end: moment().date(0)
      },
      {
        key: 'YEAR',
        value: moment().format("YYYY") + ' = ' + moment().subtract(1, 'year').format("YYYY"),
        start: moment().day(1).month(0),
        end: moment().day(31).month(11).hours(23)
      },
      {
        key: 'LASTYEAR',
        value: moment().subtract(1, 'year').format("YYYY") + ' = ' + moment().subtract(2, 'year').format("YYYY"),
        start: moment().day(1).month(0).subtract(1, 'year'),
        end: moment().day(31).month(11).subtract(1, 'year'),

      },
      // {key: 'CUSTOM', value: 'מותאם אישית'}
    ];
    vm.MODESDATE = $scope.rangeMode ? vm.MODESDATERANGE : vm.MODESDATE;
    vm.Mode = vm.MODESDATE[0].key;


    vm.classActiveMode = function (mode) {
      return (mode == vm.Mode);
    }
    vm.selectMode = function (mode, event, noSubmit) {
      /*if (mode.key == 'CUSTOM') {
       customDate(event)
       vm.Mode = mode.key;
       vm.endDate = undefined;
       }*/
      if (vm.Mode == mode)
        return;
      vm.Mode = mode.key;
      console.log(vm.Mode.key);
      var Today = new Date();
      if ($scope.rangeMode) {
        $scope.dates = {start: mode.start.toDate(), end: mode.end.toDate()};
      }
      else {
        switch (mode.key) {
          case 'TODAY':
            vm.currentDate = Today;
            vm.endDate = Today;//moment().add(1,'day').toDate();
            break;
          case 'YESTERDAY':
            Today.setDate(Today.getDate() - 1);
            vm.currentDate = Today;
            vm.endDate = Today;//moment().toDate();
            break;
          case 'WEEK':
            Today.setDate(Today.getDate() - 7);
            vm.currentDate = Today;
            vm.endDate = new Date();
            break;
          case 'MONTH':
            var datesO = {start: moment().date(1), end: moment().endOf('month')};
            Today.setDate(Today.getDate() - 30);
            vm.currentDate = datesO.start.toDate(),// Today;
              vm.endDate = datesO.end.toDate()//new Date();
            break;
          case 'MONTH-1':
            var datesO = {start: moment().add(-1, 'month').date(1), end: moment().add(-1, 'month').endOf('month')};
            Today.setDate(Today.getDate() - 30);
            vm.currentDate = datesO.start.toDate(),// Today;
              vm.endDate = datesO.end.toDate()//new Date();
            break;
          case 'MONTH-2':
            var datesO = {start: moment().add(-2, 'month').date(1), end: moment().add(-2, 'month').endOf('month')};
            vm.currentDate = datesO.start.toDate(),// Today;
              vm.endDate = datesO.end.toDate()//new Date();
            break;
          case 'CUSTOM':
            customDate(event)
            vm.endDate = undefined;
            break;
        }
        $scope.dates = {start: vm.currentDate, end: vm.endDate};
      }
      if (mode.key != 'CUSTOM' && !noSubmit)
        $timeout($scope.onChange, 500);
      // if (mode != 'CUSTOM')
      //   GetReport();

    }

    var customDate = function (ev) {
      $mdDialog.show({
        controller: 'DateDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/core/directives/date-between-buttons/date/date.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          Dates: $scope.dates//vm.currentDate
        }
      }).then(function (newDate) {
        if (newDate) {
          vm.currentDate = newDate.start;
          $scope.dates = {start: newDate.start.toDate(), end: newDate.end.toDate()};
          $timeout($scope.onChange, 500);
        }
      });
    }

    if (moment($scope.dates.start).format('LL') == moment(new Date()).format('LL'))
      vm.selectMode(vm.MODESDATE[0],undefined, true);
    else if (moment($scope.dates.start).add(1, 'day').format('LL') == moment(new Date()).format('LL'))
      vm.selectMode(vm.MODESDATE[1],undefined, true);
    else if ((moment($scope.dates.start).month() == moment(new Date()).month()) && (moment($scope.dates.start).dates() == 1) && (moment($scope.dates.end).dates() == moment().endOf('month').date()))
      vm.selectMode(vm.MODESDATE[2], undefined,true);
    else if ((moment($scope.dates.start).month() == moment(new Date()).add(-1, 'month').month()) && (moment($scope.dates.start).dates() == 1) && (moment($scope.dates.end).dates() == moment().add(-1, 'month').endOf('month').date()))
      vm.selectMode(vm.MODESDATE[3], undefined,true);
  }
})();

(function () {
  'use strict';

  angular
    .module('app.users', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.users', {
      url: '/users',
      views: {
        'content@app': {
          templateUrl: 'app/main/users/users.html',
          controller: 'UsersController as vm'
        }
      },
      resolve: {
        Users:function (orAdminService) {
          return orAdminService.UsersList();
        },
        Places:function (orPlacesService) {

          return orPlacesService.Places();
        }
      }
    });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/contacts');

    // msNavigationServiceProvider.saveItem('users', {
    //   title: 'משתמשים',
    //   icon: 'icon-person-box',
    //   group: false,
    //   weight: 4,
    //   rule: 10,
    //   permission: "users"
    // });
    // msNavigationServiceProvider.saveItem('users.users', {
    //   title: 'רשימת מנהלים',
    //   state: 'app.users',
    //   weight: 1,
    //   rule:5,
    // });
   /* msNavigationServiceProvider.saveItem('employees.employee_card', {
      title: 'כרטיס עובד',
     // icon: 'icon-account-multiple',
      state: 'app.employee_card',
      weight: 1
    });*/

    // Api




  }

})();

(function () {
  'use strict';

  angular
    .module('app.users')
    .controller('UsersController', UsersController);

  /** @ngInject */
  function UsersController(Users, Places, msUtils, $mdDialog, $mdToast, $state, $filter, orAdminService, orUserAccount) {

    var vm = this;
    // data
    if (orUserAccount.Admin_user.rule < 10) {
      $state.go('app.contacts');
      return;
    }
    console.log("users", Users)
    vm.dates = {start: new Date()};
    vm.reportType = 0;
    var Rules = [
      {id: 0, Name: 'ללא'},
      {id: 1, Name: 'Minor'},
      {id: 3, Name: 'Minor+'},
      {id: 5, Name: 'Medium (מעקב סניפים)'},
      {id: 6, Name: 'Medium+'},
      {id: 10, Name: 'Admin'},
    ];
    var YesNo = [
      {id: true, name: 'כן'},
      {id: false, name: 'לא'}
    ]
    vm.table = {
      feilds: [
        {key: 'ID', name: 'מזהה'},
        {key: 'nameHE', name: 'שם'},
        {key: 'username', name: 'שם מתשמש'},
        // {key: 'places', name: 'סניפים'},
        {key: 'rule', name: 'הרשאות'},
        {key: 'lastLogin', name: 'כניסה אחרונה', type: 'datetime'},
        {key: 'permission_doctors', name: 'הרשאות רופאים', type: 'bool'},
        {key: 'permission_inventories', name: 'ניהול מלאי', type: 'bool'},

      ],
      edit: [
        {key: 'nameHE', name: 'שם עובד', required: true, icon: 'icon-account'},
        {key: 'username', name: 'שם מתשמש', required: true, icon: 'icon-home'},
        {key: 'pass', name: 'סיסמא', required: true, readOnly: 'update', icon: 'icon-lock-outline'},
        {
          key: 'rule',
          name: 'הרשאות',
          required: true,
          icon: 'icon-block-helper',
          select: {data: Rules, key: 'id', value: 'Name'}
        },
        {
          key: 'places',
          name: 'סניפים',
          icon: 'icon-city',
          select: {data: Places, key: 'PlaceID', value: 'Name',sort:'Name', multiple: true}
        },
        {key: 'comment', name: 'הערות', icon: 'icon-comment'},
        {key: 'permission_doctors', name: 'הרשאות רופאים', select: {data: YesNo, key: 'id', value: 'name'}},
        {key: 'permission_inventories', name: 'הרשאות מלאי', select: {data: YesNo, key: 'id', value: 'name'}},

        //  {key: 'PlaceID', name: 'סניף', required: true, select: {data: Places, key: 'PlaceID', value: 'Name'}},

      ],
      data: Users.data,
      config: {
        classFunc: function (item) {
          if (!item.editable)
            return 'grey-fg'
        }
        //  rowClick: {type: 'ref', ui_serf: 'app.employee_card', params: [{key: 'id', value: 'OvedID'}]}
      }
    }
    vm.worksOnlyData = [];
    var intervalCheck;
    vm.change = function () {
      if (vm.worksNowStatus)
        return;
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(deepSearch, 500);
    }

    var deepSearch = function (dates) {
      if (vm.search.length < 2 || vm.proccess)
        return;
      vm.proccess = true;

      orAdminService.GetEmployessList(vm.search).then(function () {
        vm.proccess = false;
      });

    }

    vm.editItem = function (itemEdited) {
      if (orUserAccount.Admin_user.rule != 10) {
        var msg = 'הרשאה חסומה! נא לפנות למנהל כללי לצורך עריכת פרטים'
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + msg + '</div></md-toast>',
          hideDelay: 3000,
          position: 'top right',
          parent: '#content'
        });
        return;
      }
      else if (!itemEdited.editable) {
        var msg = 'משתמש זה אינו ניתן לעדכון'
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + msg + '</div></md-toast>',
          hideDelay: 3000,
          position: 'top right',
          parent: '#content'
        });
        return;
      }
      console.log(itemEdited);
      if (itemEdited) {
        orAdminService.UpdateUser(itemEdited).then(function (result) {
          var message = (result.status ? 'עודכן בהצלחה' : 'ארעה שגיאה');
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
            hideDelay: 3000,
            position: 'top right',
            parent: '#content'
          });
          if (result.status) {
            var item = $filter('filter')(Users, {'id': itemEdited.id}, true)[0];
            if (item)
              msUtils.setJsonObj(item, itemEdited);
          }
        });
      }
    }

    vm.addEmployee = function (itemEdited) {
      if (orUserAccount.Admin_user.rule != 10) {
        var msg = 'הרשאה חסומה! נא לפנות למנהל כללי לצורך עריכת פרטים'
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + msg + '</div></md-toast>',
          hideDelay: 3000,
          position: 'top right',
          parent: '#content'
        });
        return;
      }
      console.log(itemEdited);
      if (itemEdited) {
        orAdminService.UpdateUser(itemEdited).then(function (result) {
          var message = (result.status ? 'עודכן בהצלחה' : 'ארעה שגיאה');
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
            hideDelay: 3000,
            position: 'top right',
            parent: '#content'
          });
          if (result.status) {
            var item = $filter('filter')(Users, {'id': itemEdited.id}, true)[0];
            if (item)
              msUtils.setJsonObj(item, itemEdited);
          }
        });
      }
    }
    vm.removeEmployee = function (itemEdited) {
      if (orUserAccount.Admin_user.rule != 10) {
        var msg = 'הרשאה חסומה! נא לפנות למנהל כללי לצורך עריכת פרטים'
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + msg + '</div></md-toast>',
          hideDelay: 3000,
          position: 'top right',
          parent: '#content'
        });
        return;
      }
      if (itemEdited) {


        var alert = $mdDialog.confirm()
          .title('מחיקת משתמש')
          .textContent('האם למחוק את ' + itemEdited.nameHE)
          .ariaLabel('Dog name')
          //.targetEvent(ev)
          //.required(true)
          .ok('אישור')
          .cancel('ביטול')

        $mdDialog.show(alert).then(function (result) {
          itemEdited.removed = true;
          orAdminService.UpdateUser(itemEdited).then(function (result) {
            var message = (result.status ? 'עודכן בהצלחה' : 'ארעה שגיאה');
            $mdToast.show({
              template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
              hideDelay: 3000,
              position: 'top right',
              parent: '#content'
            });
            if (result.status) {
              var item = $filter('filter')(Users, {'id': itemEdited.id}, true)[0];
              if (item) {
                item = {};
                msUtils.setJsonObj(item, itemEdited);
              }

            }
          });
        });
      }
    }


  }

})();

(function () {
  'use strict';

  angular
    .module('app.sample', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.sample', {
        url: '/sample',
        views: {
          'content@app': {
            templateUrl: 'app/main/sample/sample.html',
            controller: 'SampleController as vm'
          }
        },
        resolve: {
          SampleData: function (msApi) {
            return msApi.resolve('sample@get');
          }
        }
      });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/sample');

    // Api
    msApiProvider.register('sample', ['app/data/sample/sample.json']);

    // Navigation
    msNavigationServiceProvider.saveItem('fuse', {
      title: 'פציינטים',
      group: true,
      weight: 1,
      rule: 1
    });

    // msNavigationServiceProvider.saveItem('fuse.sample', {
    //     title    : 'Sample',
    //     icon     : 'icon-tile-four',
    //     state    : 'app.sample',
    //     /*stateParams: {
    //         'param1': 'page'
    //      },*/
    //     translate: 'SAMPLE.SAMPLE_NAV',
    //     weight   : 1
    // });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sample')
        .controller('SampleController', SampleController);

    /** @ngInject */
    function SampleController(SampleData)
    {
        var vm = this;

        // Data
        vm.helloText = SampleData.data.helloText;

        // Methods

        //////////
    }
})();

(function () {
  'use strict';

  angular
    .module('app.profile')
    .controller('ProfileController', ProfileController);

  /** @ngInject */
  function ProfileController(Profile, $mdToast, orContacts, orPlacesService, $mdDialog, $document, $timeout, $filter, $state, orUserAccount, Upload, insuranceService) {
    var vm = this;


    vm.profile = Profile;
    vm.copies = [];

    if ($state.params.allowedit && $state.params.allowedit == 'allowedit132')
      vm.adminstatus = true;
    if (!Profile || Profile.name == 'ERROR') {
      $timeout(function () {
        $state.go('app.contacts');
      }, 500)
      return;
    }
    vm.editprofile = false;
    //vm.countCopies = {count: 0, sum: 0}

    if (Profile.ClientBirthDate)
      vm.profile.ClientBirthDate = new Date(vm.profile.ClientBirthDate);
    if (!Profile.PhotosArr) {
      orContacts.LoadPhotos(Profile);
    }
    if (!Profile.Receipts) {
      orContacts.LoadReceipts(Profile);
    }
    if (!Profile.Documents) {
      orContacts.LoadDocuments(Profile);
    }

    if (!Profile.Doctor) {

      orContacts.GetDoctorDetails(Profile.DoctorID).then(function (doctor) {
        Profile.Doctor = doctor;
      });
    }
    if (!Profile.InsuranseStatus) {
      orContacts.clientInsuranseStatus(Profile).then(function (result) {
        console.log("result", result)
      });
    }
    orContacts.GetEmployees().then(function (employees) {
      vm.employees = employees;

      if (!Profile.OvedID) {
        $timeout(function () {
          openDialogEmployee();
        }, 1600)

      }
    })

    vm.editProfileClick = function () {

      vm.editprofile = true;

    }
    orContacts.GetFactorPays().then(function (factorPays) {
      console.log(factorPays);
      vm.factorPays = factorPays;
    });

    vm.updateClientDetails = function () {
      if (Profile.ClientBirthDate)
        Profile.ClientBirthDate = Profile.ClientBirthDate.getFullYear() + '-' + (Profile.ClientBirthDate.getMonth() + 1) + '-' + Profile.ClientBirthDate.getDate();

      orContacts.updateClientDetails(Profile).then(function (result) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('הפרטים נשמרו!')
            //.position(pinTo )
            .hideDelay(5000)
        );
        vm.editprofile = true;
      })
    }


    vm.payments = {sumCashPrice: 0, sumChekPrice: 0, sumCreditCardPrice: 0};

    vm.checksArr = [{date: new Date()}];


    // vm.sumChecks = function () {
    //   var sum = 0;
    //   vm.checksArr.forEach(function (element) {
    //     if (element.amount)
    //       sum += parseFloat(element.amount);
    //   });
    //   vm.payments.checks = sum;
    //   vm.payments.sumall = parseFloat(vm.payments.checks) + parseFloat(vm.payments.creditcard) + parseFloat(vm.payments.cash);
    //   return sum;
    //
    // }

    vm.payBycardOptions = {CLOSED: 0, AUTO: 1, MANUAL: 2}
    vm.payBycardStatus = vm.payBycardOptions.CLOSED;

    // Data

    // Methods
    vm.createInvoice = createInvoice;
    vm.openDialogEmployee = openDialogEmployee;
    vm.openCashDialog = openCashDialog;
    vm.openChecksDialog = openChecksDialog;
    vm.openCreditCardDialog = openCreditCardDialog;
    vm.updateInsurance = UpdateInsurance;
    vm.AllowEditInsurance = AllowEditInsurance;
    vm.RefundStatus = PreRefundStatus;//RefundStatus;
    vm.updateDoctorPrices = updateDoctorPrices;
    vm.editCopies = editCopies;
    vm.sendToInsuranse = sendToInsuranse;
    vm.closeCopyMode = closeCopyMode;
    vm.UpdateCopiesAndDoctor = UpdateCopiesAndDoctor;
    var confirm;
    vm.clientLeft = function (ev) {
      var msg = (Profile.ShulamSW ? 'האם ' + Profile.ClientName + ' עזב?' : 'ללקוח - ' + Profile.ClientName + ' קיים חוב! האם לשחרר בכל זאת?');
      //if (!Profile.ShulamSW) {
      confirm = $mdDialog.confirm()
        .title('שחרור לקוח')
        .textContent(msg)
        .ariaLabel('Lucky day')
        .targetEvent(ev)
        .ok('כן, שחרר לקוח')
        .cancel('לא, אני מתחרט');

      $mdDialog.show(confirm).then(function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent('עודכן בהצלחה')
            .position('top right')
            .hideDelay(4000)
        );
        Profile.ZulamStatus = 5;
        Profile.TimeOUT = new Date();
        orContacts.updateClientLeft(Profile);
        $state.go('app.contacts');
      }, function () {
        //False
      }).finally(function () {
        confirm = undefined;
      });

      //}
    }

    vm.AcceptVisit = function (ev) {

      $mdDialog.show({
        controller: 'AcceptVisitController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/acceptVisit/acceptVisit.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          client: Profile,
          Place: orUserAccount.Place
        }
      }).then(function (id) {

      });

    }
//321321
    vm.sendDocsToEmail = function (ev) {
      console.log(" Profile.Doctor", Profile.Doctor)
      var confirm = $mdDialog.prompt()
        .title('שלח צילומים')
        .textContent('הזן כתובת מייל')
        .placeholder('לא זוהה כתובת מייל של הרופא, אנא הזן אותה כעת')
        .ariaLabel('Dog name')
        .initialValue(Profile.Doctor.Email1)
        .targetEvent(ev)
        //.required(true)
        .ok('שלח')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        orContacts.sendDocsToEmail(Profile.ClientID, Profile.TZ, Profile.ClientName, result);
        alertDialog("הצילומים נשלחו אל " + result, "Success")
      });
    }
    vm.OpenDocument = function (ev, doc) {
      $mdDialog.show({
        controller: 'ShowDocumentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/document/document.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        fullscreen: true,
        locals: {
          Doc: doc
        }
      }).then(function (id) {

      });

    }
    vm.OpenUploadDialog = function (ev) {

      $mdDialog.show({
        controller: 'UploadController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/upload/upload.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        fullscreen: true,
        locals: {
          Profile: Profile
        }
      }).then(function (status) {

      });

    }
    vm.AddDocument = function (ev) {
      alertDialog('פעולה זו תתאפשר בקרוב', 'הוספת מסמך')
    }
    vm.SippingDetails = function (ev) {
      if (!Profile.MishloahID) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('אין משלוח לפציינט זה.')
            .position('bottom right')
            .hideDelay(3000)
        );
        return;
      }
      $mdDialog.show({
        controller: 'SippingDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/shippingDetails/shippingDetails.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          client: Profile,
          Doctor: function () {
            return orContacts.GetDoctorDetails(Profile.DoctorID);
          },
          Place: orUserAccount.Place
        }
      }).then(function (id) {

      });

    }
    vm.RemoveClient = function (ev) {
      var msg;
      if (Profile.TimeOUT) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('לא ניתן למחוק פציינט זה.')
            .position('bottom left')
            .hideDelay(3000)
        );
      }
      if (!Profile.ShulamSW) {
        msg = 'ללקוח - ' + Profile.ClientName + ' קיים חוב! האם למחוק בכל זאת?';
      } else {
        msg = 'ללקוח - האם למחוק את ' + Profile.ClientName + '  ?';
      }
      //if (!Profile.ShulamSW) {
      confirm = $mdDialog.confirm()
        .title('מחיקת לקוח')
        .textContent(msg)
        .ariaLabel('Lucky day')
        .targetEvent(ev)
        .ok('כן, מחק לקוח')
        .cancel('לא, ביטול');

      $mdDialog.show(confirm).then(function () {

        orContacts.removeClient(Profile).then(function (result) {
          var d = new Date();
          orContacts.resolveClients(d, true);
          console.log(result);
          $mdToast.show(
            $mdToast.simple()
              .textContent('עודכן בהצלחה')
              .position('top right')
              .hideDelay(4000)
          );
        });
        // $state.go('app.contacts');
      }, function () {
        //False
      }).finally(function () {
        confirm = undefined;
      });

      //}
    }

    vm.printDetails = function (ev) {

      $mdDialog.show({
        controller: 'ClientDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/bonClient/bonClient.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          client: Profile,
          // Doctor: function () {
          //   return orContacts.GetDoctorDetails(Profile.DoctorID);
          // },
          Place: orUserAccount.Place
        }
      }).then(function (id) {
      });

    }
    function openDialogEmployee(ev) {
      if (Profile.ZulamStatus > 2) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('לא ניתן לעדכן פציינט זה.')
            .position('bottom left')
            .hideDelay(3000)
        );
        return;
      }
      $mdDialog.show({
        controller: 'ProfileDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/register_copyrator.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          copyrators: vm.employees,
          employee: Profile.OvedID
        }
      }).then(function (id) {
        if (id) {
          var selected = $filter('filter')(vm.employees, {OvedID: id}, true)[0];
          Profile.OvedID = selected.OvedID;
          Profile.ovedName = selected.Name;
          Profile.ZulamStatus = (Profile.ZulamStatus < 2 ? 2 : Profile.ZulamStatus);
          orContacts.updateEmployeeOnClient(Profile);
        }// vm.copyrators
        // alert(data);
      });
    }

    function openCashDialog(ev) {
      calculateReceipt();

      var max = (vm.refund ? vm.payments.RefundAmount : Profile.sumAll.topay - Profile.sumPaid)

      var confirm = $mdDialog.prompt()
        .title('קבלת מזומן')
        .textContent('הקש סכום שנתקבל במזומן ולחץ על אישור')
        .placeholder('הזן מחיר')
        .ariaLabel('Dog name')
        .initialValue(max)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        if (isNaN(parseInt(result))) {
          $mdDialog.show(
            $mdDialog.alert()
            //.parent(angular.element(document.querySelector('#popupContainer')))
              .clickOutsideToClose(true)
              .title('שגיאה')
              .textContent('מחיר לא תקין! - ניתן להזין מספר בלבד')
              .ariaLabel('Alert Dialog Demo')
              .ok('סגור')
              .targetEvent(ev)
          );
        } else {
          //Profile.Receipts.sumCashPrice = parseInt(result);
          vm.payments.sumCashPrice = parseInt(result);
          if (vm.refund)
            vm.payments.sumCashPrice *= -1;
          calculateReceipt();
        }
      }, function () {
//        $scope.status = 'You didn\'t name your dog.';
      });
    }

    function calculateReceipt() {
      //Profile.Receipts.sumAllRecepts = Profile.Receipts.sumCashPrice + Profile.Receipts.sumChekPrice + Profile.Receipts.sumCreditCardPrice;
      vm.payments.sumAllRecepts = vm.payments.sumCashPrice + vm.payments.sumChekPrice + vm.payments.sumCreditCardPrice;
    }

    function openChecksDialog(ev) {
      var max = (vm.refund ? vm.payments.RefundAmount : Profile.sumAll.topay - Profile.sumPaid)
      calculateReceipt();
      $mdDialog.show({
        controller: 'ChecksDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/checks/checks.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          max: max,
          checksArr: vm.checksArr
        }
      }).then(function (checks) {
        if (checks) {
          vm.checksArr = checks;
          vm.payments.checks = checks
        }
        //Profile.Receipts.sumChekPrice = 0;
        var sumChecks = 0;
        for (var check in vm.payments.checks) {
          // Profile.Receipts.sumChekPrice += parseInt(vm.payments.checks[check].amount);
          sumChecks += parseInt(vm.payments.checks[check].amount);
        }
        vm.payments.sumChekPrice = sumChecks;
        if (vm.refund)
          vm.payments.sumChekPrice *= -1;
        calculateReceipt();

      });
    }

    function openCreditCardDialog(ev) {
      calculateReceipt();
      var max = (vm.refund ? vm.payments.RefundAmount : Profile.sumAll.topay - Profile.sumPaid - vm.payments.sumAllRecepts)

      $mdDialog.show({
        controller: 'CreditDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/creditcard/creditcard.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          max: max,
          lastcach: vm.payments.creditcard,
          Client: Profile,
          IsRefund: vm.refund
        }
      }).then(function (pelecardDetails) {
        if (pelecardDetails) {
          vm.payments.pelecardDetails = pelecardDetails;
          // Profile.Receipts.sumCreditCardPrice = parseFloat(pelecardDetails.ResultData.DebitTotal) / 100;
          vm.payments.sumCreditCardPrice = parseFloat(pelecardDetails.ResultData.DebitTotal) / 100;
          if (vm.refund)
            vm.payments.sumCreditCardPrice *= -1;
          calculateReceipt();

          //if (vm.payments.sumAllRecepts == Profile.Receipts.firstToPay) {
          createInvoice();
          //}

        }
      });
    }

    function createInvoice() {
      vm.proccess = true;
      orContacts.createInvoice(Profile, vm.payments).then(function (result) {
        console.log(result);

        if (result.status) {
          vm.proccess = false;
          if (result.data.paidAll)
            Profile.ShulamSW = true;
          orContacts.LoadReceipts(Profile);
          $mdToast.show(
            $mdToast.simple()
              .textContent('חשבונית מספר' + result.data.receiptId + ' נוצרה')
              .position('top right')
              .hideDelay(3000)
          );
          $state.go('app.invoice_client.original', {id: result.data.receiptId, original: true})
        } else {
          $mdToast.show(
            $mdToast.simple()
              .textContent('שגיאה ביצירת חשבונית')
              .position('top right')
              .hideDelay(3000)
          );
        }
      });
    }

    function alertDialog(MSG, title) {
      $mdDialog.show(
        $mdDialog.alert()
        //.parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title(title || 'שגיאה')
          .textContent(MSG)
          .ariaLabel('Alert Dialog Demo')
          .ok('סגור')
        //.targetEvent(ev)
      );
    }

    function showToast(MSG) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(MSG)
          .position('bottom right')
          .hideDelay(3000)
      );
    }

    function AllowEditInsurance() {
      return;
      /*
       if (vm.editBituach) {
       vm.editBituach = false;
       return;
       }
       if (vm.profile.ShulamSW) {
       showToast('לא ניתן לעדכן לאחר קבלת תשלום')
       return;
       }
       vm.profile.BituahID_T = vm.profile.BituahID;
       vm.profile.HishtatfutPrice_T = vm.profile.HishtatfutPrice;
       if (vm.profile.BituahID == 1)
       vm.profile.HovotPhotosPrice_T = vm.profile.PhotosPrice;
       else
       vm.profile.HovotPhotosPrice_T = vm.profile.HovotPhotosPrice;
       vm.editBituach = true;
       */
    }

    function UpdateInsurance() {
      if (vm.profile.ShulamSW) {
        showToast('לא ניתן לעדכן לאחר קבלת תשלום')
        return;
      }


      var it = $filter('filter')(vm.factorPays, {BituahID: vm.profile.BituahID_T}, true)[0];
      if (it) {
        var oldIsInsurase = vm.profile.BituahID != 1;
        var newIsInsurase = vm.profile.BituahID_T != 1;
        if (oldIsInsurase != newIsInsurase) {
          if (vm.profile.BituahID == 1) {//old insure
            var s = vm.profile.PhotosPrice;
            vm.profile.HovotPhotosPrice = s;
            vm.profile.PhotosPrice = 0;
            vm.profile.HishtatfutPrice = vm.profile.HishtatfutPrice_T;
          } else {
            var s = vm.profile.HovotPhotosPrice;
            vm.profile.PhotosPrice = s;
            vm.profile.HovotPhotosPrice = 0;
            vm.profile.HishtatfutPrice = 0;
          }
        } else {
          vm.profile.HishtatfutPrice = vm.profile.HishtatfutPrice_T;
        }
        vm.profile.changeInsurance = (oldIsInsurase != newIsInsurase);
        vm.profile.bituachName = it.Name;
        vm.profile.BituahID = it.BituahID;

        //console.log(vm.profile);

        //firstToPay -> get new data from API.

      }
      vm.editBituach = false;
      orContacts.UpdateInsurance(vm.profile).then(function (result) {

        console.log(result);
        vm.profile.Receipts.firstToPay = (vm.profile.PhotosPrice + vm.profile.HishtatfutPrice ) - vm.profile.Receipts.sumAllRecepts;
        if (result.status)
          showToast('נשמר!');
        else
          showToast('ארעה שגיאה!');

      })


      // }


    }

    function PreRefundStatus(Receipt) {
      var rule = orUserAccount.Admin_user.rule;
      if (rule < 6) {
        alertDialog('אין לך הרשאות להפעלת זיכויים', 'הרשאה חסומה')
        return;
      }
      var n = Math.floor(Math.random() * 161111) + 1;
      var confirm = $mdDialog.confirm()
        .title('מספר אישור: ' + n)
        .textContent('אישור מנהל לזיכוי חשבונית ' + Receipt.KabalaID + '. להפעלה נא לחץ על "הפעל"')
        //.placeholder('הקש קוד אישור מנהל')
        .ariaLabel('Dog name')
        .ok('הפעל קוד אישור')
        .cancel('ביטול');
      $mdDialog.show(confirm).then(function (result) {
        showToast('אנא המתן...');
        orContacts.AddCreditPermission(Receipt, n).then(function (res) {
          if (res.status)
            alertDialog('קוד זה יפוג בעוד שעה', ' קוד ' + n + ' הופעל');
          else
            alertDialog('שארעה שגיאה')
        })

      });
    }

    function RefundStatus(Receipt) {
      vm.payments.sumCashPrice = 0;
      vm.payments.sumChekPrice = 0;
      vm.payments.sumCreditCardPrice = 0;

      calculateReceipt();

      if (Receipt) {
        vm.refund = true;
        vm.payments.RefundHeshbonitID = Receipt.HeshbonitID;
        vm.payments.RefundKabalaID = Receipt.KabalaID;
        vm.payments.RefundAmount = Receipt.sumAll;
      } else {
        vm.refund = false;
        vm.payments.RefundHeshbonitID = undefined;
        vm.payments.RefundKabalaID = undefined;
        vm.payments.RefundAmount = undefined;
      }
    }

    var OldCopies = [];

    function editCopies(ev) {
      vm.editCopyMode = true;

      angular.copy(Profile.PhotosArr, OldCopies);
      return;
      orContacts.GetDoctorDetails(Profile.DoctorID).then(function (doctor) {

        $mdDialog.show({
          controller: 'EditCopiesController',
          controllerAs: 'vm',
          templateUrl: 'app/main/profile/dialog/editCopies/editCopies.html',
          parent: angular.element($document.find('#content-container')),
          targetEvent: ev,
          clickOutsideToClose: false,
          escapeToClose: false,
          multiple: true,
          locals: {Doctor: doctor, Copies: vm.profile.PhotosArr}
        }).then(function (data) {
          console.log(data);
          if (data) {
            Profile.DoctorID = data.doctor.DoctorID;
            vm.profile.doctorName = data.doctor.Name;
            vm.profile.doctorName = data.doctor.Name;
            vm.profile.NoteOUT = data.doctor.NoteOUT;
            vm.profile.NoteIN = data.doctor.NoteOUT;
            vm.profile.PhotosList = data.countCopies.str;
            if (vm.profile.BituahID == 1)
              vm.profile.PhotosPrice = data.countCopies.sum;
            else
              vm.profile.HovotPhotosPrice = data.countCopies.sum;
            // calculateReceipt();
            // vm.profile.Receipts.firstToPay = (vm.profile.PhotosPrice + vm.profile.HishtatfutPrice ) - vm.profile.Receipts.sumAllRecepts;


            orContacts.UpdateCopiesAndDoctor(vm.profile).then(function (res) {
              console.log("result");
              console.log(res);
              if (res.status) {

              }
              orContacts.LoadReceipts(Profile).then(function () {
                console.log('!!!')
              });
            });
            //update dbo.clients + dbo.clientPrice/HovotPrice
          }


        });
      })


    }

    function sendToInsuranse(ev) {

      const sendNow = function () {
        vm.proccess = true;
        orContacts.SendClaimToInsurance(Profile).then(function (status) {
          //showToast("status: " + status.data);
          alertDialog(status.data === true ? "הושלם בהצלחה" : status.data, "סטטוס הגשת צילום/תביעה")

          if (status) {
            orContacts.clientInsuranseStatus(Profile).then(function (result) {
              vm.proccess = false;
            });
          }
        })
      }
      console.log(Profile);
      if (Profile.InsuranseStatus.statusCode == 200) {
        confirm = $mdDialog.confirm()
          .title('שידור תביעה')
          .textContent("הצילומים הוגשו כבר! האם לשלוח שנית?")
          .ariaLabel('Lucky day')
          .targetEvent(ev)
          .ok('כן')
          .cancel('לא, בטל');

        $mdDialog.show(confirm).then(function () {
          sendNow();
        })
      } else
        sendNow();

      //showToast('פעולה זו אינה זמינה כרגע. - בקרוב...')
      return true;
    }

    function updateDoctorPrices() {
      console.log(vm.copies)
      console.log(vm.doctor)
    }

    function closeCopyMode() {
      vm.editCopyMode = false;
      Profile.PhotosArr.splice(0, Profile.PhotosArr.length);
      for (var ind in OldCopies) {
        Profile.PhotosArr.push(OldCopies[ind]);
      }
    }

    function UpdateCopiesAndDoctor() {
      vm.editCopyMode = false;
      if (vm.profile.ClientBirthDate)
        vm.profile.ClientBirthDate = vm.profile.ClientBirthDate.getFullYear() + '-' + (vm.profile.ClientBirthDate.getMonth() + 1) + '-' + vm.profile.ClientBirthDate.getDate();

      orContacts.UpdateCopiesAndDoctor(vm.profile).then(function (res) {
        console.log("result");
        console.log(res);

        //if (res.status) {
        showToast('הפרטים עודכנו בהצלחה')

        orContacts.LoadReceipts(vm.profile).then(function () {
          console.log('!!!')
        });
        // }else


      }, function (err) {
        showToast('שגיאה בעת עדכון נתונים')
      });
    }


    vm.documents = [
      {ID: 1, docName: 'abc', name: 'צילום נשך', date: '2018-01-14', PhotoID: 52},
      {ID: 2, docName: 'abc', name: 'הפנייה', date: '2018-01-14'},
      {ID: 3, docName: 'abc', name: 'המלצות רופא', date: '2018-01-14'}
    ];

    vm.upload = function (file) {
      vm.uploadProccess = 'טוען';
      Upload.upload({
        url: 'http://pano-api.azurewebsites.net/documents/upload/' + Profile.ClientID,
        data: {file: file, 'username': '$scope.username'}
      }).then(function (resp) {
        console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
        vm.uploadProccess = 'טעינת קובץ הושלמה. אנא המתן...';
        clearProccessUpload();
        /*$timeout(function () {
         vm.uploadProccess = 'מעדכן נתונים...';
         clearProccessUpload();
         }, 1200)*/
        $timeout(function () {

          vm.uploadProccess = 'מעדכן נתונים...';
          reloadDocuments(vm.profile.Documents.length);
        }, 5000)

      }, function (resp) {
        console.log('Error status: ' + resp.status);
        vm.uploadProccess = 'ארעה שגיאה בטעינת קובץ';
        clearProccessUpload();
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
        vm.uploadProccess = 'מעלה ' + progressPercentage + '% ';
      });
    };
    var clearProccessUpload = function () {
      $timeout(function () {
        vm.uploadProccess = undefined;
      }, 3000)
    }
    var reloadDocuments = function (lastLength) {
      console.log('reloadDocuments');
      console.log(lastLength);
      orContacts.LoadDocuments(Profile).then(function (r) {
        if (lastLength == vm.profile.Documents.length) {
          $timeout(function () {
            vm.uploadProccess = 'מעדכן נתונים...';
            reloadDocuments(vm.profile.Documents.length)
          });
        } else {
          vm.uploadProccess = 'הושלם!';
          clearProccessUpload()
        }

      });

    }

    vm.addReferrence = function (ev, photo) {


      var confirm = $mdDialog.prompt()
        .title('אסמכתא')
        .textContent('הקש מספר אסמכתא')
        .placeholder('אסמכתא')
        .ariaLabel('Dog name')
        .initialValue(photo.reference)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        if (isNaN(parseInt(result)) && result !== 'מושלם') {
          $mdDialog.show(
            $mdDialog.alert()
            //.parent(angular.element(document.querySelector('#popupContainer')))
              .clickOutsideToClose(true)
              .title('שגיאה')
              .textContent('ערך אסמכתא אינו תקין!')
              .ariaLabel('Alert Dialog Demo')
              .ok('סגור')
              .targetEvent(ev)
          );
        } else {
          //Profile.Receipts.sumCashPrice = parseInt(result);
          photo.reference = result;


          insuranceService.UpdateStatusPhoto(photo).then(function (res) {
            vm.proccess = false;
            // if (!res.status)
            //   item.status = old_status;
            $mdToast.show(
              $mdToast.simple()
                .textContent(res && res.status ? 'OK' : "נכשל - ייתכן ומספר אסמכתא זה קיים כבר במערכת")
                .position('top right')
                .hideDelay(3000)
            );
          })


        }
      }, function () {
//        $scope.status = 'You didn\'t name your dog.';
      });

    }


    vm.addClalitOrder = function (ev, photo) {

      var confirm = $mdDialog.prompt()
        .title('קופ"ח כללית - הזמנת רכש')
        .textContent('הקש מספר הזמנת רכש')
        .placeholder('מספר הזמנת רכש')
        .ariaLabel('Dog name')
        .initialValue(photo.orderNumber)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        if (!result) {
          $mdDialog.show(
            $mdDialog.alert()
            //.parent(angular.element(document.querySelector('#popupContainer')))
              .clickOutsideToClose(true)
              .title('שגיאה')
              .textContent('ערך אינו תקין!')
              .ariaLabel('Alert Dialog Demo')
              .ok('סגור')
              .targetEvent(ev)
          );
        } else {
          //Profile.Receipts.sumCashPrice = parseInt(result);
          photo.orderNumber = result;


          insuranceService.updateOrderNumberPhoto(photo).then(function (res) {
            vm.proccess = false;
            // if (!res.status)
            //   item.status = old_status;
            $mdToast.show(
              $mdToast.simple()
                .textContent(res && res.status ? 'OK' : "נכשל - ייתכן ומספר רכש זה קיים כבר במערכת")
                .position('top right')
                .hideDelay(3000)
            );
          })


        }
      }, function () {
//        $scope.status = 'You didn\'t name your dog.';
      });

    }

    //////////
  }


})();

(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('NotesController', NotesController);

    /** @ngInject */
    function NotesController($document, $timeout, $scope, $mdSidenav, NotesService, LabelsService, $mdDialog)
    {
        var vm = this;

        // Data
        vm.notes = NotesService.data;
        vm.labels = LabelsService.data;
        vm.search = '';
        vm.searchToolbar = false;
        vm.filters = {
            archive: false
        };
        vm.labelFilterIds = [];
        vm.noteListType = 'notes';

        // Methods
        vm.filterChange = filterChange;
        vm.openSearchToolbar = openSearchToolbar;
        vm.closeSearchToolbar = closeSearchToolbar;
        vm.editNote = editNote;
        vm.deleteLabel = deleteLabel;
        vm.toggleSidenav = toggleSidenav;
        vm.addNewLabel = LabelsService.addLabel;

        //////////

        /**
         * Change Notes Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.noteListType = type;

            if ( type === 'notes' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    archive: false
                };
            }
            else if ( type === 'archive' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    archive: true
                };
            }
            else if ( type === 'reminders' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    reminder: '',
                    archive : false
                };
            }
            else if ( angular.isObject(type) )
            {
                vm.labelFilterIds = [];
                vm.labelFilterIds.push(type.id);
            }

            $mdSidenav('main-sidenav').close();

        }

        /**
         * Edit Note
         * @param ev
         * @param noteId
         */
        function editNote(ev, noteId)
        {
            $mdDialog.show({
                template           : '<md-dialog ms-scroll><ms-note-form note-type="\'edit\'" note-id="\'' + noteId + '\'"></ms-note-form></md-dialog>',
                parent             : $document.find('#notes'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true
            });
        }

        /**
         * Delete Label
         * @param ev
         * @param label
         */
        function deleteLabel(ev, label)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the label?')
                .htmlContent('The "' + label.name + '" label will be deleted permanently.')
                .ariaLabel('delete label')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                LabelsService.deleteLabel(label);
            });
        }

        /**
         * Open Search Toolbar
         */
        function openSearchToolbar()
        {
            vm.searchToolbar = true;

            $timeout(function ()
            {
                angular.element($document.find('#search-notes-input')).trigger('focus');

            });

            $document.on('keyup', escKeyEvent);
        }

        /**
         * Close Search Toolbar
         */
        function closeSearchToolbar()
        {
            $scope.$evalAsync(function ()
            {
                vm.searchToolbar = false;
                vm.search = '';
            });

            $document.off('keyup', escKeyEvent);
        }

        /**
         * Escape key event
         */
        function escKeyEvent(e)
        {
            if ( e.keyCode === 27 )
            {
                closeSearchToolbar();
            }
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }

})();
(function () {
  'use strict';

  angular
    .module('app.inventories')
    .controller('InventoriesController', InventoriesController);

  /** @ngInject */
  function InventoriesController(Inventories, Title, inventoriesService, $timeout,$filter) {

    var vm = this;
    // data
    vm.inventories = $filter('filter')(Inventories, {status: '!0'});

    function setBadge() {
      $timeout(function () {
        $("a[ui-sref='app.inventories'] .badge").text(Inventories.length);
      }, 1000)
    }
    vm.title = Title;
    setBadge();
    vm.clientsSearch;

    vm.feilds = [
      //{key: 'ClientID', name: 'קוד לקוח'},
      {key: 'ID', name: 'מס.'},
      {key: 'name', name: 'שם'},
      {key: 'employeeName', name: 'שם עובד'},
      {key: 'placeName', name: 'סניף'},
      {key: 'status_name', name: 'סטאטוס'},
      {key: 'stokeeperName', name: 'מחסנאי'},
      {key: 'date_created', name: 'תאריך', type: 'date'},
      {key: 'comments_place', name: 'הערות'},
      {key: 'comments_stockeeper', name: 'הערות מחסן'}

    ];
    vm.config = {
      rowClick: {
        type: 'ref',
        ui_serf: 'app.inventories_order',
        params: [{key: 'order', value: 'ID'}]
      }
    }

    vm.refresh = function (reload) {
      vm.clientsSearch = undefined;
      vm.proccess = true;
      inventoriesService.Orders(vm.search, reload).then(function () {
        vm.proccess = false;
        setBadge();
        // vm.search = '';
        //vm.inventories = Inventories;
      });
      vm.isCustomSearch = false;

    }
    var intervalCheck;
    vm.typeSearch = function () {
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(deepSearch, 500);
    }
    var deepSearch = function () {
      if (vm.search.length < 3 || vm.proccess)
        return;

      vm.refresh();

    }

    vm.clear = function () {
      // Refferings.splice(0, Refferings.length);
      // vm.clients = ReferringPlaceList.data;
    }
    vm.refreshAll = function () {
      vm.proccess = true;
      setBadge();
      // orContacts.ReferringPlaceList().then(function () {
      //   vm.proccess = false;
      //   vm.clients = ReferringPlaceList.data;
      // });
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.doctors_group', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.doctors_group', {
      url: '/doctors_group',
      views: {
        'content@app': {
          templateUrl: 'app/main/group_doctors/doctors_group.html',
          controller: 'Doctors_groupController as vm'
        }
      },
      resolve: {
        DoctorsGroup: function (orAdminService) {
          return orAdminService.GetDoctorsGroupList();
        }
      }
    });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/contacts');

    msNavigationServiceProvider.saveItem('doctors.doctors_group', {
      title: 'קבוצת מרפאות',
      state: 'app.doctors_group',
      weight: 3,
      rule: 10,
    });


  }

})();

(function () {
  'use strict';

  angular
    .module('app.doctors_group')
    .controller('Doctors_groupController', Doctors_groupController);

  /** @ngInject */
  function Doctors_groupController(DoctorsGroup, $scope, $mdSidenav, msUtils, $mdDialog, $mdToast, $document, $state, $filter,
                                   orAdminService, orUserAccount) {

    var vm = this;
    // data


    vm.dates = {start: new Date()};
    vm.reportType = 0;
    vm.ClientsReports = {
      feilds: [
        {key: 'groupID', name: 'מזהה', show: "gt-md"},
        {key: 'groupName', name: 'מרפאה'},
        {key: 'doctors', name: 'רופאים'},
        {key: 'address', name: 'כתובת'},
        {key: 'tel', name: 'טלפון', show: "gt-sm"},
        {key: 'pel', name: 'נייד', show: "gt-xs"},
        {key: 'email', name: 'אימייל', show: "gt-xs"}
      ],
      edit: [
        {key: 'groupName', name: 'רופא/מרפאה', required: true, icon: 'icon-account'},
        {key: 'address', name: 'כתובת', required: true},
        {key: 'doctors', name: 'רופאים - חובה להפריד בפסיקים', required: true, pattern: "[0-9]+(,[0-9]+)*"},
        {key: 'tel', name: 'טלפון', icon: 'icon-phone', required: true},
        {key: 'pel', name: 'נייד', icon: 'icon-phone'},
        {key: 'email', name: 'אימייל', icon: 'icon-email'},
        {key: 'fax', name: 'פקס', icon: 'icon-fax'},
        {key: 'comments', name: 'הערות', icon: 'icon-comment'},
        {key: 'username', name: 'שם משתמש', icon: 'icon-comment', required: true},
        {key: 'pass', name: 'סיסמא', icon: 'icon-comment', required: true},

      ],
      data: DoctorsGroup,
      config: {
        //rowClick: {type: 'ref', ui_serf: 'app.doctors_card', params: [{key: 'id', value: 'DoctorID'}]}
      }
    }
    var intervalCheck;
    vm.change = function () {
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(deepSearch, 500);
    }

    var deepSearch = function (dates) {
      if (vm.search.length < 3 || vm.proccess)
        return;
      vm.proccess = true;

      orAdminService.GetDoctorsGroupList(vm.search).then(function () {
        vm.proccess = false;
      });

    }


    vm.RegisterNewGroupDoctor = function (doctor) {
      orAdminService.InsertNewDoctorGroup(doctor).then(function (success) {
        var message = (success ? 'עודכן בהצלחה' : 'ארעה שגיאה');
        showToast(message);
      });
    }
    vm.InactiveDoctor = function (doctor) {
      var confirm = $mdDialog.confirm()
        .title('הסרת רופא מהמערכת')
        .htmlContent(' האם להפוך רופא ' + doctor.Name + ' ללא פעיל')
        .ariaLabel('delete label')
        //.targetEvent(ev)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function () {
        orAdminService.InactiveDoctor(doctor).then(function (result) {
          var message = (result.status ? doctor.Name + ' הוסר' : 'ארעה שגיאה');
          showToast(message);
        });
      });

    }
    function showToast(msg) {
      $mdToast.show({
        template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + msg + '</div></md-toast>',
        hideDelay: 3000,
        position: 'top right',
        parent: '#content'
      });
    }

    vm.editItem = function (itemEdited) {
      if (itemEdited) {
        orAdminService.UpdateDoctorGroupDetail(itemEdited).then(function (result) {
          var message = (result.status ? 'עודכן בהצלחה' : 'ארעה שגיאה');
          showToast(message);
          if (result.status) {
            var item = $filter('filter')(DoctorsGroup, {'groupID': itemEdited.groupID}, true)[0];
            if (item) {
              msUtils.setJsonObj(item, itemEdited);
            }
          }
        });
      }
    }

    vm.deleteItem = function (itemEdited) {
      if (itemEdited) {
        msUtils.Confirm('מחיקת מרפאה', 'האם למחוק קבוצה זו?').then(function (result) {
          orAdminService.UpdateDoctorGroupDetail(itemEdited).then(function (result) {
            var message = (result.status ? 'עודכן בהצלחה' : 'ארעה שגיאה');
            showToast(message);
            if (result.status) {
              var item = $filter('filter')(DoctorsGroup, {'groupID': itemEdited.groupID}, true)[0];
              if (item) {
                var idx = DoctorsGroup.indexOf(item);
                console.log('idx', idx);
                DoctorsGroup.splice(idx);
              }
            }
          });
        });

      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.employess', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.employees', {
      url: '/employees',
      views: {
        'content@app': {
          templateUrl: 'app/main/employees/employees.html',
          controller: 'EmployeesController as vm'
        }
      },
      resolve: {
        Employees:function (orAdminService) {
          return orAdminService.GetEmployessList();
        },
        Places:function (orPlacesService) {

          return orPlacesService.Places();
        }
      }
    });
    $stateProvider.state('app.employee_card_all', {
      url: '/employees/all/employees',
      views: {
        'content@app': {
          templateUrl: 'app/main/employees/employee-card/employee-card.html',
          controller: 'EmployeeCardController as vm'
        }
      },
      resolve: {
        Employee:function (orAdminService,$stateParams,$cookies) {
          return orAdminService.GetEmployee(0);
        },Employees:function (orAdminService) {
          return orAdminService.GetEmployessList();
        },
        Places:function (orPlacesService) {
          return orPlacesService.Places();
        }
      }
    });
    $stateProvider.state('app.employee_card', {
      url: '/employees/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/employees/employee-card/employee-card.html',
          controller: 'EmployeeCardController as vm'
        }
      },
      resolve: {
        Employee:function (orAdminService,$stateParams,$cookies) {
          var employeeID = $stateParams.id || $cookies.get('employeeID') || 5;
          $cookies.put('employeeID', employeeID);
          return orAdminService.GetEmployee(employeeID);
        },Employees:function (orAdminService) {
          return orAdminService.GetEmployessList();
        },
        Places:function (orPlacesService) {
          return orPlacesService.Places();
        }
        // DashboardData: function (msApi)
        // {
        //   return msApi.resolve('dashboard.project@get');
        // }
      }
    });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/contacts');

    msNavigationServiceProvider.saveItem('employees', {
      title: 'עובדים',
      icon: 'icon-person-box',
      group: false,
      weight: 4,
      rule: 5,
      //rule:10,
    });
    msNavigationServiceProvider.saveItem('employees.employees', {
      title: 'רשימת עובדים',
      state: 'app.employees',
      weight: 1,
      rule:5,
    });
    msNavigationServiceProvider.saveItem('employees.employee_card', {
      title: 'שעות נוכחות',
      state: 'app.employee_card_all',
      weight: 2,
      rule:10,
    });
   /* msNavigationServiceProvider.saveItem('employees.employee_card', {
      title: 'כרטיס עובד',
     // icon: 'icon-account-multiple',
      state: 'app.employee_card',
      weight: 1
    });*/

    // Api




  }

})();

(function () {
  'use strict';

  angular
    .module('app.employess')
    .controller('EmployeesController', EmployeesController);

  /** @ngInject */
  function EmployeesController(Employees, Places, msUtils, $mdDialog, $mdToast, $filter, orAdminService, orUserAccount) {

    var vm = this;
    // data


    vm.dates = {start: new Date()};
    vm.reportType = 0;

    vm.table = {
      feilds: [
        {key: 'OvedID', name: 'מזהה'},
        {key: 'Name', name: 'שם'},
        {key: 'TZ', name: 'זהות'},
        {key: 'PlaceCity', name: 'סניף', filter: true},
        {key: 'Address', name: 'כתובת'},
      ],
      feildsWorkNow: [
        {key: 'OvedID', name: 'מזהה'},
        {key: 'Name', name: 'שם'},
        {key: 'TZ', name: 'זהות'},
        {key: 'PlaceCity', name: 'סניף', filter: true},
        {key: 'Address', name: 'כתובת'},
        {key: 'TimeIN', name: 'כניסה', type: 'time'}
      ],
      edit: [
        {key: 'Name', name: 'שם עובד', required: true, icon: 'icon-account'},
        {key: 'Address', name: 'כתובת', required: true, icon: 'icon-home'},
        {key: 'TZ', name: 'מספר זהות', required: true, icon: 'icon-account-alert'},
        {key: 'Tel', name: 'טלפון', minlength: 6, icon: 'icon-phone'},
        {key: 'Pel', name: 'נייד', required: true, minlength: 6, icon: 'icon-cellphone-android'},
        {key: 'PlaceID', name: 'סניף', required: true, select: {data: Places, key: 'PlaceID', value: 'Name'}},
        {key: 'CardNumber', name: 'מספר כרטיס', required: true, icon: 'icon-credit-card'},
        {key: 'BirthDate', name: 'ת. לידה', type: 'date'},
        {key: 'StartDate', name: 'תחילת עבודה', type: 'date'},
        {key: 'NoteS', name: 'הערות', icon: 'icon-comment'},

      ],
      data: Employees,
      config: {
        rowClick: {type: 'ref', ui_serf: 'app.employee_card', params: [{key: 'id', value: 'OvedID'}]}
      }
    }
    vm.worksOnlyData = [];
    var intervalCheck;
    vm.change = function () {
      if (vm.worksNowStatus)
        return;
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(deepSearch, 500);
    }

    var deepSearch = function (dates) {
      if (vm.search.length < 2 || vm.proccess)
        return;
      vm.proccess = true;

      orAdminService.GetEmployessList(vm.search).then(function () {
        vm.proccess = false;
      });

    }

    vm.editItem = function (itemEdited) {
      if (orUserAccount.Admin_user.rule != 10) {
        var msg='הרשאה חסומה! נא לפנות למנהל כללי לצורך עריכת פרטים'
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + msg + '</div></md-toast>',
          hideDelay: 3000,
          position: 'top right',
          parent: '#content'
        });
        return;
      }
      console.log(itemEdited);
      if (itemEdited) {
        orAdminService.UpdateEmployeeDetail(itemEdited).then(function (result) {
          var message = (result.status ? 'עודכן בהצלחה' : 'ארעה שגיאה');
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
            hideDelay: 3000,
            position: 'top right',
            parent: '#content'
          });
          if (result.status) {
            var item = $filter('filter')(Employees, {'OvedID': itemEdited.OvedID}, true)[0];
            if (item)
              msUtils.setJsonObj(item, itemEdited);
          }
        });
      }
    }

    vm.addEmployee = function (itemEdited) {
      if (orUserAccount.Admin_user.rule != 10) {
        var msg='הרשאה חסומה! נא לפנות למנהל כללי לצורך עריכת פרטים'
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + msg + '</div></md-toast>',
          hideDelay: 3000,
          position: 'top right',
          parent: '#content'
        });
        return;
      }
      console.log(itemEdited);
      if (itemEdited) {
        orAdminService.UpdateEmployeeDetail(itemEdited).then(function (result) {
          var message = (result.status ? 'עודכן בהצלחה' : 'ארעה שגיאה');
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
            hideDelay: 3000,
            position: 'top right',
            parent: '#content'
          });
          if (result.status) {
            var item = $filter('filter')(Employees, {'OvedID': itemEdited.OvedID}, true)[0];
            if (item)
              msUtils.setJsonObj(item, itemEdited);
          }
        });
      }
    }
    vm.removeEmployee = function (itemEdited) {
      if (orUserAccount.Admin_user.rule != 10) {
        var msg='הרשאה חסומה! נא לפנות למנהל כללי לצורך עריכת פרטים'
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + msg + '</div></md-toast>',
          hideDelay: 3000,
          position: 'top right',
          parent: '#content'
        });
        return;
      }
      if (itemEdited) {


        var alert = $mdDialog.confirm()
          .title('מחיקת עובד')
          .textContent('האם למחוק את ' + itemEdited.Name)
          .ariaLabel('Dog name')
          //.targetEvent(ev)
          //.required(true)
          .ok('אישור')
          .cancel('ביטול')

        $mdDialog.show(alert).then(function (result) {
          orAdminService.DeleteEmployee(itemEdited).then(function (result) {
            var message = (result.status ? 'עודכן בהצלחה' : 'ארעה שגיאה');
            $mdToast.show({
              template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
              hideDelay: 3000,
              position: 'top right',
              parent: '#content'
            });
            if (result.status) {
              var item = $filter('filter')(Employees, {'OvedID': itemEdited.OvedID}, true)[0];
              if (item)
                msUtils.setJsonObj(item, itemEdited);
            }
          });
        });
      }
    }

    vm.worksNow = function (worksOnly) {
      if (worksOnly) {
        vm.proccess = true;
        orAdminService.GetEmployessWorkNow().then(function (data) {
          vm.worksNowStatus = worksOnly;
          vm.worksOnlyData = data;
          vm.proccess = false;
        });
      } else {
        vm.worksNowStatus = worksOnly;
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.doctors')
    .controller('DoctorsController', DoctorsController);

  /** @ngInject */
  function DoctorsController(Doctors, $scope, $mdSidenav, msUtils, $mdDialog, $mdToast, $document, $state, $filter,
                             orAdminService, orUserAccount) {

    var vm = this;
    // data


    vm.dates = {start: new Date()};
    vm.reportType = 0;
    vm.ClientsReports = {
      feilds: [
        {key: 'DoctorID', name: 'מזהה',show: "gt-md"},
        {key: 'Name', name: 'רופא/מרפאה'},
        {key: 'Address', name: 'כתובת'},
        {key: 'Tel1', name: 'טלפון',show: "gt-sm"},
        {key: 'Email1', name: 'אימייל',show:"gt-xs"},
        {key: 'username', name: 'ממשק פעיל', type: 'icon', icon: 'icon-check-bookmark', hideNull: true,show:"gt-xs"},
      ],
      edit: [
        {key: 'Name', name: 'רופא/מרפאה', required: true, icon: 'icon-account'},
        {key: 'Address', name: 'כתובת', required: true},
        {key: 'Tel1', name: 'טלפון', minlength: 6, icon: 'icon-phone'},
        {key: 'Email1', name: 'אימייל', icon: 'icon-email', required: true},
        {key: 'BirthDate', name: 'ת. לידה', type: 'date'},
        {key: 'NoteIN', name: 'הערות פנימיות', icon: 'icon-comment'},
        {key: 'NoteOUT', name: 'הערות למרפאה', icon: 'icon-comment'},
        {
          key: 'Sale',
          name: 'אחוזי הנחה כללי',
          icon: 'icon-percent',
          max: 100,
          min: 0,
          type: 'number',
          pattern: "/^[0-9]*$/"
        },
      ],
      data: Doctors,
      config: {
        rowClick: {type: 'ref', ui_serf: 'app.doctors_card', params: [{key: 'id', value: 'DoctorID'}]},
        filterMultyWords: "Name"
      }
    }
    var intervalCheck;
    vm.change = function () {
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(deepSearch, 500);
    }

    var deepSearch = function (dates) {
      if (vm.search.length < 3 || vm.proccess)
        return;
      vm.proccess = true;

      orAdminService.GetDoctorsList(vm.search).then(function () {
        vm.proccess = false;
      });

    }
    vm.RegisterNewDoctor = function (doctor) {
      orAdminService.InsertNewDoctor(doctor).then(function (success) {
        var message = (success ? 'עודכן בהצלחה' : 'ארעה שגיאה');
        showToast(message);
      });
    }
    vm.InactiveDoctor = function (doctor) {
      var confirm = $mdDialog.confirm()
        .title('הסרת רופא מהמערכת')
        .htmlContent(' האם להפוך רופא ' + doctor.Name + ' ללא פעיל')
        .ariaLabel('delete label')
        //.targetEvent(ev)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function () {
        orAdminService.InactiveDoctor(doctor).then(function (result) {
          var message = (result.status ? doctor.Name + ' הוסר' : 'ארעה שגיאה');
          showToast(message);
        });
      });

    }
    function showToast(msg) {
      $mdToast.show({
        template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + msg + '</div></md-toast>',
        hideDelay: 3000,
        position: 'top right',
        parent: '#content'
      });
    }

    vm.editItem = function (itemEdited) {
      if (itemEdited) {
        orAdminService.UpdateDoctorDetail(itemEdited).then(function (result) {
          var message = (result.status ? 'עודכן בהצלחה' : 'ארעה שגיאה');
          showToast(message);
          if (result.status) {
            var item = $filter('filter')(Doctors, {'DoctorID': itemEdited.DoctorID}, true)[0];
            if (item)
              msUtils.setJsonObj(item, itemEdited);
          }
        });
      }
    }


  }

})();

(function () {
  'use strict';

  angular
    .module('app.contacts')
    .controller('ContactsController', ContactsController);

  /** @ngInject */
  function ContactsController($scope, $mdSidenav, msUtils, $mdDialog, $mdToast, $document, $state, $filter,
                              orContacts, orPlacesService, Clients, orUserAccount) {

    var vm = this;
    // data
    vm.clients = Clients;
    // vm.waiters = $filter('filter')(vm.clients, {ZulamStatus: 1}, true).length;
    vm.dates = {start: new Date()};
    vm.feilds = [
      //{key: 'ClientID', name: 'קוד לקוח'},
      {key: 'ClientName', name: 'שם פציינט'},
      {key: 'KDate', name: 'תאריך', type: 'date'},
      {key: 'TimeIN', name: 'כניסה', type: 'time', show: 'gt-md'},
      {key: 'TimeOUT', name: 'יציאה', type: 'time', show: 'gt-md'},
      {key: 'PhotosListClient', name: 'צילומים', show: 'gt-xs', class: 'text-truncate'},
      {key: 'doctorName', name: 'רופא', filter: true},
      {key: 'ovedName', name: 'מצלם', filter: true, show: 'gt-md'},
      {key: 'sumPay', name: 'מחיר', type: 'customCurrency',show: 'gt-sm'},

      {key: 'placeName', name: 'סניף', filter: true},
      {key: 'bituachName', name: 'ביטוח', filter: true, show: 'gt-sm'},
      {key: 'MithareName', name: 'מתחרה', show: 'gt-md', class: 'red-fg'},
      {key: 'ClientNote', name: 'הערות', show: 'gt-lg'},
      {key: 'unUploadPhoto', name: 'תמונות במערכת', type: 'icon', icon: 'icon-film', showNull: true, show: 'gt-md'},


    ];
    var ColorClassStatus = function (item) {
      //console.log('item', item)
      if (!item.paidAll)
        return 'red-fg';
      return '';
    }
    vm.config = {
      rowClick: {type: 'ref', ui_serf: 'app.profile', params: [{key: 'id', value: 'ClientID'}]},
      classFunc: ColorClassStatus
    }


    //vm.date = orContacts.dateList();


//function
    vm.refresh = function () {
      vm.proccess = true;
      orPlacesService.GetClientsPlace(vm.dates).then(function () {
        // vm.waiters = $filter('filter')(vm.clients, {ZulamStatus: 1}, true).length;
        vm.proccess = false;
      });
      vm.isCustomSearch = false;

    }

    vm.classStatus = function (client) {
      if (client.ShulamSW)
        return '';

      switch (client.ZulamStatus) {
        case 1://open client. (no employee)
          return 'blue-fg';
        case 2://select card - select employee.
          return 'green-fg';
        default:
          if (client.PhotosPrice)
            return 'red-fg';
          return '';
      }
    }
    // vm.refresh = function () {
    //   vm.proccess=true;
    //   orContacts.resolveClients(vm.date, true).then(function () {
    //     vm.proccess=false;
    //   });
    //   vm.isCustomSearch = false;
    // }

    vm.isOpen = false;


    // Data
    vm.default_avatar = 'assets/images/avatars/profile.jpg';
    vm.contacts;

    /*orContacts.GetEmployees().then(function (employees) {
     vm.employees = employees;
     });*/
    // Methods
    vm.filterChange = filterChange;
    vm.openContactDialog = openContactDialog;
    vm.toggleSidenav = toggleSidenav;
    vm.toggleInArray = msUtils.toggleInArray;

    vm.openImportDialog = function (ev, key) {
      $mdDialog.show({
        controller: 'importContacts',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/contacts/dialogs/import/importContacts.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          key: key
        }
      });
    }
    vm.Search = function (ev) {



//321321
      $mdDialog.show({
        controller: 'ContactDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/contacts/dialogs/contact/contact-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          client: {},
          Place: {}
        }
      }).then(function (dataSearch) {
        if (!dataSearch)
          return;
        if (!dataSearch.TZ && !dataSearch.ClientName && !dataSearch.Tel && !dataSearch.KDate && !dataSearch.HeshbonitID && !dataSearch.MishloachID && !dataSearch.DoctorName) {
          var message = 'לא ניתן לבצע חיפוש. השלם לפחות שדה אחת';
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
            hideDelay: 3000,
            position: 'top right',
            parent: '#content'
          });
        } else {
          vm.proccess = true;
          orPlacesService.SearchClients(dataSearch).then(function (e) {
            vm.proccess = false;
          });
          vm.isCustomSearch = true;
        }

      });

    }
    vm.sortBy = 'KDate';
    vm.changeSort = function (feild) {
      vm.sortBy = feild;
    }
    //edit contact - navigate from report/history
    if ($state.params.id) {
      vm.header = 'פציינטים למשלוח ' + $state.params.id;
    }


    var confirm;
    var printClient = function (Profile, ev) {

      $mdDialog.show({
        controller: 'ClientDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/bonClient/bonClient.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          client: Profile,
          // Doctor: function () {
          //   return orContacts.GetDoctorDetails(Profile.DoctorID);
          // },
          Place: orUserAccount.Admin_user
        }
      }).then(function (id) {
      });

    };
    var SippingDetails = function (Profile, ev) {
      /* if (!Profile.MishloahID) {
       $mdToast.show(
       $mdToast.simple()
       .textContent('אין משלוח לפציינט זה.')
       .position('bottom right')
       .hideDelay(3000)
       );
       return;
       }*/
      $mdDialog.show({
        controller: 'SippingDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/shippingDetails/shippingDetails.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          client: Profile,
          Doctor: function () {
            return orContacts.GetDoctorDetails(Profile.DoctorID);
          },
          Place: orUserAccount.Admin_user
        }
      }).then(function (id) {

      });

    };
    var clientLeft = function (Profile, ev) {
      var msg = (Profile.ShulamSW || !Profile.PhotosPrice ? 'האם ' + Profile.ClientName + ' עזב?' : 'ללקוח - ' + Profile.ClientName + ' קיים חוב! האם לשחרר בכל זאת?');
      //if (!Profile.ShulamSW) {
      confirm = $mdDialog.confirm()
        .title('שחרור לקוח')
        .textContent(msg)
        .ariaLabel('Lucky day')
        .targetEvent(ev)
        .ok('כן, שחרר לקוח')
        .cancel('לא, אני מתחרט');

      $mdDialog.show(confirm).then(function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent('עודכן בהצלחה')
            .position('top right')
            .hideDelay(4000)
        );
        Profile.ZulamStatus = 5;
        Profile.TimeOUT = new Date();
        orContacts.updateClientLeft(Profile);
      }, function () {
        //False
      }).finally(function () {
        confirm = undefined;
      });

      //}
    };
    var clientBack = function (Profile, ev) {
      var msg = 'להחזיר לקוח - ' + Profile.ClientName + '?';
      //if (!Profile.ShulamSW) {
      confirm = $mdDialog.confirm()
        .title('חזרת לקוח')
        .textContent(msg)
        .ariaLabel('Lucky day')
        .targetEvent(ev)
        .ok('כן')
        .cancel('לא');

      $mdDialog.show(confirm).then(function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent('עודכן בהצלחה')
            .position('top right')
            .hideDelay(4000)
        );
        Profile.ZulamStatus = (Profile.OvedID ? 2 : 1);
        Profile.TimeOUT = undefined;// new Date();
        orContacts.updateClientLeft(Profile);
      }, function () {
        //False
      }).finally(function () {
        confirm = undefined;
      });

      //}
    };
    var updateEmployee = function (Profile, ev) {
      if (Profile.ZulamStatus > 2) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('לא ניתן לעדכן פציינט זה.')
            .position('bottom left')
            .hideDelay(3000)
        );
        return;
      }

      $mdDialog.show({
        controller: 'ProfileDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/register_copyrator.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          copyrators: vm.employees,
          employee: Profile.OvedID
        }
      }).then(function (id) {
        if (id) {
          var selected = $filter('filter')(vm.employees, {OvedID: id}, true)[0];
          Profile.OvedID = selected.OvedID;
          Profile.ovedName = selected.Name;
          Profile.ZulamStatus = (Profile.ZulamStatus < 2 ? 2 : Profile.ZulamStatus);
          orContacts.updateEmployeeOnClient(Profile);
        }// vm.copyrators
        // alert(data);
      });
    }
    vm.printClient = printClient;
    vm.SippingDetails = SippingDetails;
    vm.clientLeft = clientLeft;
    vm.clientBack = clientBack;
    vm.updateEmployee = updateEmployee;

    if ($state.params.key) {

      console.log($state.params.key);
      vm.openImportDialog(this, $state.params.key);
    }
    /**
     * Change Contacts List Filter
     * @param type
     */
    function filterChange(type) {

      vm.listType = type;

      if (type === 'all') {
        vm.filterIds = null;
      }
      else if (type === 'frequent') {
        vm.filterIds = vm.user.frequentContacts;
      }
      else if (type === 'starred') {
        vm.filterIds = vm.user.starred;
      }
      else if (angular.isObject(type)) {
        vm.filterIds = type.contactIds;
      }

      vm.selectedContacts = [];

    }

    /**
     * Open new contact dialog
     *
     * @param ev
     * @param contact
     */
    function openContactDialog(ev, contact) {

      console.log("***********************");
      console.log(contact);
      $mdDialog.show({
        controller: 'ContactDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/contacts/dialogs/contact/contact-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          Contact: contact,
          User: vm.user,
          Contacts: vm.contacts,
          Merge: false,
          IsInConversation: false,
          numContacts: undefined
        }
      });
    }


    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }


  }

})();

(function () {
  'use strict';

  angular
    .module('app.compare_reports', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.compare_reports', {
      url: '/compare_reports',
      views: {
        'content@app': {
          templateUrl: 'app/main/compare-reports/compare-reports.html',
          controller: 'Compare_reportsController as vm'
        }
      },
      resolve: {
        Reports: function (msApi) {
          return msApi.resolve('data.reports@get');
        },
        Places: function (orPlacesService) {
          return orPlacesService.Places();
        },
        Insurances: function (orContacts) {
          return  orContacts.GetFactorPays();
        },
        Categories_photos: function (orAdminService) {
          return orAdminService.Categories_photos();
        },
        Doctors:function (orAdminService) {
          return orAdminService.GetDoctorsList();
        }
      }
    });
    //msApiProvider.register('data.reports', ['data/reportsdataAAAAA.json']);

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/contacts');

    // msNavigationServiceProvider.saveItem('all_reports', {
    //   title: 'וחות כלליים',
    //   icon: 'icon-person-box',
    //   group: false,
    //   weight: 5
    // });

    msNavigationServiceProvider.saveItem('compare_reports', {
      title: 'דוחות יחסיים',
      rule: 5,
      // icon: 'icon-account-multiple',
      state: 'app.compare_reports',
      weight: 5
    });

    // Api


  }

})();

(function () {
  'use strict';

  angular
    .module('app.compare_reports')
    .service('Compare_reportsService', Compare_reportsService);

  /** @ngInject */
  function Compare_reportsService(orUserAccount, $q, msApi) {
    var DataSettings = {
      date_A: {
        start: moment().add('-3', 'day').toDate(),//.startOf('month').toDate(),
        end: moment().toDate()//.add('-1', 'month').endOf('month').toDate()
      },
      date_B: {
        start: moment().add('-1', 'month').add('-3', 'day').toDate(),//.startOf('month').toDate(),
        end: moment().add('-1', 'month').toDate()//.endOf('month').toDate()
      },
      doctor: {DoctorID: 0, Name: 'כל הרופאים'},// doctor: {DoctorID: 7368, Name: 'עוזי חי'},
      place: {PlaceID: 0, Name: 'כל הסניפים'},
      category: {CategoryID: 0, CategoryName: 'כל הקטגוריות'},
      insurance: {BituahID: 0, Name: 'כל הביטוחים'},
      reportType: 10
    }
    var SetDataSettings = function (data) {
      if (data.date_A)
        DataSettings.date_A = data.date_A;
      if (data.date_B)
        DataSettings.date_B = data.date_B;
      if (data.doctor) {
        DataSettings.doctor.DoctorID = data.doctor.DoctorID;
        DataSettings.doctor.Name = data.doctor.Name;
      }
      if (data.place) {
        DataSettings.place.PlaceID = data.place.PlaceID;
        DataSettings.place.Name = data.place.Name;
      }
      if (data.category) {
        DataSettings.category.CategoryID = data.category.CategoryID;
        DataSettings.category.CategoryName = data.category.CategoryName;
      }
      if (data.insurance) {
        DataSettings.insurance.BituahID = data.insurance.BituahID;
        DataSettings.insurance.Name = data.insurance.Name;
      }
      if (data.reportType)
        DataSettings.reportType = data.reportType;

    }
    var Run = function (data) {
      var deferred = $q.defer();

      PostAPI('or.reports.compare_report', {
        token: orUserAccount.AccountToken.token,
        data: data
      }).then(function (result) {
        if (result.status) {
          deferred.resolve(result.data);
        } else {
          deferred.resolve([]);
        }
      });
      return deferred.promise;
    }

    function GetAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@get', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        if (err.status == 401) {
          orUserAccount.LogOut();
          $rootScope.$broadcast('user:logout');
        }
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function PostAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@save', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    return {
      Run: Run,
      DataSettings: DataSettings,
      SetDataSettings: SetDataSettings
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.compare_reports')
    .controller('Compare_reportsController', Compare_reportsController);

  /** @ngInject */
  function Compare_reportsController(Places, Reports, Doctors, Categories_photos, Insurances, msUtils, $mdDialog, $mdToast, $filter, orAdminService, Compare_reportsService) {

    var vm = this;
    // data
    vm.Reports = Reports;
    vm.Places = Places;
    vm.AllDoctors = Doctors;
    vm.Categories_photos = Categories_photos;
    vm.Insurance = Insurances;

    vm.re_select = 1;
    vm.dates = {
      start: moment().add(-1, 'month').date(1).toDate(),
      end: moment().add(-1, 'month').endOf('month').toDate()
    };
    vm.reportType = 0;
    vm.table = Reports.data[0].config;
    vm.strDate = moment(vm.dates.start).format('MMMM - YYYY');

    /* vm.refresh = function (dates) {
     vm.strDate = moment(vm.dates.start).format('MMMM - YYYY');
     console.log(dates);
     vm.submit();
     }
     vm.submit = function () {
     var Repo = $filter('filter')(Reports.data, {id: vm.re_select}, true)[0];
     if (Repo) {
     vm.proccess = true;
     orAdminService.All_Reports(vm.re_select, vm.dates).then(function (result) {
     console.log(result);
     Repo.config.data = result.data;
     vm.table = Repo.config;
     vm.proccess = false;
     });
     } else {
     alert('err');
     }
     }*/
    // vm.table = {
    //   feilds: [
    //     {key: 'OvedID', name: 'מזהה'},
    //     {key: 'Name', name: 'שם'},
    //     {key: 'TZ', name: 'זהות'},
    //     {key: 'PlaceCity', name: 'סניף', filter: true},
    //     {key: 'Address', name: 'כתובת'}
    //   ],
    //   edit: [
    //     {key: 'Name', name: 'שם עובד', required: true, icon: 'icon-account'},
    //     {key: 'Address', name: 'כתובת', required: true, icon: 'icon-home'},
    //     {key: 'TZ', name: 'מספר זהות', required: true, icon: 'icon-account-alert'},
    //     {key: 'Tel', name: 'טלפון', required: true, minlength: 6, icon: 'icon-phone'},
    //     {key: 'Pel', name: 'נייד', minlength: 6, icon: 'icon-cellphone-android'},
    //     {key: 'PlaceID', name: 'סניף', required: true, select: {data: Places, key: 'PlaceID', value: 'PlaceName'}},
    //     {key: 'CardNumber', name: 'מספר כרטיס', required: true, icon: 'icon-credit-card'},
    //     {key: 'BirthDate', name: 'ת. לידה', type: 'date'},
    //     {key: 'StartDate', name: 'תחילת עבודה', type: 'date'},
    //     {key: 'NoteS', name: 'הערות', icon: 'icon-comment'},
    //
    //   ],
    //   // data: Employees,
    //   // config: {
    //   //   rowClick: {type: 'ref', ui_serf: 'app.employee_card', params: [{key: 'id', value: 'DoctorID'}]}
    //   // }
    // }

    vm.selectPlace = function () {
      var pl = $filter('filter')(Places, {PlaceID: vm.select.place}, true)[0];
      if (!pl)
        pl = {PlaceID: 0, Name: 'כל הסניפים'};
      msUtils.setJsonObj(vm.params.place, pl)

    }
    vm.selectCategory = function () {
      var c = $filter('filter')(Categories_photos, {CategoryID: vm.select.category}, true)[0];
      if (!c)
        c = {CategoryID: 0, CategoryName: 'כל קטגוריות'};
      msUtils.setJsonObj(vm.params.category, c);

    }
    vm.selectInsurance = function () {
      var c = $filter('filter')(Insurances, {BituahID: vm.select.insurance}, true)[0];
      if (!c)
        c = {BituahID: 0, Name: 'כל הביטוחים'};
      msUtils.setJsonObj(vm.params.insurance, c);
    }
    vm.selectDoctor = function (item) {
      // var pl = $filter('filter')(Doctors, {DoctorID: vm.select.place}, true)[0];
      // if (!pl)
      //   pl = {PlaceID: 0, Name: 'כל הסניפים'};
      // debugger
      if (!item)
        item = {DoctorID: 0, Name: 'כל הרופאים'};
      msUtils.setJsonObj(vm.params.doctor, item)

    }
    // vm.params = {
    //   //date_A: {start: moment().startOf('month').toDate(), end: moment().endOf('month').toDate()},
    //   date_A: {
    //     start: moment().add('-1', 'month').startOf('month').toDate(),
    //     end: moment().add('-1', 'month').endOf('month').toDate()
    //   },
    //   date_B: {
    //     start: moment().add('-2', 'month').startOf('month').toDate(),
    //     end: moment().add('-2', 'month').endOf('month').toDate()
    //   },
    //   doctor: {DoctorID: 7368, Name: 'עוזי חי'},
    //   place: {PlaceID: 0, Name: 'כל הסניפים'}
    // }
    vm.params = Compare_reportsService.DataSettings;

    vm.select = {
      place: vm.params.place.PlaceID,
      category: vm.params.category.CategoryID,
      doctor: vm.params.doctor.DoctorID,
      insurance: vm.params.insurance.BituahID,
      workDay_A: 0,
      workDay_B: 0
    }
    vm.filterList = [
      {id: 1, name: 'סניפים', selected: true},
      {id: 2, name: 'רופאים', selected: false},
    ]
    vm.filterList2 = [
      {id: 11, name: 'סניפים', selected: false, hide: true},
      {id: 12, name: 'רופאים', selected: false},
      {id: 13, name: 'קטגוריות', selected: false},
      {id: 14, name: 'גורם משלם', selected: false},
    ];
    var REPORT_ALL_TYPES = [
      {id: 10, name: 'סניפים', selected: false, place: true},
      {id: 20, name: 'רופאים', selected: false, doctors: true},
      {id: 11, name: 'סניפים/רופאים', selected: false, place: true, doctors: true},
      {id: 13, name: 'סניפים/קטגוריות', selected: false, place: true, category: true},
      {id: 14, name: 'סניפים/גורם משלם', selected: false, place: true, insuranse: true},
      {id: 23, name: 'רופאים/קטגוריות', selected: false, category: true, doctors: true},
      {id: 24, name: 'רופאים/גורם משלם', selected: false, doctors: true, insuranse: true},
    ];
    var selectReportType = function () {
      var first = $filter('filter')(vm.filterList, {selected: true}, true)[0];
      var secound = $filter('filter')(vm.filterList2, {selected: true}, true)[0];
      var ID_REPORT = 10;
      if (!secound) {
        if (first.id == 1)
          ID_REPORT = 10;
        else
          ID_REPORT = 20;
      } else {
        if (secound.id == 11 || secound.id == 12)
          ID_REPORT = 11;
        else if (secound.id == 13 && first.id == 1) {
          ID_REPORT = 13;
        }
        else if (secound.id == 13 && first.id == 2) {
          ID_REPORT = 23;
        }
        else if (secound.id == 14 && first.id == 1) {
          ID_REPORT = 14;
        }
        else if (secound.id == 14 && first.id == 2) {
          ID_REPORT = 24;
        }

      }
      vm.reportTypeSelected = $filter('filter')(REPORT_ALL_TYPES, {id: ID_REPORT}, true)[0];
    }
    selectReportType();
    vm.selectFilter2 = function (item) {
      vm.filterList2.map(function (itemX) {
        if (item != itemX)
          itemX.selected = false;
      })
      item.selected = !item.selected;
      selectReportType();
    }
    vm.selectFilter = function (item) {

      vm.filterList.map(function (itemX) {
        itemX.selected = false;
      })
      item.selected = true;
      if (item.id == 1) {
        vm.filterList2[0].hide = true;
        vm.filterList2[1].hide = false;
      } else {
        vm.filterList2[0].hide = false;
        vm.filterList2[1].hide = true;
      }
      selectReportType();
      return;
    }


    vm.reportsRule = {place: true};
    vm.showMoreRules = function () {
      var selected = 0;
      if (vm.reportsRule.place)
        selected++;
      if (vm.reportsRule.doctors)
        selected++;
      if (vm.reportsRule.category)
        selected++;
      if (vm.reportsRule.insurance)
        selected++;
      return selected < 2;
    }

    if (!vm.select.place && !vm.select.doctor) {
      msUtils.setJsonObj(vm.params.place, Places[0]);
      vm.select.place = vm.params.place.PlaceID;
    }
    vm.feildsReport = {

      10: [
        {key: 'Name', name: 'סניף'},
        //{key: 'doctorName', name: 'רופא'},
        {key: 'countClients', name: 'פצייניטים', compare: true, type: 'number'},
        {key: 'countPhotos', name: 'צילומים', compare: true, type: 'number'},
        {key: 'Price', name: 'מחיר', type: 'customCurrency', compare: true},
        {key: 'Deductible', name: 'השתתפות', type: 'customCurrency', compare: true}
      ],
      20: [
        //{key: 'Name', name: 'סניף'},
        {key: 'doctorName', name: 'רופא'},
        {key: 'countClients', name: 'פצייניטים', compare: true, type: 'number'},
        {key: 'countPhotos', name: 'צילומים', compare: true, type: 'number'},
        {key: 'Price', name: 'מחיר', type: 'customCurrency', compare: true},
        {key: 'Deductible', name: 'השתתפות', type: 'customCurrency', compare: true}
      ],
      11: [
        {key: 'Name', name: 'סניף'},
        {key: 'doctorName', name: 'רופא'},
        {key: 'countClients', name: 'פצייניטים', compare: true, type: 'number'},
        {key: 'countPhotos', name: 'צילומים', compare: true, type: 'number'},
        {key: 'Price', name: 'מחיר', type: 'customCurrency', compare: true},
        {key: 'Deductible', name: 'השתתפות', type: 'customCurrency', compare: true}
      ],

      13: [
        {key: 'Name', name: 'סניף'},
        {key: 'CategoryName', name: 'קטגוריה'},
        //{key: 'countClients', name: 'פצייניטים', compare: true, type: 'number'},
        {key: 'countPhotos', name: 'צילומים', compare: true, type: 'number'},
        {key: 'Price', name: 'מחיר', type: 'customCurrency', compare: true},
        {key: 'Deductible', name: 'השתתפות', type: 'customCurrency', compare: true}
      ],
      14: [
        {key: 'Name', name: 'סניף'},
        {key: 'bituachName', name: 'ביטוח'},
        //{key: 'countClients', name: 'פצייניטים', compare: true, type: 'number'},
        {key: 'countPhotos', name: 'צילומים', compare: true, type: 'number'},
        {key: 'Price', name: 'מחיר', type: 'customCurrency', compare: true},
        {key: 'Deductible', name: 'השתתפות', type: 'customCurrency', compare: true}
      ],
      23: [
        {key: 'doctorName', name: 'רופא'},
        {key: 'CategoryName', name: 'קטגוריה'},
        //{key: 'countClients', name: 'פצייניטים', compare: true, type: 'number'},
        {key: 'countPhotos', name: 'צילומים', compare: true, type: 'number'},
        {key: 'Price', name: 'מחיר', type: 'customCurrency', compare: true},
        {key: 'Deductible', name: 'השתתפות', type: 'customCurrency', compare: true}
      ], 24: [
        {key: 'doctorName', name: 'רופא'},
        {key: 'bituachName', name: 'ביטוח'},
        //{key: 'countClients', name: 'פצייניטים', compare: true, type: 'number'},
        {key: 'countPhotos', name: 'צילומים', compare: true, type: 'number'},
        {key: 'Price', name: 'מחיר', type: 'customCurrency', compare: true},
        {key: 'Deductible', name: 'השתתפות', type: 'customCurrency', compare: true}
      ],
    };

    vm.run = function () {
      vm.proccess = true;

      vm.feilds = vm.feildsReport[vm.reportTypeSelected.id];
      vm.params.reportType = vm.reportTypeSelected.id;
      Compare_reportsService.Run(vm.params).then(function (result) {
        vm.proccess = false;
        vm.select.workDay_A = result.data[2].length;
        vm.select.workDay_B = result.data[3].length;
        vm.data = result.data;
        vm.data_compare = result.data_compare;
        console.log(vm.data_compare);
      })
    }

    vm.searchDoctor = function (search) {
      vm.AllDoctors = $filter('filter')(Doctors, {Name: search});
      if (search.length < 2 || vm.proccess) {
        return vm.AllDoctors;
      }
      vm.proccess = true;
      orAdminService.GetDoctorsList(search).then(function (data) {
        console.log(Doctors.length);
        console.log(vm.AllDoctors.length);
        vm.AllDoctors = $filter('filter')(Doctors, search);
        vm.proccess = false;
      });
      return vm.AllDoctors;
    }
    vm.run();
    var intervalCheck;
    vm.change = function () {
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(deepSearch, 500);
    }

    var deepSearch = function (dates) {
      if (vm.search.length < 2 || vm.proccess)
        return;
      vm.proccess = true;

      // orAdminService.GetEmployessList(vm.search).then(function () {
      //   vm.proccess = false;
      // });

    }


  }

})();

/**
 * Created by itzik on 18/04/2018.
 */
(function () {
  'use strict';

  angular
    .module('app.bookkeeping')
    .factory('bookkeepingService', bookkeepingService);


  /** @ngInject */
  function bookkeepingService($q, orUserAccount, $log, msApi, $filter, msUtils, $timeout, $rootScope) {
    var InvoicesList = function () {
      var deferred = $q.defer();
      GetAPI('or.bookkeeping.invoices', {token: orUserAccount.AccountToken.token}).then(function (result) {
        deferred.resolve(result.data);
      }, deferred.reject)
      return deferred.promise;
    }
    var SearchInvoices = function (dataSearch) {
      var deferred = $q.defer();
      PostAPI('or.bookkeeping.invoices', {
        token: orUserAccount.AccountToken.token,
        dataSearch: dataSearch
      }).then(function (result) {
        deferred.resolve(result.data);
      }, deferred.reject)
      return deferred.promise;
    }
    var SearchClients = function (search) {
      var deferred = $q.defer();
      GetAPI('or.bookkeeping.clients', {
        token: orUserAccount.AccountToken.token,
        search: search
      }).then(function (result) {
        deferred.resolve(result.data);
      }, deferred.reject)
      return deferred.promise;
    }
    var getInvoiceDoc = function (doc_id) {
      var deferred = $q.defer();
      GetAPI('or.bookkeeping.docs.id', {
        token: orUserAccount.AccountToken.token,
        doc_id: doc_id
      }).then(function (result) {
        deferred.resolve(result.invoice);
      }, deferred.reject)
      return deferred.promise;
    }
    var createInvoiceDoc = function (data) {
      return PostAPI('or.bookkeeping.docs.create', {token: orUserAccount.AccountToken.token, data: data});
    }
    var ClientAction = function (action, data) {
      return PostAPI('or.bookkeeping.client', {token: orUserAccount.AccountToken.token, action: action, data: data});
    }
    var ClientAccountStatus = function (client_id) {
      return GetAPI('or.bookkeeping.client.accountstatus', {
        token: orUserAccount.AccountToken.token,
        client_id: client_id
      });
    }
    var PrintDocument = function (doc) {
      console.log(doc)
      // debugger
      return PostAPI('or.bookkeeping.docs.set_printed', {
        token: orUserAccount.AccountToken.token,
        doc_id: doc.data.doc_id
      })
      //doc.data.copy = true;
    }

    function GetAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@get', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {

        if (err.status == 401) {
          orUserAccount.LogOut();
          //$timeout(function () {
          $rootScope.$broadcast('user:logout');
          //},1000)

          deferred.resolve({});
        }
        else
          deferred.reject(err);
      });
      return deferred.promise;
    }

    function PostAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@save', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
        if (err.status == 401) {
          orUserAccount.LogOut();
          $rootScope.$broadcast('user:logout');
        }
      });
      return deferred.promise;
    }

    return {
      InvoicesList: InvoicesList,
      SearchInvoices: SearchInvoices,
      SearchClients: SearchClients,
      getInvoiceDoc: getInvoiceDoc,
      createInvoiceDoc: createInvoiceDoc,
      ClientAction: ClientAction,
      ClientAccountStatus: ClientAccountStatus,
      PrintDocument: PrintDocument
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.all_reports', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.all_reports', {
      url: '/allreports',
      views: {
        'content@app': {
          templateUrl: 'app/main/all-reports/all-reports.html',
          controller: 'All_reportsController as vm'
        }
      },
      resolve: {
        Reports: function (msApi) {
          return msApi.resolve('data.reports@get');
        },
        Places: function (orPlacesService) {

          return orPlacesService.Places();
        }
      }
    });
    msApiProvider.register('data.reports', ['admin/all_reports/data/reportsdata']);

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/contacts');

    // msNavigationServiceProvider.saveItem('all_reports', {
    //   title: 'וחות כלליים',
    //   icon: 'icon-person-box',
    //   group: false,
    //   weight: 5
    // });

    msNavigationServiceProvider.saveItem('all_reports', {
      title: 'דוחות כלליים',
      rule: 5,
      // icon: 'icon-account-multiple',
      state: 'app.all_reports',
      weight: 5
    });

    // Api


  }

})();

(function () {
  'use strict';

  angular
    .module('app.all_reports')
    .controller('All_reportsController', All_reportsController);

  /** @ngInject */
  function All_reportsController(Places, Reports, $timeout, msUtils, $mdDialog, $mdToast, $filter, orAdminService) {

    var vm = this;
    // data


    vm.Reports = Reports;
    var lastReport = orAdminService.GetLastReport();
    vm.favoriteR = orAdminService.GetFavoriteReports();
    vm.transformChip = function (chip) {
      return {id: chip.id, name: chip.name};
    }
    vm.querySearch = function (str) {
      var items = $filter('filter')(Reports.data, {'name': str});
      return items;
    }
    vm.chipClicked = function (chip) {
      vm.re_select = chip.id;
    }
    vm.favoriteChanges = function () {
      console.log(vm.favoriteR.length);
      orAdminService.AddToFavoriteReport(vm.favoriteR);
    }

    vm.re_select = lastReport.re_select || 1;
    vm.dates = lastReport.dates || {start: new Date()};
    /*{
     start: moment().add(-1, 'month').date(1).toDate(),
     end: moment().add(-1, 'month').endOf('month').toDate()
     };*/
    console.log(vm.dates);
    vm.reportType = 0;
    vm.table = lastReport.table || Reports.data[0].config;
    vm.strDate = moment(vm.dates.start).format('MMMM - YYYY');

    vm.refresh = function (dates) {
      vm.strDate = moment(vm.dates.start).format('MMMM - YYYY');
      console.log(dates);
      vm.submit();
    }
    vm.submit = function () {
      var Repo = $filter('filter')(Reports.data, {id: vm.re_select}, true)[0];
      if (Repo) {
        vm.proccess = true;
        orAdminService.All_Reports(vm.re_select, vm.dates).then(function (result) {
          console.log(result);
          Repo.config.data = result.data;
          vm.table = Repo.config;
          if (result.file) {
            //vm.report_file = 'http://localhost:4900/' + result.file;
            vm.report_file = 'https://or-admin-api.azurewebsites.net/' + result.file;
          }else
            delete vm.report_file;
          vm.proccess = false;
          orAdminService.SaveLastReport({table: vm.table, dates: vm.dates, re_select: vm.re_select});
        });
      } else {
        alert('err');
      }
    }
    vm.focusSearch = function () {
      console.log('a')
      $timeout(function () {
        console.log('aaa')
        $('#s_search').focus();
      }, 500);
    }
    window.mdSelectOnKeyDownOverride = function (event) {
      event.stopPropagation();
      // NOTE: hack until this is fixed...
    };
// vm.table = {
//   feilds: [
//     {key: 'OvedID', name: 'מזהה'},
//     {key: 'Name', name: 'שם'},
//     {key: 'TZ', name: 'זהות'},
//     {key: 'PlaceCity', name: 'סניף', filter: true},
//     {key: 'Address', name: 'כתובת'}
//   ],
//   edit: [
//     {key: 'Name', name: 'שם עובד', required: true, icon: 'icon-account'},
//     {key: 'Address', name: 'כתובת', required: true, icon: 'icon-home'},
//     {key: 'TZ', name: 'מספר זהות', required: true, icon: 'icon-account-alert'},
//     {key: 'Tel', name: 'טלפון', required: true, minlength: 6, icon: 'icon-phone'},
//     {key: 'Pel', name: 'נייד', minlength: 6, icon: 'icon-cellphone-android'},
//     {key: 'PlaceID', name: 'סניף', required: true, select: {data: Places, key: 'PlaceID', value: 'PlaceName'}},
//     {key: 'CardNumber', name: 'מספר כרטיס', required: true, icon: 'icon-credit-card'},
//     {key: 'BirthDate', name: 'ת. לידה', type: 'date'},
//     {key: 'StartDate', name: 'תחילת עבודה', type: 'date'},
//     {key: 'NoteS', name: 'הערות', icon: 'icon-comment'},
//
//   ],
//   // data: Employees,
//   // config: {
//   //   rowClick: {type: 'ref', ui_serf: 'app.employee_card', params: [{key: 'id', value: 'DoctorID'}]}
//   // }
// }


    var intervalCheck;
    vm.change = function () {
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(deepSearch, 500);
    }

    var deepSearch = function (dates) {
      if (vm.search.length < 2 || vm.proccess)
        return;
      vm.proccess = true;

      // orAdminService.GetEmployessList(vm.search).then(function () {
      //   vm.proccess = false;
      // });

    }


  }

})();

/**
 * Created by itzik on 27/06/2018.
 */
(function () {
  'use strict';

  angular
    .module('app.advanced_settings')
    .controller('Advanced_settingsController', Advanced_settingsController);

  /** @ngInject */
  function Advanced_settingsController(hasPermission, $state, msUtils, $mdDialog, $mdToast, $document, $filter, orAdminService) {

    var vm = this;
    if (!hasPermission)
      $state.go('app.report_places');
    vm.permission = hasPermission;

    var taxDialog = function (ev) {
      $mdDialog.show({
        controller: 'Advanced_taxDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/advanced_settings/taxDialog/taxDialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          // client: Profile,
          // // Doctor: function () {
          // //   return orContacts.GetDoctorDetails(Profile.DoctorID);
          // // },

        }
      }).then(function (id) {

      });
    }
    var placePassDialog = function (ev) {
      $mdDialog.show({
        controller: 'Advanced_passPlaceDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/advanced_settings/passPlaceDialog/passPlaceDialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          Admin:false
          // client: Profile,
          // // Doctor: function () {
          // //   return orContacts.GetDoctorDetails(Profile.DoctorID);
          // // },

        }
      }).then(function (id) {

      });
    }
    vm.taxDialog = taxDialog;
    vm.placePassDialog = placePassDialog;
  }

})();

(function () {
  'use strict';

  angular
    .module('app.admin', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.admin', {
      url: '/admin',
      views: {
        'content@app': {
          templateUrl: 'app/main/admin/admin.html',
          controller: 'AdminController as vm'
        }
      },
      resolve: {}
    });


    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/contacts');

    msNavigationServiceProvider.saveItem('doctors.admin', {
      title: 'תרשים רופאים',
      rule: 100,
      //icon: 'icon-account-multiple',
      state: 'app.admin',
      /*stateParams: {
       'param1': 'page'
       },*/
      // translate: 'SAMPLE.CONTACTS',
      weight: 6
    });

    // Api

    var API = 'http://localhost:4900/';
    API = 'https://or-admin-api.azurewebsites.net/';

    if (!msApiProvider.getBaseUrl())
      msApiProvider.setBaseUrl(API);
    msApiProvider.register('or.doctors.report', ['admin/doctors_report']);
    msApiProvider.register('or.report_places.client', ['admin/report_places/client']);
    msApiProvider.register('or.report_places.money', ['admin/report_places/money']);
    msApiProvider.register('or.report_places.chart', ['admin/report_places/:id/chart']);
    msApiProvider.register('or.places.statusnow', ['admin/placestatusnow/:id']);


    //Clients

    msApiProvider.register('or.clients', ['admin/clients']);

    msApiProvider.register('or.clients.copies', ['client/copies/update']);
    msApiProvider.register('or.clients.search', ['admin/clients/search']);
    //msApiProvider.register('or.clients.single', ['admin/clients/:id']);
    msApiProvider.register('or.clients.single', ['client/:clientid']);
    msApiProvider.register('or.clients.delete', ['client/delete']);
    msApiProvider.register('or.client.insuranse_status', ['client/insurancestatus/:clientid/:insuranceid']);
    msApiProvider.register('or.client.insurance_sendclaim', ['insurance/sendclaim']);
    msApiProvider.register('or.client.files.send', ['client/copies/sendtoemail']);

    msApiProvider.register('or.client.copies', ['photosclient/:clientid']);
    msApiProvider.register('or.client.receipts', ['receipts/:clientid']);
    msApiProvider.register('or.client.documents', ['documents/:clientid']);

    msApiProvider.register('or.doctor.detail', ['doctors/:doctorid']);
    msApiProvider.register('or.doctor.detail.update', ['doctors/update']);
    msApiProvider.register('or.doctor.detail.pass.create', ['doctors/pass/create']);
    // msApiProvider.register('or.doctor.detail.pass.update', ['doctors/pass/update']);
    msApiProvider.register('or.doctor.copies', ['doctors/copies/:doctorid']);
    msApiProvider.register('or.doctor.prices', ['doctors/prices/:doctorid']);
    msApiProvider.register('or.doctor.prices.update', ['doctors/prices/update']);
    msApiProvider.register('or.doctor.inbox', ['doctors/inbox/:doctorid']);

    //msApiProvider.register('or.doctor.prices.del', ['doctors/prices/del']);


    msApiProvider.register('or.billing.invoice.addpermissioncredit', ['billing/addcreditpermission']);

    //insurance

    msApiProvider.register('or.insurance.prices', ['insurance/prices']);
    msApiProvider.register('or.insurance.summary', ['insurance/summary']);
    msApiProvider.register('or.insurance.report', ['insurance/report']);
    msApiProvider.register('or.insurance.shela-order', ['insurance/shela-order']);
    msApiProvider.register('or.insurance.listofcopies', ['insurance/listofcopies']);
    msApiProvider.register('or.insurance.prices.delete', ['insurance/prices/delete']);
    msApiProvider.register('or.factorPays', ['admin/factorpays']);
    msApiProvider.register('or.insurance.create', ['insurance/create']);
    msApiProvider.register('or.insurance.doctors', ['insurance/doctors/:id']);
    msApiProvider.register('or.insurance.statusphoto', ['insurance/status']);
    msApiProvider.register('or.insurance.klalit-order', ['insurance/klalit-order']);

    msApiProvider.register('or.insurance.claim.create', ['insurance/claim/create']);
    msApiProvider.register('or.insurance.claim.creategroup', ['insurance/claim/creategroup']);
    msApiProvider.register('or.insurance.claims', ['insurance/claims']);
    msApiProvider.register('or.insurance.claims.update', ['insurance/claim/update']);
    msApiProvider.register('or.insurance.claims.delete', ['insurance/claim/delete']);

    msApiProvider.register('or.insurance.claims.id', ['insurance/claims/:id']);
    msApiProvider.register('or.insurance.claim.statuses', ['insurance/claim/statuses']);
    msApiProvider.register('or.insurance.claim.photos.update', ['insurance/claim/updatephotos']);
    msApiProvider.register('or.insurance.claim.photos.remove', ['insurance/claim/removeclaimphotos']);

    //doctors
    msApiProvider.register('or.doctors', ['admin/doctors']);
    msApiProvider.register('or.doctors.group', ['admin/doctors/group']);
    msApiProvider.register('or.doctors.inactive', ['admin/doctors/inactive']);
    msApiProvider.register('or.doctor', ['admin/doctor/:id']);
    msApiProvider.register('or.doctor.clients', ['admin/doctor/:id/clients']);
    msApiProvider.register('or.doctor.photos', ['admin/doctor/:id/photos']);
    msApiProvider.register('or.doctor.chart', ['admin/doctor/:id/chart']);
    msApiProvider.register('or.doctor.compare', ['admin/doctorreport/compare']);

    //msApiProvider.register('or.doctors.update', ['admin/doctors']);


    //Places
    msApiProvider.register('or.places', ['admin/places']);
    msApiProvider.register('or.place.data', ['admin/placereport/:placeid']);
    msApiProvider.register('or.place.compare', ['admin/placereport/compare']);
    msApiProvider.register('or.place.prices', ['admin/place/prices/:placeid']);
    msApiProvider.register('or.place.prices.update', ['admin/place/prices/update']);

    //employees
    msApiProvider.register('or.employees', ['admin/employees']);
    msApiProvider.register('or.employee.id', ['admin/employee/:id']);
    msApiProvider.register('or.employee.id.timework', ['admin/employee/:id/timework']);
    msApiProvider.register('or.employee.timework.update', ['admin/employee/timework/update']);
    msApiProvider.register('or.employees.del', ['admin/employees/del/:id']);

//Login
    msApiProvider.register('or.auth.login', ['admin/login']);

    //Allreports
    msApiProvider.register('or.allreports', ['admin/all_reports/:report_id']);
    msApiProvider.register('or.admin.discount', ['admin/discount_permission']);


    msApiProvider.register('or.reports.compare_report', ['reports/compare_report']);
    msApiProvider.register('or.categories_photos', ['admin/categoriesphoto']);


    //Bookkeeping
    msApiProvider.register('or.bookkeeping.invoices', ['bookkeeping/invoices']);
    msApiProvider.register('or.bookkeeping.clients', ['bookkeeping/clients']);
    msApiProvider.register('or.bookkeeping.client', ['bookkeeping/client']);//add/edot/del
    msApiProvider.register('or.bookkeeping.docs.id', ['bookkeeping/docs/:doc_id']);
    msApiProvider.register('or.bookkeeping.docs.create', ['bookkeeping/docs/create']);
    msApiProvider.register('or.bookkeeping.client.accountstatus', ['bookkeeping/accountstatus/:client_id']);
    msApiProvider.register('or.bookkeeping.docs.set_printed', ['bookkeeping/docs/set_printed']);

    //SETTINGS
    msApiProvider.register('or.settings.tax', ['settings/tax']);
    msApiProvider.register('or.settings.changepassplace', ['settings/changepassplace']);

    //users
    msApiProvider.register('or.users', ['users']);


  }

})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('AdminController', AdminController);

  /** @ngInject */
  function AdminController($scope, $mdSidenav, msUtils, $mdDialog, $mdToast, $document, $state, $filter,
                           orAdminService, orUserAccount) {

    var vm = this;
    // data
    vm.proccess = true;
    vm.dates = {
      start: moment().day(1).toDate(),
      end: moment().add('months', 1).date(0).toDate()
    }
    orAdminService.DoctorsReprt(vm.dates).then(function (data) {
      vm.proccess = false;
      vm.data = data.res;
    })


    vm.MODESDATE = [
      {key: 'TODAY', value: 'היום'},
      {key: 'YESTERDAY', value: 'אתמול'},
      {key: 'WEEK', value: 'שבוע'},
      {key: 'MONTH', value: 'חודש'},
      {key: 'CUSTOM', value: 'מותאם אישית'}
    ];
//function
    vm.changedate = function () {
      orContacts.resolveClients(vm.date);
      vm.isCustomSearch = false;

    }

    vm.refresh = function () {
      vm.proccess = true;
      console.log(0);
      orAdminService.DoctorsReprt(vm.dates).then(function (data) {
        vm.proccess = false;
        vm.data = data.res;
      })
    }

    vm.isOpen = false;


    // Data


    vm.sortBy = 'KDate';
    vm.changeSort = function (feild) {
      vm.sortBy = feild;
    }
    //edit contact - navigate from report/history


    var confirm;
    var printClient = function (Profile, ev) {

      $mdDialog.show({
        controller: 'ClientDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/bonClient/bonClient.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          client: Profile,
          // Doctor: function () {
          //   return orContacts.GetDoctorDetails(Profile.DoctorID);
          // },
          Place: orUserAccount.Admin_user
        }
      }).then(function (id) {
      });

    };


  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'blue-grey',
                // name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'orange',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();

(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('app.orHashen', [])
    .factory('orContacts', orContactsService)
    .config(config);


  /** @ngInject */
  function orContactsService($q, $log, msApi, $filter, msUtils, orUserAccount) {
    var _clients;
    var _employees;
    var _doctors;
    var _factorPays;
    var _isCustomSearch;
    // var _lastDate = new Date('2016-06-15');
    var _lastDate = new Date();

    function resolveClients(dates, reload) {
      if (_isCustomSearch)
        reload = true;
      var deferred = $q.defer();

      if (!dates)
        dates = {start: new Date()};
      if (_clients && (!reload))//if send new date , alwise result new data.
      {
        deferred.resolve(_clients);
      }
      else {
        _lastDate = dates;
        _isCustomSearch = false;
        // var strDate = _lastDate.getFullYear() + '/' + (_lastDate.getMonth() + 1) + '/' + _lastDate.getDate();

        msApi.resolve('or.clients@get', {
          token: orUserAccount.AccountToken.token,
          start: (dates && dates.start ? dates.start.toDateString() : ''),
          end: (dates && dates.end ? dates.end.toDateString() : '')
        }).then(function (result) {
          // console.log(result);

          if (!_clients)
            _clients = result.data;
          else {
            // _clients.splice(0, _clients.length);
            msUtils.setJsonObj(_clients, result.data);
          }
          deferred.resolve(_clients)
        }, function () {

          deferred.resolve([{name: 'ERROR'}]);
        })
      }
      return deferred.promise;
    }


    function searchClients(dataSearch) {
      var deferred = $q.defer();
      _isCustomSearch = true;
      console.log(dataSearch);
      msApi.resolve('or.clients.search@save', {
        data: dataSearch,
        token: orUserAccount.AccountToken.token
      }).then(function (result) {
        // console.log(result);

        if (!_clients)
          _clients = result.data;
        else {
          _clients.splice(0, _clients.length);
          msUtils.setJsonObj(_clients, result.data);
        }
        deferred.resolve(_clients)
      }, function () {

        deferred.resolve([{name: 'ERROR'}]);
      })

      return deferred.promise;
    }

    function updateClientDetails(client) {
      var deferred = $q.defer();

      msApi.resolve('or.clients.single@save', {
        client: client,
        token: orUserAccount.AccountToken.token
      }).then(function (result) {
        console.log(result);
        deferred.resolve(result.status);

      });
      return deferred.promise;

    }

    function SendClaimToInsurance(Client) {

      var deferred = $q.defer();

      msApi.resolve('or.client.insurance_sendclaim@save', {
        client: Client,
        token: orUserAccount.AccountToken.token
      }).then(function (result) {
        deferred.resolve(result);
      }, function (e) {
        Invalid_OAuth(e, deferred.resolve)
      });
      return deferred.promise;

    }

    function loadCustomClient(id) {
      var deferred = $q.defer();
      msApi.resolve('or.clients.single@get', {
        token: orUserAccount.AccountToken.token,
        clientid: id
      }).then(function (result) {
        deferred.resolve(result.data)
      }, function () {
        deferred.resolve({name: 'ERROR'});
      })
      return deferred.promise;

    }

    function clientInsuranseStatus(Client) {
      var deferred = $q.defer();
      if (Client.unUploadPhoto) {
        deferred.resolve();
        return deferred.promise;
      }
      // if (Client.InsuranseStatus)
      //   deferred.resolve(Client.InsuranseStatus);
      msApi.resolve('or.client.insuranse_status@get', {
        token: orUserAccount.AccountToken.token,
        clientid: Client.ClientID,
        insuranceid: Client.BituahID
      }).then(function (result) {
        Client.InsuranseStatus = result.data;
        deferred.resolve(Client.InsuranseStatus);
      }, function () {
        deferred.resolve({name: 'ERROR'});
      })
      return deferred.promise;
    }

    function getProfile(id) {
      if (!id && (_clients && _clients.length)) {
        return _clients[_clients.length - 1];
      }
      var profile;
      if (_clients)
        profile = $filter('filter')(_clients, {ClientID: id})[0];
      if (profile)
        return profile;
      return loadCustomClient(id);
    }

    function LoadPhotos(Client) {
      msApi.resolve('or.client.copies@get', {
        token: orUserAccount.AccountToken.token,
        clientid: Client.ClientID
      }).then(function (result) {

        Client.PhotosArr = result.data.data;
        Client.sumAll = result.sumAll;

      });
    }

    function LoadReceipts(Client) {
      var deferred = $q.defer();
      msApi.resolve('or.client.receipts@get', {
        token: orUserAccount.AccountToken.token,
        clientid: Client.ClientID
      }).then(function (result) {
        if (!Client.Receipts)
          Client.Receipts = {};
        msUtils.setJsonObj(Client.Receipts, result)
        //Client.Receipts = result;
        Client.Receipts.firstToPay = (Client.PhotosPrice + Client.HishtatfutPrice ) - Client.Receipts.sumAllRecepts;
        deferred.resolve(true);
      });
      return deferred.promise;
    }

    function GetEmployees() {
      var deferred = $q.defer();
      if (_employees)
        deferred.resolve(_employees);
      else {
        msApi.resolve('or.employees@get', {
          token: orUserAccount.AccountToken.token
        }).then(function (result) {
          _employees = result.data;
          deferred.resolve(_employees);
        });
      }
      return deferred.promise;
    }

    function GetDoctors(search) {
      var deferred = $q.defer();
      if (_doctors && !search)
        deferred.resolve(_doctors);
      else {
        msApi.resolve('or.doctors@get', {
          token: orUserAccount.AccountToken.token,
          doctorname: search
        }).then(function (result) {

          if (result.status) {
            if (!_doctors) {
              _doctors = [];
              msUtils.setJsonObj(_doctors, result.data);
            } else {
              msUtils.PushIfNotExsist(_doctors, result.data, 'DoctorID');
            }
          }
          deferred.resolve(_doctors);
        }, function (e) {
          deferred.resolve([]);
        });
      }
      return deferred.promise;
    }


    function GetDoctorDetails(doctor_id) {
      var deferred = $q.defer();

      msApi.resolve('or.doctor.detail@get', {
        token: orUserAccount.AccountToken.token,
        doctorid: doctor_id
      }).then(function (result) {

        deferred.resolve(result.data);
      });

      return deferred.promise;
    }

    function GetFactorPays() {
      var deferred = $q.defer();
      if (_factorPays)
        deferred.resolve(_factorPays);
      else {
        msApi.resolve('or.factorPays@get', {
          token: orUserAccount.AccountToken.token
        }).then(function (result) {
          _factorPays = result.data;
          deferred.resolve(_factorPays);
        });
      }
      return deferred.promise;
    }

    function LoadPhotosDoctor(doctor, insuranceID) {
      var deferred = $q.defer();
      msApi.resolve('or.doctor.copies@get', {
        token: orUserAccount.AccountToken.token,
        doctorid: doctor.DoctorID,
        percent: doctor.Sale,
        agreementid: doctor.agreementID,
        insuranceID: insuranceID
      }).then(function (result) {
        deferred.resolve(result.data);
      });
      return deferred.promise;
    }

    function LoadDocuments(Client) {
      var deferred = $q.defer();
      msApi.resolve('or.client.documents@get', {
        token: orUserAccount.AccountToken.token,
        clientid: Client.ClientID
      }).then(function (result) {
        if (!Client.Documents)
          Client.Documents = [];
        msUtils.setJsonObj(Client.Documents, result.data);
        deferred.resolve(true);
      });
      return deferred.promise;
    }

    function CreateNewClient(client) {
      var deferred = $q.defer();
      msApi.resolve('or.clients.new@save', {
        token: orUserAccount.AccountToken.token,
        client: client
      }).then(function (result) {
        if (result.status) {
          if (_clients) {
            _clients.push(result.client)
          }
          var da = new Date();
          resolveClients(da, true);
        }

        deferred.resolve(result.status);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function updateEmployeeOnClient(client) {
      return postAPI('or.clients.employee', {client: client, token: orUserAccount.AccountToken.token});
    }

    function updateClientLeft(client) {
      return postAPI('or.clients.left', {client: client, token: orUserAccount.AccountToken.token});
    }

    function removeClient(client) {
      return postAPI('or.clients.delete', {client: client, token: orUserAccount.AccountToken.token});
    }

    function pelecardPay(client, card) {
      var deferred = $q.defer();
      msApi.resolve('or.billing.pelecard@save', {
        token: orUserAccount.AccountToken.token,
        client: client,
        card: card
      }).then(function (result) {
        deferred.resolve({status: result, pelecard: result.result});
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function getInvoice(id) {
      return GetAPI('or.billing.invoice.customer', {id: id, token: orUserAccount.AccountToken.token});
    }

    function createInvoice(client, paymentsDetails) {
      var deferred = $q.defer();
      msApi.resolve('or.billing.invoice@save', {
        token: orUserAccount.AccountToken.token,
        client: client,
        payment: paymentsDetails
      }).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function postAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@save', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function GetAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@get', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function EmployeeActionEntry(card, mode) {
      var modeS = (mode ? 'entry' : 'left');
      return postAPI('or.employees.entry', {token: orUserAccount.AccountToken.token, card: card, mode: modeS})
    }

    function shippingReport(dateS, dateE) {
      return GetAPI('or.shipping.report', {date: dateS, dateend: dateE, token: orUserAccount.AccountToken.token});
    }

    function deliveryNow(clients, deliver_name) {
      return postAPI('or.shipping.delivery', {
        clients: clients,
        deliver_name: deliver_name,
        place_name: orUserAccount.Admin_user.Name,
        token: orUserAccount.AccountToken.token
      });
    }

    function updateInsurance(client) {
      return postAPI('or.clients.insurance', {token: orUserAccount.AccountToken.token, client: client})

    }

    function updateCopiesAndDoctor(client) {
      //? remove... update an api
      if (client.Doctor) {
        client.DoctorID = client.Doctor.DoctorID;
        if (client.BituahID == 1)
          client.PhotosPrice = client.countCopies.sum;
        else
          client.HovotPhotosPrice = client.countCopies.sum;
      }
      return postAPI('or.clients.copies', {token: orUserAccount.AccountToken.token, client: client})

    }

    function clearContacts() {
      _clients = undefined;
    }

    function addCreditPermission(Receipt, number) {
      return postAPI('or.billing.invoice.addpermissioncredit', {
        data: {
          KabalaID: Receipt.KabalaID,
          permission: number
        },
        token: orUserAccount.AccountToken.token
      });
    }


    function LinkUrlDownloadDocument(docName) {
      //return 'http://localhost:4900/documents/download/' + docName + '?token=' + orUserAccount.AccountToken.token;
      return 'https://or-admin-api.azurewebsites.net/documents/download/' + docName + '?token=' + orUserAccount.AccountToken.token;
    }

    function sendDocsToEmail(client_id, tz,name, email) {
      return postAPI('or.client.files.send', {
        client_id: client_id,
        tz: tz,
        email: email,
        name: name,
        token: orUserAccount.AccountToken.token
      });
    }

    // function Copiesclient(id) {
    //   var deferred = $q.defer();
    //   msApi.resolve('or.client.copies@get', {clientid: id}).then(function (result) {
    //     deferred.resolve(result.data)
    //   }, function () {
    //     deferred.resolve([]);
    //   })
    //   return deferred.promise;
    // }

    return {
      resolveClients: resolveClients,
      searchClients: searchClients,
      isCustomSearch: function () {
        return _isCustomSearch;
      },
      dateList: function () {
        if (!_lastDate)
          _lastDate = new Date();
        return _lastDate;
      },
      Profile: getProfile,
      GetEmployees: GetEmployees,
      GetDoctors: GetDoctors,
      LoadPhotos: LoadPhotos,
      LoadReceipts: LoadReceipts,
      LoadPhotosDoctor: LoadPhotosDoctor,
      LoadDocuments: LoadDocuments,
      LinkUrlDownloadDocument: LinkUrlDownloadDocument,
      GetFactorPays: GetFactorPays,
      GetDoctorDetails: GetDoctorDetails,

      CreateNewClient: CreateNewClient,
      updateClientDetails: updateClientDetails,
      updateEmployeeOnClient: updateEmployeeOnClient,
      updateClientLeft: updateClientLeft,
      removeClient: removeClient,

      pelecardPay: pelecardPay,
      createInvoice: createInvoice,
      getInvoice: getInvoice,
      AddCreditPermission: addCreditPermission,

      EmployeeActionEntry: EmployeeActionEntry,

      ShippingReport: shippingReport,
      DeliveryNow: deliveryNow,
      UpdateInsurance: updateInsurance,
      UpdateCopiesAndDoctor: updateCopiesAndDoctor,
      clearContacts: clearContacts,
      clientInsuranseStatus: clientInsuranseStatus,
      SendClaimToInsurance: SendClaimToInsurance,
      sendDocsToEmail:sendDocsToEmail
      // Copiesclient: Copiesclient

    }
  }

  function config() {

  }

})();

/**
 * Created by itzik on 14/11/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.orHashen')
    .factory('orUserAccount', userAccountService);

  function userAccountService($q, msApi, msUtils) {
    var _admin_user = {isLoggedIn: false};
    var _accountToken = {};
    const URL_TESTMODE = "https://orapi-t.azurewebsites.net/";
    // const URL_TESTMODE = "http://localhost:4900/";
    var Login = function (userData) {
      var deferred = $q.defer();

      msApi.resolve('or.auth.login@save', userData).then(function (result) {
        if (result.status) {
          msUtils.setJsonObj(_admin_user, result.account);
          _admin_user.isLoggedIn = true;
          if (_admin_user.tester)
            msApi.setBaseUrl(URL_TESTMODE);
          msUtils.setJsonObj(_accountToken, {token: result.token});
          saveLocal();
          deferred.resolve({status: result.status});
        } else {
          deferred.reject(result)
        }


      });

      return deferred.promise;

    }
    var saveLocal = function () {
      window.localStorage['PlaceAcc'] = JSON.stringify({_place: _admin_user, _accountToken: _accountToken});
    }
    var LoadLocal = function () {
      if (window.localStorage['PlaceAcc']) {
        var JS = JSON.parse(window.localStorage['PlaceAcc']);

        _admin_user = JS._place;
        _accountToken = JS._accountToken;
        if (_admin_user.tester)
          msApi.setBaseUrl(URL_TESTMODE);
      }
    }
    var LogOut = function () {
      msUtils.setJsonObj(_admin_user, {isLoggedIn: false});
      msUtils.setJsonObj(_accountToken, {});
      localStorage.removeItem('PlaceAcc');
    }
    var PermissionPlaces = function () {
      return _admin_user.places.split(',');
    }
    var checkPermission = function (name) {
      switch (name) {
        case "storage":
          if (_admin_user.permission_inventories)
            return true;
          return false;
          break;
        case "doctors":
          if (_admin_user.permission_doctors)
            return true;
          return false;
          break;
        case "users":
          if (_admin_user.permission_users)
            return true;
          return false;
          break;
        default:
          return false;
      }
    }
    LoadLocal();

    return {
      Admin_user: _admin_user,
      LoggedIn: _admin_user.isLoggedIn,
      Login: Login,
      LogOut: LogOut,
      PermissionPlaces: PermissionPlaces,
      AccountToken: _accountToken,
      checkPermission: checkPermission
    }
  }

})();

/**
 * Created by itzik on 28/06/2018.
 */
(function () {
  'use strict';

  angular
    .module('app.orHashen')
    .factory('orSettinsgService', orSettinsgService);

  function orSettinsgService($q, $rootScope, msApi, orUserAccount) {
    var _tax;
    var _taxList;
    var tax = function () {

      var deferred = $q.defer();
      if (_tax) {
        deferred.resolve(_tax);
      } else {
        getTaxList().then(function () {
          deferred.resolve(_tax);
        })
      }
      return deferred.promise;

    }

    var getTaxList = function (reload) {

      var deferred = $q.defer();
      if (_taxList && !reload) {
        deferred.resolve(_taxList);
      } else {
        console.log('loading or.settings.tax...')
        GetAPI('or.settings.tax', {
          token: orUserAccount.AccountToken.token
        }).then(function (res) {
          console.log('response tax: ', res);
          _taxList = res.data;
          angular.forEach(_taxList, function (value, key) {
            if (!value.isFuture)
              _tax = value.tax;
          })
          deferred.resolve(_taxList);
        })
      }
      return deferred.promise;

    }
    var saveNewTax = function (data) {
      var deferred = $q.defer();
      postAPI('or.settings.tax', {
        token: orUserAccount.AccountToken.token,
        data: data
      }).then(function (res) {
        getTaxList(true);
        deferred.resolve(res.status);
      })
      return deferred.promise;
    }
    const changePasswordPlace= function (data) {
      var deferred = $q.defer();
      postAPI('or.settings.changepassplace', {
        token: orUserAccount.AccountToken.token,
        data: data
      }).then(function (res) {
        deferred.resolve(res);
      })
      return deferred.promise;
    }


    function GetAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@get', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        if (err.status == 401) {
          orUserAccount.LogOut();
          $rootScope.$broadcast('user:logout');
        }
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function postAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@save', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    return {
      TAX: tax,
      TAXList: getTaxList,
      saveNewTax: saveNewTax,
      changePasswordPlace:changePasswordPlace
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.orHashen')
    .factory('orReportsService', orReportsService);


  /** @ngInject */
  function orReportsService($q, orUserAccount,$log, msApi, $filter, msUtils) {

    var _lastDate;
    var _reportDaily = {data: {}};

    var RunReport = function (date) {
      if (date)
        _lastDate = date;
      var strDate = _lastDate.getFullYear() + '/' + (_lastDate.getMonth() + 1) + '/' + _lastDate.getDate();

      var deferred = $q.defer();
      GetAPI('or.reports.daily', {date: strDate, token: orUserAccount.AccountToken.token}).then(function (result) {
        msUtils.setJsonObj(_reportDaily, result);
        deferred.resolve(_reportDaily);
      }, deferred.reject)
      return deferred.promise;
    }

    function GetAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@get', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }


    return {

      dateReport: function () {
        if (!_lastDate)
          _lastDate = new Date();
        return _lastDate;
      },
      RunReport: RunReport,
      ReportDaily: _reportDaily.data


    }
  }


})();

(function () {
  'use strict';

  angular
    .module('app.orHashen')
    .factory('orPlacesService', orPlacesService);


  /** @ngInject */
  function orPlacesService($q, orUserAccount, $rootScope, $log, msApi, $filter, msUtils) {

    var _places;

    var GetPlacesList = function () {
      var deferred = $q.defer();
      if (_places)
        deferred.resolve(_places);
      else {
        GetAPI('or.places', {token: orUserAccount.AccountToken.token}).then(function (result) {
          _places = [];
          msUtils.setJsonObj(_places, result.data);
          deferred.resolve(_places);
        }, deferred.reject);
      }
      return deferred.promise;
    }
    var GetPlace = function (placeID) {

      var deferred = $q.defer();
      GetPlacesList().then(function (x) {
        var pl = $filter('filter')(_places, {PlaceID: parseInt(placeID)}, true)[0];
        deferred.resolve(pl);
      });
      return deferred.promise;
    }
    var _ClientsPlace;

    function GetClientsPlace(dates, placeID) {
      if (!_ClientsPlace)
        _ClientsPlace = [];
      var deferred = $q.defer();
      if (!dates) {
        deferred.resolve(_ClientsPlace);

      }
      //dates = {start: new Date()};
      else {
        GetAPI('or.clients@get', {
          start: (dates && dates.start ? dates.start.toDateString() : ''),
          end: (dates && dates.end ? dates.end.toDateString() : ''),
          token: orUserAccount.AccountToken.token,
          placeid: placeID
        }).then(function (result) {
          msUtils.setJsonObj(_ClientsPlace, result.data);
          deferred.resolve(_ClientsPlace)
        }, function () {

          deferred.resolve([{name: 'ERROR'}]);
        })
        //msApi.resolve
      }
      return deferred.promise;
    }

    function GetDataPlace(dates, Place) {


      var deferred = $q.defer();
      if (!dates)
        dates = {start: new Date()};

      GetAPI('or.place.data@get', {
        start: (dates && dates.start ? dates.start.toDateString() : ''),
        end: (dates && dates.end ? dates.end.toDateString() : ''),
        token: orUserAccount.AccountToken.token,
        placeid: Place.PlaceID
      }).then(function (result) {

        Place.ClientsData = result.data;
        deferred.resolve(result.data)
      }, function () {

        deferred.resolve([{name: 'ERROR'}]);
      })
      return deferred.promise;
    }

    function searchClients(dataSearch) {
      var deferred = $q.defer();
      console.log(dataSearch);
      msApi.resolve('or.clients.search@save', {
        data: dataSearch,
        token: orUserAccount.AccountToken.token
      }).then(function (result) {
        // console.log(result);

        if (!_ClientsPlace)
          _ClientsPlace = result.data;
        else {
          msUtils.setJsonObj(_ClientsPlace, result.data);
        }
        deferred.resolve(_ClientsPlace)
      }, function () {

        deferred.resolve([{name: 'ERROR'}]);
      })

      return deferred.promise;
    }

    function getClient(id) {
      if (!id && (_ClientsPlace && _ClientsPlace.length)) {
        return _ClientsPlace[_ClientsPlace.length - 1];
      }
      var profile;
      if (_ClientsPlace)
        profile = $filter('filter')(_ClientsPlace, {ClientID: id})[0];
      if (profile)
        return profile;
      return loadCustomClient(id);
    }

    function loadCustomClient(id) {
      var deferred = $q.defer();
      msApi.resolve('or.clients.single@get', {
        token: orUserAccount.AccountToken.token,
        clientid: id
      }).then(function (result) {
        deferred.resolve(result.data)
      }, function () {
        deferred.resolve({name: 'ERROR'});
      })
      return deferred.promise;

    }


    function GetAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@get', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        if (err.status == 401) {
          orUserAccount.LogOut();
          $rootScope.$broadcast('user:logout');
        }
        deferred.reject(err);
      });
      return deferred.promise;
    }

    var Invalid_OAuth = function (err, resolve) {

      if (err.status == 401) {
        orUserAccount.LogOut();
        $rootScope.$broadcast('user:logout');
      }
      resolve([{name: 'ERROR'}]);
      /*function (e) {
       if (e.status == 401)
       orUserAccount.LogOut();
       deferred.resolve([{name: 'ERROR'}]);
       }*/
    }
    var GetStatusNow = function (Place) {

      var deferred = $q.defer();
      msApi.resolve('or.places.statusnow@get', {
        token: orUserAccount.AccountToken.token,
        id: Place.PlaceID
      }).then(function (result) {
        deferred.resolve(result.data)
      }, function () {
        deferred.resolve({name: 'ERROR'});
      })
      return deferred.promise;

    }
    return {


      Place: GetPlace,
      Places: GetPlacesList,
      Client: getClient,
      GetClientsPlace: GetClientsPlace,
      SearchClients: searchClients,
      GetDataPlace: GetDataPlace,
      GetStatusNow: GetStatusNow


    }
  }


})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('msUtils', msUtils);

  /** @ngInject */
  function msUtils($window, $filter, $mdToast, $mdDialog) {
    // Private variables
    var mobileDetect = new MobileDetect($window.navigator.userAgent),
      browserInfo = null;
    var tax = 'NO TAX!! BUG!';
    var CLAIM_CODE = '4141';
    var service = {
      exists: exists,
      detectBrowser: detectBrowser,
      guidGenerator: guidGenerator,
      isMobile: isMobile,
      toggleInArray: toggleInArray,
      setJsonObj: setJsonObj,
      PushIfNotExsist: pushIfNotExsist,
      Toast: Toast,
      Confirm: Confirm,
      Alert: Alert,
      Prompt: Prompt,
      CheckClaimCode: CheckClaimCode,
      TAX: tax
    };

    return service;

    //////////

    /**
     * Check if item exists in a list
     *
     * @param item
     * @param list
     * @returns {boolean}
     */
    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    /**
     * Returns browser information
     * from user agent data
     *
     * Found at http://www.quirksmode.org/js/detect.html
     * but modified and updated to fit for our needs
     */
    function detectBrowser() {
      // If we already tested, do not test again
      if (browserInfo) {
        return browserInfo;
      }

      var browserData = [
        {
          string: $window.navigator.userAgent,
          subString: 'Edge',
          versionSearch: 'Edge',
          identity: 'Edge'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Chrome',
          identity: 'Chrome'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'OmniWeb',
          versionSearch: 'OmniWeb/',
          identity: 'OmniWeb'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Apple',
          versionSearch: 'Version',
          identity: 'Safari'
        },
        {
          prop: $window.opera,
          identity: 'Opera'
        },
        {
          string: $window.navigator.vendor,
          subString: 'iCab',
          identity: 'iCab'
        },
        {
          string: $window.navigator.vendor,
          subString: 'KDE',
          identity: 'Konqueror'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Firefox',
          identity: 'Firefox'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Camino',
          identity: 'Camino'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Netscape',
          identity: 'Netscape'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'MSIE',
          identity: 'Explorer',
          versionSearch: 'MSIE'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Trident/7',
          identity: 'Explorer',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Gecko',
          identity: 'Mozilla',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Mozilla',
          identity: 'Netscape',
          versionSearch: 'Mozilla'
        }
      ];

      var osData = [
        {
          string: $window.navigator.platform,
          subString: 'Win',
          identity: 'Windows'
        },
        {
          string: $window.navigator.platform,
          subString: 'Mac',
          identity: 'Mac'
        },
        {
          string: $window.navigator.platform,
          subString: 'Linux',
          identity: 'Linux'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPhone',
          identity: 'iPhone'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPod',
          identity: 'iPod'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPad',
          identity: 'iPad'
        },
        {
          string: $window.navigator.platform,
          subString: 'Android',
          identity: 'Android'
        }
      ];

      var versionSearchString = '';

      function searchString(data) {
        for (var i = 0; i < data.length; i++) {
          var dataString = data[i].string;
          var dataProp = data[i].prop;

          versionSearchString = data[i].versionSearch || data[i].identity;

          if (dataString) {
            if (dataString.indexOf(data[i].subString) !== -1) {
              return data[i].identity;

            }
          }
          else if (dataProp) {
            return data[i].identity;
          }
        }
      }

      function searchVersion(dataString) {
        var index = dataString.indexOf(versionSearchString);

        if (index === -1) {
          return;
        }

        return parseInt(dataString.substring(index + versionSearchString.length + 1));
      }

      var browser = searchString(browserData) || 'unknown-browser';
      var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
      var os = searchString(osData) || 'unknown-os';

      // Prepare and store the object
      browser = browser.toLowerCase();
      version = browser + '-' + version;
      os = os.toLowerCase();

      browserInfo = {
        browser: browser,
        version: version,
        os: os
      };

      return browserInfo;
    }

    /**
     * Generates a globally unique id
     *
     * @returns {*}
     */
    function guidGenerator() {
      var S4 = function () {
        return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
      };
      return (S4() + S4() + S4() + S4() + S4() + S4());
    }

    /**
     * Return if current device is a
     * mobile device or not
     */
    function isMobile() {
      return mobileDetect.mobile();
    }

    /**
     * Toggle in array (push or splice)
     *
     * @param item
     * @param array
     */
    function toggleInArray(item, array) {
      if (array.indexOf(item) === -1) {
        array.push(item);
      }
      else {
        array.splice(array.indexOf(item), 1);
      }
    }

    function setJsonObj(mainObj, data) {
      if (Array.isArray(mainObj) && Array.isArray(data)) {
        mainObj.splice(0, mainObj.length);
      }
      angular.forEach(data, function (value, key) {

        if (typeof value === 'object' && value != null && key != '$promise') {

          if (mainObj[key] === undefined) {
            if (Array.isArray(value))
              mainObj[key] = [];
            else
              mainObj[key] = {};
          }
          setJsonObj(mainObj[key], value);
        }
        else if (key != '$promise')
          mainObj[key] = value;

      })
    }

    function pushIfNotExsist(mainObj, data, key) {
      if (!Array.isArray(mainObj))
        throw error("object is'nt array!");
      else {
        data.map(function (obj, index) {
          var sear = _defineProperty({}, key, obj[key]);
          var i = $filter('filter')(mainObj, sear, true)[0];
          if (!i)
            mainObj.push(obj);
        })
      }
    }

    function Toast(message) {
      $mdToast.show({
        template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
        hideDelay: 3000,
        position: 'top right',
        parent: 'body'
      });
    }

    var confirm;

    function Confirm(Title, message) {
      confirm = $mdDialog.confirm()
        .title(Title)
        .textContent(message)
        .ariaLabel('Lucky day')
        //.targetEvent(ev)
        .ok('אישור')
        .cancel('ביטול');

      return $mdDialog.show(confirm)
    }

    function Alert(Title, message) {
      confirm = $mdDialog.alert()
        .title(Title)
        .textContent(message)
        .ariaLabel('Lucky day')
        //.targetEvent(ev)
        .ok('סגור');


      return $mdDialog.show(confirm)
    }

    function Prompt(Title, msg, placeholder) {
      confirm = $mdDialog.prompt()
        .title(Title)
        .textContent(msg)
        .placeholder(placeholder)
        .ariaLabel('Dog name')
        .initialValue('')
        // .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      return $mdDialog.show(confirm)
    }

    function CheckClaimCode(code) {
      return code == CLAIM_CODE;
    }

//forES5
    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {value: value, enumerable: true, configurable: true, writable: true});
      } else {
        obj[key] = value;
      }
      return obj;
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('app.core')
    .provider('msApi', msApiProvider);

  /** @ngInject **/
  function msApiProvider() {
    /* ----------------- */
    /* Provider          */
    /* ----------------- */
    var provider = this;

    // Inject the $log service
    var $log = angular.injector(['ng']).get('$log');

    // Data
    var baseUrl = '';
    var api = [];

    // Methods
    provider.setBaseUrl = setBaseUrl;
    provider.getBaseUrl = getBaseUrl;
    provider.getApiObject = getApiObject;
    provider.register = register;

    //////////

    /**
     * Set base url for API endpoints
     *
     * @param url {string}
     */
    function setBaseUrl(url) {
      baseUrl = url;
    }

    /**
     * Return the base url
     *
     * @returns {string}
     */
    function getBaseUrl() {
      return baseUrl;
    }

    /**
     * Return the api object
     *
     * @returns {object}
     */
    function getApiObject() {
      return api;
    }

    /**
     * Register API endpoint
     *
     * @param key
     * @param resource
     */
    function register(key, resource, urlApi) {
      if (!angular.isString(key)) {
        $log.error('"path" must be a string (eg. `dashboard.project`)');
        return;
      }

      if (!angular.isArray(resource)) {
        $log.error('"resource" must be an array and it must follow $resource definition');
        return;
      }
      // Store the API object
      api[key] = {
        // url          : (urlApi||baseUrl) + (resource[0] || ''),
        url: (resource[0] || ''),
        paramDefaults: resource[1] || [],
        actions: resource[2] || [],
        options: resource[3] || {}
      };
    }

    /* ----------------- */
    /* Service           */
    /* ----------------- */
    this.$get = function ($log, $q, $resource, $rootScope) {
      // Data

      // Methods
      var service = {
        setBaseUrl: setBaseUrl,
        getBaseUrl: getBaseUrl,
        register: register,
        resolve: resolve,
        request: request
      };

      return service;

      //////////

      /**
       * Resolve an API endpoint
       *
       * @param action {string}
       * @param parameters {object}
       * @returns {promise|boolean}
       */
      function resolve(action, parameters) {
        // Emit an event
        $rootScope.$broadcast('msApi::resolveStart');

        var actionParts = action.split('@'),
          resource = actionParts[0],
          method = actionParts[1],
          params = parameters || {};

        if (!resource || !method) {
          $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
          return false;
        }

        // Create a new deferred object
        var deferred = $q.defer();

        // Get the correct resource definition from api object
        var apiObject = api[resource];

        if (!apiObject) {
          $log.error('Resource "' + resource + '" is not defined in the api service!');
          deferred.reject('Resource "' + resource + '" is not defined in the api service!');
        }
        else {
          // Generate the $resource object based on the stored API object
          var resourceObject = $resource(baseUrl + apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

          // Make the call...
          resourceObject[method](params,

            // Success
            function (response) {
              deferred.resolve(response);

              // Emit an event
              $rootScope.$broadcast('msApi::resolveSuccess');
            },

            // Error
            function (response) {
              deferred.reject(response);

              // Emit an event
              $rootScope.$broadcast('msApi::resolveError');
            }
          );
        }

        // Return the promise
        return deferred.promise;
      }

      /**
       * Make a request to an API endpoint
       *
       * @param action {string}
       * @param [parameters] {object}
       * @param [success] {function}
       * @param [error] {function}
       *
       * @returns {promise|boolean}
       */
      function request(action, parameters, success, error) {
        // Emit an event
        $rootScope.$broadcast('msApi::requestStart');

        var actionParts = action.split('@'),
          resource = actionParts[0],
          method = actionParts[1],
          params = parameters || {};

        if (!resource || !method) {
          $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
          return false;
        }

        // Create a new deferred object
        var deferred = $q.defer();

        // Get the correct resource definition from api object
        var apiObject = api[resource];

        if (!apiObject) {
          $log.error('Resource "' + resource + '" is not defined in the api service!');
          deferred.reject('Resource "' + resource + '" is not defined in the api service!');
        }
        else {
          // Generate the $resource object based on the stored API object
          var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

          // Make the call...
          resourceObject[method](params,

            // SUCCESS
            function (response) {
              // Emit an event
              $rootScope.$broadcast('msApi::requestSuccess');

              // Resolve the promise
              deferred.resolve(response);

              // Call the success function if there is one
              if (angular.isDefined(success) && angular.isFunction(success)) {
                success(response);
              }
            },

            // ERROR
            function (response) {
              // Emit an event
              $rootScope.$broadcast('msApi::requestError');

              // Reject the promise
              deferred.reject(response);

              // Call the error function if there is one
              if (angular.isDefined(error) && angular.isFunction(error)) {
                error(response);
              }
            }
          );
        }

        // Return the promise
        return deferred.promise;
      }
    };
  }
})();

/**
 * Created by itzik on 14/12/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.orHashen')
    .factory('inventoriesService', inventoriesService);


  /** @ngInject */
  function inventoriesService($q, $log, msApi, $filter,$timeout, msUtils, orUserAccount) {

    var orders_list;
    var archived_orders_list;

    function Orders(query, reload) {
      var deferred = $q.defer();
      if (orders_list && orders_list.length && !query && !reload) {
        deferred.resolve(orders_list);
      } else {
        GetAPI('or.inventories.orders', {token: orUserAccount.AccountToken.token, query: query}).then(function (data) {
          if (data.status) {
            if (!orders_list)
              orders_list = [];
            //debugger
            if (data.data)
              msUtils.PushIfNotExsist(orders_list, data.data, "ID")
          }
          $("a[ui-sref='app.inventories'] .badge").text(orders_list.length);
          deferred.resolve(orders_list);
        });
      }
      return deferred.promise;
    }
    $timeout(Orders, 2000);
    function ArchivedOrders(query, reload) {
      var deferred = $q.defer();
      if (archived_orders_list && archived_orders_list.length && !query && !reload) {
        deferred.resolve(archived_orders_list);
      } else {
        GetAPI('or.inventories.orders', {
          token: orUserAccount.AccountToken.token,
          query: query,
          archive: true
        }).then(function (data) {
          if (data.status) {
            if (!archived_orders_list)
              archived_orders_list = [];
            msUtils.setJsonObj(archived_orders_list, data.data)
          }
          deferred.resolve(archived_orders_list);
        });
      }
      return deferred.promise;
    }

    function Order(orderID) {
      var deferred = $q.defer();
      if (!orders_list || !orders_list.length || !$filter('filter')(orders_list, {ID: orderID})[0]) {
        Orders(orderID).then(function () {
          var OrderItem = $filter('filter')(orders_list, {ID: orderID})[0];
          deferred.resolve(OrderItem);
        })
      }
      else {
        var OrderItem = $filter('filter')(orders_list, {ID: orderID})[0];
        deferred.resolve(OrderItem);
      }
      return deferred.promise;

    }

    function OrderArchive(orderID) {
      var deferred = $q.defer();
      if (!archived_orders_list || !archived_orders_list.length || !$filter('filter')(archived_orders_list, {ID: orderID})[0]) {
        ArchivedOrders(orderID).then(function () {
          var OrderItem = $filter('filter')(archived_orders_list, {ID: orderID})[0];
          deferred.resolve(OrderItem);
        })
      }
      else {
        var OrderItem = $filter('filter')(archived_orders_list, {ID: orderID})[0];
        deferred.resolve(OrderItem);
      }
      return deferred.promise;

    }

    function GetOrderDetailsForEdit(orderID) {
      var deferred = $q.defer();
      GetAPI('or.inventories.editorderdetails', {
        token: orUserAccount.AccountToken.token,
        orderid: orderID
      }).then(function (data) {

        deferred.resolve(data.data);
      });
      return deferred.promise;
    }

    function OrderDetails(orderID) {
      var deferred = $q.defer();

      Order(orderID).then(function (OrderItem) {
          if (OrderItem && OrderItem.items) {
            deferred.resolve(OrderItem);
          }
          else if (OrderItem) {
            GetAPI('or.inventories.orderdetails', {
              token: orUserAccount.AccountToken.token,
              orderid: orderID
            }).then(function (data) {
              if (data.status) {
                if (!OrderItem.items)
                  OrderItem.items = [];
                msUtils.setJsonObj(OrderItem.items, data.data)
              }
              deferred.resolve(OrderItem);
            });
          } else {
            OrderArchive(orderID).then(function (OrderItem) {
              if (OrderItem && OrderItem.items) {
                deferred.resolve(OrderItem);
              }
              else if (OrderItem) {
                GetAPI('or.inventories.orderdetails', {
                  token: orUserAccount.AccountToken.token,
                  orderid: orderID
                }).then(function (data) {
                  if (data.status) {
                    if (!OrderItem.items)
                      OrderItem.items = [];
                    msUtils.setJsonObj(OrderItem.items, data.data)
                  }
                  deferred.resolve(OrderItem);
                });
              } else {
                deferred.resolve(undefined);
              }
            })

          }
        }
      )


      return deferred.promise;
    }

    function SaveInventory(inventory) {
      var deferred = $q.defer();
      postAPI("or.inventories.orders", {
        token: orUserAccount.AccountToken.token,
        data: inventory
      }).then(function (result) {
        Orders(undefined, true);
        deferred.resolve(result.data);
      }, deferred.reject);
      return deferred.promise;

    }

    function ChangeStatusInventory(inventory, option) {
      inventory.status = 4;//Send
      inventory.status_name = "מאושר";//Send
      if (option && option.toship) {
        inventory.status = 5;
        inventory.status_name = "ממתין למשלוח";

      }
      if (option && option.shipped) {
        inventory.status = 6;
        inventory.status_name = "נשלח";
      }

      else if (option && option.removed) {
        inventory.status = -1;
        inventory.status_name = "הזמנה נמחקה";

      }
      var deferred = $q.defer();
      postAPI("or.inventories.edit_status", {
        token: orUserAccount.AccountToken.token,
        data: inventory
      }).then(function (result) {
        Orders(undefined, true);
        deferred.resolve(result);
      }, deferred.reject);
      return deferred.promise;
    }

    var _Statuses_options;

    function Statuses_option() {
      var deferred = $q.defer();
      if (_Statuses_options)
        deferred.resolve(_Statuses_options);
      else {
        GetAPI("or.inventories.statuses", {
          token: orUserAccount.AccountToken.token
        }).then(function (result) {

          _Statuses_options = (result.data ? result.data.data : []);
          deferred.resolve(_Statuses_options);
        }, deferred.reject);
      }
      return deferred.promise;
    }

    function itemEdit_status(inventoryItem) {
      var deferred = $q.defer();
      postAPI("or.inventories.item.edit_status", {
        token: orUserAccount.AccountToken.token,
        data: inventoryItem
      }).then(function (result) {
        deferred.resolve(result);
      }, deferred.reject);
      return deferred.promise;
    }

    function GetEmployeeDetails(card_employee) {
      var deferred = $q.defer();
      GetAPI("or.employees.details", {
        token: orUserAccount.AccountToken.token,
        card: card_employee
      }).then(function (result) {
        deferred.resolve(result.data);
      }, deferred.reject);
      return deferred.promise;
    }

    function GetInventoriesTracking() {
      var deferred = $q.defer();
      GetAPI("or.inventories.tracking", {
        token: orUserAccount.AccountToken.token
      }).then(function (result) {
        deferred.resolve(result.data);
      }, deferred.reject);
      return deferred.promise;
    }

    var _tracking_history = [];

    function GetInventoriesHistoryTracking() {
      var deferred = $q.defer();
      GetAPI("or.inventories.tracking.history", {
        token: orUserAccount.AccountToken.token
      }).then(function (result) {

        msUtils.setJsonObj(_tracking_history, result.data)
        //_tracking_history = result.data;
        deferred.resolve(_tracking_history);
      }, deferred.reject);
      return deferred.promise;
    }

    var _allItems;

    function GetAllItemsProducts(reload) {
      var deferred = $q.defer();
      if (_allItems && !reload) {
        deferred.resolve(_allItems);
      }
      else {
        GetAPI('or.inventories.items', {token: orUserAccount.AccountToken.token}).then(function (data) {
          if (data.status) {
            if (!_allItems)
              _allItems = [];
            msUtils.setJsonObj(_allItems, data.data)
          }
          deferred.resolve(_allItems);
        });

      }
      return deferred.promise;
    }

    function UpdateItemProduct(item) {
      item.token = orUserAccount.AccountToken.token;
      item.permission = (item.permission == 1 || item.permission == "1" ? 1 : 0);
      var deferred = $q.defer();
      postAPI("or.inventories.items", item).then(function (result) {
        if (item.ID) {
          var obj = $filter('filter')(_allItems, {ID: item.ID}, true)[0];
          if (obj)
            msUtils.setJsonObj(obj, item);
        } else
          GetAllItemsProducts(true);
        deferred.resolve(result.data);
      }, deferred.reject)
      return deferred.promise;
    }

    var _suppliers;

    function GetSuppliers(reload) {
      var deferred = $q.defer();
      if (_suppliers && !reload) {
        deferred.resolve(_suppliers);
      }
      else {
        GetAPI('or.inventories.suppliers', {token: orUserAccount.AccountToken.token}).then(function (data) {
          if (data.status) {
            if (!_suppliers)
              _suppliers = [];
            msUtils.setJsonObj(_suppliers, data.data)
          }
          deferred.resolve(_suppliers);
        });
      }
      return deferred.promise;
    }

    function UpdateSuppliers(item) {
      item.token = orUserAccount.AccountToken.token;
      var deferred = $q.defer();
      postAPI("or.inventories.suppliers", item).then(function (result) {
        if (item.ID) {
          var obj = $filter('filter')(_suppliers, {ID: item.ID}, true)[0];
          if (obj)
            msUtils.setJsonObj(obj, item);
        } else
          GetSuppliers(true);
        deferred.resolve(result.data);
      }, deferred.reject)
      return deferred.promise;
    }

    function UpdateTrackingData(item) {
      item.token = orUserAccount.AccountToken.token;
      var deferred = $q.defer();
      postAPI("or.inventories.tracking", item).then(function (result) {
        GetInventoriesHistoryTracking().then(function (re) {
          console.log(re);
        });
        deferred.resolve(result.data);
      }, deferred.reject)
      return deferred.promise;
    }

    function GetAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@get', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function postAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@save', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }


    return {
      Orders: Orders,
      Order: Order,
      OrderDetails: OrderDetails,
      GetAllItemsProducts: GetAllItemsProducts,
      GetSuppliers: GetSuppliers,
      GetOrderDetailsForEdit: GetOrderDetailsForEdit,
      GetEmployeeDetails: GetEmployeeDetails,
      SaveInventory: SaveInventory,
      ChangeStatusInventory: ChangeStatusInventory,
      ArchivedOrders: ArchivedOrders,
      itemEdit_status: itemEdit_status,
      Statuses_option: Statuses_option,
      GetInventoriesTracking: GetInventoriesTracking,
      GetInventoriesHistoryTracking: GetInventoriesHistoryTracking,
      UpdateTrackingData: UpdateTrackingData,
      UpdateSuppliers: UpdateSuppliers,
      UpdateItemProduct: UpdateItemProduct
    }
  }
})
();

/**
 * Created by itzik on 14/12/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.orHashen')
    .factory('insuranceService', InsuranceService);


  /** @ngInject */
  function InsuranceService($q, $log, msApi, $filter, msUtils, orUserAccount,$rootScope) {

    var _insurancePrices;
    var _insuranceSummary;
    var _insuranceReport;
    var _insuranceDateSummary;
    var _listofcopies;

    function insurancePrices(reload) {
      var deferred = $q.defer();
      if (_insurancePrices && !reload) {
        deferred.resolve(_insurancePrices);
      } else {
        GetAPI('or.insurance.prices', {token: orUserAccount.AccountToken.token}).then(function (data) {
          if (data.status) {
            if (!_insurancePrices)
              _insurancePrices = [];
            msUtils.setJsonObj(_insurancePrices, data.data);
          }
          deferred.resolve(_insurancePrices);
        });
      }
      return deferred.promise;
    }

    function updateInsurancePrices(data) {
      return postAPI('or.insurance.prices', {token: orUserAccount.AccountToken.token, copy: data})
    }

    function InsuranceSummary(dates) {

      var deferred = $q.defer();
      if (!_insuranceDateSummary)
        _insuranceDateSummary = {start: new Date()}
      if (_insuranceSummary && _insuranceDateSummary == dates) {
        deferred.resolve(_insuranceSummary);
      } else {
        if (dates)
          _insuranceDateSummary = dates;

        GetAPI('or.insurance.summary', {
          token: orUserAccount.AccountToken.token,
          start: (_insuranceDateSummary && _insuranceDateSummary.start ? _insuranceDateSummary.start : ''),
          end: (_insuranceDateSummary && _insuranceDateSummary.end ? _insuranceDateSummary.end : '')
        }).then(function (data) {
          if (data.status) {
            if (!_insuranceSummary)
              _insuranceSummary = [[], []];
            msUtils.setJsonObj(_insuranceSummary[0], data.data[0]);
            msUtils.setJsonObj(_insuranceSummary[1], data.data[1]);
          }
          deferred.resolve(_insuranceSummary);
        });
      }
      return deferred.promise;
    }

    function InsuranceReport(dates, insuranceID) {
      var deferred = $q.defer();
      if (!_insuranceDateSummary)
        _insuranceDateSummary = {start: new Date()}
      if (!insuranceID) {
        _insuranceReport = [];
        deferred.resolve(_insuranceReport);
      }

      else if (_insuranceReport && _insuranceDateSummary == dates) {
        deferred.resolve(_insuranceReport);
      } else {
        if (dates)
          _insuranceDateSummary = dates;

        GetAPI('or.insurance.report', {
          token: orUserAccount.AccountToken.token,
          start: (_insuranceDateSummary && _insuranceDateSummary.start ? _insuranceDateSummary.start : ''),
          end: (_insuranceDateSummary && _insuranceDateSummary.end ? _insuranceDateSummary.end : ''),
          insurance: insuranceID
        }).then(function (data) {

          if (data.status) {

            if (!_insuranceReport)
              _insuranceReport = [];

            msUtils.setJsonObj(_insuranceReport, data.data);
          }
          deferred.resolve(_insuranceReport);
        });
      }
      return deferred.promise;
    }

    function InsertPrice(copy) {
      var deferred = $q.defer();
      if (!copy) {
        deferred.reject('misiimg copy');
      } else {
        postAPI('or.insurance.prices', {token: orUserAccount.AccountToken.token, copy: copy}).then(function (data) {
          if (data.status) {
            copy.ID = data.data.lastid;
            _insurancePrices.push(copy);
          }
          deferred.resolve(data.status);
        });
      }
      return deferred.promise;
    }

    function GetListofCopies() {
      var deferred = $q.defer();
      if (_listofcopies) {
        deferred.resolve(_listofcopies);
      } else {
        _listofcopies = [];
        deferred.resolve(_listofcopies);
        console.log('!!!!!!!!!!!!!!!!!!!!!!!')
        GetAPI('or.insurance.listofcopies', {token: orUserAccount.AccountToken.token}).then(function (data) {
          if (data.status)
            msUtils.setJsonObj(_listofcopies, data.data);
        });
      }
      return deferred.promise;
    }

    function RemoveCopie(copy) {
      var deferred = $q.defer();

      postAPI('or.insurance.prices.delete', {
        token: orUserAccount.AccountToken.token,
        copy: copy
      }).then(function (data) {

        if (data.status) {
          var x = $filter('filter')(_insurancePrices, {ID: copy.ID})[0];
          x.InsuranceID = -1;
          deferred.resolve(data);
        }
      });

      return deferred.promise;
    }

    function CreateAgreement(insuranseDetails) {
      var deferred = $q.defer();

      postAPI('or.insurance.create', {
        token: orUserAccount.AccountToken.token,
        data: insuranseDetails
      }).then(function (result) {
        if (result.status) {

        }
        deferred.resolve(result);

      });
      return deferred.promise;
    }


    function CreateClaim(data) {
      switch (data.InsuranceID) {
        case 20:
          data.HMO = data.HMO_Maccabi;
          break;
        case 21:
          data.HMO = data.HMO_Meuhedte;
          break;
        case 22:
        case 14:
          data.HMO = data.HMO_Shela;
          break;
      }

      return postAPI('or.insurance.claim.create', {token: orUserAccount.AccountToken.token, data: data})
    }

    function CreateGroupClaim(data) {
      return postAPI('or.insurance.claim.creategroup', {token: orUserAccount.AccountToken.token, data: data})
    }

    function UpdateClaimPhotos(status, items) {
      var deferred = $q.defer();
      ClaimStatuses().then(function () {
        items.map(function (item) {
          item.claimStatus = status;
          item.statusName = $filter('filter')(_claimStatuses, {ID: parseInt(item.claimStatus)}, true)[0].status;
          item._selected = false;
        })
        postAPI('or.insurance.claim.photos.update', {
          token: orUserAccount.AccountToken.token,
          data: items
        }).then(function (s) {
          deferred.resolve();
        }, deferred.reject)
      })
      return deferred.promise;

    }

    function RemoveClaimPhotos(items) {
      var deferred = $q.defer();

      items.map(function (item, index) {
        // item.removed = true;
        item._selected = false;
      })
      // deferred.resolve();
      postAPI('or.insurance.claim.photos.remove', {
        token: orUserAccount.AccountToken.token,
        data: items
      }).then(function (s) {
        //msUtils.PushIfNotExsist()
        deferred.resolve();
      }, deferred.reject)

      return deferred.promise;

    }

    var _claimList;

    function ClaimList(overide) {
      var deferred = $q.defer();
      if (_claimList && !overide)
        deferred.resolve(_claimList);
      else {
        if (!_claimList)
          _claimList = [];
        GetAPI('or.insurance.claims', {token: orUserAccount.AccountToken.token}).then(function (result) {
          msUtils.setJsonObj(_claimList, result.data);
          deferred.resolve(_claimList);
        })
      }
      return deferred.promise;
    }

    function GetClaim(ID) {
      var deferred = $q.defer();
      ClaimList().then(function (resu) {
        var item = $filter('filter')(_claimList, {"ID": parseInt(ID)}, true)[0];
        if (item)
          deferred.resolve(item);
      });
      return deferred.promise;
    }

    function LoadDataClaim(item) {
      var deferred = $q.defer();
      if (!item.data)
        item.data = [];
      GetAPI('or.insurance.claims.id', {token: orUserAccount.AccountToken.token, id: item.ID}).then(function (result) {
        msUtils.setJsonObj(item.data, result.data);
        deferred.resolve(true);
      })
      return deferred.promise;
    }

    var _claimStatuses;

    function ClaimStatuses() {
      var deferred = $q.defer();
      if (_claimStatuses)
        deferred.resolve(_claimStatuses);
      else {
        GetAPI('or.insurance.claim.statuses', {token: orUserAccount.AccountToken.token}).then(function (result) {
          _claimStatuses = result.data;
          deferred.resolve(_claimStatuses);
        })
      }
      return deferred.promise;
    }

    function UpdateClaim(data) {
      return postAPI('or.insurance.claims.update', {
        token: orUserAccount.AccountToken.token,
        data: {ID: data.ID, sumPaid: data.sumPaid, status: data.status, comments: data.comments, name: data.name}
      })
    }

    function GetDoctorsInsurance(ID) {
      return GetAPI('or.insurance.doctors', {token: orUserAccount.AccountToken.token, id: ID});
    }

    function DeleteClaim(data) {
      return postAPI('or.insurance.claims.delete', {
        token: orUserAccount.AccountToken.token,
        data: {ID: data.ID}
      })
    }

    function GetAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@get', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
        if (err.status == 401) {
          orUserAccount.LogOut();
          $rootScope.$broadcast('user:logout');
        }
      });
      return deferred.promise;
    }

    function postAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@save', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
        if (err.status == 401) {
          orUserAccount.LogOut();
          $rootScope.$broadcast('user:logout');
        }
      });
      return deferred.promise;
    }

    function updateStatusPhoto(item) {
      var deferred = $q.defer();
      if (!item) {
        deferred.reject('misiimg copy');
      } else {
        postAPI('or.insurance.statusphoto', {
          token: orUserAccount.AccountToken.token,
          photo: item
        }).then(function (data) {
          deferred.resolve({status: data.status, err: data.err});
        });
      }
      return deferred.promise;
    }
    function updateOrderNumberPhoto(item) {//Insurance14 - klalit
      var deferred = $q.defer();
      if (!item) {
        deferred.reject('misiimg copy');
      } else {
        postAPI('or.insurance.klalit-order', {
          token: orUserAccount.AccountToken.token,
          photo: item
        }).then(function (data) {
          deferred.resolve({status: data.status, err: data.err});
        });
      }
      return deferred.promise;
    }

    function shelaSetOrderNumber(item) {
      var deferred = $q.defer();
      if (!item) {
        deferred.reject('misiimg copy');
      } else {
        postAPI('or.insurance.shela-order', {
          token: orUserAccount.AccountToken.token,
          photo: item
        }).then(function (data) {
          deferred.resolve({status: data.status, err: data.err});
        });
      }
      return deferred.promise;
    }

    return {
      InsurancePrices: insurancePrices,
      UpdateInsurancePrices: updateInsurancePrices,
      InsuranceSummary: InsuranceSummary,
      InsuranceReport: InsuranceReport,
      InsertPrice: InsertPrice,
      GetListofCopies: GetListofCopies,
      RemoveCopie: RemoveCopie,
      CreateAgreement: CreateAgreement,
      GetDoctorsInsurance: GetDoctorsInsurance,

      CreateClaim: CreateClaim,
      CreateGroupClaim: CreateGroupClaim,
      ClaimList: ClaimList,
      ClaimStatuses: ClaimStatuses,
      GetClaim: GetClaim,
      LoadDataClaim: LoadDataClaim,
      UpdateClaimPhotos: UpdateClaimPhotos,
      RemoveClaimPhotos: RemoveClaimPhotos,
      UpdateClaim: UpdateClaim,
      DeleteClaim: DeleteClaim,

      UpdateStatusPhoto: updateStatusPhoto,
      updateOrderNumberPhoto: updateOrderNumberPhoto,
      shelaSetOrderNumber:shelaSetOrderNumber

    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
/**
 * Created by itzik on 14/11/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.orHashen')
    .factory('orAdminService', orAdminService);

  function orAdminService($q, $rootScope, msApi, orUserAccount, msUtils, $filter) {
    var _factorPays;

    var DoctorsReport = function (dates) {
      if (!dates)
        dates = {start: new Date()};
      var deferred = $q.defer();
      if (_factorPays)
        deferred.resolve(_factorPays);
      else {
        msApi.resolve('or.doctors.report@get', {
          token: orUserAccount.AccountToken.token,
          start: (dates && dates.start ? dates.start.toDateString() : ''),
          end: (dates && dates.end ? dates.end.toDateString() : '')
        }).then(function (result) {
          deferred.resolve(result.data);
        });
      }
      return deferred.promise;
    }

    var _reportPlace_client;
    var _reportAdmin_client;
    var PlacesClientReport = function (dates) {
      if (!dates)
        dates = {start: new Date()};
      var deferred = $q.defer();
      GetAPI('or.report_places.client', {
        token: orUserAccount.AccountToken.token,
        start: (dates && dates.start ? dates.start.toDateString() : ''),
        end: (dates && dates.end ? dates.end.toDateString() : '')
      }).then(function (result) {
        if (result.status) {
          if (!_reportPlace_client)
            _reportPlace_client = [];
          if (result.Admindata && !_reportAdmin_client)
            _reportAdmin_client = [];

          msUtils.setJsonObj(_reportPlace_client, result.data);
          if (result.Admindata)
            msUtils.setJsonObj(_reportAdmin_client, result.Admindata);
          deferred.resolve({place: _reportPlace_client, admin: _reportAdmin_client});
        } else
          deferred.resolve({place: []});

      }, function (e) {
        Invalid_OAuth(e, deferred.resolve);
      });
      return deferred.promise;
    }

    function PricesPlace(Place) {
      GetAPI('or.place.prices', {
        token: orUserAccount.AccountToken.token,
        placeid: Place.PlaceID
      }).then(function (result) {
        Place.Prices = result.data;
      })
    }

    function UpdatePricesPlace(Item) {
      return postAPI('or.place.prices.update', {token: orUserAccount.AccountToken.token, data: Item});
    }


    var _reportPlace_money;
    var PlacesMoneyReport = function (dates) {
      if (!dates)
        dates = {start: new Date()};
      var deferred = $q.defer();
      GetAPI('or.report_places.money', {
        token: orUserAccount.AccountToken.token, start: (dates && dates.start ? dates.start.toDateString() : ''),
        end: (dates && dates.end ? dates.end.toDateString() : '')
      }).then(function (result) {

        if (result.status) {
          if (!_reportPlace_money)
            _reportPlace_money = [];
          msUtils.setJsonObj(_reportPlace_money, result.data);
          deferred.resolve(_reportPlace_money);
        } else
          deferred.resolve([]);

      }, function (e) {
        Invalid_OAuth(e, deferred.resolve);
      });
      return deferred.promise;
    }


    var _doctorsList;
    var GetDoctorsList = function (search) {
      var deferred = $q.defer();
      if (_doctorsList && !search)
        deferred.resolve(_doctorsList);
      else {
        GetAPI('or.doctors', {
          token: orUserAccount.AccountToken.token,
          doctorname: search
        }).then(function (result) {
          if (result.status) {
            if (!_doctorsList) {
              _doctorsList = [];
              msUtils.setJsonObj(_doctorsList, result.data);
              deferred.resolve(_doctorsList);
            } else {
              msUtils.PushIfNotExsist(_doctorsList, result.data, 'DoctorID');
              deferred.resolve(_doctorsList);
            }
          }

        }, function (e) {
          Invalid_OAuth(e, deferred.resolve);
        });
      }
      return deferred.promise;
    }

    var _doctorsGroupList;
    var GetDoctorsGroupList = function (search) {
      var deferred = $q.defer();

      if (_doctorsGroupList && !search)
        deferred.resolve(_doctorsGroupList);
      else {
        GetAPI('or.doctors.group', {
          token: orUserAccount.AccountToken.token,
          groupname: search
        }).then(function (result) {
          if (result.status) {
            if (!_doctorsGroupList) {
              _doctorsGroupList = [];
              msUtils.setJsonObj(_doctorsGroupList, result.data);
              deferred.resolve(_doctorsGroupList);
            } else {
              msUtils.PushIfNotExsist(_doctorsGroupList, result.data, 'groupID');
              deferred.resolve(_doctorsGroupList);
            }
          }

        }, function (e) {
          Invalid_OAuth(e, deferred.resolve);
        });
      }
      return deferred.promise;
    }

    var _employeesList;
    var GetEmployessList = function (search) {
      var deferred = $q.defer();
      if (_employeesList && !search)
        deferred.resolve(_employeesList);
      else {
        GetAPI('or.employees', {
          token: orUserAccount.AccountToken.token,
          search: search
        }).then(function (result) {
          if (result.status) {
            if (!_employeesList) {
              _employeesList = [];
              msUtils.setJsonObj(_employeesList, result.data);
              deferred.resolve(_employeesList);
            } else {
              msUtils.PushIfNotExsist(_employeesList, result.data, 'OvedID');
              deferred.resolve(_employeesList);
            }
          }

        });
      }
      return deferred.promise;
    }
    var GetEmployessWorkNow = function () {
      var deferred = $q.defer();

      GetAPI('or.employees', {
        token: orUserAccount.AccountToken.token,
        worksNow: true
      }).then(function (result) {
        if (result.status) {
          deferred.resolve(result.data);
        }
        deferred.resolve([])

      });

      return deferred.promise;
    }
    var GetEmployee = function (ID) {
      var deferred = $q.defer();
      ID = parseInt(ID);
      var item;
      if (_employeesList) {
        item = $filter('filter')(_employeesList, {OvedID: ID}, true)[0];
      }
      if (item)
        deferred.resolve(item);
      else {
        GetAPI('or.employee.id', {
          token: orUserAccount.AccountToken.token,
          id: ID
        }).then(function (result) {
          if (result.status) {
            item = result.data;
          }
          deferred.resolve(item);
        });
      }
      return deferred.promise;
    }
    var EmployeeTimeWork = function (Employee, dates) {
      var deferred = $q.defer();

      GetAPI('or.employee.id.timework', {
        token: orUserAccount.AccountToken.token,
        id: Employee.OvedID,
        start: (dates && dates.start ? dates.start.toDateString() : ''),
        end: (dates && dates.end ? dates.end.toDateString() : '')
      }).then(function (result) {
        if (result.status) {
          result.data.map(function (item, idx) {
            var dur = moment.duration(moment(item.TimeOut).diff(item.TimeIN));
            item.duration = dur;
            item.durationH = dur.asHours();
            item.duration_regular = (item.durationH > 9 ? 9 : item.durationH)
            item.duration_extra = (item.durationH > 9 ? item.durationH - item.duration_regular : 0 )
          });
          Employee.timework = result.data;
          Employee.workDays = result.workDays;
        }
        deferred.resolve(Employee.timework);

      });

      return deferred.promise;

    }
    var UpdateEmployeeTimeWork = function (EmployeeEvent) {
      // if (EmployeeEvent.TimeIn)
      //   moment(EmployeeEvent.TimeIn).add(2, 'hour');
      return postAPI('or.employee.timework.update', {
        token: orUserAccount.AccountToken.token,
        employee: EmployeeEvent
      })
    }
    var GetDoctor = function (ID) {
      var deferred = $q.defer();
      var item;
      if (_doctorsList) {
        item = $filter('filter')(_doctorsList, {DoctorID: ID}, true)[0];
      }
      if (item)
        deferred.resolve(item);
      else {
        GetAPI('or.doctor', {
          token: orUserAccount.AccountToken.token,
          id: ID
        }).then(function (result) {
          if (result.status) {
            item = result.data;
            // if (!_doctorsList)
            //   _doctorsList = [];
            //msUtils.PushIfNotExsist(_doctorsList, [item], 'DoctorID');
          }
          deferred.resolve(item);
        });
      }
      return deferred.promise;
    }
    var LoadClientsDoctor = function (Doctor, dates) {
      var deferred = $q.defer();

      GetAPI('or.doctor.clients', {
        token: orUserAccount.AccountToken.token,
        id: Doctor.DoctorID,
        start: (dates && dates.start ? dates.start.toDateString() : ''),
        end: (dates && dates.end ? dates.end.toDateString() : '')
      }).then(function (result) {
        if (result.status) {
          Doctor.ClientsData = result.data;
          /*debugger
           Doctor.ClientsSummary = result.data.summary;
           Doctor.ClientsChart = result.data.summary;*/

          //msUtils.PushIfNotExsist(_doctorsList, [item], 'DoctorID');
        }
        deferred.resolve(Doctor.ClientsData);
      });
      //}
      return deferred.promise;
    }
    var compareDoctors = function (Doctor, datesA, datesB) {
      var deferred = $q.defer();
      postAPI('or.doctor.compare', {
        token: orUserAccount.AccountToken.token,
        doctorid: Doctor.DoctorID,
        dateA: datesA,
        dateB: datesB
      }).then(function (result) {
        if (result.status) {
          Doctor.ClientsData.percent = result.data;
        }
        deferred.resolve(Doctor.ClientsData);
      });
      return deferred.promise;
    }
    var ComparePlace = function (Place, datesA, datesB) {
      var deferred = $q.defer();
      postAPI('or.place.compare', {
        token: orUserAccount.AccountToken.token,
        placeid: Place.PlaceID,
        dateA: datesA,
        dateB: datesB
      }).then(function (result) {
        if (result.status) {
          Place.ClientsData.percent = result.data;
        }
        deferred.resolve(Place.ClientsData);
      });
      return deferred.promise;
    }

    // var LoadPhotosDoctor = function (Doctor, dates) {
    //   var deferred = $q.defer();
    //
    //   GetAPI('or.doctor.photos', {
    //     token: orUserAccount.AccountToken.token,
    //     id: Doctor.DoctorID,
    //     start: (dates && dates.start ? dates.start.toDateString() : ''),
    //     end: (dates && dates.end ? dates.end.toDateString() : '')
    //   }).then(function (result) {
    //     if (result.status) {
    //       Doctor.Photos = result.data;
    //
    //       //msUtils.PushIfNotExsist(_doctorsList, [item], 'DoctorID');
    //     }
    //     deferred.resolve(Doctor.Photos);
    //   });
    //   //}
    //   return deferred.promise;
    // }
    var LoadChartDoctor = function (Doctor, dates) {
      var deferred = $q.defer();

      GetAPI('or.doctor.chart', {
        token: orUserAccount.AccountToken.token,
        id: Doctor.DoctorID
      }).then(function (result) {
        if (result.status) {
          Doctor.ChartData = result.data;
          var xx = setCahrtFromData(Doctor.ChartData[0]);
          Doctor.ChartDataX = xx;
          console.log(xx);

          //msUtils.PushIfNotExsist(_doctorsList, [item], 'DoctorID');
        }
        deferred.resolve(Doctor.ChartData);
      });
      //}
      return deferred.promise;
    }

    var LoadChartPlace = function (Place, dates) {
      var deferred = $q.defer();

      GetAPI('or.report_places.chart', {
        token: orUserAccount.AccountToken.token,
        id: Place.PlaceID
      }).then(function (result) {
        if (result.status) {
          Place.ChartData = result.data;
          var xx = setCahrtFromData(Place.ChartData);
          Place.ChartDataX = xx;
          console.log(xx);
        }
        deferred.resolve(Place.ChartData);
      });
      //}
      return deferred.promise;
    }

    var UpdateDoctorDetail = function (doctor) {
      return postAPI('or.doctors', {
        token: orUserAccount.AccountToken.token,
        doctor: doctor
      })
    }
    var UpdateDoctorGroupDetail = function (doctor) {
      return postAPI('or.doctors.group', {
        token: orUserAccount.AccountToken.token,
        doctor: doctor
      })
    }

    function InsertNewDoctorGroup(doctor) {
      var deferred = $q.defer();
      if (!doctor) {
        deferred.reject('misiimg details');
      } else {
        postAPI('or.doctors.group', {token: orUserAccount.AccountToken.token, doctor: doctor}).then(function (data) {

          if (data.status) {
            doctor.groupID = data.data.lastid;
            _doctorsGroupList.push(doctor);
          }
          deferred.resolve(data.status);
        });
      }
      return deferred.promise;
    }

    var InactiveDoctor = function (doctor) {
      var deferred = $q.defer();
      postAPI('or.doctors.inactive', {
        token: orUserAccount.AccountToken.token,
        doctor: doctor
      }).then(function (data) {
        _doctorsList.map(function (item, index) {
          if (item.DoctorID == doctor.DoctorID) {
            _doctorsList.splice(index, 1);
            return;
          }
        })
      });
      return deferred.promise;
    }
    var _categories_photos;
    var Categories_photos = function () {
      var deferred = $q.defer();
      if (_categories_photos)
        deferred.resolve(_categories_photos);
      else {
        GetAPI('or.categories_photos', {
          token: orUserAccount.AccountToken.token
        }).then(function (result) {
          _categories_photos = result.data;
          deferred.resolve(_categories_photos);
        });
      }
      return deferred.promise;
    }

    function InsertNewDoctor(doctor) {
      var deferred = $q.defer();
      if (!doctor) {
        deferred.reject('misiimg details');
      } else {
        postAPI('or.doctors', {token: orUserAccount.AccountToken.token, doctor: doctor}).then(function (data) {

          if (data.status) {
            doctor.DoctorID = data.data.lastid;
            _doctorsList.push(doctor);
          }
          deferred.resolve(data.status);
        });
      }
      return deferred.promise;
    }

    var UpdateEmployeeDetail = function (employee) {
      return postAPI('or.employees', {
        token: orUserAccount.AccountToken.token,
        employee: employee
      })
    }
    var DeleteEmployee = function (employee) {
      return GetAPI('or.employees.del', {
        token: orUserAccount.AccountToken.token,
        id: employee.OvedID
      })
    }

    function GetAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@get', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        if (err.status == 401) {
          orUserAccount.LogOut();
          $rootScope.$broadcast('user:logout');
        }
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function postAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@save', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function setCahrtFromData(data) {
      /*{
       dateWork: "2017-09-12T00:00:00.000Z",
       countClients: 3,
       countPhotos: 7,
       Price: 2130,
       Deductible: 0
       },*/

      var dataChart = {
        YEAR: [{key: "Clients", values: []}, {key: "Photos", values: []}],//,{key: "Price", values: []}],
        MONTH: [{key: "Clients", values: []}, {key: "Photos", values: []}],//,{key: "Price", values: []}],
        WEEK: [{key: "Clients", values: []}, {key: "Photos", values: []}],//{key: "Price", values: []}],
        DAY: [{key: "Clients", values: []}, {key: "Photos", values: []}],//{key: "Price", values: []}]
      };
      var dataChart2 = {
        YEAR: [{key: "Price", values: []}, {key: "Photos", values: []}],//,{key: "Price", values: []}],
        MONTH: [{key: "Price", values: []}, {key: "Photos", values: []}],//,{key: "Price", values: []}],
        WEEK: [{key: "Price", values: []}, {key: "Photos", values: []}],//{key: "Price", values: []}],
        DAY: [{key: "Price", values: []}, {key: "Photos", values: []}],//{key: "Price", values: []}]
      };

      var lastDate = {d: 0, m: 0, y: 0};
      var sumYear = {clients: 0, copies: 0, new: true, date: moment()},
        sumMonth = {clients: 0, copies: 0, new: true, date: moment()},
        sumDay = {clients: 0, copies: 0, new: true, date: moment()}
      var PushData = function (type) {
        switch (type) {
          case 'year':
            dataChart.YEAR[0].values.push({"x": lastDate.y, "y": sumYear.clients});
            dataChart.YEAR[1].values.push({"x": lastDate.y, "y": sumYear.copies});
            var length = dataChart2.YEAR[0].values.length;
            dataChart2.YEAR[0].values.push({"x": length, "y": sumYear.price});
            dataChart2.YEAR[1].values.push({"x": length, "y": sumYear.copies});
            break;
          case "month":
            console.log(moment().month(lastDate.m).format('MMM'));
            dataChart.MONTH[0].values.push({
              "x": moment().month(lastDate.m).year(lastDate.y).format('MMM YY'),
              "y": sumMonth.clients
            });
            dataChart.MONTH[1].values.push({
              "x": moment().month(lastDate.m).year(lastDate.y).format('MMM YY'),
              "y": sumMonth.copies
            });
            var length = dataChart2.MONTH[0].values.length;
            dataChart2.MONTH[0].values.push({"x": length, "y": sumMonth.price});
            dataChart2.MONTH[1].values.push({"x": length, "y": sumMonth.copies});
            // dataChart.MONTH[2].values.push({"x": moment().month(lastDate.m).format('MMM'), "y": sumMonth.price});
            break;
          case "day":
            dataChart.WEEK[0].values.push({"x": sumDay.date.format('DD/MM/YY'), "y": sumDay.clients});
            dataChart.WEEK[1].values.push({"x": sumDay.date.format('DD/MM/YY'), "y": sumDay.copies});
            var length = dataChart2.WEEK[0].values.length;
            dataChart2.WEEK[0].values.push({"x": length, "y": sumDay.price});
            dataChart2.WEEK[1].values.push({"x": length, "y": sumDay.copies});
            // dataChart.WEEK[2].values.push({"x": sumDay.date.format('DD/MM/YY'), "y": sumDay.price});
            break;
        }


      }
      data.map(function (item, index) {
        var d = moment(item.dateWork);
        if (d.month() == moment().month() && d.date() == moment().date()) {
          //debugger
        }
        if (!lastDate.y) {
          lastDate.y = d.year();
          lastDate.m = d.month();
          lastDate.d = d.date();
        }
        if (d.year() > lastDate.y) {
          PushData('year');
          lastDate.y = d.year();
          lastDate.m = 0;
          lastDate.d = 0
          sumYear = {clients: 0, copies: 0, price: 0};
          sumMonth = {clients: 0, copies: 0, price: 0};
          sumDay = {clients: 0, copies: 0, price: 0};
        }
        else if (d.month() > lastDate.m) {
          PushData('month');
          lastDate.m = d.month();
          lastDate.d = 0
          sumMonth = {clients: 0, copies: 0, price: 0};
          sumDay = {clients: 0, copies: 0, price: 0};
        }
        else if (d.date() > lastDate.d) {
          PushData('day');
          lastDate.d = d.date();
          sumDay = {clients: 0, copies: 0, price: 0};
        }
        sumYear.clients += item.countClients;
        sumYear.copies += item.countPhotos;
        sumYear.price += item.Price;
        sumMonth.clients += item.countClients;
        sumMonth.copies += item.countPhotos;
        sumMonth.price += item.Price;
        sumDay.clients += item.countClients;
        sumDay.copies += item.countPhotos;
        sumDay.price += item.Price;
        sumDay.date = d;
        sumMonth.date = d;

      });
      PushData('year');
      PushData('month');
      PushData('day');
      if (dataChart.WEEK[0].values.length > 7) {

        dataChart.WEEK[0].values.splice(0, dataChart.WEEK[0].values.length - 7);
        dataChart.WEEK[1].values.splice(0, dataChart.WEEK[1].values.length - 7);

        dataChart2.WEEK[0].values.splice(0, dataChart2.WEEK[0].values.length - 7);
        dataChart2.WEEK[1].values.splice(0, dataChart2.WEEK[1].values.length - 7);
      }
      if (dataChart.MONTH[0].values.length > 12) {
        dataChart.MONTH[0].values.splice(0, dataChart.MONTH[0].values.length - 12);
        dataChart.MONTH[1].values.splice(0, dataChart.MONTH[1].values.length - 12);

        dataChart2.MONTH[0].values.splice(0, dataChart2.MONTH[0].values.length - 12);
        dataChart2.MONTH[1].values.splice(0, dataChart2.MONTH[1].values.length - 12);
        // dataChart.MONTH[2].values.splice(dataChart.MONTH[1].values.length - 12,dataChart.MONTH[2].values.length);
      }
      return [dataChart, dataChart2];
      var Tempdata = [
        {
          "key": "פציינטים",
          "values": [
            {"x": "Mon", "y": 9},
            {"x": "Tue", "y": 12},
            {"x": "Wed", "y": 9},
            {"x": "Thu", "y": 12},
            {"x": "Fri", "y": 7},
            {"x": "Sat", "y": 8},
            {"x": "Sun", "y": 16}
          ]
        },
        {
          "key": "צילומים",
          "values": [
            {"x": "Mon", "y": 37},
            {"x": "Tue", "y": 32},
            {"x": "Wed", "y": 39},
            {"x": "Thu", "y": 27},
            {"x": "Fri", "y": 18},
            {"x": "Sat", "y": 24},
            {"x": "Sun", "y": 20}
          ]
        }]
    }

    function UpdateProfileDoctor(data) {
      if (!data.NoteOUT)
        data.NoteOUT = '-';
      data.doctorid = data.DoctorID;
      return postAPI('or.doctor.detail.update', {token: orUserAccount.AccountToken.token, data: data});
    }

    function CreatePassword(data) {
      return postAPI('or.doctor.detail.pass.create', {token: orUserAccount.AccountToken.token, data: data});
    }

    function PricesDoctor(Doctor) {
      GetAPI('or.doctor.prices', {
        token: orUserAccount.AccountToken.token,
        doctorid: Doctor.DoctorID
      }).then(function (result) {
        Doctor.Prices = result.data;
      })
    }

    function InboxDoctor(Doctor) {
      GetAPI('or.doctor.inbox', {
        token: orUserAccount.AccountToken.token,
        doctorid: Doctor.DoctorID
      }).then(function (result) {
        if (!Doctor.Inbox)
          Doctor.Inbox = [];
        msUtils.setJsonObj(Doctor.Inbox, result.data);
      })
    }

    function PostMessageToDoctor(MainMessage, message, Doctor) {
      MainMessage.messages.push(message)
      MainMessage.lastMessage = message.content;
      MainMessage.lastDate = new Date();
      MainMessage.unread++;
      postAPI('or.doctor.inbox', {
        token: orUserAccount.AccountToken.token,
        messageId: MainMessage.messageId,
        doctor_id: MainMessage.doctor_id,
        title: MainMessage.title,
        newMessage: message
      }).then(function (result) {
        console.log(result);
        if (MainMessage.isnew) {
          InboxDoctor(Doctor);
        }
      })
    }

    function UpdatePricesDoctor(Item) {
      return postAPI('or.doctor.prices.update', {token: orUserAccount.AccountToken.token, data: Item});
    }

    function UsersList() {
      return GetAPI('or.users', {token: orUserAccount.AccountToken.token});
    }
    function UpdateUser(user) {
      return postAPI('or.users', {token: orUserAccount.AccountToken.token, user: user});
    }

    // function DeletePricesDoctor(Item) {
    //   postAPI('or.doctor.prices.del', {token: orUserAccount.AccountToken.token, data: Item}).then(function (result) {
    //     Item.doctorPrice = 0;
    //   })
    // }

    function All_Reports(report_ID, dates) {
      return GetAPI('or.allreports', {
        token: orUserAccount.AccountToken.token,
        report_id: report_ID,
        start: dates.start,
        end: dates.end
      });
    }


    /*REPORTS - ALL*/
    var _lastReport = {};
    var _favoriteReports;

    function SaveLastReport(obj) {
      _lastReport = obj;
    }

    function GetLastReport() {
      return _lastReport;
    }

    function GetFavoriteReports() {
      if (_favoriteReports)
        return _favoriteReports;
      if (window.localStorage['_favoriteReports'])
        _favoriteReports = JSON.parse(window.localStorage['_favoriteReports']);
      else
        _favoriteReports = [];
      return _favoriteReports;
    }

    function AddToFavoriteReport(items) {
      console.log('_favoriteReports', _favoriteReports);
      window.localStorage['_favoriteReports'] = JSON.stringify(_favoriteReports);
    }

    /*END REPORTS - ALL*/


    function AddDiscountPermission(number) {
      return postAPI('or.admin.discount', {
        data: {
          permission: number
        },
        token: orUserAccount.AccountToken.token
      });
    }

    function DeleteAccessUserDoctor(doctorID) {
      return postAPI('or.doctor.detail.pass.create', {
        token: orUserAccount.AccountToken.token,
        data: {DoctorID: doctorID}
      });
    }

    var Invalid_OAuth = function (err, resolve) {

      if (err.status == 401)
        orUserAccount.LogOut();
      resolve([{name: 'ERROR'}]);

    }
    return {
      DoctorsReprt: DoctorsReport,
      PlacesClientReport: PlacesClientReport,
      PlacesMoneyReport: PlacesMoneyReport,
      PricesPlace: PricesPlace,
      UpdatePricesPlace: UpdatePricesPlace,
      GetDoctorsList: GetDoctorsList,
      GetDoctorsGroupList: GetDoctorsGroupList,
      GetDoctor: GetDoctor,
      UpdateDoctorDetail: UpdateDoctorDetail,
      UpdateDoctorGroupDetail: UpdateDoctorGroupDetail,
      InsertNewDoctorGroup: InsertNewDoctorGroup,
      InactiveDoctor: InactiveDoctor,
      InsertNewDoctor: InsertNewDoctor,
      LoadClientsDoctor: LoadClientsDoctor,
      UpdateProfileDoctor: UpdateProfileDoctor,
      CreatePassword: CreatePassword,
      //LoadPhotosDoctor: LoadPhotosDoctor,
      LoadChartDoctor: LoadChartDoctor,
      LoadChartPlace: LoadChartPlace,

      //Employees
      GetEmployessList: GetEmployessList,
      GetEmployessWorkNow: GetEmployessWorkNow,
      GetEmployee: GetEmployee,
      EmployeeTimeWork: EmployeeTimeWork,
      UpdateEmployeeTimeWork: UpdateEmployeeTimeWork,

      DeleteEmployee: DeleteEmployee,
      UpdateEmployeeDetail: UpdateEmployeeDetail,
      DeleteAccessUserDoctor: DeleteAccessUserDoctor,
      PricesDoctor: PricesDoctor,
      InboxDoctor: InboxDoctor,
      PostMessageToDoctor: PostMessageToDoctor,
      UpdatePricesDoctor: UpdatePricesDoctor,
      //DeletePricesDoctor: DeletePricesDoctor,
      All_Reports: All_Reports,
      SaveLastReport: SaveLastReport,
      GetFavoriteReports: GetFavoriteReports,
      AddToFavoriteReport: AddToFavoriteReport,
      GetLastReport: GetLastReport,
      CompareDoctors: compareDoctors,
      ComparePlace: ComparePlace,
      AddDiscountPermission: AddDiscountPermission,

      Categories_photos: Categories_photos,

      UsersList: UsersList,
      UpdateUser:UpdateUser
    }
  }

})
();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('customCurrency', customCurrency)
    .filter('customCurrencyWithTax', customCurrencyWithTax)
    .filter('unique', Unique)
    .filter('dateBetween', DateBetween);

  /** @ngInject */
  function customCurrency() {

    return function (input, symbol, place) {
      if (typeof input === 'string')
        input = parseFloat(input);

      if (isNaN(input)) {
        return input;
      } else {
        var a_symbol = symbol || ' ₪ ';
        var a_place = place === undefined ? true : place;
        if (a_place === true) {
          // return a_symbol + ' ' + (input ? input.toFixed(2) : 0);
          return  (input ? input.toFixed(2) : 0) + ' ' +a_symbol;
        } else {
          //return a_symbol + ' ' + input;
          return input+ ' ' +a_symbol;
        }
      }

    }
  }

  function customCurrencyWithTax(msUtils) {
    var TAX = msUtils.TAX / 100 + 1;
    return function (input, symbol, place) {
      if (typeof input === 'string')
        input = parseFloat(input);

      if (isNaN(input)) {
        return input;
      } else {
        var a_symbol = symbol || ' ₪ ';
        var a_place = place === undefined ? true : place;
        input = input * TAX;
        if (a_place === true) {
          return (input ? input.toFixed(2) : 0) + a_symbol;
        } else {
          return a_symbol + ' ' + input;
        }
      }

    }
  }

  function Unique() {
    return function (collection, keyname) {
      var output = [],
        keys = [];

      // we utilize angular's foreach function
      // this takes in our original collection and an iterator function
      angular.forEach(collection, function (item) {
        // we check to see whether our object exists
        var key = item[keyname];
        // if it's not already part of our keys array
        if (keys.indexOf(key) === -1) {
          // add it to our keys array
          keys.push(key);
          // push this item to our final output array
          output.push(item);
        }
      });
      // return our array which should be devoid of
      // any duplicates
      return output;
    }
  }

  function DateBetween() {
    return function (items, key, from, to) {
      console.log(key);
      if (moment.isMoment(from)) {
        from = from.toDate();
      }
      if (moment.isMoment(to)) {
        to = to.toDate();
      }
      //var df = parseDate(from);
      //var dt = parseDate(to);

      var result = [];
      var startDate = new Date(from)
        , endDate = new Date(to);
      startDate.setHours(0);
      startDate.setMinutes(0);
      startDate.setSeconds(0);
      endDate.setHours(23);
      endDate.setMinutes(59);
      endDate.setSeconds(59);

      for (var i = 0; i < items.length; i++) {
        var date = new Date(items[i][key]);
        if (date >= startDate && date <= endDate)
          result.push(items[i]);
      }
      return result;
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('toTrusted', toTrustedFilter)
    .filter('htmlToPlaintext', htmlToPlainTextFilter)
    .filter('nospace', nospaceFilter)
    .filter('humanizeDoc', humanizeDocFilter)
    .filter('filterMultyWords', filterMultyWords);

  /** @ngInject */
  function toTrustedFilter($sce) {
    return function (value) {
      return $sce.trustAsHtml(value);
    };
  }

  /** @ngInject */
  function htmlToPlainTextFilter() {
    return function (text) {
      return String(text).replace(/<[^>]+>/gm, '');
    };
  }

  /** @ngInject */
  function nospaceFilter() {
    return function (value) {
      return (!value) ? '' : value.replace(/ /g, '');
    };
  }

  /** @ngInject */
  function humanizeDocFilter() {
    return function (doc) {
      if (!doc) {
        return;
      }
      if (doc.type === 'directive') {
        return doc.name.replace(/([A-Z])/g, function ($1) {
          return '-' + $1.toLowerCase();
        });
      }
      return doc.label || doc.name;
    };
  }

  /** @ngInject */
  function filterMultyWords() {
    return function (input, option) {
      var output = [];
      // console.log(option);
      // return input;
      // Do filter work here
      if ((!option || option == 0))
        return input;
      else {
        for (var idx in input) {
          var item = input[idx];
          var key = Object.keys(option)[0];
          var valueOfArray = (item[key]);
          var valueSearchs = [];
          if (option[key])
            valueSearchs = option[key].split(' ');
          //console.log(valueOfArray);

          var allow = true;
          for (var x in valueSearchs) {
            if (valueOfArray.indexOf(valueSearchs[x]) == -1)
              allow = false;
          }
          if (allow)
            output.push(item);
        }
      }
      return output;
    };
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'E',
            compile : function (element, attr)
            {
                var code;
                //No attribute? code is the content
                if ( !attr.code )
                {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr)
                {

                    if ( attr.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
  'use strict';

  angular
    .module('app.toolbar')
    .controller('ToolbarController', ToolbarController);

  /** @ngInject */
  function ToolbarController($rootScope, $q, $window, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, $mdDialog, $document, orAdminService, AdminAccount, orUserAccount, inventoriesService) {
    var vm = this;
    if (!AdminAccount.isLoggedIn) {
      $state.go('app.pages_auth_login-v2');
      return;
    }
    vm.username = AdminAccount.nameHE;
    vm.PlaceAccount = AdminAccount;
    vm.fullPermission = orUserAccount.Admin_user.rule == 10;
    vm.users_permission=orUserAccount.Admin_user.permission_users;
    // Data
    $rootScope.global = {
      search: ''
    };
    $rootScope.$on('user:logout', function () {
      AdminAccount.LogOut();
      $state.go('app.pages_auth_login-v2');
    });
    vm.discoundDialog = function () {
      var n = Math.floor(Math.random() * 161111) + 1;
      var confirm = $mdDialog.confirm()
        .title('מספר אישור: ' + n)
        .textContent('אישור מנהל להנחת מחיר. להפעלה נא לחץ על "הפעל" ')
        //.placeholder('הקש קוד אישור מנהל')
        .ariaLabel('Dog name')
        .ok('הפעל קוד הנחה')
        .cancel('ביטול');
      $mdDialog.show(confirm).then(function (result) {
        showToast('אנא המתן...');
        orAdminService.AddDiscountPermission(n).then(function (res) {
          if (res.status)
            alertDialog('קוד זה תקף ל 5 דקות בלבד', ' קוד ' + n + ' הופעל');
          else
            alertDialog('ארעה שגיאה')
        })

      });
    }

    vm.passwordDialog = function (ev) {

      $mdDialog.show({
        controller: 'Advanced_passPlaceDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/advanced_settings/passPlaceDialog/passPlaceDialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          Admin:true
          // client: Profile,
          // // Doctor: function () {
          // //   return orContacts.GetDoctorDetails(Profile.DoctorID);
          // // },

        }
      }).then(function (id) {

      });

      // var confirm = $mdDialog.prompt()
      //   .title('שינוי סיסמא')
      //   .textContent('הקש סיסמא ישנה')
      //   .placeholder('הזן מחיר')
      //   .ariaLabel('Dog name')
      //   .initialValue(max)
      //   .targetEvent(ev)
      //   //.required(true)
      //   .ok('אישור')
      //   .cancel('ביטול');
      //
      // $mdDialog.show(confirm).then(function (result) {
      //   showToast('אנא המתן...');
      //   // orAdminService.AddDiscountPermission(n).then(function (res) {
      //   //   if (res.status)
      //   //     alertDialog('קוד זה תקף ל 5 דקות בלבד', ' קוד ' + n + ' הופעל');
      //   //   else
      //   //     alertDialog('ארעה שגיאה')
      //   // })
      // });
    }


    function showToast(MSG) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(MSG)
          .position('bottom right')
          .hideDelay(3000)
      );
    }

    function alertDialog(MSG, title) {
      $mdDialog.show(
        $mdDialog.alert()
        //.parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title(title || 'שגיאה')
          .textContent(MSG)
          .ariaLabel('Alert Dialog Demo')
          .ok('סגור')
        //.targetEvent(ev)
      );
    }

    vm.employeeEntryDialog = function (ev) {
      $mdDialog.show({
        controller: 'employeesEntryController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employees/entry_dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {}
      }).then(function (id) {

      });
    }
    vm.bodyEl = angular.element('body');
    vm.userStatusOptions = [
      {
        'title': 'Online',
        'icon': 'icon-checkbox-marked-circle',
        'color': '#4CAF50'
      },
      {
        'title': 'Away',
        'icon': 'icon-clock',
        'color': '#FFC107'
      },
      {
        'title': 'Do not Disturb',
        'icon': 'icon-minus-circle',
        'color': '#F44336'
      },
      {
        'title': 'Invisible',
        'icon': 'icon-checkbox-blank-circle-outline',
        'color': '#BDBDBD'
      },
      {
        'title': 'Offline',
        'icon': 'icon-checkbox-blank-circle-outline',
        'color': '#616161'
      }
    ];
    vm.languages = {
      en: {
        'title': 'English',
        'translation': 'TOOLBAR.ENGLISH',
        'code': 'en',
        'flag': 'us'
      },
      es: {
        'title': 'Spanish',
        'translation': 'TOOLBAR.SPANISH',
        'code': 'es',
        'flag': 'es'
      },
      tr: {
        'title': 'Turkish',
        'translation': 'TOOLBAR.TURKISH',
        'code': 'tr',
        'flag': 'tr'
      }
    };

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.logout = logout;
    vm.changeLanguage = changeLanguage;
    vm.setUserStatus = setUserStatus;
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    vm.search = search;
    vm.searchResultClick = searchResultClick;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Select the first status as a default
      vm.userStatus = vm.userStatusOptions[0];

      // Get the selected language directly from angular-translate module setting
      vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
    }


    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Sets User Status
     * @param status
     */
    function setUserStatus(status) {
      vm.userStatus = status;
    }

    /**
     * Logout Function
     */
    function logout() {
      // Do logout here..
    }

    /**
     * Change Language
     */
    function changeLanguage(lang) {
      vm.selectedLanguage = lang;

      /**
       * Show temporary message if user selects a language other than English
       *
       * angular-translate module will try to load language specific json files
       * as soon as you change the language. And because we don't have them, there
       * will be a lot of errors in the page potentially breaking couple functions
       * of the template.
       *
       * To prevent that from happening, we added a simple "return;" statement at the
       * end of this if block. If you have all the translation files, remove this if
       * block and the translations should work without any problems.
       */
      if (lang.code !== 'en') {
        var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
          hideDelay: 7000,
          position: 'top right',
          parent: '#content'
        });

        return;
      }

      // Change the language
      $translate.use(lang.code);
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }

    /**
     * Toggle msNavigation folded
     */
    function toggleMsNavigationFolded() {
      msNavigationService.toggleFolded();
    }

    /**
     * Search action
     *
     * @param query
     * @returns {Promise}
     */
    function search(query) {
      var navigation = [],
        flatNavigation = msNavigationService.getFlatNavigation(),
        deferred = $q.defer();

      // Iterate through the navigation array and
      // make sure it doesn't have any groups or
      // none ui-sref items
      for (var x = 0; x < flatNavigation.length; x++) {
        if (flatNavigation[x].uisref) {
          navigation.push(flatNavigation[x]);
        }
      }

      // If there is a query, filter the navigation;
      // otherwise we will return the entire navigation
      // list. Not exactly a good thing to do but it's
      // for demo purposes.
      if (query) {
        navigation = navigation.filter(function (item) {
          if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
            return true;
          }
        });
      }

      // Fake service delay
      $timeout(function () {
        deferred.resolve(navigation);
      }, 1000);

      return deferred.promise;
    }

    /**
     * Search result click action
     *
     * @param item
     */
    function searchResultClick(item) {
      // If item has a link
      if (item.uisref) {
        // If there are state params,
        // use them...
        if (item.stateParams) {
          $state.go(item.state, item.stateParams);
        }
        else {
          $state.go(item.state);
        }
      }
    }

    vm.back = function () {
      $window.history.back();
    }
  }


})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(false);

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('fuse')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    $urlRouterProvider.otherwise('/reports/places');

    /**
     * Layout Style Switcher
     *
     * This code is here for demonstration purposes.
     * If you don't need to switch between the layout
     * styles like in the demo, you can set one manually by
     * typing the template urls into the `State definitions`
     * area and remove this code
     */
      // Inject $cookies
    var $cookies;

    angular.injector(['ngCookies']).invoke([
      '$cookies', function (_$cookies) {
        $cookies = _$cookies;
      }
    ]);

    // Get active layout
    var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

    var layouts = {
      verticalNavigation: {
        main: 'app/core/layouts/vertical-navigation.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
      },
      verticalNavigationFullwidthToolbar: {
        main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
      },
      verticalNavigationFullwidthToolbar2: {
        main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
      },
      horizontalNavigation: {
        main: 'app/core/layouts/horizontal-navigation.html',
        toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
        navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
      },
      contentOnly: {
        main: 'app/core/layouts/content-only.html',
        toolbar: '',
        navigation: ''
      },
      contentWithToolbar: {
        main: 'app/core/layouts/content-with-toolbar.html',
        toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
        navigation: ''
      }
    };
    // END - Layout Style Switcher

    // State definitions
    $stateProvider
      .state('app', {
        abstract: true,
        views: {
          'main@': {
            templateUrl: layouts[layoutStyle].main,
            controller: 'MainController as vm'
          },
          'toolbar@app': {
            templateUrl: layouts[layoutStyle].toolbar,
            controller: 'ToolbarController as vm'
          },
          'navigation@app': {
            templateUrl: layouts[layoutStyle].navigation,
            controller: 'NavigationController as vm'
          },
          'quickPanel@app': {
            templateUrl: 'app/quick-panel/quick-panel.html',
            controller: 'QuickPanelController as vm'
          }
        }, resolve: {
          AdminAccount: function (orUserAccount) {
            return orUserAccount.Admin_user;
          }
        }
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController(fuseTheming) {
    var vm = this;

    // Data
    vm.themes = fuseTheming.themes;
    vm.loaderService = {isLoading: false};
    //////////
  }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config(vcRecaptchaServiceProvider,$mdDateLocaleProvider,$compileProvider)
    {
        // Put your custom configurations here
      vcRecaptchaServiceProvider.setDefaults({
        key: '6LeMhjoUAAAAAPAjsbXglYrwqVexxrBy6dk9D-3J',
        lang:'he'
      });

      $mdDateLocaleProvider.formatDate = function(date) {
        return moment(date).format('DD/MM/YYYY');
      };

      $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|mailto|tel|waze):/);

    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
(function () {
  'use strict';

  angular
    .module('app.support', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.support', {
      url: '/support',
      views: {
        'content@app': {
          templateUrl: 'app/main/support/support.html'
        }
      },
      resolve: {}
    })

    msNavigationServiceProvider.saveItem('others', {
      title : 'תמיכה',
      group : true,
      weight: 10
    });
    msNavigationServiceProvider.saveItem('others.support', {
      title: 'טופס תמיכה',
      icon: 'icon-cog',
      state: 'app.support',
      weight: 1
    });

    // Api


  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.auth.login-v2',
            // 'app.pages.error-404',
            // 'app.pages.error-500',
            // 'app.pages.invoice',
            // 'app.pages.maintenance',
            // 'app.pages.search',
            // 'app.pages.timeline'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        // msNavigationServiceProvider.saveItem('pages', {
        //     title : 'PAGES',
        //     group : true,
        //     weight: 2
        // });
    }
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div id=\"content-container\" flex \nlayout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex>\n</md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/admin/admin.html","<div id=\"admin\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon>\n</span>&nbsp; <span class=\"logo-text\">תרשים מעקב רופאים</span></div><div class=\"mt-16\" layout=\"row\" \nlayout-align=\"start center\"></div></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nng-change=\"vm.showAdvancedSearch=true\" type=\"text\" ng-model=\"vm.search\" placeholder=\"חיפוש\"></md-input-container></div>\n</div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div \nclass=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\"><div><or-date-between-buttons dates=\"vm.dates\" \nrange-mode=\"true\" on-change=\"vm.refresh()\"></or-date-between-buttons></div><div class=\"main\" flex ms-scroll \nid=\"contactslist\"><md-list class=\"contacts-list\"><or-report-precent data=\"vm.data\" filter=\"vm.search\">\n</or-report-precent></md-list><md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>\nאין תוצאות</p></md-list-item></div></div></div>");
$templateCache.put("app/main/advanced_settings/advanced_settings.html","<div class=\"or-header page-layout simple left-sidenav inner-sidenav\"><div class=\"header smallheader md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\">\n</md-icon></span>&nbsp; <span class=\"logo-text\">ניהול מתקדם</span></div><div class=\"mt-16\" layout=\"row\" \nlayout-align=\"start center\"></div></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"></div></div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" \nclass=\"md-primary\"></md-progress-linear><div ng-if=\"vm.permission\" class=\"content scrollable\" flex layout=\"row\" \nlayout-align=\"start start\" ms-scroll=\"\"><div class=\"content\" flex=\"\" layout=\"row\"><h3>בקרוב...</h3></div><div \nclass=\"content\" flex=\"\" layout=\"row\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.taxDialog($event)\">הגדרת מע\"מ\n</md-button><md-button class=\"md-raised md-accent\">פתיחת סניף</md-button><md-button class=\"md-raised md-accent\">\nניהול הרשאות</md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.placePassDialog($event)\">שינוי סיסמא לסניף\n</md-button></div></div><div ng-if=\"!vm.permission\" class=\"content scrollable\" flex layout=\"row\" \nlayout-align=\"start start\" ms-scroll=\"\"><h1>אין לך הרשאות נא פנה למנהל</h1></div></div>");
$templateCache.put("app/main/all-reports/all-reports.html","<div class=\"or-header page-layout simple left-sidenav inner-sidenav\"><div class=\"header smallheader md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\">\n</md-icon></span>&nbsp; <span class=\"logo-text\">דוחות כלליים</span></div><div class=\"mt-16\" layout=\"row\" \nlayout-align=\"start center\"></div></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"></div></div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" \nclass=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\" \nms-scroll=\"\"><div class=\"content\" flex=\"\" layout=\"row\"></div><div flex=\"\" layout=\"row\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><md-chips ng-model=\"vm.favoriteR\" md-autocomplete-snap \nmd-on-add=\"vm.favoriteChanges()\" md-on-remove=\"vm.favoriteChanges()\" md-transform-chip=\"vm.transformChip($chip)\" \nmd-require-match=\"false\"><md-autocomplete md-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" placeholder=\"מועדפים:\"><span \nmd-highlight-text=\"vm.searchText\">{{item.name}}</span></md-autocomplete><md-chip-template><span \nng-click=\"vm.chipClicked($chip)\"><strong>{{$chip.name}}</strong></span></md-chip-template></md-chips></div><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap>\nבחר דוח רצוי, ולחץ על כפתור טווח הרצוי<div class=\"pv-8 h3\">{{vm.strDate}}</div><a ng-show=\"vm.report_file\" \nhref=\"{{vm.report_file}}\" target=\"_blank\">- להורדת הדוח המלא</a></div><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><md-select ng-model=\"vm.re_select\" \nmd-on-open=\"vm.focusSearch()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchselect\" \nid=\"s_search\" type=\"text\" placeholder=\"הקש ערך לחיפוש\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-option \nng-repeat=\"op in vm.Reports.data|filter:searchselect\" ng-if=\"!op.hide\" ng-value=\"op.id\">{{op.name}}</md-option>\n</md-select><div><or-date-between-buttons dates=\"vm.dates\" custom-range=\"vm.range\" on-change=\"vm.refresh()\">\n</or-date-between-buttons></div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" \nflex-sm=\"100\"><md-input-container md-no-float class=\"m-0\"><input id=\"search\" type=\"text\" ng-model=\"vm.search\" \nplaceholder=\"חיפוש\"></md-input-container></div></div><div layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"p-16\" layout=\"row\" flex=\"100\"><table-report flex feilds=\"vm.table.feilds\" data=\"vm.table.data\" \neditfeilds=\"vm.table.edit\" config=\"vm.table.config\" on-edit-item=\"vm.editItem\" on-insert-item=\"vm.addEmployee\" \non-remove-item=\"vm.removeEmployee\" filter-input=\"vm.search\" date-report=\"vm.dates\" order-default=\"Name\"></table-report>\n</div></div></ms-widget-front></ms-widget></div><div flex id=\"\"><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item></div></div></div>");
$templateCache.put("app/main/compare-reports/compare-reports.html","<div class=\"or-header page-layout simple left-sidenav inner-sidenav\"><div class=\"header smallheader md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\">\n</md-icon></span>&nbsp; <span class=\"logo-text\">דוחות יחסיים</span> &nbsp; &nbsp; <span class=\"logo-text\">\n{{vm.reportTypeSelected.name}}</span></div><div class=\"mt-16\" layout=\"row\" layout-align=\"start center\"></div></div><div\n hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"></div></div><md-progress-linear \nng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" \nflex layout=\"row\" layout-align=\"start start\" ms-scroll=\"\"><div class=\"content\" layout=\"row\" flex><ms-widget \nlayout=\"row\" flex layout-align=\"center start\"><ms-widget-front class=\"white-bg\"><div class=\"header\">בחר קטגוריה ראשית\n</div><div layout=\"row\" flex ng-repeat=\"item in vm.filterList\" class=\"m-5\"><md-button flex \nclass=\"md-raised md-primary\" ng-class=\"{\'md-accent\':item.selected}\" ng-click=\"vm.selectFilter(item);\">{{item.name}}\n</md-button></div></ms-widget-front></ms-widget><ms-widget layout=\"row\" flex layout-align=\"center start\">\n<ms-widget-front class=\"white-bg\"><div class=\"header\">בחר קטגוריה נוספת, לחץ שוב לביטול</div><div layout=\"row\" flex \nng-repeat=\"item in vm.filterList2\" ng-hide=\"item.hide\" class=\"m-5\"><md-button flex class=\"md-raised md-primary\" \nng-class=\"{\'md-accent\':item.selected}\" ng-click=\"vm.selectFilter2(item);\">{{item.name}}</md-button></div>\n</ms-widget-front></ms-widget></div><div class=\"content\" layout=\"row\" flex><div ng-show=\"false\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-primary\" ng-class=\"{\'md-accent\':vm.params.reportType==1}\" \nng-click=\"vm.params.reportType=1\">סניפים</md-button><md-button class=\"md-raised md-primary\" \nng-class=\"{\'md-accent\':vm.params.reportType==2}\" ng-click=\"vm.params.reportType=2\">רופאים</md-button><md-button \nclass=\"md-raised md-primary\" ng-class=\"{\'md-accent\':vm.params.reportType==1}\" ng-click=\"vm.params.reportType=1\">\nסניפים/רופאים</md-button><md-button class=\"md-raised md-primary\" ng-class=\"{\'md-accent\':vm.params.reportType==2}\" \nng-click=\"vm.params.reportType=2\">סניפים/קטגוריות</md-button><md-button class=\"md-raised md-primary\" \nng-class=\"{\'md-accent\':vm.params.reportType==3}\" ng-click=\"vm.params.reportType=3\">סניפים/גורם משלם</md-button>\n<md-button class=\"md-raised md-primary\" ng-class=\"{\'md-accent\':vm.params.reportType==4}\" \nng-click=\"vm.params.reportType=4\">רופאים/קטגוריות</md-button><md-button class=\"md-raised md-primary\" \nng-class=\"{\'md-accent\':vm.params.reportType==5}\" ng-click=\"vm.params.reportType=5\">רופאים/גורם משלם</md-button></div>\n</div><div class=\"content\" layout=\"row\" flex></div><div ng-if=\"false\" class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" class=\"ms-widget\">\n<ms-widget-front ng-click=\"flipWidget();vm.select.workDay_A=0\" class=\"h-170 p-16 light-blue-bg\"><div class=\"pb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">דוח לתאריך (לחץ לשינוי)\n</div></div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-headline\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"p-4\">{{vm.params.date_A.start|date:\'dd/MM/yy\'}}</div><span \nclass=\"m-8\">-</span> <span class=\"p-4\">{{vm.params.date_A.end|date:\'dd/MM/yy\'}}</span><md-icon ng-show=\"true\" \nmd-font-icon=\"icon-calendar\" class=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\"><span \nng-show=\"vm.select.workDay_A\" class=\"text-boxed-light\">{{vm.select.workDay_A|number}} ימי עבודה</span></div></div>\n</ms-widget-front><ms-widget-back class=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" \ntype=\"button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" \nrole=\"img\" aria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></button></div><div class=\"pt-8 pb-8\" \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"md-subhead\" layout=\"row\" flex><div \nclass=\"font-weight-500 secondary-text\">בין תאריך</div><md-datepicker ng-model=\"vm.params.date_A.start\"></md-datepicker>\n</div><div class=\"md-subhead\" layout=\"row\" flex><div class=\"font-weight-500 secondary-text mr-8\">לתאריך</div>\n<md-datepicker ng-model=\"vm.params.date_A.end\"></md-datepicker></div><div class=\"font-weight-500 secondary-text\">\n<md-button ng-click=\"flipWidget()\">אישור</md-button></div></div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" class=\"ms-widget\"><ms-widget-front \nng-click=\"flipWidget()\" class=\"h-170 p-16 light-blue-bg\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">השוואה לתאריך (לחץ לשינוי)</div>\n</div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-headline\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"p-4\">{{vm.params.date_B.start|date:\'dd/MM/yy\'}}</div><span class=\"m-8\">-</span>\n <span class=\"p-4\">{{vm.params.date_B.end|date:\'dd/MM/yy\'}}</span><md-icon ng-show=\"true\" md-font-icon=\"icon-calendar\" \nclass=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\"><span ng-show=\"vm.select.workDay_B\" \nclass=\"text-boxed-light\">{{vm.select.workDay_B|number}} ימי עבודה</span></div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" type=\"button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" role=\"img\" aria-hidden=\"true\"></md-icon><div \nclass=\"md-ripple-container\"></div></button></div><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" \nflex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div class=\"md-subhead\" layout=\"row\" \nflex><div class=\"font-weight-500 secondary-text\">בין תאריך</div><md-datepicker ng-model=\"vm.params.date_B.start\">\n</md-datepicker></div><div class=\"md-subhead\" layout=\"row\" flex><div class=\"font-weight-500 secondary-text mr-8\">לתאריך\n</div><md-datepicker ng-model=\"vm.params.date_B.end\"></md-datepicker></div><div class=\"font-weight-500 secondary-text\">\n<md-button ng-click=\"flipWidget()\">אישור</md-button></div></div></div></ms-widget-back></ms-widget><ms-widget \nng-show=\"vm.reportsRule.place\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nclass=\"ms-widget\"><ms-widget-front ng-click=\"flipWidget()\" class=\"h-170 p-16 red-bg\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">סניף</div></div><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-headline\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"p-4\">{{vm.params.place.Name}}</div><md-icon ng-show=\"true\" \nmd-font-icon=\"icon-bank\" class=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"text-boxed-light\">{{(vm.params.place.PlaceID?1:vm.Places.length)|number}} סניפים</span></div></div>\n</ms-widget-front><ms-widget-back class=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" \ntype=\"button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" \nrole=\"img\" aria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></button></div><md-select \nng-model=\"vm.select.place\" ng-change=\"vm.selectPlace();flipWidget()\"><md-option ng-value=\"0\">הכל</md-option><md-option \nng-repeat=\"pl in  vm.Places\" ng-value=\"pl.PlaceID\">{{pl.Name}}</md-option></md-select><md-button \nng-click=\"flipWidget()\">אישור</md-button></ms-widget-back></ms-widget><ms-widget ng-show=\"vm.reportsRule.category\" \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" class=\"ms-widget\"><ms-widget-front \nng-click=\"flipWidget()\" class=\"h-170 p-16 blue-bg\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"h4 font-weight-500 secondary-text\">קטגוריות</div></div><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"space-between\" flex><div class=\"md-headline\" layout=\"row\" layout-align=\"start center\"><div class=\"p-4\">\n{{vm.params.category.CategoryName}}</div><md-icon ng-show=\"true\" md-font-icon=\"icon-multiplication\" class=\"s36 ml-16\">\n</md-icon></div><div layout=\"row\" layout-align=\"start center\"><span class=\"text-boxed-light\">\n{{(vm.params.category.CategoryID?1:vm.Categories_photos.length)|number}} קטגוריות</span></div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" type=\"button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" role=\"img\" \naria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></button></div><md-select \nng-model=\"vm.select.category\" ng-change=\"vm.selectCategory();flipWidget()\"><md-option ng-value=\"0\">הכל</md-option>\n<md-option ng-repeat=\"pl in  vm.Categories_photos\" ng-value=\"pl.CategoryID\">{{pl.CategoryName}}</md-option></md-select>\n<md-button ng-click=\"flipWidget()\">אישור</md-button></ms-widget-back></ms-widget><ms-widget \nng-show=\"vm.reportsRule.doctors\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nclass=\"ms-widget\"><ms-widget-front ng-click=\"flipWidget()\" class=\"h-170 p-16 green-bg\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">רופאים</div></div><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-headline\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"p-4\">{{vm.params.doctor.Name}}</div><md-icon ng-show=\"true\" \nmd-font-icon=\"icon-account-box\" class=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"text-boxed-light\">{{vm.params.doctor.DoctorID?\'1 רופא\': \'כל הרופאים\'}}</span></div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" type=\"button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" role=\"img\" \naria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></button></div><md-autocomplete \nmd-autofocus=\"true\" md-search-text=\"searchText\" md-item-text=\"item.Name\" \nmd-selected-item-change=\"vm.selectDoctor(item)\" placeholder=\"הקש שם רופא\" \nmd-items=\"item in vm.searchDoctor(searchText)\"><md-item-template><span md-highlight-text=\"searchText\">{{item.Name}}\n</span></md-item-template></md-autocomplete><div layout=\"row\" flex><md-button ng-click=\"flipWidget()\">אישור</md-button>\n<md-button ng-click=\"vm.selectDoctor();flipWidget()\">כל הרופאים</md-button></div></ms-widget-back></ms-widget>\n<ms-widget ng-show=\"vm.reportsRule.insurance\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\" class=\"ms-widget\"><ms-widget-front ng-click=\"flipWidget()\" class=\"h-170 p-16 grey-bg\"><div \nclass=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">גורם משלם\n</div></div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-headline\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"p-4\">{{vm.params.insurance.Name}}</div><md-icon ng-show=\"true\" \nmd-font-icon=\"icon-flag\" class=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"text-boxed-light\">{{(vm.params.insurance.BituahID?1:vm.Categories_photos.length)|number}} משלם/ים</span></div>\n</div></ms-widget-front><ms-widget-back class=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" \ntype=\"button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" \nrole=\"img\" aria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></button></div><md-select \nng-model=\"vm.select.insurance\" ng-change=\"vm.selectInsurance();flipWidget()\"><md-option ng-value=\"0\">הכל</md-option>\n<md-option ng-repeat=\"pl in  vm.Insurance\" ng-value=\"pl.BituahID\">{{pl.Name}}</md-option></md-select><md-button \nng-click=\"flipWidget()\">אישור</md-button></ms-widget-back></ms-widget><ms-widget ng-show=\"vm.showMoreRules()\" \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" class=\"ms-widget\"><ms-widget-front \nng-click=\"flipWidget()\" class=\"h-170 p-16 grey-bg\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"h4 font-weight-500 secondary-text\">הוסף פרמטר</div></div><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"space-between\" flex><div class=\"md-headline\" layout=\"row\" layout-align=\"start center\"><div class=\"p-4\">\nהוסף פרמטר</div><md-icon ng-show=\"true\" md-font-icon=\"icon-plus\" class=\"s36 ml-16\"></md-icon></div><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"text-boxed-light\">מקסימום 2 פרמטרים</span></div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" type=\"button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" role=\"img\" \naria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></button></div><md-select \nng-model=\"vm.reportsRuleaa\" ng-change=\"flipWidget()\"><md-option ng-value=\"0\">הכל</md-option><md-option \nng-repeat=\"pl in  vm.reportsRule|filter:\'!0\'\" ng-value=\"pl\">{{pl}}</md-option></md-select><md-button \nng-click=\"flipWidget()\">אישור</md-button></ms-widget-back></ms-widget></div><div ng-show=\"true\" class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\" class=\"ms-widget\"><ms-widget-front ng-click=\"flipWidget();vm.select.workDay_A=0\" \nclass=\"h-170 p-16 light-blue-bg\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h4 font-weight-500 secondary-text\">דוח לתאריך (לחץ לשינוי)</div></div><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"space-between\" flex><div class=\"md-headline\" layout=\"row\" layout-align=\"start center\"><div class=\"p-4\">\n{{vm.params.date_A.start|date:\'dd/MM/yy\'}}</div><span class=\"m-8\">-</span> <span class=\"p-4\">\n{{vm.params.date_A.end|date:\'dd/MM/yy\'}}</span><md-icon ng-show=\"true\" md-font-icon=\"icon-calendar\" class=\"s36 ml-16\">\n</md-icon></div><div layout=\"row\" layout-align=\"start center\"><span ng-show=\"vm.select.workDay_A\" \nclass=\"text-boxed-light\">{{vm.select.workDay_A|number}} ימי עבודה</span></div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" type=\"button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" role=\"img\" aria-hidden=\"true\"></md-icon><div \nclass=\"md-ripple-container\"></div></button></div><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" \nflex><div class=\"md-subhead\" layout=\"row\" flex><div class=\"font-weight-500 secondary-text\">בין תאריך</div>\n<md-datepicker ng-model=\"vm.params.date_A.start\"></md-datepicker></div><div class=\"md-subhead\" layout=\"row\" flex><div \nclass=\"font-weight-500 secondary-text mr-8\">לתאריך</div><md-datepicker ng-model=\"vm.params.date_A.end\"></md-datepicker>\n</div><div class=\"font-weight-500 secondary-text\"><md-button ng-click=\"flipWidget()\">אישור</md-button></div></div>\n</ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nclass=\"ms-widget\"><ms-widget-front ng-click=\"flipWidget()\" class=\"h-170 p-16 light-blue-bg\"><div class=\"pb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">\nהשוואה לתאריך (לחץ לשינוי)</div></div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div \nclass=\"md-headline\" layout=\"row\" layout-align=\"start center\"><div class=\"p-4\">\n{{vm.params.date_B.start|date:\'dd/MM/yy\'}}</div><span class=\"m-8\">-</span> <span class=\"p-4\">\n{{vm.params.date_B.end|date:\'dd/MM/yy\'}}</span><md-icon ng-show=\"true\" md-font-icon=\"icon-calendar\" class=\"s36 ml-16\">\n</md-icon></div><div layout=\"row\" layout-align=\"start center\"><span ng-show=\"vm.select.workDay_B\" \nclass=\"text-boxed-light\">{{vm.select.workDay_B|number}} ימי עבודה</span></div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" type=\"button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" role=\"img\" aria-hidden=\"true\"></md-icon><div \nclass=\"md-ripple-container\"></div></button></div><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" \nflex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div class=\"md-subhead\" layout=\"row\" \nflex><div class=\"font-weight-500 secondary-text\">בין תאריך</div><md-datepicker ng-model=\"vm.params.date_B.start\">\n</md-datepicker></div><div class=\"md-subhead\" layout=\"row\" flex><div class=\"font-weight-500 secondary-text mr-8\">לתאריך\n</div><md-datepicker ng-model=\"vm.params.date_B.end\"></md-datepicker></div><div class=\"font-weight-500 secondary-text\">\n<md-button ng-click=\"flipWidget()\">אישור</md-button></div></div></div></ms-widget-back></ms-widget><ms-widget \nng-show=\"vm.reportTypeSelected.place\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nclass=\"ms-widget\"><ms-widget-front ng-click=\"flipWidget()\" class=\"h-170 p-16 red-bg\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">סניף</div></div><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-headline\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"p-4\">{{vm.params.place.Name}}</div><md-icon ng-show=\"true\" \nmd-font-icon=\"icon-bank\" class=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"text-boxed-light\">{{(vm.params.place.PlaceID?1:vm.Places.length)|number}} סניפים</span></div></div>\n</ms-widget-front><ms-widget-back class=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" \ntype=\"button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" \nrole=\"img\" aria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></button></div><md-select \nng-model=\"vm.select.place\" ng-change=\"vm.selectPlace();flipWidget()\"><md-option ng-value=\"0\">הכל</md-option><md-option \nng-repeat=\"pl in  vm.Places\" ng-value=\"pl.PlaceID\">{{pl.Name}}</md-option></md-select><md-button \nng-click=\"flipWidget()\">אישור</md-button></ms-widget-back></ms-widget><ms-widget \nng-show=\"vm.reportTypeSelected.doctors\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nclass=\"ms-widget\"><ms-widget-front ng-click=\"flipWidget()\" class=\"h-170 p-16 green-bg\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">רופאים</div></div><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-headline\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"p-4\">{{vm.params.doctor.Name}}</div><md-icon ng-show=\"true\" \nmd-font-icon=\"icon-account-box\" class=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"text-boxed-light\">{{vm.params.doctor.DoctorID?\'1 רופא\': \'כל הרופאים\'}}</span></div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" type=\"button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" role=\"img\" \naria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></button></div><md-autocomplete \nmd-autofocus=\"true\" md-search-text=\"searchText\" md-item-text=\"item.Name\" \nmd-selected-item-change=\"vm.selectDoctor(item)\" placeholder=\"הקש שם רופא\" \nmd-items=\"item in vm.searchDoctor(searchText)\"><md-item-template><span md-highlight-text=\"searchText\">{{item.Name}}\n</span></md-item-template></md-autocomplete><div layout=\"row\" flex><md-button ng-click=\"flipWidget()\">אישור</md-button>\n<md-button ng-click=\"vm.selectDoctor();flipWidget()\">כל הרופאים</md-button></div></ms-widget-back></ms-widget>\n<ms-widget ng-show=\"vm.reportTypeSelected.category\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\" class=\"ms-widget\"><ms-widget-front ng-click=\"flipWidget()\" class=\"h-170 p-16 blue-bg\"><div \nclass=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">קטגוריות\n</div></div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-headline\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"p-4\">{{vm.params.category.CategoryName}}</div><md-icon \nng-show=\"true\" md-font-icon=\"icon-multiplication\" class=\"s36 ml-16\"></md-icon></div><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"text-boxed-light\">\n{{(vm.params.category.CategoryID?1:vm.Categories_photos.length)|number}} קטגוריות</span></div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" type=\"button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" role=\"img\" \naria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></button></div><md-select \nng-model=\"vm.select.category\" ng-change=\"vm.selectCategory();flipWidget()\"><md-option ng-value=\"0\">הכל</md-option>\n<md-option ng-repeat=\"pl in  vm.Categories_photos\" ng-value=\"pl.CategoryID\">{{pl.CategoryName}}</md-option></md-select>\n<md-button ng-click=\"flipWidget()\">אישור</md-button></ms-widget-back></ms-widget><ms-widget \nng-show=\"vm.reportTypeSelected.insuranse\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nclass=\"ms-widget\"><ms-widget-front ng-click=\"flipWidget()\" class=\"h-170 p-16 grey-bg\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">גורם משלם</div></div><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-headline\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"p-4\">{{vm.params.insurance.Name}}</div><md-icon ng-show=\"true\" \nmd-font-icon=\"icon-flag\" class=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"text-boxed-light\">{{(vm.params.insurance.BituahID?1:vm.Categories_photos.length)|number}} משלם/ים</span></div>\n</div></ms-widget-front><ms-widget-back class=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" \ntype=\"button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" \nrole=\"img\" aria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></button></div><md-select \nng-model=\"vm.select.insurance\" ng-change=\"vm.selectInsurance();flipWidget()\"><md-option ng-value=\"0\">הכל</md-option>\n<md-option ng-repeat=\"pl in  vm.Insurance\" ng-value=\"pl.BituahID\">{{pl.Name}}</md-option></md-select><md-button \nng-click=\"flipWidget()\">אישור</md-button></ms-widget-back></ms-widget></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button flex flex-gt-xs=\"50\" class=\"md-raised md-primary\" ng-click=\"vm.run()\">הצג דוח\n</md-button></div><div flex=\"\" layout=\"row\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap>\n<div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-input-container \nmd-no-float class=\"m-0\"><input id=\"search\" type=\"text\" ng-model=\"vm.search\" placeholder=\"חיפוש\"></md-input-container>\n</div></div><div layout=\"row\" layout-align=\"start start\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\">\n<table-compare-report flex feilds=\"vm.feilds\" data=\"vm.data_compare\" editfeilds=\"vm.table.edit\" \nconfig=\"vm.table.config\" on-edit-item=\"vm.editItem\" on-insert-item=\"vm.addEmployee\" on-remove-item=\"vm.removeEmployee\" \nfilter-input=\"vm.search\" date-report=\"vm.dates\" order-default=\"Name\"></table-compare-report></div></div>\n</ms-widget-front></ms-widget></div><div flex id=\"\"><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item></div></div></div>");
$templateCache.put("app/main/contacts/contacts.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon>\n</span>&nbsp; <span class=\"logo-text\">{{(vm.header?vm.header:\'פציינטים\')}}</span><md-button \nclass=\"md-raised md-accent\" hide-gt-md ng-click=\"vm.Search(event)\"><md-icon md-font-icon=\"icon-account-search\">\n</md-icon>חיפוש לקוח</md-button><span hide show-gt-md class=\"logo-text\" ng-hide=\"vm.isCustomSearch\">\n&nbsp; ליום: {{vm.dates.start|date}}</span> <span hide show-gt-md class=\"logo-text\" ng-hide=\"vm.isCustomSearch\" \nng-show=\"vm.dates&& vm.dates.end\">&nbsp; עד {{vm.dates.end|date}}</span> <span hide show-gt-md class=\"logo-text\" \nng-show=\"vm.isCustomSearch\">&nbsp;(חיפוש)</span></div><div class=\"mt-16\" layout=\"row\" layout-align=\"start center\">\n<or-date-between-buttons dates=\"vm.dates\" on-change=\"vm.refresh(vm.dates)\"></or-date-between-buttons><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.Search(event)\" hide show-gt-md><md-icon md-font-icon=\"icon-account-search\">\n</md-icon>חיפוש לקוח</md-button><md-button class=\"md-raised md-primary\" ui-sref=\"app.contacts\" ng-click=\"vm.refresh()\">\n<md-icon ng-hide=\"vm.header\" md-font-icon=\"icon-refresh\"></md-icon><md-icon ng-show=\"vm.header\" \nmd-font-icon=\"icon-account-multiple\"></md-icon>{{(vm.header?\'הצג הכל\':\'רענן\')}}</md-button></div></div><div hide \nshow-gt-xs class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-input-container md-no-float \nclass=\"m-0\"><input id=\"search\" ng-change=\"vm.showAdvancedSearch=true\" type=\"text\" ng-model=\"vm.search\" \nplaceholder=\"חיפוש\"></md-input-container></div></div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" \nclass=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\">\n<div class=\"main\" flex ms-scroll id=\"contactslist\"><md-list class=\"contacts-list\"><table-report config=\"vm.config\" \nfeilds=\"vm.feilds\" data=\"vm.clients\" order-default=\"KDate\" filter-input=\"vm.search\"></table-report><div \nng-show=\"!vm.clients.length\"><div class=\"content\"><div class=\"info-line md-title dir-rtl\" layout=\"row\" \nlayout-align=\"center center\" flex><div class=\"info-line md-title dir-rtl\" layout=\"column\" layout-align=\"center center\" \nflex><div>בחר תאריך להצגת פציינטים או לחץ על חיפוש</div><div><md-icon md-font-icon=\"icon-close\" class=\"s200\"></md-icon>\n</div><md-button class=\"md-accent\" ng-click=\"vm.Search(event)\">חיפוש<md-icon md-font-icon=\"icon-account-search\">\n</md-icon></md-button></div></div></div></div></md-list><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item></div></div><div id=\"add-contact-button\">\n<md-button class=\"md-fab md-accent md-icon-button\" ui-sref=\"app.newclient\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/main/doctors/doctors.html","<div class=\"or-header doctor page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header smallheader md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span>&nbsp; <span class=\"logo-text\">רשימת רופאים</span></div>\n<div class=\"mt-16\" layout=\"row\" layout-align=\"start center\"></div></div><div hide show-gt-xs \nclass=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"></div></div><md-progress-linear \nng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" \nflex layout=\"row\" layout-align=\"start start\" ms-scroll=\"\"><div class=\"content\" flex=\"\" layout=\"row\"></div><div flex=\"\" \nlayout=\"row\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8\" \nlayout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-input-container md-no-float \nclass=\"m-0\"><input id=\"search\" ng-change=\"vm.change()\" type=\"text\" ng-model=\"vm.search\" placeholder=\"חיפוש\">\n</md-input-container></div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" \nflex-sm=\"100\">החיפוש לפי שם רופא בלבד (ניתן להקיש שם פרטי ו\\או שם משפחה. אין חשיבות לקדימות)</div></div><div \nlayout=\"row\" layout-align=\"start start\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\"><table-report flex \nfeilds=\"vm.ClientsReports.feilds\" data=\"vm.ClientsReports.data\" editfeilds=\"vm.ClientsReports.edit\" \nconfig=\"vm.ClientsReports.config\" on-edit-item=\"vm.editItem\" on-insert-item=\"vm.RegisterNewDoctor\" \non-remove-item=\"vm.InactiveDoctor\" filter-input=\"vm.search\" order-default=\"Name\"></table-report></div></div>\n</ms-widget-front></ms-widget></div><div flex id=\"\"><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item></div></div></div>");
$templateCache.put("app/main/employees/employees.html","<div class=\"or-header page-layout simple left-sidenav inner-sidenav\"><div class=\"header smallheader md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\">\n</md-icon></span>&nbsp; <span class=\"logo-text\">רשימת עובדים</span></div><div class=\"mt-16\" layout=\"row\" \nlayout-align=\"start center\"></div></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"></div></div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" \nclass=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\" \nms-scroll=\"\"><div class=\"content\" flex=\"\" layout=\"row\"></div><div flex=\"\" layout=\"row\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">רשימת עובדים</div><div><md-button \nng-disabled=\"vm.proccess\" ng-hide=\"vm.worksNowStatus\" class=\"md-raised md-primary\" ng-click=\"vm.worksNow(true)\">\n<md-icon md-font-icon=\"icon-timetable\"></md-icon>הצג עובדים זמינים כעת...</md-button><md-button \nng-disabled=\"vm.proccess\" ng-show=\"vm.worksNowStatus\" class=\"md-primary\" ng-click=\"vm.worksNow(false)\">הצג כל העובדים\n</md-button></div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\">\n<md-input-container md-no-float class=\"m-0\"><input id=\"search\" ng-change=\"vm.change()\" type=\"text\" \nng-model=\"vm.search\" placeholder=\"חיפוש\"></md-input-container></div></div><div layout=\"row\" layout-align=\"start start\" \nlayout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\"><table-report ng-hide=\"vm.worksNowStatus\" flex \nfeilds=\"vm.table.feilds\" data=\"vm.table.data\" editfeilds=\"vm.table.edit\" config=\"vm.table.config\" \non-edit-item=\"vm.editItem\" on-insert-item=\"vm.addEmployee\" on-remove-item=\"vm.removeEmployee\" filter-input=\"vm.search\" \norder-default=\"Name\"></table-report><table-report ng-show=\"vm.worksNowStatus\" flex feilds=\"vm.table.feildsWorkNow\" \ndata=\"vm.worksOnlyData\" config=\"vm.table.config\" filter-input=\"vm.search\" order-default=\"Name\"></table-report></div>\n</div></ms-widget-front></ms-widget></div><div flex id=\"\"><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item></div></div></div>");
$templateCache.put("app/main/group_doctors/doctors_group.html","<div class=\"or-header doctors_group page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header smallheader md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span>&nbsp; <span class=\"logo-text\">רשימת קבוצת מרפאות</span>\n</div><div class=\"mt-16\" layout=\"row\" layout-align=\"start center\"></div></div><div hide show-gt-xs \nclass=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"></div></div><md-progress-linear \nng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" \nflex layout=\"row\" layout-align=\"start start\" ms-scroll=\"\"><div class=\"content\" flex=\"\" layout=\"row\"></div><div flex=\"\" \nlayout=\"row\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8\" \nlayout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-input-container md-no-float \nclass=\"m-0\"><input id=\"search\" ng-change=\"vm.change()\" type=\"text\" ng-model=\"vm.search\" placeholder=\"חיפוש\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"start start\" layout-wrap><div class=\"p-16\" \nlayout=\"row\" flex=\"100\"><table-report flex feilds=\"vm.ClientsReports.feilds\" data=\"vm.ClientsReports.data\" \neditfeilds=\"vm.ClientsReports.edit\" config=\"vm.ClientsReports.config\" on-edit-item=\"vm.editItem\" \non-insert-item=\"vm.RegisterNewGroupDoctor\" on-remove-item=\"vm.deleteItem\" filter-input=\"vm.search\" \norder-default=\"Name\"></table-report></div></div></ms-widget-front></ms-widget></div><div flex id=\"\"><md-list-item \nclass=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item></div></div>\n</div>");
$templateCache.put("app/main/inventories/inventories.html","<div id=\"inventories\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header smallheader md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span>&nbsp; <span class=\"logo-text\">{{vm.title}}</span></div>\n</div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-input-container \nmd-no-float class=\"m-0\"><input id=\"search\" ng-change=\"vm.typeSearch()\" type=\"text\" ng-model=\"vm.search\" \nplaceholder=\"חפש מספר הזמנה\"></md-input-container></div></div><md-progress-linear ng-show=\"vm.proccess\" \nmd-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" flex layout=\"row\" \nlayout-align=\"start start\"><div class=\"main\" flex ms-scroll id=\"contactslist\"><div class=\"widget-group\" ng-if=\"false\" \nlayout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-16 white-bg\" layout=\"row\" flex><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"md-display-2 pb-8 md-default-theme\"><span ng-show=\"vm.proccess\">מחפש...</span> <span ng-hide=\"vm.proccess\">\n{{(vm.search?\'לא נמצא\':\'איתור הזמנה\')}}</span></div><div class=\"h3 font-weight-500\"><md-input-container><input \nplaceholder=\"הקש מספר הזמנה\" ng-change=\"vm.typeSearch()\" ng-model=\"vm.search\"></md-input-container></div></div>\n</ms-widget-front></ms-widget></div><md-list class=\"contacts-list\"><table-report config=\"vm.config\" feilds=\"vm.feilds\" \ndata=\"vm.inventories\" order-default=\"-KDate\" filter-input=\"vm.search\"></table-report><div \nng-show=\"vm.inventories.length\" layout-align=\"center center\" layout=\"row\" flex><md-button class=\"md-accent md-raised\" \nng-disabled=\"vm.proccess\" ng-click=\"vm.refresh(true)\">רענן</md-button></div><ms-widget ng-hide=\"vm.inventories.length\" \nclass=\"h-300\" layout=\"column\" flex><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"md-display-3 pb-8 md-default-theme\"><span>\nלא נמצאו פריטים ב {{vm.search||vm.title}}</span></div><div class=\"h3 font-weight-500\"></div></div></ms-widget-front>\n</ms-widget></md-list><md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>\nאין תוצאות</p></md-list-item></div></div></div>");
$templateCache.put("app/main/notes/notes.html","<div id=\"notes\" class=\"\" layout=\"column\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" ms-scroll \nmd-component-id=\"main-sidenav\" ms-sidenav-helper ng-include=\"\'app/main/notes/sidenavs/main/main-sidenav.html\'\">\n</md-sidenav><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"NOTES.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button>\n<div class=\"main-title\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"logo-icon mr-8\" \nmd-font-icon=\"icon-lightbulb\"></md-icon><span class=\"title\" ng-if=\"vm.noteListType === \'notes\'\" \ntranslate=\"NOTES.NOTES\">Notes</span> <span class=\"title\" ng-if=\"vm.noteListType === \'reminders\'\" \ntranslate=\"NOTES.REMINDERS\">Reminders</span> <span class=\"title\" ng-if=\"vm.noteListType === \'archive\'\" \ntranslate=\"NOTES.ARCHIVE\">Archive</span> <span class=\"title\" ng-if=\"vm.noteListType.name\">{{vm.noteListType.name}}\n</span> <span ng-if=\"filteredNotes.length\" class=\"pl-8 white-text secondary-text notes-count\">\n({{filteredNotes.length}})</span></div></div><div flex></div><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.openSearchToolbar()\" aria-label=\"open search toolbar\" translate \ntranslate-attr-aria-label=\"NOTES.OPEN_SEARCH_TOOLBAR\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon\"></md-icon>\n</md-button></div><div ng-show=\"vm.searchToolbar\" \nclass=\"md-toolbar-tools search-toolbar animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeSearchToolbar()\" translate translate-attr-aria-label=\"NOTES.CLOSE\" \naria-label=\"close\"><md-icon md-font-icon=\"icon-close\" class=\"mr-8\"></md-icon></md-button><input \nid=\"search-notes-input\" placeholder=\"Search notes\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"NOTES.SEARCH_NOTES\" ng-model-options=\"{\'debounce\': 200}\" flex></div></md-toolbar>\n<md-content ms-scroll flex><ms-new-note ng-hide=\"vm.noteListType === \'archive\'\" class=\"md-whiteframe-2dp\">\n</ms-new-note><ms-masonry class=\"notes\" options=\'{\"columnCount\":5}\'><ms-masonry-item class=\"note\" \nng-repeat=\"note in vm.notes | filter:vm.search | filter:vm.filters | filterByPropIds:\'labels\':vm.labelFilterIds |  orderBy: \'time\':true | filter:query as filteredNotes track by note.id \" \nms-note-item=\"note\" ng-click=\"vm.editNote($event, note.id)\"></ms-masonry-item></ms-masonry><div \nclass=\"no-results text-center\" ng-if=\"filteredNotes.length === 0 &&  vm.search === \'\'\"><div class=\"message\" \nng-if=\"vm.noteListType === \'notes\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-lightbulb\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_YET\">No notes yet...</div></div><div class=\"message\" \nng-if=\"vm.noteListType === \'reminders\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-bell\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_WITH_REMINDERS\">No notes with reminders</div></div><div class=\"message\" \nng-if=\"vm.noteListType === \'archive\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-archive\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_ARCHIVED_NOTES\">No archived Notes</div></div><div class=\"message\" \nng-if=\"vm.noteListType.name\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-label\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_WITH_THIS_LABEL\">No notes with this label</div></div></div><div \nclass=\"no-results text-center\" ng-if=\"filteredNotes.length === 0 &&  vm.search !== \'\'\"><div class=\"message\"><md-icon \nclass=\"message-icon s96\" md-font-icon=\"icon-lightbulb\"></md-icon><div class=\"message-text\" \ntranslate=\"NOTES.NO_RESULTS\">No results...</div></div></div></md-content></div>");
$templateCache.put("app/main/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" src=\"assets/images/avatars/katherine.jpg\"><div layout=\"column\"><div \nclass=\"name black-fg\">{{vm.profile.ClientName}}</div><div class=\"black-fg\">{{vm.profile.KDate|date}}</div></div></div>\n<div class=\"actions\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.clientLeft(event)\" ng-hide=\"vm.profile.ZulamStatus==5\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">\nשחרר לקוח</md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.AcceptVisit(event)\" \nng-show=\"vm.profile.ZulamStatus==5\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">אישור ביקור</md-button><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.RemoveClient(event)\" ng-hide=\"vm.profile.isClosed\" \ntranslate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">מחק לקוח</md-button></div></div><div class=\"content\" flex><md-tabs \nmd-dynamic-height><md-tab><md-tab-label><span>פרטים אישיים</span></md-tab-label><md-tab-body><md-content \nclass=\"details-tab\" ng-include=\"\'app/main/profile/tabs/details/details.html\'\"></md-content></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>קופה ותשלומים</span></md-tab-label><md-tab-body><md-content class=\"billing-tab\" \nng-include=\"\'app/main/profile/tabs/billing/billing.html\'\"></md-content></md-tab-body></md-tab><md-tab ng-if=\"true\">\n<md-tab-label><span>צילומים ומסמכים<md-icon md-font-icon=\"icon-alert\" \nng-if=\"vm.profile.ZulamStatus==5 &&vm.profile.unUploadPhoto\" class=\"red-fg\"></md-icon></span></md-tab-label>\n<md-tab-body><md-content class=\"billing-tab\" ng-include=\"\'app/main/profile/tabs/photos/photos.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/sample/sample.html","<h1>{{vm.helloText}}</h1>");
$templateCache.put("app/main/support/support.html","<iframe \nsrc=\"https://docs.google.com/forms/d/e/1FAIpQLSdNoB21gLp4HWp-yI21r9Z1Lqn1_UL0bc8cucRhKhZaxKXU5A/viewform?embedded=true\" \nonload=\"this.width=screen.width;this.height=screen.height\" width=\"760\" height=\"1000\" frameborder=\"0\" marginheight=\"0\" \nmarginwidth=\"0\">טוען...</iframe>");
$templateCache.put("app/main/users/users.html","<div class=\"or-header page-layout simple left-sidenav inner-sidenav\"><div class=\"header smallheader md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\">\n</md-icon></span>&nbsp; <span class=\"logo-text\">רשימת משתמשים</span></div><div class=\"mt-16\" layout=\"row\" \nlayout-align=\"start center\"></div></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"></div></div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" \nclass=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\" \nms-scroll=\"\"><div class=\"content\" flex=\"\" layout=\"row\"></div><div flex=\"\" layout=\"row\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">מנהלים\\משתמשים</div><div class=\"pv-8\" \nlayout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-input-container md-no-float \nclass=\"m-0\"><input id=\"search\" ng-change=\"vm.change()\" type=\"text\" ng-model=\"vm.search\" placeholder=\"חיפוש\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"start start\" layout-wrap><div class=\"p-16\" \nlayout=\"row\" flex=\"100\"><table-report flex feilds=\"vm.table.feilds\" data=\"vm.table.data\" editfeilds=\"vm.table.edit\" \nconfig=\"vm.table.config\" on-edit-item=\"vm.editItem\" on-insert-item=\"vm.addEmployee\" on-remove-item=\"vm.removeEmployee\" \nfilter-input=\"vm.search\" order-default=\"nameHE\"></table-report></div></div></ms-widget-front></ms-widget></div><div \nflex id=\"\"><md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p>\n</md-list-item></div></div></div>");
$templateCache.put("app/core/directives/date-between-buttons/date-between-buttons.html","<div class=\"content\" layout=\"row\" flex=\"100\"><div ng-repeat=\"mode in vm.MODESDATE\"><md-button class=\"md-accent\" \nng-disabled=\"mode.disable\" ng-click=\"vm.selectMode(mode,event)\" ng-show=\"$mdMedia(mode.show)\" \nng-class=\"{\'md-raised\':vm.classActiveMode(mode.key)}\">{{mode.value}}</md-button></div></div>");
$templateCache.put("app/core/directives/image-viewer/image-viewer.html","<div class=\"image-viewer\"><div style=\"padding:10px\"><md-button id=\"girardir_90\" class=\"md-raised md-primary\" \nng-disabled=\"noImage\"><span class=\"glyphicon glyphicon-menu-left\"></span> סובב 90 שמאלה</md-button><md-button \nid=\"girardir\" class=\"md-raised md-primary\" ng-disabled=\"noImage\"><span class=\"glyphicon glyphicon-menu-left\"></span>\n סובב שמאלה</md-button><md-button id=\"giraresq\" class=\"md-raised md-primary\" ng-disabled=\"noImage\">סובב ימינה <span \nclass=\"glyphicon glyphicon-menu-right\"></span></md-button><md-button id=\"giraresq_90\" class=\"md-raised md-primary\" \nng-disabled=\"noImage\">סובב 90 ימינה<span class=\"glyphicon glyphicon-menu-right\"> </span></md-button><md-button \nid=\"zoomIn\" class=\"md-raised md-primary\" ng-disabled=\"noImage\"><span class=\"glyphicon glyphicon-zoom-in\"></span> הגדל\n</md-button><md-button id=\"zoomOut\" class=\"md-raised md-primary\" ng-disabled=\"noImage\"><span \nclass=\"glyphicon glyphicon-zoom-out\"></span> הקטן</md-button><md-button id=\"carregar\" class=\"md-raised md-warn\" \nng-disabled=\"noImage\"><span class=\"fa fa-arrow-left\"></span> איפוס</md-button><md-button class=\"md-raised md-primary\" \nng-disabled=\"noImage\" ng-href=\"{{file}}\" target=\"_blank\">הורדה</md-button></div><div id=\"image-zoom\" \nstyle=\"padding:10px\"><h2 class=\"text-center text-danger\" id=\"error-message\">Image Not Available</h2><ms-widget \nid=\"image-viewr-loader-message\" class=\"h-300\" layout=\"column\" flex><ms-widget-front class=\"p-16 grey-bg white-fg\" \nlayout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-3 pb-8\">אנא המתן</div>\n</div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-filmstrip-off\" class=\"s256 faint-text\">\n</md-icon></div></ms-widget-front></ms-widget><canvas id=\"canvas\" height=\"650\" data-girar=\"0\" \nstyle=\"display:none; border:1px solid #000;z-index:555555;cursor:grab\">sdsd</canvas><iframe id=\"image-viewr-pdf-file\" \nwidth=\"100\" height=\"650\" style=\"display:none\"></iframe><img ng-src=\"{{image}}\" id=\"image\" style=\"display:none\"></div>\n</div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-prices-doctors/ms-prices-doctors.html","<div layout=\"column\" ng-if=\"!vm.copmiesMode\" flex layout-align=\"end center\"><md-progress-linear ng-show=\"vm.proccess\" \nmd-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div layout=\"row\" flex layout-align=\"end center\">\n<md-input-container flex=\"50\" class=\"md-block m-8 mt-2\"><label>גורם משלם</label><md-select \nng-change=\"vm.selectInsurance()\" ng-model=\"vm.formWizard.BituahID\" ng-disabled=\"!vm.standrdInsurances\" \nmd-on-open=\"vm.focusSearch()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchselect\" \nid=\"s_search\" type=\"text\" placeholder=\"הקש ערך לחיפוש\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-value=\"0\">בחר גורם משלם</md-option><md-option \nng-repeat=\"factor in vm.factorPays|filter:searchselect |filter:{isInsurances:vm.standrdInsurances} \" \nng-value=\"factor.BituahID\">{{factor.Name}}</md-option></md-select></md-input-container><input ng-hide=\"true\" \ntype=\"text\" required ng-model=\"vm.formWizard.DoctorID\"><md-input-container flex=\"50\" class=\"md-block m-8 mt-2\"><label>\nסניף</label><md-select ng-model=\"vm.placeSelcted\" ng-disabled=\"true\"><md-option><em>None</em></md-option><md-option \nng-repeat=\"place in vm.places\" ng-value=\"place.placeId\">{{place.Name}}</md-option></md-select></md-input-container>\n</div><div ng-hide=\"vm.formWizard.DoctorID||(!vm.formWizard.BituahID)\" layout=\"column\" flex layout-gt-lg=\"row\" \nclass=\"mt-30\"><md-input-container flex=\"70\" class=\"md-block\"><label>\nהקלד שם רופא לחיפוש, לבחירת רופא יש ללחוץ על השם הרצוי</label><input type=\"text\" ng-model=\"vm.search\" \nng-change=\"vm.searchDoctor()\"></md-input-container><div class=\"list mt-30\" layout=\"column\" flex=\"30\"><center><h1 \nng-hide=\"!vm.doctors.length||queryFil.length\">אין תוצאות</h1><div ng-hide=\"vm.doctors.length\">טוען רשימת רופאים....\n</div></center><md-list-item flex layout-align=\"start start\" ng-click=\"vm.selectDoctor(doctor)\" \nng-repeat=\"doctor in vm.doctors|  filter: {Name:vm.search}  | limitTo :10|  filter: query as queryFil \"><p flex \nlayout-align=\"end end\" class=\"text-truncate\">{{ doctor.Name }} - {{ doctor.Address }}</p></md-list-item></div></div>\n<div ng-show=\"vm.formWizard.DoctorID\" class=\"info-line md-title dir-rtl mt-30\" layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"md-title mb-32 dir-rtl s100\" flex=\"50\">\n{{vm.formWizard.doctorName||\'לא נבחר רופא\'}}</div><div><md-icon md-font-icon=\"icon-account-box\" class=\"s150\"></md-icon>\n</div><md-button class=\"md-accent md-raised\" ng-click=\"vm.copmiesMode=true\">אנא המתן...</md-button><md-button \nclass=\"md-accent\" ng-click=\"vm.resetDoctor()\">בחר רופא אחר<md-icon md-font-icon=\"icon-account-plus\"></md-icon>\n</md-button></div></div><div ng-if=\"vm.copmiesMode\" class=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><div \nclass=\"content\"><form novalidate><input ng-model=\"vm.countCopies.count\" type=\"number\" required min=\"1\" ng-hide=\"true\">\n<div ng-hide=\"vm.copies.length\">טוען....</div><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"cardholder\" ng-model=\"vm.searchcopies\" placeholder=\"חיפוש צילום\"></md-input-container><div \nng-show=\"vm.copies.length\" class=\"white-bg md-whiteframe-4dp list max-height-400\"><table id=\"copiesDoctor\" dir=\"rtl\" \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">שם צילום</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מחיר</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">סוג תשלום</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">מחיר סופי</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">בחר</span></div></th></tr></thead><tbody><tr \nng-repeat=\"copy in vm.copies|filter:vm.searchcopies\" ng-if=\"copy.PhotoListID\"><td class=\"text-truncate\" ng-class=\"\">\n{{ copy.Name }}</td><td>{{ copy.basePrice |customCurrency}}</td><td><span>{{vm.PriceForStr(copy)}}</span></td><td \nng-hide=\"copy.editMode\" ng-class=\"{\'green-fg\':copy.Deductible||copy.customfixprice}\">\n{{copy.Deductible|| copy.fixprice |customCurrency}}</td><td ng-if=\"copy.editMode\"><md-input-container><input \nng-model=\"copy.fixprice \"></md-input-container></td><td><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" \nng-disabled=\"vm.hideSelect\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-disabled=\"copy.priceFor==\'agreement\'&&(!copy.Deductible||copy.InsuranceAccept)\" ng-click=\"vm.editPrice(copy,event)\">\n<md-icon md-font-icon=\"icon-table-edit\"></md-icon>ערוך מחיר</md-button></md-menu-item><md-menu-item><md-button \nng-disabled=\"copy.priceFor!=\'agreement\'\" ng-click=\"vm.editDeductible(copy, event)\"><md-icon \nmd-font-icon=\"icon-eyedropper\"></md-icon>השתתפות עצמית</md-button></md-menu-item><md-menu-item><md-button \nng-disabled=\"copy.fixprice==copy.main_fixprice\" ng-click=\"vm.cancelDiscount(copy)\"><md-icon md-font-icon=\"icon-cancel\">\n</md-icon>בטל הנחה</md-button></md-menu-item></md-menu-content></md-menu><md-checkbox ng-hide=\"vm.hideSelect\" \nng-model=\"copy.selected\" ng-change=\"vm.selectedCopy(copy)\"></md-checkbox></td></tr></tbody></table></div></form></div>\n<footer layout=\"column\" flex class=\"dir-rtl mb-8\" layout-align=\"space-between center\"><div layout=\"row\" flex \nlayout-align=\"end center\"><div layout=\"column\" flex=\"\"><div layout=\"row\" flex><span>\nרופא/ה: {{vm.formWizard.doctorName}}</span>&nbsp; <span>% {{vm.formWizard.Sale}}</span></div><div layout=\"row\" flex>\n<span>גורם משלם: {{vm.formWizard.BituahName}}</span>&nbsp;</div></div><div layout=\"column\" flex=\"\"><md-button \nclass=\"md-accent\" ng-click=\"vm.resetPhotoes()\">אפס צילומים<md-icon md-font-icon=\"icon-eraser\"></md-icon></md-button>\n</div><div layout=\"column\" flex=\"\"><md-button class=\"md-accent\" ng-click=\"vm.resetDoctor()\">לחץ כאן לשינוי<md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div><div layout=\"column\" flex=\"\"><md-button class=\"md-accent\" \nng-click=\"vm.printDetails(doctor,event)\">הדפס פרטי רופא<md-icon md-font-icon=\"icon-printer\"></md-icon></md-button>\n</div></div></footer><footer layout=\"row\" ng-hide=\"vm.hideSelect\" class=\"dir-rtl mb-8\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\"><span>\n{{vm.countselected()}} צילומים נבחרו. לתשלום: {{client.sumAll.topay|customCurrency}}</span></div></footer><footer \nlayout=\"row\" ng-if=\"vm.DoctorNoteOUT\" class=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end center\"><span>{{vm.DoctorNoteOUT}}</span></div></footer></div>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" ms-scroll \nng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/or-insurance/or-insurance.html","<div layout=\"column\" flex layout-align=\"end center\"><table-report flex feilds=\"vm.feilds\" data=\"data\" \neditfeilds=\"vm.feildsEdit\" on-edit-item=\"vm.editItem\" on-remove-item=\"vm.remove\" \nfilter-input=\"{InsuranceID:insuranceId}\" order-default=\"Name\"></table-report><table ng-if=\"false\" dir=\"rtl\" \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th hide show-gt-xs \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'mkt\')\">מק\"ט</a>\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a \nng-click=\"vm.changeSort(\'Name\')\">שם</a></span></div></th><th hide show-gt-xs class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'sum\')\">סכום</a></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'sumInclude\')\">\nכולל מע\"מ</a></span></div></th><th hide show-gt-xs class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><a ng-click=\"vm.changeSort(\'deductible\')\">השתתפות</a></span></div></th><th hide show-gt-xs \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'dateCreated\')\">\nתאריך רישום</a></span></div></th><th hide show-gt-md class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><a ng-click=\"vm.changeSort(\'Comment\')\">הערות</a></span></div></th><th hide show-gt-xs>פעולות</th>\n</tr></thead><tbody><tr \nng-repeat=\"co in vm.data |orderBy :vm.sortBy |filter:vm.search|filter:{InsuranceID:insuranceId}:true|filter:query as waiters track by $index \">\n<td hide show-gt-xs>{{ co.mkt}}</td><td>{{ co.Name}}</td><td hide show-gt-xs>{{ co.sum|customCurrency}}</td><td>\n{{ co.sumInclude|customCurrency}}</td><td>{{ co.deductible|customCurrency}}</td><td hide show-gt-xs>\n{{ co.dateCreated|date}}</td><td hide show-gt-md>{{ co.Comment}}</td><td hide show-gt-xs><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.edit(co)\"><md-icon \nmd-font-icon=\"icon-cancel\"></md-icon>ערוך</md-button></md-menu-item><md-menu-item><md-button ng-disabled=\"true\" \nng-click=\"\"><md-icon md-font-icon=\"icon-cancel\"></md-icon>הפוך ללא פעיל</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.remove(co)\"><md-icon md-font-icon=\"icon-cancel\"></md-icon>מחק</md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr></tbody></table><h1><md-button ng-click=\"vm.add()\" class=\"md-primary md-raised\">\nהוסף צילום</md-button></h1></div>");
$templateCache.put("app/core/directives/or-report-precent/or-report-precent.html","<div layout=\"column\" flex layout-align=\"end center\"><table ng-show=\"data.length\" dir=\"rtl\" \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th colspan=\"2\">פרטים</th><th \ncolspan=\"3\" class=\"md-primary-bg\">כמות</th><th colspan=\"3\" class=\"grey-bg\">סכום</th><th>&nbsp;</th></tr><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'DoctorID\')\">ID\n</a></span></div></th><th hide show-gt-xs class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n<a ng-click=\"vm.changeSort(\'Name\')\">שם</a></span></div></th><th class=\"secondary-text md-primary-bg\"><div \nclass=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'KDate\')\">ממוצע תקופה קודמת</a></span></div>\n</th><th hide show-gt-xs class=\"secondary-text md-primary-bg\"><div class=\"table-header\"><span class=\"column-title\"><a \nng-click=\"vm.changeSort(\'TimeOUT\')\">נוכחי</a></span></div></th><th hide show-gt-xs \nclass=\"secondary-text md-primary-bg\"><div class=\"table-header\"><span class=\"column-title\"><a \nng-click=\"vm.changeSort(\'PhotosList\')\">הפרש</a></span></div></th><th class=\"secondary-text grey-bg\"><div \nclass=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'KDate\')\">ממוצע תקופה קודמת</a></span></div>\n</th><th hide show-gt-xs class=\"secondary-text grey-bg\"><div class=\"table-header\"><span class=\"column-title\"><a \nng-click=\"vm.changeSort(\'TimeOUT\')\">נוכחי</a></span></div></th><th hide show-gt-xs class=\"secondary-text grey-bg\"><div \nclass=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'PhotosList\')\">הפרש</a></span></div></th><th\n ng-hide=\"true\" hide show-gt-xs class=\"secondary-text\">&nbsp;</th></tr></thead><tbody><tr ng-if=\"item.status\" \nng-repeat=\"item in data |filter:filter|filter:query as waiters track by $index \"><td>{{ item.DoctorID}}</td><td>\n{{ item.Name}}</td><td class=\"md-primary-bg\">{{ item.status.count.oldAvarageDay.toFixed(2)}}</td><td \nclass=\"md-primary-bg\">{{ item.status.count.countClient}}</td><td class=\"md-primary-bg\" \nng-class=\"vm.classPrecent(item.status.count.percentCountClient)\">% {{ item.status.count.percentCountClient}}</td><td \nclass=\"grey-bg\">{{ item.status.sum.oldAvarageDay|customCurrency}}</td><td class=\"grey-bg\">\n{{ item.status.sum.PhotosPrice|customCurrency}}</td><td class=\"grey-bg\" \nng-class=\"vm.classPrecent(item.status.sum.percentPhotosPrice)\">% {{ item.status.sum.percentPhotosPrice}}</td></tr>\n</tbody></table></div>");
$templateCache.put("app/core/directives/or-table-report/table-compare-report.html","<div class=\"table-report-directive\" layout=\"column\" flex layout-align=\"end center\"><table ng-show=\"data.length\" \ndir=\"rtl\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"hide-excel\"><th \ncolspan=\"{{(editfeilds?feilds.length+1:feilds.length)}}\" align=\"rigth\" class=\"hide-excel\"><md-button export-to-excel \nspecialdata=\"vm.convertData(data)\" class=\"md-accent\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon>הורד נתונים\n</md-button><md-button ng-click=\"print()\" data=\"data\" class=\"md-accent\" hide show-gt-xs><md-icon \nmd-font-icon=\"icon-printer\"></md-icon>הדפס</md-button><md-button ng-show=\"onInsertItem\" class=\"md-accent\" \nng-click=\"vm.editItem($event,{},true)\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon>הוסף</md-button></th>\n</thead><thead><th ng-repeat=\"feild in feilds\" ng-show=\"$mdMedia(feild.show)\" class=\"secondary-text\"><div \nclass=\"table-header\" layout=\"row\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(feild.key)\">{{feild.name}}</a>\n</span><md-menu ng-if=\"feild.filter\" class=\"hide-excel\"><a class=\"md-accent-fg\" ng-click=\"$mdOpenMenu($event)\"><md-icon\n ng-hide=\"feild.filtered\" class=\"font-size-20\" md-font-icon=\"icon-filter-outline m-0 p-0\"></md-icon><md-icon \nng-show=\"feild.filtered\" class=\"font-size-20\" md-font-icon=\"icon-filter-remove-outline m-0 p-0\"></md-icon></a>\n<md-menu-content width=\"3\" class=\"table-report-md-menu-content\"><md-input-container ng-hide=\"feild.filtered\"><input \nng-model=\"feild.filter_header\" placeholder=\"חיפוש\"></md-input-container><md-menu-item><md-button \nng-click=\"vm.setFilter(feild.key,\'\')\">הכל</md-button></md-menu-item><md-menu-item \nng-repeat=\"val in waiters|unique:feild.key| orderBy:feild.key|filter:feild.filter_header\"><md-button \nng-click=\"vm.setFilter(feild.key,val[feild.key])\">{{ val[feild.key]}}</md-button></md-menu-item></md-menu-content>\n</md-menu></div></th><th hide show-gt-xs ng-if=\"editfeilds\">&nbsp;</th><tr></tr></thead><thead><th \nng-repeat=\"feild in feilds\" ng-show=\"$mdMedia(feild.show)\" class=\"secondary-text\"><div class=\"table-header\" \nlayout=\"row\">&nbsp;<div ng-if=\"feild.compare\" layout=\"row\" flex><table flex><tr><td><div flex>קודם</div></td><td><div \nflex>&nbsp;&nbsp;</div></td><td><div flex>נוכחי</div></td></tr></table><md-divider></md-divider></div></div></th><th \nhide show-gt-xs ng-if=\"editfeilds\">&nbsp;</th><tr></tr></thead><tbody><tr class=\"rowItem\" iditem=\"$index\" \nng-click=\"(config.rowClick?vm.clickRow(item):vm.editItem(event,item))\" \nng-repeat=\"item in data|orderBy:orderDefault |orTableFilter:vm.filterParams|filter:filterInput|filter:filterCustom:true|filter: query as waiters track by $index \">\n<td ng-repeat=\"feild in feilds\" ng-show=\"$mdMedia(feild.show)\"><span ng-if=\"feild.type==\'customCurrency\'\"><div \nlayout=\"row\" flex ng-if=\"feild.compare\"><table flex><tr><td>{{ item.b[feild.key]||0|customCurrency}}<br><div>\n({{item.b.average[feild.key]||0}})<md-tooltip>ממוצע יומי</md-tooltip></div></td><td><div flex class=\"text-boxed-light\" \nng-class=\"{\'red-fg\':item.percent[feild.key]<0,\'green-fg\':item.percent[feild.key]>0}\">\n{{ item.percent[feild.key]||0|number:0}}%<md-tooltip>\nממוצע יומי: {{item.b.average[feild.key]||0}}/{{item.a.average[feild.key]||0}}. &nbsp; תקופה קודמת {{item.b[feild.key]||0}}\n</md-tooltip></div></td><td><div flex>{{ item.a[feild.key]||0|customCurrency}}<br><div>\n({{item.a.average[feild.key]||0}})<md-tooltip>ממוצע יומי</md-tooltip></div></div></td></tr></table><md-divider>\n</md-divider></div><span ng-if=\"!feild.compare\">{{ item.a[feild.key]||item.b[feild.key]|customCurrency}}</span> </span>\n<span ng-if=\"feild.type==\'date\'\">{{ item[feild.key]|date:\'dd/MM/yyyy\'}}</span> <span ng-if=\"feild.type==\'time\'\">\n{{ item[feild.key]|date:\'HH:mm\'}}</span> <span ng-if=\"feild.type==\'day\'\">{{ item[feild.key]|date:\'EEEE\'}}</span> <span \nng-if=\"feild.type==\'number\'\"><div layout=\"row\" flex ng-if=\"feild.compare\"><table flex><tr><td>\n{{ item.b[feild.key]||0|number}}<br><div>({{item.b.average[feild.key]||0|number}})<md-tooltip>ממוצע יומי</md-tooltip>\n</div></td><td><div flex class=\"text-boxed-light\" \nng-class=\"{\'red-fg\':item.percent[feild.key]<0,\'green-fg\':item.percent[feild.key]>0}\">\n{{ item.percent[feild.key]||0|number:0}}%<md-tooltip>\nממוצע יומי: {{item.b.average[feild.key]||0}}/{{item.a.average[feild.key]||0}}. &nbsp; תקופה קודמת {{item.b[feild.key]||0}}\n</md-tooltip></div></td><td><div flex>{{ item.a[feild.key]||0|number}}<div>({{item.a.average[feild.key]||0|number}})\n<md-tooltip>ממוצע יומי</md-tooltip></div></div></td></tr></table><md-divider></md-divider></div><span \nng-if=\"!feild.compare\">{{ item.a[feild.key]||item.b[feild.key]|number}}</span> </span><span ng-if=\"feild.type==\'icon\'\">\n<md-icon ng-hide=\"feild.showNull&&item[feild.key]||(feild.hideNull&&!item[feild.key])\" md-font-icon=\"{{feild.icon}}\">\n</md-icon></span><span ng-if=\"!feild.type\">{{ item.a[feild.key]||item.b[feild.key]}}</span></td><td hide show-gt-xs \nng-if=\"editfeilds\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"s-8\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content \nwidth=\"3\" class=\"hide-excel\"><md-menu-item><md-button ng-click=\"vm.editItem(ev,item)\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon>ערוך</md-button></md-menu-item><md-menu-item ng-if=\"onRemoveItem\"><md-button \nng-click=\"onRemoveItem(item)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>הסר</md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr></tbody><tfoot ng-hide=\"config.hideFotter\"><th ng-repeat=\"feild in feilds\" \nng-show=\"$mdMedia(feild.show)\"><span ng-if=\"feild.type!=\'customCurrency\'\">\n{{($index==0?\' רשומות: \'+waiters.length:\'&nbsp;\')}}</span></th><th hide show-gt-xs ng-if=\"editfeilds\">&nbsp;</th>\n</tfoot></table></div>");
$templateCache.put("app/core/directives/or-table-report/table-report.html","<div class=\"table-report-directive\" layout=\"column\" flex layout-align=\"end center\"><table ng-show=\"data.length\" \ndir=\"rtl\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"hide-excel\"><th \ncolspan=\"{{(editfeilds?feilds.length+1:feilds.length)}}\" align=\"rigth\" class=\"hide-excel\"><div layout=\"row\" flex><div \nlayout-align=\"right\" flex><md-button export-to-excel data=\"data\" class=\"md-accent\" hide show-gt-xs><md-icon \nmd-font-icon=\"icon-file-excel\"></md-icon>הורד נתונים</md-button><md-button hide show-gt-xs ng-click=\"print()\" \ndata=\"data\" class=\"md-accent\"><md-icon md-font-icon=\"icon-printer\"></md-icon><span>הדפס</span></md-button><md-button \nhide-gt-xs ng-click=\"print()\" data=\"data\" class=\"md-accent md-icon-button\"><md-icon md-font-icon=\"icon-printer\">\n</md-icon></md-button><md-button hide show-gt-xs ng-show=\"onInsertItem\" class=\"md-accent\" \nng-click=\"vm.editItem($event,config.default_Item||{},true)\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>\nהוסף</span></md-button><md-button hide-gt-xs ng-click=\"vm.editItem($event,{},true)\" data=\"data\" \nclass=\"md-accent md-icon-button\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div><div \nng-show=\"config.selectBox\" layout-align=\"end end\" flex layout=\"row\"><md-button ng-show=\"config.selectBox\" \nclass=\"md-accent xmd-icon-button\" ng-disabled=\"!enabledGroupAction()\" ng-click=\"vm.editGroup($event)\"><md-icon \nmd-font-icon=\"icon-label\"></md-icon><md-tooltipx>עריכת מסומנים</md-tooltipx></md-button><md-button \nng-show=\"config.selectBox\" class=\"md-accent xmd-icon-button\" ng-disabled=\"!enabledGroupAction()\" \nng-click=\"vm.removeGroup()\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltipx>מחק מסומנים</md-tooltipx>\n</md-button></div></div></th><th hide show-gt-xs ng-if=\"config.selectBox\">&nbsp;&nbsp;</th></thead><thead><th \nng-repeat=\"feild in feilds\" ng-show=\"$mdMedia(feild.show)&&!feild.printOnly\" class=\"secondary-text\"><div \nclass=\"table-header\" layout=\"row\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(feild.key)\">{{feild.name}}</a>\n</span><md-menu ng-if=\"feild.filter\" class=\"hide-excel\"><a class=\"md-accent-fg\" ng-click=\"$mdOpenMenu($event)\"><md-icon\n ng-hide=\"feild.filtered\" class=\"font-size-20\" md-font-icon=\"icon-filter-outline m-0 p-0\"></md-icon><md-icon \nng-show=\"feild.filtered\" class=\"font-size-20\" md-font-icon=\"icon-filter-remove-outline m-0 p-0\"></md-icon></a>\n<md-menu-content width=\"3\" class=\"table-report-md-menu-content\"><md-input-container ng-hide=\"feild.filtered\"><input \nng-model=\"feild.filter_header\" placeholder=\"חיפוש\"></md-input-container><md-menu-item><md-button \nng-click=\"vm.setFilter(feild.key,\'\')\">הכל</md-button></md-menu-item><md-menu-item \nng-repeat=\"val in waiters|unique:feild.key| orderBy:feild.key|filter:feild.filter_header\"><md-button \nng-click=\"vm.setFilter(feild.key,val[feild.key])\">{{ val[feild.key]}}</md-button></md-menu-item></md-menu-content>\n</md-menu></div></th><th hide show-gt-xs ng-if=\"editfeilds\">&nbsp;</th><th hide show-gt-xs ng-if=\"config.selectBox\">\n&nbsp;&nbsp;<md-checkbox ng-model=\"vm._selectedAll\">בחר הכל</md-checkbox></th><tr></tr></thead><tbody><tr \nclass=\"rowItem\" iditem=\"$index\" ng-click=\"(config.rowClick?vm.clickRow(item):vm.editItem(event,item))\" \nng-class=\"config.classFunc(item)\" \nng-repeat=\"item in data|orderBy:orderDefault |orTableFilter:vm.filterParams| filterMultyWords:(config.filterMultyWords?{[config.filterMultyWords]:filterInput}:undefined)|filter:(config.filterMultyWords?undefined:filterInput)|filter:filterCustom:true|filter: query as waiters track by $index \">\n<td ng-repeat=\"feild in feilds\" ng-show=\"$mdMedia(feild.show)&&!feild.printOnly\"><span \nng-show=\"vm.showFunc(feild,item)\"><span ng-class=\"feild.class\" ng-if=\"feild.type==\'customCurrency\'\"><span \nng-hide=\"(feild.nghide&&feild.nghide==item[feild.key])||(feild.hideNull&&!item[feild.key])\">\n{{ item[feild.key]|customCurrency}}</span> <span \nng-show=\"feild.nghide&&feild.nghide==item[feild.key]||(feild.hideNull&&!item[feild.key])\">-</span> </span><span \nng-class=\"feild.class\" ng-if=\"feild.type==\'date\'\">{{ item[feild.key]|date:\'dd/MM/yyyy\'}}</span> <span \nng-class=\"feild.class\" ng-if=\"feild.type==\'datetime\'\">{{ item[feild.key]|date:\'dd/MM/yyyy HH:mm\'}}</span> <span \nng-class=\"feild.class\" ng-if=\"feild.type==\'time\'\">{{ item[feild.key]|date:\'HH:mm\'}}</span> <span \nng-class=\"feild.class\" ng-if=\"feild.type==\'day\'\">{{ item[feild.key]|date:\'EEEE\'}}</span> <span ng-class=\"feild.class\" \nng-if=\"feild.type==\'number\'\">{{ item[feild.key]|number:2}}</span> <span ng-if=\"feild.type==\'bool\'\"><md-icon \nng-if=\"item[feild.key]\" md-font-icon=\"icon-check-circle\"></md-icon><md-icon ng-if=\"!item[feild.key]\" \nmd-font-icon=\"icon-close-circle\"></md-icon></span><span ng-if=\"feild.type==\'icon\'\"><md-icon ng-class=\"feild.class\" \nng-hide=\"feild.showNull&&item[feild.key]||(feild.hideNull&&!item[feild.key])||(feild.value&&item[feild.key]!=feild.value)||vm.hideIf(feild,item)\" \nmd-font-icon=\"{{feild.icon}}\"></md-icon></span><span ng-class=\"feild.class\" ng-if=\"!feild.type\">{{ item[feild.key]}}\n</span> <span ng-class=\"feild.class\" ng-if=\"feild.type==\'click\'\" \nng-show=\"!feild.ngshow||(feild.ngshow&&feild.ngshow.value==item[feild.key])\"><a ng-if=\"feild.onclick.type==\'ref\'\" \nng-click=\"vm.clickFeild(feild.onclick,item,$event)\">{{feild.value}}</a> </span></span><span ng-class=\"feild.class\" \nng-if=\"feild.type==\'button\'\"><md-button class=\"md-raised md-accent\" ng-click=\"feild.onclick\">עדכן הפניה</md-button>\n</span><span ng-if=\"!vm.showFunc(feild,item)\">&nbsp;</span></td><td hide show-gt-xs ng-if=\"editfeilds\"><md-menu>\n<md-button class=\"md-icon-button\" aria-label=\"More\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"s-8\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\" class=\"hide-excel\"><md-menu-item>\n<md-button ng-disabled=\"!onEditItem\" ng-click=\"vm.editItem(ev,item)\"><md-icon md-font-icon=\"icon-account\"></md-icon>\nערוך</md-button></md-menu-item><md-menu-item ng-if=\"onRemoveItem\"><md-button ng-click=\"onRemoveItem(item)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon>הסר</md-button></md-menu-item></md-menu-content></md-menu></td><td hide \nshow-gt-xs ng-if=\"config.selectBox\">&nbsp;<md-checkbox ng-model=\"item._selected\" ng-click=\"$event.stopPropagation()\">\n</md-checkbox></td></tr></tbody><tfoot ng-hide=\"config.hideFotter\"><th ng-repeat=\"feild in feilds\" \nng-show=\"$mdMedia(feild.show)&&!feild.printOnly\"><span ng-if=\"feild.type==\'customCurrency\'\">\n{{waiters|sumByKey:feild.key|customCurrency}}</span> <span ng-if=\"feild.type==\'number\'\">\n{{waiters|sumByKey:feild.key|number:2}}</span> <span ng-if=\"feild.type!=\'customCurrency\'\">\n{{($index==0?\' רשומות: \'+waiters.length:\'&nbsp;\')}}</span></th><th hide show-gt-xs ng-if=\"editfeilds\">&nbsp;</th>\n</tfoot></table></div>");
$templateCache.put("app/main/advanced_settings/passPlaceDialog/passPlaceDialog.html","<md-dialog id=\"importContacts\"><form class=\"md-inline-form\"><md-toolbar class=\"md-primary md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-show=\"vm.isAdmin\">\nשינוי סיסמת משתמש</span> <span class=\"title\" ng-hide=\"vm.isAdmin\">שינוי סיסמא לסניף</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div flex><p ng-hide=\"vm.places||vm.isAdmin\">טוען.... אנא המתן</p><p></p><div \nng-if=\"!vm.isAdmin\"><md-select required flex ng-model=\"vm.form.placeID\" md-on-close=\"clearSearchTerm()\" \nmd-on-open=\"vm.focusSearch(1)\" data-md-container-class=\"selectdemoSelectHeader\" ng-change=\"vm.selectInsuranse()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchInsurance\" id=\"s_searchInsurance\" type=\"text\" \nplaceholder=\"הקש ערך לחיפוש\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" class=\"demo-header-searchbox md-text\">\n</md-select-header><md-option ng-value=\"0\">בחר סניף</md-option><md-option \nng-repeat=\"place in vm.places |filter:searchInsurance|orderBy:\'PlaceName\'\" ng-value=\"place.PlaceID\">{{place.Name}}\n</md-option></md-select></div><div ng-if=\"vm.isAdmin\"><md-input-container><input type=\"password\" \nng-model=\"vm.form.oldPass\" placeholder=\"הקש סיסמא ישנה\"></md-input-container></div><div><md-input-container><input \ntype=\"password\" ng-model=\"vm.form.newPass\" placeholder=\"הקש סיסמא חדשה\"></md-input-container></div><div>\n<md-input-container><input type=\"password\" name=\"newPass\" ng-model=\"vm.form.newPassConfirm\" \nplaceholder=\"הקש סיסמא שנית\"></md-input-container></div><div class=\"red-fg mb-8\" \nng-show=\"vm.form.newPassConfirm&&vm.form.newPassConfirm!=vm.form.newPass\" role=\"alert\">סיסמא אינה תואמת</div><div>\n<md-input-container><input type=\"text\" readonly=\"readonly\" ng-model=\"vm.username\" placeholder=\"שם מבצע העדכון\">\n</md-input-container></div><div><md-button class=\"md-accent md-raised\" ng-disabled=\"!vm.isValid()\" \nng-click=\"vm.submit()\">שמור</md-button></div><md-divider></md-divider></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/advanced_settings/taxDialog/taxDialog.html","<md-dialog id=\"importContacts\"><form class=\"md-inline-form\"><md-toolbar class=\"md-primary md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">ניהול מע\"מ</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><div flex><p ng-show=\"vm.currentTax\">שיעור מע\"מ נוכחי: %{{vm.currentTax}}</p><p \nng-hide=\"vm.currentTax\">טוען.... אנא המתן</p><p></p><div><md-input-container><input type=\"text\" ng-model=\"vm.newTax\" \nplaceholder=\"הקש שיעור מע\'מ חדש\"></md-input-container></div><div><md-input-container><input type=\"date\" \nng-model=\"vm.newTaxDate\" placeholder=\"יחול בתאריך\"></md-input-container></div><div><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.submit()\">שמור</md-button></div><md-divider></md-divider><p class=\"dir-rtl\" \nng-if=\"vm.futureTax\">שיעור {{vm.futureTax.tax}}% יחול בתאריך {{vm.futureTax.date_start|date}}</p></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/bookkeeping/clients/clients.html","<div id=\"claimPage\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\">\n</md-icon></span>&nbsp; <span class=\"logo-text\">לקוחות</span></div><div class=\"mt-16\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.SearchInvoice(event)\"><md-icon \nmd-font-icon=\"icon-account-search\"></md-icon>חיפוש</md-button></div></div><div hide show-gt-xs \nclass=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-input-container md-no-float class=\"m-0\">\n<input id=\"search\" ng-change=\"vm.showAdvancedSearch=true\" type=\"text\" ng-model=\"vm.search\" placeholder=\"חיפוש\">\n</md-input-container></div></div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\">\n</md-progress-linear><div class=\"content scrollable\" flex layout=\"column\" layout-align=\"start start\"><div layout=\"row\" \nflex><div class=\"logo\" layout=\"row\" flex layout-align=\"start center\"><table-report flex feilds=\"vm.table.feilds\" \ndata=\"vm.table.data\" filter-input=\"vm.search\" order-default=\"-ID\" editfeilds=\"vm.table.edit\" \non-edit-item=\"vm.editItem\" on-insert-item=\"vm.addItem\" on-remove-item=\"vm.removeItem\" config=\"vm.table.configTbl\">\n</table-report></div></div><div id=\"add-contact-button\"><md-button class=\"md-fab md-accent md-icon-button\" \nui-sref=\"app.bookkeeping_new\" aria-label=\"add contact\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button>\n</div></div></div>");
$templateCache.put("app/main/bookkeeping/create_doc/create_doc.html","<div id=\"createDoc\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\">\n</md-icon></span>&nbsp; <span class=\"logo-text\">צור {{vm.invoice.data.type}}</span> <span class=\"logo-text\" \nng-show=\"vm.invoice.receipt.invoiceid\">- סגירת חשבונית {{vm.invoice.receipt.invoiceid}}</span></div><div class=\"mt-16\" \nlayout=\"row\" layout-align=\"start center\"></div></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"></div></div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" \nclass=\"md-primary\"></md-progress-linear><form name=\"docInvoice\"><div class=\"content scrollable\" flex layout=\"column\" \nlayout-align=\"start start\"><div layout=\"row\" flex><md-button \nng-class=\"{\'md-accent md-raised\':(vm.invoice.data.doc_type==1)}\" ng-click=\"vm.invoice.data.doc_type=1\" \nng-disabled=\"vm.invoice.locked\">חשבונית מס קבלה</md-button><md-button \nng-class=\"{\'md-accent md-raised\':(vm.invoice.data.doc_type==2)}\" ng-click=\"vm.invoice.data.doc_type=2\" \nng-disabled=\"vm.invoice.locked\">חשבונית מס</md-button><md-button \nng-class=\"{\'md-accent md-raised\':(vm.invoice.data.doc_type==5)}\" ng-click=\"vm.invoice.data.doc_type=5\" \nng-disabled=\"true||vm.invoice.locked\">חשבונית זיכוי מס</md-button><md-button \nng-class=\"{\'md-accent md-raised\':(vm.invoice.data.doc_type==4)}\" ng-click=\"vm.invoice.data.doc_type=4\" \nng-disabled=\"true||vm.invoice.locked\">חשבונית זיכוי קבלה</md-button><md-button \nng-class=\"{\'md-accent md-raised\':(vm.invoice.data.doc_type==6)}\" ng-click=\"vm.invoice.data.doc_type=6\" \nng-disabled=\"true\">קבלה</md-button></div><div layout=\"row\" flex layout-wrap class=\"dir-rtl\"><div \nclass=\"about-sidebar p-8\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"30\"><div \nclass=\"profile-box friends md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title\">פרטי לקוח</div><md-button class=\"md-icon-button\" \naria-label=\"add location\" ng-click=\"vm.editProfileClick(event)\"><md-icon md-font-icon=\"icon-table-edit\"></md-icon>\n<md-tooltip><span>ערוך</span></md-tooltip></md-button></header><div class=\"form content dir-rtl\" flex><div \nng-hide=\"vm.invoice.locked\" layout=\"row\" flex><form flex ng-submit=\"$event.preventDefault()\"><md-autocomplete \nmd-search-text=\"searchText\" md-selected-item-change=\"vm.selectedItem(item)\" \nmd-search-text-change=\"vm.search(searchText)\" md-items=\"item in vm.bookkeepingClients\" md-item-text=\"item.name\" \nmd-min-length=\"0\" placeholder=\"הקש שם חברה\"><md-item-template><span md-highlight-text=\"searchText\" \nmd-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>לא נמצאו תוצאות לחיפוש {{searchText}} <a \nui-sref=\"app.bookkeeping_clients\">צור כעת</a></md-not-found></md-autocomplete></form></div><div layout=\"column\" \nclass=\"m-8\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"name\" \nng-disabled=\"true\" ng-model=\"vm.invoice.client.name\" placeholder=\"שם\"></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"id\" required ng-disabled=\"true\" ng-model=\"vm.invoice.client.id\" \nplaceholder=\"מזהה\"></md-input-container></div><div layout=\"column\" class=\"m-8\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"address\" ng-disabled=\"true\" \nng-model=\"vm.invoice.client.address\" placeholder=\"כתובת\"></md-input-container></div><div layout=\"column\" class=\"m-8\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"phone\" \nng-disabled=\"true\" ng-model=\"vm.invoice.client.phone\" placeholder=\"טלפון\"></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"mobile\" ng-disabled=\"true\" ng-model=\"vm.invoice.client.mobile\" \nplaceholder=\"נייד\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"email\" \nng-disabled=\"true\" ng-model=\"vm.invoice.client.email\" placeholder=\"אימייל\"></md-input-container></div></div><footer \nclass=\"dir-rtl\"><div layout=\"row\" class=\"md-title\" flex><div flex=\"50\">תאריך הפקה</div><div flex=\"50\">\n{{vm.invoice.data.date|date}}</div></div></footer><footer class=\"dir-rtl\"><div layout=\"row\" class=\"md-title\" flex><div \nflex=\"\">{{vm.invoice.data.type}}</div></div></footer></div></div><div class=\"about-sidebar p-8\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"30\"><div class=\"profile-box friends md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"end center\"><div class=\"title\">פרטי חשבונית</div><md-button \nclass=\"md-icon-button\" aria-label=\"add location\" ng-click=\"vm.editProfileClick(event)\"><md-icon \nmd-font-icon=\"icon-table-edit\"></md-icon><md-tooltip><span>ערוך</span></md-tooltip></md-button></header><div \nng-if=\"vm.invoice.data.doc_type!=6\" class=\"form content dir-rtl\" flex><div layout=\"column\" class=\"m-8\" \nlayout-gt-xs=\"row\" ng-repeat=\"des in vm.invoice.description\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<md-icon ng-show=\"$index+1<vm.invoice.description.length\" md-font-icon=\"icon-cancel\" \nng-click=\"vm.spliceDescription($index)\"><md-tooltip>הסר</md-tooltip></md-icon><md-icon \nng-hide=\"$index+1<vm.invoice.description.length\" md-font-icon=\"icon-plus\" ng-click=\"vm.addDescription()\"><md-tooltip>\nהוסף</md-tooltip></md-icon><input type=\"text\" name=\"description\" ng-model=\"des.description\" required \nplaceholder=\"הזן תיאור לחשבונית\"></md-input-container></div><div layout=\"column\" class=\"m-8\" layout-gt-xs=\"row\" flex>\n<md-radio-group ng-model=\"vm.sumisIncluded\"><md-radio-button ng-value=\"1\">סכום כולל מע\"מ</md-radio-button>\n<md-radio-button ng-value=\"2\">סכום ללא מע\"מ</md-radio-button></md-radio-group></div><div layout=\"column\" class=\"m-8\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"amount\" \nng-model=\"vm.invoice.data.amount\" ng-pattern=\"/^[0-9]+([,.][0-9]+)?$/\" required ng-disabled=\"vm.sumisIncluded==1\" \nplaceholder=\"סכום\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"amountIncluded\" ng-disabled=\"vm.sumisIncluded==2\" ng-pattern=\"/^[0-9]+([,.][0-9]+)?$/\" \nng-model=\"vm.invoice.data.amountIncluded\" required placeholder=\"סך כולל מעמ\"></md-input-container></div><div \nlayout=\"column\" class=\"m-8\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"tax\" ng-disabled=\"true\" ng-model=\"vm.invoice.data.tax\" placeholder=\"מעמ\"></md-input-container><md-input-container\n flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"amountTax\" ng-disabled=\"true\" \nng-model=\"vm.invoice.data.amountTax\" required placeholder=\"סך מעמ\"></md-input-container></div></div><div \nng-if=\"vm.invoice.data.doc_type==6\" class=\"form content dir-rtl\" flex><div layout=\"column\" class=\"m-8\" \nlayout-gt-xs=\"row\" ng-repeat=\"des in vm.invoice.description\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<md-icon ng-show=\"$index+1<vm.invoice.description.length\" md-font-icon=\"icon-cancel\" \nng-click=\"vm.spliceDescription($index)\"><md-tooltip>הסר</md-tooltip></md-icon><md-icon \nng-hide=\"$index+1<vm.invoice.description.length\" md-font-icon=\"icon-plus\" ng-click=\"vm.addDescription()\"><md-tooltip>\nהוסף</md-tooltip></md-icon><input type=\"text\" name=\"description\" ng-model=\"des.description\" required \nplaceholder=\"הזן תיאור קבלה\"></md-input-container></div></div><footer class=\"dir-rtl\"><div layout=\"row\" \nclass=\"md-title\" flex><div flex=\"50\">סך לתשלום</div><div flex=\"50\">{{vm.invoice.receipt.amount| customCurrency}}</div>\n</div></footer><footer ng-if=\"!vm.showreceiptForm\" class=\"dir-rtl\" layout=\"row\"><md-button flex ng-click=\"vm.submit()\" \nng-disabled=\"vm.proccess||!vm.invoice.receipt.amount||docInvoice.$invalid\" class=\"post-button md-accent md-raised\" \naria-label=\"POST\">{{(vm.proccess?\'אנא המתן...\':\'אישור והפקת חשבונית\')}}</md-button></footer></div></div><div \nng-if=\"vm.showreceiptForm\" class=\"about-sidebar p-8\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"40\"><div \nclass=\"profile-box friends md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button ng-if=\"vm.refund\" \nclass=\"md-raised\" aria-label=\"insert photo\" ng-click=\"vm.RefundStatus()\"><md-icon md-font-icon=\"icon-backburger\">\n</md-icon>חזור</md-button></div><div class=\"title dir-rtl\">קבלת תשלום</div></header><div class=\"content\"><div \nclass=\"info-line md-title dir-rtl\" ng-if=\"vm.profile.paidAll\" layout=\"row\" layout-align=\"center center\" flex><div \nclass=\"info-line md-title dir-rtl\" layout=\"column\" layout-align=\"center center\" flex><div ng-if=\"!vm.refund\">שולם הכל\n</div><div ng-if=\"vm.refund\">קבלת זיכוי - חשבונית {{vm.payments.RefundKabalaID}}</div><div ng-if=\"!vm.refund\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s96\"></md-icon></div></div></div><div class=\"info-line md-title dir-rtl\" \nng-if=\"!vm.profile.paidAll&&(vm.profile.sumAll.topay)<=vm.profile.Receipts.sumAllRecepts\" layout=\"row\" \nlayout-align=\"center center\" flex><div class=\"info-line md-title dir-rtl\" layout=\"column\" layout-align=\"center center\" \nflex><div>לא לתשלום</div><div><md-icon md-font-icon=\"icon-close\" class=\"s96\"></md-icon></div></div></div><div \nlayout=\"row\" flex><md-button layout=\"column\" flex ng-click=\"vm.openCashDialog()\" \nclass=\"post-button md-accent md-raised pt-8\" aria-label=\"POST\"><img src=\"assets/images/etc/money.png\"> מזומן\n</md-button><md-button layout=\"column\" flex ng-click=\"vm.openTransferDialog()\" \nclass=\"post-button md-accent md-raised pt-8\" aria-label=\"POST\"><img src=\"assets/images/etc/transfer.png\"> העברה בנקאית\n</md-button><md-button layout=\"column\" flex ng-click=\"vm.openChecksDialog()\" \nclass=\"post-button md-accent md-raised pt-8\" aria-label=\"POST\"><img src=\"assets/images/etc/check.png\"> שיק</md-button>\n<md-button layout=\"column\" flex ng-disabled=\"true\" ng-click=\"vm.openCreditCardDialog()\" \nclass=\"post-button md-accent md-raised pt-8\" aria-label=\"POST\"><img src=\"assets/images/etc/visa.png\"> אשראי</md-button>\n</div></div><header class=\"md-accent-bga\" layout=\"row\" layout-align=\"end center\"><div class=\"title dir-rtl\" flex>\nפירוט תשלומים</div></header><div class=\"content dir-rtl\"><div layout=\"row\" flex><div flex=\"50\">ס\"ה מזומן</div><div \nflex=\"50\">{{(vm.payments.sumCashPrice ||0)| customCurrency}}</div></div><div layout=\"row\" flex><div flex=\"50\">ס\"ה העברה\n</div><div flex=\"50\">{{(vm.payments.sumTransferPrice ||0)| customCurrency}}</div></div><div layout=\"row\" flex><div \nflex=\"50\">ס\"ה שיקים</div><div flex=\"50\">{{(vm.payments.sumChekPrice ||0)| customCurrency}}</div></div><div \nlayout=\"row\" flex><div flex=\"50\">ס\"ה אשראי</div><div flex=\"50\">{{(vm.payments.sumCreditCardPrice||0) | customCurrency}}\n</div></div></div><footer layout=\"row\" class=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" \nclass=\"md-title\" flex><div flex=\"50\" ng-show=\"vm.refund\">סך לזיכוי</div><div flex=\"50\" ng-hide=\"vm.refund\">סך נתקבל\n</div><div flex=\"50\">{{vm.payments.sumAllRecepts||0 | customCurrency}}</div></div></footer><footer layout=\"row\" \nclass=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" class=\"md-title\" flex><div flex=\"50\">יתרת חוב\n</div><div flex=\"50\">{{(vm.invoice.data.amountIncluded-vm.payments.sumAllRecepts)|customCurrency}}</div></div></footer>\n<footer class=\"dir-rtl\" layout=\"row\"><md-button flex ng-click=\"vm.submit()\" \nng-disabled=\"vm.proccess||!vm.payments.sumAllRecepts||(vm.invoice.data.doc_type==6?false:vm.payments.sumAllRecepts!=vm.invoice.data.amountIncluded)\" \nclass=\"post-button md-accent md-raised\" aria-label=\"POST\">{{(vm.proccess?\'אנא המתן...\':\'אישור והפקת חשבונית\')}}\n</md-button></footer></div></div></div></div></form></div>");
$templateCache.put("app/main/bookkeeping/create_doc/createdoc.html","<div id=\"createdoc\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nlayout=\"row\" flex><md-button ng-class=\"{\'md-accent\':(vm.invoice.data.doc_type==1)}\" \nng-click=\"vm.invoice.data.doc_type=1\">חשבונית מס קבלה</md-button><md-button \nng-class=\"{\'md-accent\':(vm.invoice.data.doc_type==2)}\" ng-click=\"vm.invoice.data.doc_type=2\">חשבונית מס</md-button>\n<md-button ng-class=\"{\'md-accent\':(vm.invoice.data.doc_type==6)}\" ng-click=\"vm.invoice.data.doc_type=6\">קבלה\n</md-button></div><div class=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"center start\"><div\n class=\"ids\" layout=\"column\"><div layout=\"row\" class=\"seller\" layout-align=\"center center\"><div \nclass=\"logo xmd-accent-bg\" layout=\"row\" layout-align=\"center center\"><div><img src=\"assets/images/logos/logo-or.png\">\n</div></div><div class=\"divider\"></div><div class=\"detail text-right\"><div class=\"title\">{{vm.invoice.from.title}}\n</div><div ng-if=\"vm.invoice.from.address\" class=\"address\">{{vm.invoice.from.address}}</div><div \nng-if=\"vm.invoice.from.phone\" class=\"phone\"><span>טלפון</span>: {{vm.invoice.from.phone}}</div><div \nng-if=\"vm.invoice.from.email\" class=\"email\"><span>Email</span>: {{vm.invoice.from.email}}</div><div \nng-if=\"vm.invoice.from.website\" class=\"website\"><span>Web</span>: {{vm.invoice.from.website}}</div></div></div></div>\n</div><div class=\"header\" layout=\"row\" layout-align=\"center start\"><table class=\"summary\"><tr class=\"code\"><td \nclass=\"value red-fg\">{{vm.invoice.data.doc_id}}</td><td class=\"label\">{{vm.invoice.data.type}}</td></tr><tr><td \nclass=\"value\">{{vm.invoice.data.date|date}}</td><td class=\"label\">תאריך</td></tr></table></div><div class=\"header\" \nlayout=\"row\" layout-align=\"end start\"><div class=\"detail text-right\"><form ng-submit=\"$event.preventDefault()\"><p>\nהקש שם חברה להשלמת נתונים</p><md-autocomplete md-search-text=\"searchText\" \nmd-selected-item-change=\"vm.selectedItem(item)\" md-items=\"item in vm.search(searchText)\" md-item-text=\"item.name\" \nmd-min-length=\"0\" placeholder=\"הקש שם חברה\"><md-item-template><span md-highlight-text=\"searchText\" \nmd-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>לא נמצאו תוצאות לחיפוש \"{{searchText}}\" <a\n ng-click=\"ctrl.newState(searchText)\">צור כעת!</a></md-not-found></md-autocomplete></form><div class=\"title\">\nלכבוד {{vm.invoice.client.name}}</div><div ng-if=\"vm.invoice.client.contactName\" class=\"address\">\n{{vm.invoice.client.contactName}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">\n{{vm.invoice.client.address}}</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\"><span>טלפון</span>\n: {{vm.invoice.client.phone}}</div><div ng-if=\"vm.invoice.client.email\" class=\"email\"><span>Email</span>\n: {{vm.invoice.client.email}}</div><div ng-if=\"vm.invoice.client.website\" class=\"website\"><span>Web</span>\n: {{vm.invoice.client.website}}</div></div></div><div ng-if=\"false\" class=\"header\" layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"ids\" layout=\"column\"><div layout=\"row\" class=\"seller\" \nlayout-align=\"start center\"><div class=\"logo xmd-accent-bg\" layout=\"row\" layout-align=\"center center\"><div><img \nsrc=\"assets/images/logos/logo-or.png\"></div></div><div class=\"divider\"></div><div class=\"detail\"><div class=\"title\">\n{{vm.invoice.from.title}}</div><div ng-if=\"vm.invoice.from.address\" class=\"address\">{{vm.invoice.from.address}}</div>\n<div ng-if=\"vm.invoice.from.phone\" class=\"phone\"><span>טלפון</span>: {{vm.invoice.from.phone}}</div><div \nng-if=\"vm.invoice.from.email\" class=\"email\"><span>Email</span>: {{vm.invoice.from.email}}</div><div \nng-if=\"vm.invoice.from.website\" class=\"website\"><span>Web</span>: {{vm.invoice.from.website}}</div></div></div><div \nlayout=\"row\" class=\"client\" layout-align=\"start center\"><div class=\"label\" layout=\"row\" layout-align=\"end center\"><div>\nCLIENT</div></div><div class=\"divider\"></div><div class=\"detail\"><div class=\"title\">{{vm.invoice.client.name}}</div>\n<div ng-if=\"vm.invoice.client.contactName\" class=\"address\">{{vm.invoice.client.contactName}}</div><div \nng-if=\"vm.invoice.client.address\" class=\"address\">{{vm.invoice.client.address}}</div><div \nng-if=\"vm.invoice.client.phone\" class=\"phone\"><span>טלפון</span>: {{vm.invoice.client.phone}}</div><div \nng-if=\"vm.invoice.client.email\" class=\"email\"><span>Email</span>: {{vm.invoice.client.email}}</div><div \nng-if=\"vm.invoice.client.website\" class=\"website\"><span>Web</span>: {{vm.invoice.client.website}}</div></div></div>\n</div><table class=\"summary\"><tr class=\"code\"><td class=\"value red-fg\">{{vm.invoice.data.doc_id}}</td><td \nclass=\"label\">{{vm.invoice.data.type}}</td></tr><tr><td class=\"value\">{{vm.invoice.data.date|date}}</td><td \nclass=\"label\">תאריך</td></tr><tr><td class=\"value\">{{vm.invoice.data.amountIncluded | customCurrency}}</td><td \nclass=\"label\">סך לחשבונית</td></tr></table></div><div class=\"content\"><table class=\"simplex invoice-table\"><tbody><tr \nng-repeat=\"service in vm.invoice.description\"><td class=\"text-right\"><md-input-container layout=\"row\" flex><input flex \ntype=\"text\" ng-model=\"service.description\" placeholder=\"כתוב תיאור\"></md-input-container></td></tr></tbody></table>\n<table class=\"simple invoice-table-footer\"><tbody><tr class=\"subtotal\"><td>{{vm.invoice.data.amount | customCurrency}}\n</td><td>סך הכל</td></tr><tr class=\"tax\"><td>{{vm.invoice.data.amountTax | customCurrency}}</td><td>\n{{(vm.invoice.data.tax)}}% מע\"מ</td></tr><tr class=\"discount\"><td>-{{vm.invoice.data.discount | customCurrency}}</td>\n<td>הנחה</td></tr><tr class=\"total\"><td>{{vm.invoice.data.amountIncluded | customCurrency}}</td><td>סך הכל</td></tr>\n</tbody></table></div><div class=\"content\" ng-repeat=\"rec in vm.invoice.receipt\"><div class=\"detail text-right\"><div \nclass=\"title\">שולם ב{{rec.payBy}}</div><div class=\"title\">סך {{rec.amount|customCurrency}}</div></div></div><div \nclass=\"footer\"><div class=\"note\">Please pay within 15 days. Thank you for your business.</div><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div>\n<div class=\"small-note\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/bookkeeping/doc/doc.html","DOC");
$templateCache.put("app/main/bookkeeping/docs_list/docs_list.html","<div id=\"claimPage\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\">\n</md-icon></span>&nbsp; <span class=\"logo-text\">רשימת חשבוניות</span></div><div class=\"mt-16\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.SearchInvoice(event)\"><md-icon \nmd-font-icon=\"icon-account-search\"></md-icon>חיפוש</md-button></div></div><div hide show-gt-xs \nclass=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-input-container md-no-float class=\"m-0\">\n<input id=\"search\" ng-change=\"vm.showAdvancedSearch=true\" type=\"text\" ng-model=\"vm.search\" placeholder=\"חיפוש\">\n</md-input-container></div></div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\">\n</md-progress-linear><div class=\"content scrollable\" flex layout=\"column\" layout-align=\"start start\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\" ng-show=\"vm.AccountStatus\"><ms-widget class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex=\"\">\n<div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex=\"\"><div class=\"md-display-1 pb-8\">\n{{vm.AccountStatus.name}}</div><div class=\"font-weight-500 secondary-text\">{{vm.AccountStatus.email}}</div></div>\n</ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex=\"\"><div class=\"pt-8 pb-8\" layout=\"column\" \nlayout-align=\"center center\" flex=\"\"><div class=\"font-weight-500 secondary-text pb-8\">סכום חשבוניות</div><div \nclass=\"md-display-1\">{{vm.AccountStatus.amountIncluded|customCurrency}}</div></div></ms-widget-front></ms-widget>\n<ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 white-bg\" layout=\"row\" flex=\"\"><div class=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" \nflex=\"\"><div class=\"pl-8\" layout=\"column\" layout-align=\"center start\"><span class=\"md-display-1 pb-8\">\n{{(vm.AccountStatus.amountIncluded-vm.AccountStatus.receiptAmount)|customCurrency}}</span> <span \nclass=\"font-weight-500 secondary-text\">יתרת חוב</span></div><div><md-icon \nng-hide=\"(vm.AccountStatus.amountIncluded-vm.AccountStatus.receiptAmount)\" md-font-icon=\"icon-thumb-up\" \nclass=\"s48 hint-text md-default-theme\" role=\"img\" aria-label=\"icon-thumb-up\"></md-icon><md-icon \nng-show=\"(vm.AccountStatus.amountIncluded-vm.AccountStatus.receiptAmount)\" md-font-icon=\"icon-thumb-down\" \nclass=\"s48 hint-text md-default-theme\" role=\"img\" aria-label=\"icon-thumb-up\"></md-icon></div></div></ms-widget-front>\n</ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 white-bg\" layout=\"row\" flex=\"\"><div class=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" \nflex=\"\"><div><md-icon md-font-icon=\"icon-lock-unlocked\" class=\"s48 hint-text md-default-theme\" role=\"img\" \naria-label=\"icon-thumb-up\"></md-icon></div><div class=\"pl-8\" layout=\"column\" layout-align=\"center start\"><span \nclass=\"md-display-1 pb-8\">{{(vm.AccountStatus.sumInvoices-vm.AccountStatus.sumClosed)}}</span> <span \nclass=\"font-weight-500 secondary-text\">חשבוניות פתוחות</span></div></div></ms-widget-front></ms-widget></div><div \nlayout=\"row\" flex><div class=\"logo\" layout=\"row\" flex layout-align=\"start center\"><table-report flex \nfeilds=\"vm.feilds\" data=\"vm.Invoices\" filter-input=\"vm.search\" order-default=\"-date\" config=\"vm.configTbl\">\n</table-report></div></div><div id=\"add-contact-button\"><md-button class=\"md-fab md-accent md-icon-button\" \nui-sref=\"app.bookkeeping_new\" aria-label=\"add contact\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button>\n</div></div></div>");
$templateCache.put("app/main/claims/claim_data/claim_data.html","<div id=\"claimPage\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\">\n</md-icon></span>&nbsp; <span class=\"logo-text\">דוח תביעה מס #{{vm.Claim.ID}}</span></div><div class=\"mt-16\" \nlayout=\"row\" layout-align=\"start center\"></div></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nng-change=\"vm.showAdvancedSearch=true\" type=\"text\" ng-model=\"vm.search\" placeholder=\"חיפוש\"></md-input-container></div>\n</div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div \nclass=\"content scrollable\" flex layout=\"column\" layout-align=\"start start\"><md-tabs md-dynamic-height><md-tab>\n<md-tab-label><span>פירוט צילומים</span></md-tab-label><md-tab-body><md-content flex layout=\"column\" \nclass=\"details-tab\" ms-scroll><div layout=\"row\" flex><div class=\"logo\" layout=\"row\" flex layout-align=\"start center\">\n<table-report flex feilds=\"vm.feilds\" data=\"vm.Claim.data\" order-default=\"date_created\" on-edit-item=\"vm.editItem\" \non-remove-item=\"vm.removeItem\" editfeilds=\"vm.feildsedit\" filter-input=\"vm.search\" config=\"vm.configTbl\">\n</table-report></div></div></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>פרטי תביעה</span>\n</md-tab-label><md-tab-body><md-content flex layout=\"column\" class=\"details-tab\" ms-scroll><div layout=\"row\" flex \nclass=\"md-content\"><div ng-hide=\"vm.editMode\" class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\">\n<div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\">מספר תביעה: #{{vm.Claim.ID}}</div></header><div class=\"content md-subhead\"><div>\nמתאריך: {{vm.Claim.date_created|date}}</div><div ng-show=\"vm.Claimdate_closed\">\nנסגר בתאריך: {{vm.Claim.date_closed|date}}</div><div>ביטוח: {{vm.Claim.InsuranceName}}</div><div>\nסכום: {{vm.Claim.priceA|customCurrency}}</div><div>סכום שאושר: {{ vm.Claim.sumPaid|customCurrency}}</div><div>\nסטאטוס תביעה: {{vm.Claim.statusName}}</div><div>שם תביעה: {{vm.Claim.name}}</div><div>הערות: {{vm.Claim.comments}}\n</div><div layout=\"row\" flex><md-button class=\"md-raised md-primary\" ng-click=\"vm.editMode=!vm.editMode\">ערוך\n</md-button></div></div></div></div><div ng-show=\"vm.editMode\" class=\"about\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"65\"><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\">מספר תביעה: #{{vm.Claim.ID}}</div></header><div class=\"content md-subhead\"><div\n layout=\"row\" flex><md-input-container><input type=\"text\" ng-model=\"vm.Claim.date_created\" ng-disabled=\"true\" \nplaceholder=\"מתאריך\"></md-input-container><md-input-container><input type=\"text\" ng-model=\"vm.Claim.InsuranceName\" \nng-disabled=\"true\" placeholder=\"ביטוח\"></md-input-container><md-input-container><input type=\"text\" \nng-model=\"vm.Claim.priceA\" ng-disabled=\"true\" placeholder=\"סכום\"></md-input-container><md-input-container><input \ntype=\"text\" ng-model=\"vm.Claim.sumPaid\" ng-disabled=\"false\" placeholder=\"סכום שאושר\"></md-input-container></div><div \nlayout=\"row\" flex><md-select flex ng-model=\"vm.Claim.status\"><md-option ng-repeat=\"st in vm.ClaimStatuses\" \nng-value=\"st.ID\">{{st.status}}</md-option></md-select></div><div layout=\"row\" flex><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.Claim.name\" placeholder=\"שם תביעה\"></md-input-container></div><div layout=\"row\" flex>\n<md-input-container flex><input type=\"text\" ng-model=\"vm.Claim.comments\" placeholder=\"הערות\"></md-input-container>\n</div><div layout=\"row\" flex><md-button class=\"md-raised md-accent\" ng-click=\"vm.UpdateClaim()\">שמור</md-button>\n<md-button class=\"md-raised md-warn\" ng-click=\"vm.DeleteClaim()\">מחק תביעה</md-button><md-button \nclass=\"md-raised md-primary\" ng-disabled=\"true\" ng-click=\"\">סגור והפק חשבונית</md-button></div></div></div></div></div>\n</md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/claims/claims_list/claims_list.html","<div id=\"claimPage\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\">\n</md-icon></span>&nbsp; <span class=\"logo-text\">רשימת תביעות</span></div><div class=\"mt-16\" layout=\"row\" \nlayout-align=\"start center\"></div></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nng-change=\"vm.showAdvancedSearch=true\" type=\"text\" ng-model=\"vm.search\" placeholder=\"חיפוש\"></md-input-container></div>\n</div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div \nclass=\"content scrollable\" flex layout=\"column\" layout-align=\"start start\"><div layout=\"row\" flex><div class=\"logo\" \nlayout=\"row\" flex layout-align=\"start center\"><table-report flex feilds=\"vm.feilds\" data=\"vm.ClaimList\" \nfilter-input=\"vm.search\" order-default=\"-ID\" config=\"vm.configTbl\"></table-report></div></div><div \nid=\"add-contact-button\"><md-button class=\"md-fab md-accent md-icon-button\" ui-sref=\"app.claims\" \naria-label=\"add contact\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div></div></div>");
$templateCache.put("app/main/claims/create_claim/create_claim.html","<div id=\"claimPage\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\">\n</md-icon></span>&nbsp; <span class=\"logo-text\">צור תביעה</span></div><div class=\"mt-16\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" flex><md-button class=\"md-raised md-primary\" \nng-class=\"{\'md-accent\': vm.createtype==1}\" ng-click=\"vm.createtype=1\">הפקה ידנית</md-button><md-button \nclass=\"md-raised md-primary\" ng-class=\"{\'md-accent\':vm.createtype==2}\" ng-click=\"vm.createtype=2\">הפקה אוטומטית\n</md-button></div></div></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nng-change=\"vm.showAdvancedSearch=true\" type=\"text\" ng-model=\"vm.search\" placeholder=\"חיפוש\"></md-input-container></div>\n</div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div \nclass=\"content scrollable\" flex layout=\"column\" layout-align=\"start start\"><div layout=\"row\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"></div></div><div flex=\"\" ng-hide=\"vm.createtype==2\" layout=\"row\"><form \nflex=\"\" layout=\"row\" name=\"verticalStepper\" ms-vertical-stepper ng-submit=\"vm.submit()\" ng-model=\"vm.verticalStepper\" \nnovalidate><ms-vertical-stepper-step ng-form=\"verticalStep1\" step=\"1\" step-title=\"\'בחר ביטוח/קופח\'\"><div><md-select \nrequired flex ng-model=\"vm.claim.InsuranceID\" md-on-close=\"clearSearchTerm()\" md-on-open=\"vm.focusSearch(1)\" \ndata-md-container-class=\"selectdemoSelectHeader\" ng-change=\"vm.selectInsuranse()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchInsurance\" id=\"s_searchInsurance\" type=\"text\" \nplaceholder=\"הקש ערך לחיפוש\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" class=\"demo-header-searchbox md-text\">\n</md-select-header><md-option ng-value=\"0\">בחר</md-option><md-option \nng-repeat=\"ins in vm.factorPays |filter:{BituahID:\'!1\'}:true|filter:searchInsurance|orderBy:\'Name\'\" \nng-value=\"ins.BituahID\">{{ins.Name}}</md-option></md-select></div></ms-vertical-stepper-step><ms-vertical-stepper-step \nng-form=\"verticalStep2\" step=\"2\" step-title=\"\'סניף מכבי\'\" hide-step=\"vm.claim.InsuranceID!=20\"><md-select \nng-required=\"vm.claim.InsuranceID==20\" flex ng-model=\"vm.claim.HMO_Maccabi\" md-on-open=\"vm.focusSearch(2)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchMaccabi\" type=\"text\" id=\"s_searchMaccabi\" \nplaceholder=\"הקש ערך לחיפוש\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" class=\"demo-header-searchbox md-text\">\n</md-select-header><md-option ng-value=\"0\">בחר</md-option><md-option \nng-repeat=\"ins in vm.maccabi.data |filter:{BituahID:\'!1\'}:true|filter:searchMaccabi\" ng-value=\"ins.id\">{{ins.Name}}\n</md-option></md-select></ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"verticalStep3\" step=\"3\" \nstep-title=\"\'סניף מאוחדת\'\" hide-step=\"vm.claim.InsuranceID!=21\"><md-select ng-required=\"vm.claim.InsuranceID==21\" flex \nng-model=\"vm.claim.HMO_Meuhedte\" md-on-open=\"vm.focusSearch(3)\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchMeuhedet\" type=\"text\" id=\"s_searchMeuhedet\" placeholder=\"הקש ערך לחיפוש\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option \nng-value=\"0\">בחר</md-option><md-option ng-repeat=\"ins in vm.meuhedet.data|filter:searchMeuhedet\" ng-value=\"ins.id\">\n{{ins.Name}}</md-option></md-select></ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"verticalStep4\" \nstep=\"4\" step-title=\"\'סניף ש.ל.ה\'\" hide-step=\"vm.claim.InsuranceID!=14\"><md-select \nng-required=\"vm.claim.InsuranceID==14\" flex ng-model=\"vm.claim.HMO_Shela\" md-on-open=\"vm.focusSearch(4)\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchshela\" id=\"s_searchShela\" type=\"text\" \nplaceholder=\"הקש ערך לחיפוש\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" class=\"demo-header-searchbox md-text\">\n</md-select-header><md-option ng-value=\"0\">בחר</md-option><md-option \nng-repeat=\"ins in vm.shela.data|filter:searchshela\" ng-value=\"ins.id\">{{ins.Name}}</md-option></md-select>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"verticalStep54\" step=\"5\" step-title=\"\'תאריכים\'\"><div \nclass=\"content dir-rtl\"><or-date-between-buttons dates=\"vm.claim.dates\" current-month=\"true\"></or-date-between-buttons>\n</div></ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"verticalStep6\" step=\"6\" \nstep-title=\"\'אפשרויות נוספות\'\" optional-step><div><md-input-container flex><input required type=\"text\" \nng-model=\"vm.claim.name\" placeholder=\"שם\"></md-input-container></div></ms-vertical-stepper-step></form></div><div \nng-show=\"vm.createtype==2\" flex=\"\" class=\"list_create_claim\"><div flex>בחר את הביטוחים/קופ\"ח להפקת דוח תביעה</div><div \nflex><div class=\"content dir-rtl\"><or-date-between-buttons dates=\"vm.claim.dates\" current-month=\"true\">\n</or-date-between-buttons></div></div><div layout=\"row\" flex><p class=\"red-fg\">קיצורי דרך</p><md-button \nclass=\"md-primary\" ng-class=\"{\'md-raised\':vm.maccabi.main.selectedall}\" ng-click=\"vm.shortcutsClaim(20)\">מכבי\n</md-button><md-button class=\"md-primary\" ng-class=\"{\'md-raised\':vm.shela.main.selectedall}\" \nng-click=\"vm.shortcutsClaim(14)\">ש.ל.ה</md-button><md-button class=\"md-primary\" \nng-class=\"{\'md-raised\':vm.meuhedet.main.selectedall}\" ng-click=\"vm.shortcutsClaim(21)\">מאוחדת</md-button></div><div \nflex=\"\" layout=\"row\" class=\"list_create_claim\"><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"25\" \nflex-gt-md=\"50\"><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\">רשימת ביטוחים</div></header><div class=\"content md-subhead\"><md-list>\n<md-list-item><md-checkbox ng-model=\"vm.selectedAll\"></md-checkbox><span>בחר הכל</span></md-list-item><md-list-item \nng-repeat=\"ins in vm.factorPays\" ng-hide=\"ins.hide\"><md-checkbox ng-model=\"ins.selected\"></md-checkbox><span>\n{{ins.Name}}</span></md-list-item></md-list></div></div></div><div ng-show=\"vm.maccabi.main.selected\" class=\"about\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"50\"><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">סניפי מכבי</div></header><div \nclass=\"content md-subhead\"><md-list-item><md-checkbox ng-model=\"vm.maccabi.main.selectedall\"></md-checkbox><span>\nבחר הכל</span></md-list-item><md-list-item ng-repeat=\"ins in vm.maccabi.data\"><md-checkbox ng-model=\"ins.selected\">\n</md-checkbox><span>{{ins.Name}}</span></md-list-item></div></div></div><div ng-show=\"vm.meuhedet.main.selected\" \nclass=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"50\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nסניפי מאוחדת</div></header><div class=\"content md-subhead\"><md-list-item><md-checkbox \nng-model=\"vm.meuhedet.main.selectedall\"></md-checkbox><span>בחר הכל</span></md-list-item><md-list-item \nng-repeat=\"ins in vm.meuhedet.data\"><md-checkbox ng-model=\"ins.selected\"></md-checkbox><span>{{ins.Name}}</span>\n</md-list-item></div></div></div><div ng-show=\"vm.shela.main.selected\" class=\"about\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"25\" flex-gt-md=\"50\"><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\">סניפי שלה</div></header><div class=\"content md-subhead\"><md-list-item>\n<md-checkbox ng-model=\"vm.shela.main.selectedall\"></md-checkbox><span>בחר הכל</span></md-list-item><md-list-item \nng-repeat=\"ins in vm.shela.data\"><md-checkbox ng-model=\"ins.selected\"></md-checkbox><span>{{ins.Name}}</span>\n</md-list-item></div></div></div></div><div flex><md-button class=\"md-accent md-raised\" ng-click=\"vm.submitGroup()\">\nהפק דוח תביעה</md-button></div></div></div></div>");
$templateCache.put("app/main/doctors/doctor-card/doctor-card.html","<div class=\"doctor or-header page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header smallheader md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span>&nbsp; <span class=\"logo-text\">{{vm.doctor.Name}} </span>\n<span class=\"logo-text\" hide show-gt-xs>: כרטיס רופא/מרפאה</span></div></div><div hide show-gt-xs \nclass=\"search-input-wrapper logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\"></span></div></div>\n<md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div \nclass=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\"><div layout=\"row\" flex><md-button \nclass=\"md-raised md-primary\" ng-class=\"{\'md-accent\':vm.tabstatus==1,\'w-60\':$mdMedia(\'xs\')}\" ng-click=\"vm.tabstatus=1\">\n<md-icon md-font-icon=\"icon-chart-bar\"></md-icon><span hide show-gt-xs>תרשים ודוחות</span></md-button><md-button \nclass=\"md-raised md-primary\" ng-class=\"{\'md-accent\':vm.tabstatus==2,\'w-60\':$mdMedia(\'xs\')}\" ng-click=\"vm.tabstatus=2\">\n<md-icon md-font-icon=\"icon-details\"></md-icon><span hide show-gt-xs>פרטים והרשאות</span></md-button><md-button \nclass=\"md-raised md-primary\" ng-class=\"{\'md-accent\':vm.tabstatus==3,\'w-60\':$mdMedia(\'xs\')}\" ng-click=\"vm.tabstatus=3\">\n<md-icon md-font-icon=\"icon-cash\"></md-icon><span hide show-gt-xs>מחירון צילומים</span></md-button><md-button \nclass=\"md-raised md-primary\" ng-class=\"{\'md-accent\':vm.tabstatus==4,\'w-60\':$mdMedia(\'xs\')}\" ng-click=\"vm.tabstatus=4\">\n<md-icon md-font-icon=\"icon-message-text\"></md-icon><span hide show-gt-xs>תיבת הודעות</span></md-button></div>\n<md-content ng-show=\"vm.tabstatus==1\" flex layout=\"column\" class=\"details-tab\" ms-scroll><div class=\"widget-group ltr\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget ng-if=\"false\" layout=\"row\" flex=\"70\"><ms-widget-front class=\"white-bg\">\n<div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nclass=\"pv-8 h3\">פירוט צילומים</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" \nflex-sm=\"100\"><or-date-between-buttons dates=\"vm.dates\" on-change=\"vm.refresh(vm.dates)\"></or-date-between-buttons>\n</div></div><div layout=\"row\" layout-align=\"start start\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\">\n<table-report flex feilds=\"vm.ClientsReports.feilds\" data=\"vm.doctor.ClientsData.data\" filterinput=\"vm.search\" \norder-default=\"ClientName\"></table-report><div ng-hide=\"vm.doctor.ClientsData.data.length\">אין נתונים</div></div></div>\n</ms-widget-front></ms-widget><div layout=\"row\" flex=\"100\" flex-gt-xs=\"100\"><div flex class=\"white-bg\"><div flex \nlayout=\"column\"><div flex class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<or-date-between-buttons dates=\"vm.dates\" on-change=\"vm.refresh(vm.dates)\"></or-date-between-buttons></div><md-divider>\n</md-divider></div><md-tabs md-dynamic-height md-border-bottom=\"true\"><md-tab><md-tab-label><span>תרשים כללי</span>\n</md-tab-label><md-tab-body><md-content ms-scroll class=\"billing-tab\" layout=\"row\" flex><div layout=\"column\" flex \nlayout-gt-xs=\"row\" layout-wrap><div layout=\"column\" flex><div class=\"p-16\" layout=\"row\" flex><ms-widget flex \nflippable=\"true\" layout=\"column\"><ms-widget-front class=\"white-bg\"><div ng-hide=\"false\" class=\"ph-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">פציינטים</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n{{vm.doctor.ClientsData.summary.countClients}}</div><div class=\"h3 secondary-text font-weight-500\">פציינטים</div></div>\n<div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">צילומים:</span> <span class=\"h4 ml-8\">\n{{vm.doctor.ClientsData.summary.countPhotos||0}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\">\n<div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>כמות פציינטים<br>צילומים: כמות צילומים שבוצעו\n</div></ms-widget-back></ms-widget></div><div class=\"p-16\" layout=\"row\" flex><ms-widget flex flippable=\"true\" \nlayout=\"column\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">הכנסות</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">\n{{vm.doctor.ClientsData.summary.Price.toFixed(0)||0 |number : fractionSize}}</div><div \nclass=\"h3 secondary-text font-weight-500\">₪</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">תשלום לקוחות:</span> <span class=\"h4 ml-8\">\n{{vm.doctor.ClientsData.summary.Deductible.toFixed(2)||0 |number : fractionSize}}</span></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>סך הכנסות כולל ביטוחים שנתקבלו ע\"י הפניית הרופא<br>תשלום לקוחות: תשלום ששולמו בפועל ע\"י הפציינטים</div>\n</ms-widget-back></ms-widget></div></div><div layout=\"column\" flex><div layout=\"column\" flex><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\" class=\"ms-widget\"><ms-widget-front ng-click=\"flipWidget()\" class=\"h-170 p-16 light-blue-bg\"><div \nclass=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">פציינטים\n</div></div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-display-1\" \nlayout=\"row\" layout-align=\"start center\"><span>{{vm.doctor.ClientsData.percent.data_A.data.countClients||0|number}}\n</span><md-icon ng-show=\"vm.doctor.ClientsData.percent.percent.countClients>0\" md-font-icon=\"icon-trending-up\" \nclass=\"s36 ml-16\"></md-icon><md-icon ng-show=\"vm.doctor.ClientsData.percent.percent.countClients<0\" \nmd-font-icon=\"icon-trending-down\" class=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\">\n<span>אשתקד: {{vm.doctor.ClientsData.percent.data_B.data.countClients||0|number}}</span> <span \nclass=\"text-boxed-light\">{{vm.doctor.ClientsData.percent.percent.countClients||0|number}} %</span></div></div>\n</ms-widget-front><ms-widget-back ng-click=\"flipWidget()\" class=\"p-16 light-blue-bg white-fg\"><div><button \nclass=\"md-icon-button\" type=\"button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\" role=\"img\" aria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div>\n</button></div><div>This is the back side. You can show detailed information here.</div></ms-widget-back></ms-widget>\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" class=\"ms-widget\">\n<ms-widget-front ng-click=\"flipWidget()\" class=\"h-170 p-16 light-blue-bg\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">צילומים</div></div><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-display-1\" layout=\"row\" \nlayout-align=\"start center\"><span>{{vm.doctor.ClientsData.percent.data_A.data.countPhotos||0|number}}</span><md-icon \nng-show=\"vm.doctor.ClientsData.percent.percent.countPhotos>0\" md-font-icon=\"icon-trending-up\" class=\"s36 ml-16\">\n</md-icon><md-icon ng-show=\"vm.doctor.ClientsData.percent.percent.countPhotos<0\" md-font-icon=\"icon-trending-down\" \nclass=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\"><span>\nאשתקד: {{vm.doctor.ClientsData.percent.data_B.data.countPhotos||0|number}}</span> <span class=\"text-boxed-light\">\n{{vm.doctor.ClientsData.percent.percent.countPhotos||0|number}} %</span></div></div></ms-widget-front><ms-widget-back \nng-click=\"flipWidget()\" class=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" type=\"button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" role=\"img\" \naria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></button></div><div>\nThis is the back side. You can show detailed information here.</div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" class=\"ms-widget\"><ms-widget-front \nng-click=\"flipWidget()\" class=\"h-170 p-16 light-blue-bg\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">סכום</div></div><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-display-1\" layout=\"row\" \nlayout-align=\"start center\"><span>{{vm.doctor.ClientsData.percent.data_A.data.Price||0|number}}</span><md-icon \nng-show=\"vm.doctor.ClientsData.percent.percent.Price>0\" md-font-icon=\"icon-trending-up\" class=\"s36 ml-16\"></md-icon>\n<md-icon ng-show=\"vm.doctor.ClientsData.percent.percent.Price<0\" md-font-icon=\"icon-trending-down\" class=\"s36 ml-16\">\n</md-icon></div><div layout=\"row\" layout-align=\"start center\"><span>\nאשתקד: {{vm.doctor.ClientsData.percent.data_B.data.Price||0|number}}</span> <span class=\"text-boxed-light\">\n{{vm.doctor.ClientsData.percent.percent.Price||0|number}} %</span></div></div></ms-widget-front><ms-widget-back \nng-click=\"flipWidget()\" class=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" type=\"button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" role=\"img\" \naria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></button></div><div>\nThis is the back side. You can show detailed information here.</div></ms-widget-back></ms-widget></div><div \nng-hide=\"true\" class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" class=\"ms-widget\"><ms-widget-front ng-click=\"flipWidget()\" \nclass=\"h-170 p-16 red-bg\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h4 font-weight-500 secondary-text\">קטגוריות</div></div><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"space-between\" flex><div ng-repeat=\"a in [\'ct\',\'panuramic\',\'status\',\'other\']\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"40\" layout=\"row\" layout-align=\"start center\">{{a}}:</div><div flex=\"60\" \nlayout=\"row\" layout-align=\"end center\"><span flex>1</span> <span flex><md-icon \nng-show=\"vm.doctor.ClientsData.percent.percent.countClients>0\" md-font-icon=\"icon-trending-up\" class=\"qml-16\">\n</md-icon><md-icon ng-show=\"vm.doctor.ClientsData.percent.percent.countClients<0\" md-font-icon=\"icon-trending-down\" \nclass=\"qml-16\"></md-icon></span>&nbsp; <span flex>12</span> <span class=\"text-boxed-light\" flex>\n{{vm.doctor.ClientsData.percent.percent.countClients||0|number}} %</span></div></div></div></ms-widget-front>\n<ms-widget-back ng-click=\"flipWidget()\" class=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" \ntype=\"button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" \nrole=\"img\" aria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></button></div><div>\nThis is the back side. You can show detailed information here.</div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" class=\"ms-widget\"><ms-widget-front \nng-click=\"flipWidget()\" class=\"h-170 p-16 red-bg\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"h4 font-weight-500 secondary-text\">פציינטים / צילומים</div></div><div class=\"white-fg\" layout=\"column\" \nflex><div layout=\"row\" layout-align=\"space-between center\"><div flex=\"40\" layout=\"row\" layout-align=\"start center\">\nפציינטים:</div><div flex=\"60\" layout=\"row\" layout-align=\"end center\"><span flex>\n{{vm.doctor.ClientsData.percent.data_B.data.countClients||0|number}}</span> <span flex><md-icon \nng-show=\"vm.doctor.ClientsData.percent.percent.countClients>0\" md-font-icon=\"icon-trending-up\" class=\"qml-16\">\n</md-icon><md-icon ng-show=\"vm.doctor.ClientsData.percent.percent.countClients<0\" md-font-icon=\"icon-trending-down\" \nclass=\"qml-16\"></md-icon></span>&nbsp; <span flex>{{vm.doctor.ClientsData.percent.data_A.data.countClients||0|number}}\n</span> <span class=\"text-boxed-light\" flex>{{vm.doctor.ClientsData.percent.percent.countClients||0|number}} %</span>\n</div></div><div layout=\"row\" layout-align=\"space-between center\"><div flex=\"40\" layout=\"row\" \nlayout-align=\"start center\">צילומים:</div><div flex=\"60\" layout=\"row\" layout-align=\"end center\"><span flex>\n{{vm.doctor.ClientsData.percent.data_A.data.countPhotos||0|number}}</span> <span flex><md-icon \nng-show=\"vm.doctor.ClientsData.percent.percent.countPhotos>0\" md-font-icon=\"icon-trending-up\" class=\"qml-16\"></md-icon>\n<md-icon ng-show=\"vm.doctor.ClientsData.percent.percent.countPhotos<0\" md-font-icon=\"icon-trending-down\" \nclass=\"qml-16\"></md-icon></span>&nbsp; <span flex>{{vm.doctor.ClientsData.percent.data_B.data.countPhotos||0|number}}\n</span> <span class=\"text-boxed-light\" flex>{{vm.doctor.ClientsData.percent.percent.countPhotos||0|number}} %</span>\n</div></div></div></ms-widget-front><ms-widget-back ng-click=\"flipWidget()\" class=\"p-16 light-blue-bg white-fg\"><div>\n<button class=\"md-icon-button\" type=\"button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\" role=\"img\" aria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div>\n</button></div><div>This is the back side. You can show detailed information here.</div></ms-widget-back></ms-widget>\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" class=\"ms-widget\">\n<ms-widget-front ng-click=\"flipWidget()\" class=\"h-170 p-16 red-bg\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">סכום</div></div><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-display-1\" layout=\"row\" \nlayout-align=\"start center\"><span>{{vm.doctor.ClientsData.percent.data_A.data.Price||0|number}}</span><md-icon \nng-show=\"vm.doctor.ClientsData.percent.percent.Price>0\" md-font-icon=\"icon-trending-up\" class=\"s36 ml-16\"></md-icon>\n<md-icon ng-show=\"vm.doctor.ClientsData.percent.percent.Price<0\" md-font-icon=\"icon-trending-down\" class=\"s36 ml-16\">\n</md-icon></div><div layout=\"row\" layout-align=\"start center\"><span>\nאשתקד: {{vm.doctor.ClientsData.percent.data_B.data.Price||0|number}}</span> <span class=\"text-boxed-light\">\n{{vm.doctor.ClientsData.percent.percent.Price||0|number}} %</span></div></div></ms-widget-front><ms-widget-back \nng-click=\"flipWidget()\" class=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" type=\"button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" role=\"img\" \naria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></button></div><div>\nThis is the back side. You can show detailed information here.</div></ms-widget-back></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget class=\"h-160\" layout=\"column\" flippable=\"true\" \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"75\"><ms-widget-front ng-click=\"flipWidget()\" class=\"p-16 white-bg\" layout=\"row\" \nflex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div class=\"header pb-8\">\nתקופה נוכחית: {{vm.dates.start|date:\'dd/MM/yy\'}} <span>- {{vm.dates.end|date:\'dd/MM/yy\'}}</span></div><div \nclass=\"header pb-8\">תקופה קודמת: {{vm.compare.start|date:\'dd/MM/yy\'}} <span ng-show=\"vm.compare.isEqual||true\">\n- {{vm.compare.end|date:\'dd/MM/yy\'}}</span></div><div class=\"font-weight-500 secondary-text\">\nההשוואה מתייחסת בהתאם לטווח הנ\"ל. לשינוי תקופת השוואה לחץ כאן</div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\" layout=\"row\" flex><md-datepicker ng-model=\"vm.compare.end\"></md-datepicker><div \nclass=\"font-weight-500 secondary-text mr-8\">לתאריך</div><md-datepicker ng-model=\"vm.compare.start\"></md-datepicker><div\n class=\"font-weight-500 secondary-text\">בין תאריך</div></div><div class=\"font-weight-500 secondary-text\"><md-button \nng-click=\"vm.refreshCompare();flipWidget()\">לחץ לאישור</md-button></div></div></ms-widget-back></ms-widget></div></div>\n</div></div></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>סיכום לפי סניפים</span></md-tab-label>\n<md-tab-body><md-content class=\"details-tab\"><div layout=\"row\" layout-align=\"start start\" layout-wrap ms-scroll flex>\n<div class=\"p-16\" layout=\"row\" flex=\"100\"><table-report flex feilds=\"vm.feildsPlaces\" \ndata=\"vm.doctor.ClientsData.summarybyplaces\" filterinput=\"vm.search\" date-report=\"vm.dates\" \nconfig=\"vm.config.summarybyplaces\" order-default=\"Name\"></table-report><div \nng-hide=\"vm.doctor.ClientsData.data.length\">אין נתונים</div></div></div><div layout=\"row\" layout-align=\"center center\" \nflex><md-button layout=\"row\" layout-align=\"center center\" class=\"md-raised md-primary\" \nng-click=\"vm.compareReport(\'sumbyplace\')\">השוואה לתקופה קודמת</md-button></div></md-content></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>פירוט צילומים/פציינטים</span></md-tab-label><md-tab-body><md-content class=\"billing-tab\">\n<div layout=\"row\" layout-align=\"start start\" layout-wrap ms-scroll flex><div class=\"p-16\" layout=\"row\" flex=\"100\">\n<table-report flex feilds=\"vm.ClientsReports.feilds\" data=\"vm.doctor.ClientsData.data\" filterinput=\"vm.search\" \ndate-report=\"vm.dates\" config=\"vm.config.clients\" order-default=\"ClientName\"></table-report><div \nng-hide=\"vm.doctor.ClientsData.data.length\">אין נתונים</div></div></div></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>סיכום לפי גורם משלם</span></md-tab-label><md-tab-body><md-content class=\"details-tab\"><div \nlayout=\"row\" layout-align=\"start start\" layout-wrap ms-scroll flex><div class=\"p-16\" layout=\"row\" flex=\"100\">\n<table-report flex feilds=\"vm.feildsInsurance\" data=\"vm.doctor.ClientsData.summarybyinsurance\" filterinput=\"vm.search\" \ndate-report=\"vm.dates\" config=\"vm.config.summarybyinsurance\" order-default=\"Name\"></table-report><div \nng-hide=\"vm.doctor.ClientsData.data.length\">אין נתונים</div></div></div><div layout=\"row\" layout-align=\"center center\" \nflex><md-button layout=\"row\" layout-align=\"center center\" class=\"md-raised md-primary\" \nng-click=\"vm.compareReport(\'summarybyinsurance\')\">השוואה לתקופה קודמת</md-button></div></md-content></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>סיכום קטגוריות צילום</span></md-tab-label><md-tab-body><md-content \nclass=\"details-tab\"><div layout=\"row\" layout-align=\"start start\" layout-wrap ms-scroll flex><div class=\"p-16\" \nlayout=\"row\" flex=\"100\"><table-report flex feilds=\"vm.feildsByCategory\" data=\"vm.doctor.ClientsData.summarybycategory\" \nfilterinput=\"vm.search\" date-report=\"vm.dates\" config=\"vm.config.summarybycategory\" order-default=\"Name\">\n</table-report><div ng-hide=\"vm.place.ClientsData.data.length\">אין נתונים</div></div></div><div layout=\"row\" \nlayout-align=\"center center\" flex><md-button layout=\"row\" layout-align=\"center center\" class=\"md-raised md-primary\" \nng-click=\"vm.compareReport(\'summarybycategory\')\">השוואה לתקופה קודמת</md-button></div></md-content></md-tab-body>\n</md-tab></md-tabs></div></div></div><div ng-if=\"false\" class=\"widget-group ltr\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget class=\"h-500\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\" layout=\"column\" \nlayout-align=\"space-between\" flex><div class=\"pb-16\"><div class=\"h4 weight-500 pb-8\">{{vm.widgetChartDayli.title}}\n</div><div class=\"secondary-text\">{{vm.widgetChartDayli.subtitle}}</div></div><div><c3chart class=\"c3 stroke-2\" \nbindto-id=\"io-rate1\"><chart-column ng-repeat=\"column in vm.widgetChartDayli.chart.columns\" column-id=\"{{column.id}}\" \ncolumn-name=\"{{column.name}}\" column-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"spline\">\n<chart-axes values-x=\"x\" y2=\"data2\"><chart-axis><chart-axis-x axis-position=\"outer-center\" axis-label=\"Number by 10\" \naxis-type=\"category\" show=\"false\"><chart-axis-x-tick tick-rotate=\"50\"></chart-axis-x><chart-axis-y show=\"true\">\n</chart-axis-y></chart-axis><chart-size chart-height=\"300\"></c3chart></div></ms-widget-front></ms-widget><ms-widget \nng-hide=\"true\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">תרשים לקוחות וצילומים</div><div \nclass=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button \nclass=\"ph-16 md-primary\" ng-class=\"{\'md-raised\':vm.ChartWidget.currentRange == key}\" \nng-repeat=\"(key, range) in vm.ChartWidget.ranges\" ng-click=\"vm.ChartWidget.changeRange(key)\">{{range}}</md-button>\n</div></div><div ng-hide=\"true\" layout=\"row\" layout-align=\"start center\" layout-wrap>{{vm.ChartWidget.data}}</div><div \nlayout=\"row\" layout-align=\"start start\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\"><nvd3 \nclass=\"h-420 remove-x-lines\" config=\"vm.ChartWidget.config\" options=\"vm.ChartWidget.options\" \ndata=\"vm.ChartWidget.data\"></nvd3></div><div ng-if=\"false\" class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\" \nlayout-wrap><div class=\"p-16\" layout=\"column\" flex=\"100\" layout-align=\"start start\"><div class=\"h4 secondary-text\">\nמחירים</div><div class=\"md-display-1\">25</div></div></div></div></ms-widget-front></ms-widget></div></md-content>\n<md-content ms-scroll ng-show=\"vm.tabstatus==2\" flex class=\"billing-tab\"><div class=\"content text-right\" \nlayout=\"column\"><div class=\"md-title mt-32\">פרטי רופא</div><div class=\"pb-16\">\nלעדכון הפרטים, נא להשלים את הנתונים בטופס להלן, ולחץ על כפתור שמור</div><div><a \nhref=\"tel:{{vm.doctor.Pel1||vm.doctor.Tel1}}\" class=\"md-button\">חייג</a> <a \nhref=\"waze://?q={{vm.addressEncode(vm.doctor.Address)}}\" target=\"_blank\" class=\"md-button\">נווט</a></div><div \nlayout=\"row\" layout-wrap><div flex=\"100\" flex-gt-sm=\"60\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate ng-submit=\"vm.changeDetails()\"><div class=\"form-title\">פרטי רופא\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"firstname\" \nng-model=\"vm.doctor.Name\" placeholder=\"שם\" required><div ng-messages=\"basicForm.firstname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex><input type=\"text\" name=\"Email1\" ng-model=\"vm.doctor.Email1\" placeholder=\"אימייל\" autocomplete=\"off\"><div \nng-messages=\"basicForm.Email1.$error\" role=\"alert\"><div ng-message=\"required\"><span>Email field is required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input \ntype=\"text\" name=\"Address\" ng-model=\"vm.doctor.Address\" placeholder=\"כתובת\" required><div \nng-messages=\"basicForm.Address.$error\" role=\"alert\"><div ng-message=\"required\"><span>Address field is required.</span>\n</div></div></md-input-container><md-input-container flex><label>תאריך לידה</label><input type=\"date\" name=\"date\" \nng-model=\"vm.doctor.BirthDate\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" name=\"Tel1\" ng-model=\"vm.doctor.Tel1\" placeholder=\"טלפון\"><div \nng-messages=\"basicForm.Tel1.$error\" role=\"alert\"><div ng-message=\"required\"><span>note field is required.</span></div>\n</div></md-input-container><md-input-container flex><input type=\"text\" name=\"Tel2\" ng-model=\"vm.doctor.Tel2\" \nplaceholder=\"טלפון נוסף\"><div ng-messages=\"basicForm.Tel2.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nnote field is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"Pel1\" \nng-model=\"vm.doctor.Pel1\" placeholder=\"נייד\"><div ng-messages=\"basicForm.Pel1.$error\" role=\"alert\"><div \nng-message=\"required\"><span>note field is required.</span></div></div></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"Fax1\" ng-model=\"vm.doctor.Fax1\" placeholder=\"פקס\"><div ng-messages=\"basicForm.Fax1.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>note field is required.</span></div></div></md-input-container></div><div\n layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><textarea rows=\"3\" name=\"NoteOUT\" \nng-model=\"vm.doctor.comments\" placeholder=\"הערות רופא (פרטים אלו בשליטת הרופא דרך הממשק רופאים)\"></textarea>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><textarea flex rows=\"4\" \ntype=\"text\" name=\"NoteOUT\" ng-model=\"vm.doctor.NoteOUT\" placeholder=\"הערות מערכת - מוצג בסניפים בלבד\"></textarea>\n</md-input-container></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">שמור</md-button></form></div></div><div flex=\"100\" \nflex-gt-sm=\"40\"><div class=\"form-wrapper form-data-wrapper md-whiteframe-1dp\" flex><div class=\"form-title\">\n{{(vm.doctor.username?\'שינוי סיסמא\':\'הגדר גישה למערכת רופאים\')}}</div><form name=\"loginNewForm\" class=\"md-inline-form\" \nnovalidate ng-submit=\"vm.createPassword()\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input \ntype=\"text\" name=\"username\" ng-model=\"vm.loginNewForm.username\" autocomplete=\"off\" placeholder=\"שם משתמש\" required><div\n ng-messages=\"loginNewForm.username.$error\" role=\"alert\"><div ng-message=\"required\"><span>שדה חובה</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" \nname=\"newpassword\" ng-model=\"vm.loginNewForm.pass\" placeholder=\" הגדר סיסמא 6 תוים לפחות\" ng-minlength=\"6\" required \nautocomplete=\"off\"><div ng-messages=\"loginNewForm.newpassword.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nשדה חובה</span></div></div></md-input-container></div><md-button type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"loginNewForm.$invalid || loginNewForm.$pristine\">\n{{(vm.doctor.username?\'הגדר סיסמא חדשה\':\'הגדר משתמש\')}}</md-button><md-button type=\"button\" \nng-show=\"vm.doctor.username\" class=\"md-raised md-warn\" aria-label=\"Submit\" \nng-click=\"vm.cancelDoctorPermission($event)\">מחק הרשאה לרופא</md-button></form></div></div></div></div></md-content>\n<md-content ng-show=\"vm.tabstatus==3\" flex class=\"billing-tab\"><div class=\"content text-right\" layout=\"column\"><div \nclass=\"widget-group ltr\" layout=\"row\" flex=\"100\" layout-wrap><div layout=\"row\" flex=\"100\"><div flex class=\"white-bg\">\n<div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nclass=\"pv-8 h3\">מחירון צילומים</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" \nflex-sm=\"100\"><md-input-container><input type=\"text\" ng-model=\"vm.searchprice\" placeholder=\"חיפוש\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"start start\" layout-wrap><div ms-scroll=\"\" \nclass=\"p-16\" layout=\"row\" flex=\"100\"><table-report flex feilds=\"vm.PricesDoctors.feilds\" \neditfeilds=\"vm.PricesDoctors.edit\" data=\"vm.doctor.Prices\" filter-input=\"vm.searchprice\" \non-edit-item=\"vm.editPriceDoctor\" on-remove-item=\"vm.deletePriceDoctor\" config=\"vm.PricesDoctors.config\" \norder-default=\"Name\"></table-report><div ng-hide=\"vm.doctor.Prices.length\">אין נתונים</div></div></div></div></div>\n</div></div></md-content><md-content ng-show=\"vm.tabstatus==4\" flex class=\"billing-tab\"><div \nclass=\"content text-right\" layout=\"column\"><div class=\"widget-group ltr\" layout=\"row\" flex=\"100\" layout-wrap><div \nlayout=\"row\" flex=\"100\"><div flex class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">תיבת הודעות</div><div class=\"pv-8\" layout=\"row\" \nlayout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-input-container><input type=\"text\" \nng-model=\"vm.searchMessage\" placeholder=\"חיפוש\"></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.sendNewMessage()\">שלח הודעה חדשה</md-button>\n</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><div ms-scroll=\"\" class=\"p-16\" layout=\"row\" flex=\"100\">\n<table-report flex feilds=\"vm.InboxDoctors.feilds\" data=\"vm.doctor.Inbox\" filter-input=\"vm.searchMessage\" \nconfig=\"vm.InboxDoctors.config\" order-default=\"-lastDate\"></table-report></div></div><div \nng-hide=\"vm.doctor.Inbox.length\" flex layout=\"row\" layout-align=\"center center\" class=\"h1\">אין הודעות</div><div \nlayout=\"row\" layout-align=\"center center\" ng-hide=\"vm.doctor.Inbox.length<5\"><md-button class=\"md-accent\" \nng-click=\"vm.sendNewMessage()\">שלח הודעה חדשה</md-button></div></div></div></div></div></md-content></div></div>");
$templateCache.put("app/main/employees/employee-card/employee-card.html","<div class=\"doctor or-header page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header smallheader md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span>&nbsp; <span class=\"logo-text\">\n{{vm.employee.Name}} : כרטיס עובד</span></div></div><div hide show-gt-xs class=\"search-input-wrapper logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-text\"></span></div></div><md-progress-linear \nng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" \nflex layout=\"row\" layout-align=\"start start\" ms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label><span>\nנוכחות עובד</span></md-tab-label><md-tab-body><md-content flex layout=\"column\" class=\"details-tab\" ms-scroll><div \nclass=\"widget-group ltr\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap>\n<div class=\"pv-8 h3\"><md-autocomplete md-autofocus=\"true\" md-search-text=\"searchText\" md-item-text=\"item.Name\" \nmd-selected-item-change=\"vm.selectedItem(item)\" placeholder=\"בחר עובד\" \nmd-items=\"item in vm.searchEmployee(searchText)\"><md-item-template><span md-highlight-text=\"searchText\">{{item.Name}}\n</span></md-item-template></md-autocomplete></div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"><or-date-between-buttons dates=\"vm.dates\" current-month=\"true\" \non-change=\"vm.refresh()\"></or-date-between-buttons></div></div><div layout=\"row\" layout-align=\"start start\" \nlayout-wrap><div class=\"p-16\" layout=\"row\" layout-align=\"end start \" flex=\"50\">\n{{vm.employee.workDays}} : ימי עבודה בדוח</div></div><div layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"p-16\" layout=\"row\" flex=\"100\"><table-report flex data=\"vm.employee.timework\" feilds=\"vm.table.feilds\" \neditfeilds=\"vm.table.edit\" config=\"vm.table.config\" on-edit-item=\"vm.editItem\" on-insert-item=\"vm.addEmployee\" \non-remove-item=\"vm.removeItem\" filter-input=\"vm.search\" order-default=\"Dates\"></table-report><div \nng-hide=\"vm.doctor.ClientsData.data.length\">אין נתונים</div></div></div><div layout=\"row\" layout-align=\"start start\" \nlayout-wrap><div class=\"p-16\" layout=\"row\" layout-align=\"end start \" flex=\"100\">\n{{vm.employee.workDays}} : ימי עבודה בדוח</div></div></ms-widget-front></ms-widget></div></md-content></md-tab-body>\n</md-tab></md-tabs></div></div>");
$templateCache.put("app/main/insurance/klalit-report/klalit-report.html","<div id=\"insuranceReport\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\">\n</md-icon></span>&nbsp; <span class=\"logo-text\">דוח כללית בלבד</span> <span hide show-gt-md class=\"logo-text\">\n&nbsp; ליום: {{vm.dates.start|date}}</span></div><div class=\"mt-16\" layout=\"row\" layout-align=\"start center\"></div>\n</div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-input-container \nmd-no-float class=\"m-0\"><input id=\"search\" ng-change=\"vm.showAdvancedSearch=true\" type=\"text\" ng-model=\"vm.search\" \nplaceholder=\"חיפוש\"></md-input-container></div></div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" \nclass=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" flex layout=\"column\" \nlayout-align=\"start start\"><div layout=\"row\" flex><or-date-between-buttons dates=\"vm.dates\" on-change=\"vm.refresh()\">\n</or-date-between-buttons><md-button class=\"md-raised md-primary\" ng-click=\"vm.OpenUploadDialog()\">ייבוא מקובץ אקסל\n</md-button></div><div flex=\"\" layout=\"row\"><div flex=\"100\" class=\"m-10 groups md-whiteframe-1dp\" layout=\"column\">\n<header class=\"md-accent-bg\" layout=\"row\" layout-align=\"end center\"><div class=\"title dir-rtl\" flex>פירוט מצב סניפים\n</div></header><div class=\"content dir-rtl\"><table-report feilds=\"vm.feilds\" data=\"vm.data\" config=\"vm.config\" \norder-default=\"Name\" filter-input=\"vm.search\"></table-report></div><footer layout=\"row\" class=\"dir-rtl\" \nlayout-align=\"space-between center\"><div layout=\"row\" class=\"md-title\" flex><div flex=\"50\">סוף דוח</div></div></footer>\n</div></div><div flex id=\"\"><md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>\nאין תוצאות</p></md-list-item></div></div></div>");
$templateCache.put("app/main/insurance/new_agreement/new_agreement.html","<md-dialog class=\"new_agreement-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-primary md-tall tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת הסכם מרפאה / ביטוח</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll class=\"ng-form\" name=\"dialogForm\"><md-input-container \nclass=\"md-icon-float md-block\"><label flex=\"50\">שם ביטוח/מרפאה</label><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><input name=\"Name\" ng-model=\"vm.insurance.Name\" required type=\"text\" ng-minlength=\"4\" \nmd-autofocus><div ng-messages=\"dialogForm.Name.$error\"><div ng-message=\"required\">שדה חובה</div><div \nng-message=\"minlength\">מינימום 4 תוים</div></div></md-input-container><md-input-container class=\"md-block\"><label>\nבחר סוג הסכם</label><md-select ng-model=\"vm.insurance.type\" required><md-option ng-value=\"1\">ביטוח</md-option>\n<md-option ng-value=\"0\">הסכם קיבוצי</md-option></md-select></md-input-container><div ng-if=\"vm.insurance.type==0\">\n<md-list ng-cloak><md-subheader class=\"md-no-sticky\">בחר מרפאה לצירוף הסכם</md-subheader><md-input-container \nclass=\"md-icon-float md-block\"><label flex=\"50\">חפש מרפאה</label><md-icon md-font-icon=\"icon-account\" class=\"name\">\n</md-icon><input ng-model=\"vm.search\" type=\"text\" ng-minlength=\"3\" ng-change=\"vm.searchDoctor()\"></md-input-container>\n<h1 ng-hide=\"!vm.doctors.length||queryFil.length\">אין תוצאות</h1><div ng-hide=\"vm.doctors.length\">טוען רשימת רופאים....\n</div><md-radio-group layout=\"column\" ng-model=\"vm.insurance.doctor\" required><md-radio-button \nng-repeat=\"doc in vm.doctors|filter:vm.search|limitTo :10|filter: query as queryFil\" ng-value=\"doc\">{{doc.Name}}\n</md-radio-button></md-radio-group></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.submit()\" class=\"send-button md-accent md-raised font-size-12 saveBtn\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\">אישור</md-button></div><div \nng-show=\"vm.insurance.type==0\" layout=\"row\" layout-align=\"end center\"><label class=\"pr-8\">ייבא מחירונים</label>\n<md-checkbox class=\"md-secondary\" ng-model=\"vm.insurance.photoprice\"></md-checkbox></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/insurance/prices/prices.html","<div id=\"insurance\" class=\"page-layout simple tabbed\"><div class=\"fheader header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" flex layout-align=\"start center\"><div flex class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.addAgreement()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>הוסף הסכם מרפאה/ביטוח</md-button></div><div flex class=\"logo\" layout=\"row\" \nlayout-align=\"end center\"></div><div flex class=\"logo\" layout=\"row\" layout-align=\"start center\"><md-select flex \nng-model=\"vm.insuranceid\" md-on-open=\"vm.focusSearch()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchselect\" id=\"s_search\" type=\"text\" placeholder=\"הקש ערך לחיפוש\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option \nng-repeat=\"ins in vm.factorPays|filter:searchselect |filter:{BituahID:\'!1\'}:true\" ng-value=\"ins.BituahID\">{{ins.Name}}\n</md-option></md-select><div layout=\"row\" layout-align=\"end center\" flex class=\"logo-text\">בחר הסכם ביטוח</div></div>\n</div></div><div class=\"content\" ng-show=\"vm.allowPage\" flex><md-divider></md-divider><md-content \nclass=\"details-tab p-16\"><or-insurance data=\"vm.InsurancePrices\" insurance-id=\"vm.insuranceid\"></or-insurance>\n</md-content>--></div><div class=\"content\" ng-hide=\"vm.allowPage\" flex layout=\"row\" layout-align=\"center center\">\n<ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-md=\"60\" flex-gt-xs=\"50\"><ms-widget-front \nclass=\"p-16 grey-bg white-fg\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-3 pb-8\">אין הרשאות</div></div><div class=\"background-image-center\"><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/insurance/summary/summary.html","<div id=\"placeReport\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\">\n</md-icon></span>&nbsp; <span class=\"logo-text\">דוח ביטוחים לסניפי מנהל</span> <span hide show-gt-md class=\"logo-text\">\n&nbsp; ליום: {{vm.dates.start|date}}</span></div><div class=\"mt-16\" layout=\"row\" layout-align=\"start center\"></div>\n</div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-input-container \nmd-no-float class=\"m-0\"><input id=\"search\" ng-change=\"vm.showAdvancedSearch=true\" type=\"text\" ng-model=\"vm.search\" \nplaceholder=\"חיפוש\"></md-input-container></div></div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" \nclass=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\">\n<div><or-date-between-buttons dates=\"vm.dates\" on-change=\"vm.refresh(vm.dates)\"></or-date-between-buttons></div><div \nflex=\"\" layout=\"row\"><div flex=\"100\" class=\"m-10 groups md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"end center\"><div class=\"title dir-rtl\" flex>דוח ביטוחים</div></header>\n<div class=\"content dir-rtl\"><table-report ng-hide=\"vm.reportType\" feilds=\"vm.InsuranceReports.feilds\" \nconfig=\"vm.InsuranceReports.configTbl\" data=\"vm.InsuranceReports.data1\" order-default=\"Name\"></table-report>\n<table-report ng-show=\"vm.reportType\" feilds=\"vm.InsuranceReports.feilds\" config=\"vm.InsuranceReports.configTbl\" \ndata=\"vm.InsuranceReports.data2\" order-default=\"Name\"></table-report></div><footer layout=\"row\" class=\"dir-rtl\" \nlayout-align=\"space-between center\"><div layout=\"row\" class=\"md-title\" flex><div flex=\"50\" class=\"p-5\"><md-radio-group \nlayout=\"row\" ng-model=\"vm.reportType\"><md-radio-button class=\"p-5\" ng-value=\"0\">סכום הכל</md-radio-button>\n<md-radio-button class=\"p-5\" ng-value=\"1\">לא נפרע</md-radio-button></md-radio-group></div></div></footer></div></div>\n<div flex id=\"\"><md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p>\n</md-list-item></div></div></div><div ng-if=\"false\" id=\"insurance\" class=\"page-layout simple\"><div \nclass=\"fheader header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" flex \nlayout-align=\"start center\"><div class=\"logo pr-10\" flex layout=\"row\" layout-align=\"end center\"><span \nclass=\"logo-text\">ביטוחים</span></div></div></div><div class=\"content scrollable\" flex layout=\"row\" \nlayout-align=\"end start\"><div class=\"main\" flex=\"50\" ms-scroll id=\"contactslist\"><md-list class=\"contacts-list\">\n<or-date-between-buttons dates=\"vm.dates\" on-change=\"vm.refresh(vm.dates)\"></or-date-between-buttons><div \nclass=\"content m-10\" flex layout=\"row\" layout-align=\"start start\"><div layout=\"column\" flex layout-align=\"end center\">\n<div layout=\"row\" flex=\"\"><md-radio-group ng-model=\"vm.reportType\"><md-radio-button ng-value=\"0\">הכל</md-radio-button>\n<md-radio-button ng-value=\"1\">לא נפרע</md-radio-button></md-radio-group></div></div></div></md-list></div></div></div>");
$templateCache.put("app/main/insurance/reports/reports.html","<div id=\"insuranceReport\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\">\n</md-icon></span>&nbsp; <span class=\"logo-text\">דוח ביטוחים</span> <span hide show-gt-md class=\"logo-text\">\n&nbsp; ליום: {{vm.dates.start|date}}</span></div><div class=\"mt-16\" layout=\"row\" layout-align=\"start center\"></div>\n</div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-input-container \nmd-no-float class=\"m-0\"><input id=\"search\" ng-change=\"vm.showAdvancedSearch=true\" type=\"text\" ng-model=\"vm.search\" \nplaceholder=\"חיפוש\"></md-input-container></div></div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" \nclass=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" flex layout=\"column\" \nlayout-align=\"start start\"><div layout=\"row\" flex><or-date-between-buttons dates=\"vm.dates\" on-change=\"vm.refresh()\">\n</or-date-between-buttons><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><md-select flex \nng-model=\"vm.insuranceid\" md-on-open=\"vm.focusSearch()\" ng-change=\"vm.refresh()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchselect\" id=\"s_search\" type=\"text\" placeholder=\"הקש ערך לחיפוש\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option \nng-repeat=\"ins in vm.factorPays|filter:searchselect |filter:{BituahID:\'!1\'}:true\" ng-value=\"ins.BituahID\">{{ins.Name}}\n</md-option></md-select></div></div><div flex=\"\" layout=\"row\"><div flex=\"100\" class=\"m-10 groups md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"end center\"><div class=\"title dir-rtl\" flex>\nפירוט מצב סניפים</div></header><div class=\"content dir-rtl\"><table-report feilds=\"vm.feilds\" data=\"vm.data\" \norder-default=\"Name\" filter-input=\"{InsuranceID:vm.insuranceid}\"></table-report></div><footer layout=\"row\" \nclass=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" class=\"md-title\" flex><div flex=\"50\">סוף דוח\n</div></div></footer></div></div><div flex id=\"\"><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item></div></div></div>");
$templateCache.put("app/main/inventories/items/items.html","<div id=\"_inventories_items\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header smallheader md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span>&nbsp; <span class=\"logo-text\">ניהול מוצרים</span></div>\n</div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-input-container \nmd-no-float class=\"m-0\"><input id=\"search\" type=\"text\" ng-model=\"vm.search\" placeholder=\"חפש\"></md-input-container>\n</div></div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear>\n<div class=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\"><div class=\"main\" flex ms-scroll \nid=\"contactslist\"><div class=\"widget-group\" ng-if=\"false\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget \nclass=\"h-140\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"h3 font-weight-500\"><md-input-container><input \nplaceholder=\"חיפוש\" ng-model=\"vm.search\"></md-input-container></div></div></ms-widget-front></ms-widget></div><md-list \nclass=\"contacts-list\"><table-report config=\"vm.config\" feilds=\"vm.feilds\" data=\"vm.data\" on-insert-item=\"vm.InsertRow\" \non-edit-item=\"vm.EditRow\" editfeilds=\"vm.editfeilds\" order-default=\"-date\" filter-input=\"vm.search\"></table-report><div\n ng-show=\"vm.data.length\" layout-align=\"center center\" layout=\"row\" flex><md-button class=\"md-accent md-raised\" \nng-disabled=\"vm.proccess\" ng-click=\"vm.refresh(true)\">רענן</md-button></div><ms-widget ng-hide=\"vm.data.length\" \nclass=\"h-300\" layout=\"column\" flex><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"md-display-3 pb-8 md-default-theme\"><span>\nלא נמצאו פריטים ב {{vm.search||vm.title}}</span></div><div class=\"h3 font-weight-500\"></div></div></ms-widget-front>\n</ms-widget></md-list><md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>\nאין תוצאות</p></md-list-item></div></div></div>");
$templateCache.put("app/main/inventories/order/inventories_order.html","<div id=\"inventories_order\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header smallheader md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span>&nbsp; <span class=\"logo-text\">הזמנה #{{vm.order.ID}}\n</span></div></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-primary md-raised\" ng-disabled=\"vm.order.status>=4\" ng-click=\"vm.UpdateStatus()\">אשר הזמנה\n</md-button><md-button class=\"md-primary md-raised\" ng-show=\"vm.order.status==4\" ng-click=\"vm.UpdateStatus(5)\">\nהפק תעודת משלוח</md-button><md-button class=\"md-warn md-raised\" ng-show=\"vm.order.status==5\" \nng-click=\"vm.UpdateStatus(6)\">הוצא משלוח</md-button><md-menu><md-button aria-label=\"Open demo menu\" \nclass=\"md-primary md-raised\" ng-hide=\"vm.order.status>=6\" ng-click=\"$mdOpenMenu()\">עדכון סטטוס {{vm.order.status}}\n</md-button><md-menu-content><md-menu-item ng-repeat=\"item in vm.statuses_option\" \nng-show=\"item.ID<6&&(item.ID>=0&&vm.order.status<4?item.ID<4:true)\"><md-button ng-click=\"vm.selectStatus(item.ID)\" \nng-disabled=\"vm.disabledStatus(item)\"><span md-menu-align-target>{{item.status_name}}</span>&nbsp;<md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" ng-show=\"item.ID==vm.order.status\"></md-icon></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" \nclass=\"md-primary\"></md-progress-linear><md-tabs md-dynamic-height md-selected=\"vm.selectedIndex\"><md-tab>\n<md-tab-label><span>פרטי הזמנה</span></md-tab-label><md-tab-body><md-content class=\"details-tab\"><div \nclass=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\"><div class=\"md-whiteframe-8dp\" layout=\"column\" \nlayout-gt-md=\"row\" flex layout-wrap><div class=\"timeline p-8\" layout=\"column\" flex=\"100\" flex-gt-sm=\"55\" \nflex-gt-md=\"65\" flex-order=\"2\" flex-order-gt-sm=\"1\"><div class=\"profile-box latest-activity md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"form content dir-rtl\" flex><div layout=\"column\" class=\"m-8\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"tz\" placeholder=\"מספר הזמנה\" \ndisabled=\"disabled\" ng-model=\"vm.order.ID\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input \ntype=\"text\" name=\"tz\" placeholder=\"סטטוס הזמנה\" disabled=\"disabled\" ng-model=\"vm.order.status_name\">\n</md-input-container></div><div layout=\"column\" class=\"m-8\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"place\" placeholder=\"סניף\" disabled=\"disabled\" ng-model=\"vm.order.placeName\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"place\" \nplaceholder=\"שם המזמין\" disabled=\"disabled\" ng-model=\"vm.order.employeeName\"></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"date\" name=\"birthdate\" ng-disabled=\"true\" ng-model=\"vm.order.date_created\" \nplaceholder=\"תאריך \"></md-input-container></div><div layout=\"column\" class=\"m-8\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><textarea name=\"place\" placeholder=\"הערות סניף\" disabled=\"disabled\" \nng-model=\"vm.order.comments_place\"></textarea></md-input-container></div><div layout=\"column\" class=\"m-8\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><textarea name=\"place\" placeholder=\"הערות מחסן\" \nng-model=\"vm.order.comments_stockeeper\"></textarea></md-input-container></div></div><footer layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \naria-label=\"insert photo\" translate ng-click=\"vm.printDetails(event)\" translate-attr-aria-label=\"PROFILE.INSERT_PHOTO\">\n<md-icon md-font-icon=\"icon-printer\"></md-icon><md-tooltip><span>הדפס</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"add person\" translate ng-click=\"vm.editProfileClick(event)\" \ntranslate-attr-aria-label=\"PROFILE.ADD_PERSON\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon><md-tooltip><span>\nעריכת פרטים</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"add location\" translate \nng-click=\"vm.SippingDetails(event)\" translate-attr-aria-label=\"PROFILE.LOCATION\"><md-icon \nmd-font-icon=\"icon-wallet-travel\"></md-icon><md-tooltip><span>פרטי משלוח</span></md-tooltip></md-button></div>\n<md-button ng-click=\"vm.updateClientDetails()\" class=\"post-button md-accent md-raised\" aria-label=\"POST\">עדכן הערות\n</md-button></footer></div></div></div></div></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>\nפירוט הזמנה</span></md-tab-label><md-tab-body><md-content class=\"details-tab\"><div class=\"content scrollable\" flex \nlayout=\"row\" layout-align=\"start start\"><div class=\"main\" flex ms-scroll id=\"contactslist\"><md-list \nclass=\"contacts-list\"><table-report config=\"vm.config\" feilds=\"vm.feilds\" data=\"vm.order.items\" on-edit-item=\"\" \non-remove-item=\"vm.remove\" editfeilds=\"vm.feildsedit\" order-default=\"-KDate\" filter-input=\"vm.search\"></table-report>\n<div ng-show=\"vm.inventories.length\" layout-align=\"center center\" layout=\"row\" flex><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.clear()\">הצג הכל</md-button></div></md-list><md-list-item \nclass=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item></div></div>\n</md-content></md-tab-body></md-tab><md-tab ng-disabled=\"vm.order.status<5\"><md-tab-label><span>תעודת משלוח</span>\n</md-tab-label><md-tab-body><md-content class=\"details-tab\"><div class=\"content scrollable\" flex layout=\"row\" \nlayout-align=\"start start\"><div class=\"main\" flex ms-scroll id=\"contactslist\"><md-list class=\"contacts-list\">\n<table-report config=\"vm.config2\" feilds=\"vm.feilds_ship\" data=\"vm.items_ship\" order-default=\"-KDate\" \nfilter-input=\"vm.search\"></table-report></md-list><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item></div></div></md-content></md-tab-body>\n</md-tab></md-tabs></div>");
$templateCache.put("app/main/inventories/suppliers/suppliers.html","<div id=\"suppliers_items\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header smallheader md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span>&nbsp; <span class=\"logo-text\">ניהול ספקים</span></div>\n</div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-input-container \nmd-no-float class=\"m-0\"><input id=\"search\" type=\"text\" ng-model=\"vm.search\" placeholder=\"חפש\"></md-input-container>\n</div></div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear>\n<div class=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\"><div class=\"main\" flex ms-scroll \nid=\"contactslist\"><div class=\"widget-group\" ng-if=\"false\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget \nclass=\"h-140\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"h3 font-weight-500\"><md-input-container><input \nplaceholder=\"חיפוש\" ng-model=\"vm.search\"></md-input-container></div></div></ms-widget-front></ms-widget></div><md-list \nclass=\"contacts-list\"><table-report config=\"vm.config\" feilds=\"vm.feilds\" data=\"vm.data\" on-insert-item=\"vm.InsertRow\" \non-edit-item=\"vm.EditRow\" editfeilds=\"vm.editfeilds\" order-default=\"-date\" filter-input=\"vm.search\"></table-report><div\n ng-show=\"vm.data.length\" layout-align=\"center center\" layout=\"row\" flex><md-button class=\"md-accent md-raised\" \nng-disabled=\"vm.proccess\" ng-click=\"vm.refresh(true)\">רענן</md-button></div><ms-widget ng-hide=\"vm.data.length\" \nclass=\"h-300\" layout=\"column\" flex><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"md-display-3 pb-8 md-default-theme\"><span>\nלא נמצאו פריטים ב {{vm.search||vm.title}}</span></div><div class=\"h3 font-weight-500\"></div></div></ms-widget-front>\n</ms-widget></md-list><md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>\nאין תוצאות</p></md-list-item></div></div></div>");
$templateCache.put("app/main/inventories/tracking/inventories_tracking.html","<div id=\"inventories\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header smallheader md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span>&nbsp; <span class=\"logo-text\">מצב מלאי סניפים</span>\n</div></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\">\n<md-input-container md-no-float class=\"m-0\"><input id=\"search\" type=\"text\" ng-model=\"vm.search\" placeholder=\"חפש\">\n</md-input-container></div></div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\">\n</md-progress-linear><div class=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\"><div class=\"main\" \nflex ms-scroll id=\"contactslist\"><div class=\"widget-group\" ng-if=\"false\" layout=\"row\" flex=\"100\" layout-wrap=\"\">\n<ms-widget class=\"h-140\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div \nlayout=\"row\" layout-align=\"space-between center\" flex><div class=\"h3 font-weight-500\"><md-input-container><input \nplaceholder=\"חיפוש\" ng-model=\"vm.search\"></md-input-container></div></div></ms-widget-front></ms-widget></div><md-list \nclass=\"contacts-list\"><table-report config=\"vm.config\" feilds=\"vm.feilds\" data=\"vm.data\" order-default=\"-place_name\" \nfilter-input=\"vm.search\"></table-report><div ng-show=\"vm.data.length\" layout-align=\"center center\" layout=\"row\" flex>\n<md-button class=\"md-accent md-raised\" ng-disabled=\"vm.proccess\" ng-click=\"vm.refresh(true)\">רענן</md-button></div>\n<ms-widget ng-hide=\"vm.data.length\" class=\"h-300\" layout=\"column\" flex><ms-widget-front class=\"p-16 white-bg\" \nlayout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-3 pb-8 md-default-theme\"><span>לא נמצאו פריטים ב {{vm.search||vm.title}}</span></div><div \nclass=\"h3 font-weight-500\"></div></div></ms-widget-front></ms-widget></md-list><md-list-item \nclass=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item></div></div>\n</div>");
$templateCache.put("app/main/inventories/tracking_history/tracking_history.html","<div id=\"inventories\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header smallheader md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span>&nbsp; <span class=\"logo-text\">תנועות מלאי</span></div>\n</div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-input-container \nmd-no-float class=\"m-0\"><input id=\"search\" type=\"text\" ng-model=\"vm.search\" placeholder=\"חפש\"></md-input-container>\n</div></div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear>\n<div class=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\"><div class=\"main\" flex ms-scroll \nid=\"contactslist\"><div class=\"widget-group\" ng-if=\"false\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget \nclass=\"h-140\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"h3 font-weight-500\"><md-input-container><input \nplaceholder=\"חיפוש\" ng-model=\"vm.search\"></md-input-container></div></div></ms-widget-front></ms-widget></div><md-list \nclass=\"contacts-list\"><table-report config=\"vm.config\" feilds=\"vm.feilds\" data=\"vm.data\" on-insert-item=\"vm.InsertRow\" \neditfeilds=\"vm.editfeilds\" order-default=\"-date\" filter-input=\"vm.search\"></table-report><div ng-show=\"vm.data.length\" \nlayout-align=\"center center\" layout=\"row\" flex><md-button class=\"md-accent md-raised\" ng-disabled=\"vm.proccess\" \nng-click=\"vm.refresh(true)\">רענן</md-button></div><ms-widget ng-hide=\"vm.data.length\" class=\"h-300\" layout=\"column\" \nflex><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex>\n<div class=\"md-display-3 pb-8 md-default-theme\"><span>לא נמצאו פריטים ב {{vm.search||vm.title}}</span></div><div \nclass=\"h3 font-weight-500\"></div></div></ms-widget-front></ms-widget></md-list><md-list-item \nclass=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item></div></div>\n</div>");
$templateCache.put("app/main/pages/coming-soon/coming-soon.html","<div id=\"coming-soon\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"coming-soon-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"coming-soon-form\" class=\"md-whiteframe-8dp\"><div class=\"top\"><div\n class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"COMINGSOON.TITLE\">\nHey! Thank you for checking out our app.</div><div class=\"subtitle\" translate=\"COMINGSOON.SUBTITLE\">\nIt’s not quite ready yet, but we are working hard and it will be ready in approximately:</div><timer \nend-time=\"vm.endTime\" layout=\"row\" layout-wrap><div flex-xs=\"50\"><div class=\"value\">{{days}}</div><div class=\"type\" \ntranslate=\"COMINGSOON.DAYS\">days</div></div><div flex-xs=\"50\"><div class=\"value\">{{hours}}</div><div class=\"type\" \ntranslate=\"COMINGSOON.HOURS\">hours</div></div><div flex-xs=\"50\"><div class=\"value\">{{minutes}}</div><div class=\"type\" \ntranslate=\"COMINGSOON.MINUTES\">minutes</div></div><div flex-xs=\"50\"><div class=\"value\">{{seconds}}</div><div \nclass=\"type\" translate=\"COMINGSOON.SECONDS\">seconds</div></div></timer></div><form><div class=\"message\" \ntranslate=\"COMINGSOON.MESSAGE\">\nIf you would like to be notified when the app is ready, you can subscribe to our e-mail list.</div><md-input-container \nflex md-no-float><input type=\"email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"COMINGSOON.EMAIL_ADRESS\"></md-input-container><md-button class=\"md-raised md-accent\" \naria-label=\"SUBSCRIBE\" translate=\"COMINGSOON.SUBSCRIBE\" translate-attr-aria-label=\"COMINGSOON.SUBSCRIBE\">SUBSCRIBE\n</md-button></form></div></div></div>");
$templateCache.put("app/main/pages/maintenance/maintenance.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"MAINTENANCE.TITLE\">\nClosed for scheduled maintenance!</div><div class=\"subtitle\" translate=\"MAINTENANCE.SUBTITLE\">\nWe\'re sorry for the inconvenience.<br>Please check back later.</div></div></div></div>");
$templateCache.put("app/main/pages/search/search.html","<div id=\"search\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input\" ng-model=\"vm.search\" \ntype=\"text\" placeholder=\"Search..\" translate translate-attr-placeholder=\"SEARCH.SEARCH\" flex></div><md-menu \nclass=\"search-settings\" md-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Search settings\" translate translate-attr-aria-label=\"SEARCH.SEARCH_SETTINGS\">\n<md-icon md-menu-origin md-menu-align-target md-font-icon=\"icon-cog\" class=\"icon s16\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\">\n</md-icon><span translate=\"SEARCH.SETTINGS_1\">Settings 1</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\"></md-icon><span translate=\"SEARCH.SETTINGS_2\">Settings 2\n</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"content\" flex><md-tabs \nmd-dynamic-height><md-tab label=\"Classic\"><md-content class=\"classic-tab\" \nng-include=\"\'app/main/pages/search/tabs/classic/classic.html\'\"></md-content></md-tab><md-tab label=\"Emails\"><md-content\n class=\"emails-tab\" ng-include=\"\'app/main/pages/search/tabs/emails/emails.html\'\"></md-content></md-tab><md-tab \nlabel=\"Users\"><md-content class=\"users-tab\" ng-include=\"\'app/main/pages/search/tabs/users/users.html\'\"></md-content>\n</md-tab><md-tab label=\"Contacts\"><md-content class=\"contacts-tab\" \nng-include=\"\'app/main/pages/search/tabs/contacts/contacts.html\'\"></md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/timeline/timeline-left.html","<div id=\"timeline\" class=\"timeline-left\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\">\n<div ms-timeline-item layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" \nlayout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in vm.timeline\"><div \nclass=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon></div>\n<div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.time}}</div><div class=\"event\">\n{{timelineItem.event}}</div></div><div class=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card \ntemplate=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div></div></div>");
$templateCache.put("app/main/pages/timeline/timeline-right.html","<div id=\"timeline\" class=\"timeline-right\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\">\n<div ms-timeline-item layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" \nlayout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in vm.timeline\"><div \nclass=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon></div>\n<div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.time}}</div><div class=\"event\">\n{{timelineItem.event}}</div></div><div class=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card \ntemplate=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div></div></div>");
$templateCache.put("app/main/pages/timeline/timeline.html","<div id=\"timeline\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\"><div ms-timeline-item \nlayout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" layout-align-gt-md=\"center start\" \nng-repeat=\"timelineItem in vm.timeline\"><div class=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon \nmd-font-icon=\"{{timelineItem.icon}}\"></md-icon></div><div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">\n{{timelineItem.time}}</div><div class=\"event\">{{timelineItem.event}}</div></div><div class=\"timeline-card\" \nlayout=\"row\" flex=\"50\"><ms-card template=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div>\n</div></div>");
$templateCache.put("app/main/profile/dialog/register_copyrator.html","<md-dialog class=\"register_copyrator\" aria-label=\"New Task\"><div class=\"profile-box latest-activity md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"end center\"><md-button class=\"\" \nng-click=\"vm.cancel()\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-close\" \nclass=\"icon\" ng-click=\"vm.removeCheck(check,$index)\"></md-icon></md-button><div flex=\"90\" class=\"title dir-rtl\">\nשם המצלם</div></header><div class=\"content dir-rtl\" layout=\"row\" flex layout-wrap><div class=\"activity\" layout=\"row\" \nflex=\"\" layout-align=\"start start\"><div layout=\"row\" flex><div class=\"m-8 profile-box\" flex><div layout=\"row\" \nclass=\"m-8\" flex><md-input-container layout=\"row\" flex><input type=\"text\" ng-model=\"vm.search\" \nplaceholder=\"הקש שם מצלם\"></md-input-container></div><div layout=\"row\" layout-align=\"center center\" \nng-hide=\"vm.search.length\"><center><h2 flex>הקש שם מצלם</h2></center></div><md-list ng-show=\"vm.search.length\" flex \nms-scroll><md-list-item ng-repeat=\"copyrator in vm.copyrators| filter:vm.search|limitTo:5\" \nng-click=\"vm.selectEmployee(copyrator.OvedID, $event)\" class=\"noright\"><img alt=\"{{ copyrator.Name }}\" \nng-src=\"assets/images/avatars/profile.jpg\" class=\"md-avatar\"><p>{{ copyrator.Name }}</p></md-list-item></md-list></div>\n</div></div></div></div></md-dialog>");
$templateCache.put("app/main/reports/placesReport/places_report.html","<div id=\"placeReport\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\">\n</md-icon></span>&nbsp; <span class=\"logo-text\">דוח סניפים</span> <span hide show-gt-md class=\"logo-text\">\n&nbsp; ליום: {{vm.dates.start|date}}</span></div><div class=\"mt-16\" layout=\"row\" layout-align=\"start center\"></div>\n</div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-input-container \nmd-no-float class=\"m-0\"><input id=\"search\" ng-change=\"vm.showAdvancedSearch=true\" type=\"text\" ng-model=\"vm.search\" \nplaceholder=\"חיפוש\"></md-input-container></div></div><md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" \nclass=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\" \nms-scroll><div><or-date-between-buttons dates=\"vm.dates\" on-change=\"vm.refresh(vm.dates)\"></or-date-between-buttons>\n</div><div ng-show=\"vm.ClientsReports.data.admin\" flex=\"\" layout=\"row\" layout-wrap><div flex=\"100\" \nclass=\"m-10 groups md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title dir-rtl\" flex>פירוט מנהלים</div></header><div class=\"content dir-rtl\" \nlayout=\"row\"><table-report flex ng-hide=\"vm.reportType\" feilds=\"vm.ClientsReports.feildsAdmin\" \ndata=\"vm.ClientsReports.data.admin\" filter-input=\"vm.search\" config=\"vm.ClientsReports.configAdmin\" \ndate-report=\"vm.dates\" order-default=\"Name\"></table-report></div><footer layout=\"row\" class=\"dir-rtl\" \nlayout-align=\"space-between center\"><div layout=\"row\" class=\"md-title\" flex><div flex=\"50\"><div flex=\"50\">&nbsp;</div>\n</div></div></footer></div></div><div flex=\"\" layout=\"row\" layout-wrap><div flex=\"100\" flex-gt-sm=\"45\" \nclass=\"m-10 groups md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title dir-rtl\" flex>פירוט מצב סניפים</div></header><div class=\"content dir-rtl\" \nlayout=\"row\"><table-report flex ng-hide=\"vm.reportType\" feilds=\"vm.ClientsReports.feilds\" \ndata=\"vm.ClientsReports.data.place\" filter-input=\"vm.search\" config=\"vm.ClientsReports.config\" date-report=\"vm.dates\" \norder-default=\"Name\"></table-report></div><footer layout=\"row\" class=\"dir-rtl\" layout-align=\"space-between center\"><div\n layout=\"row\" class=\"md-title\" flex><div flex=\"50\"><div flex=\"50\">&nbsp;</div></div></div></footer></div><div \nflex=\"100\" flex-gt-sm=\"45\" class=\"m-10 groups md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"title dir-rtl\" flex>פירוט תקבולים</div></header><div \nclass=\"content dir-rtl\" layout=\"row\"><table-report flex ng-hide=\"vm.reportType\" feilds=\"vm.MoneyReports.feilds\" \ndata=\"vm.MoneyReports.data\" date-report=\"vm.dates\" filter-input=\"vm.search\" config=\"vm.ClientsReports.config\" \norder-default=\"Name\"></table-report></div><footer layout=\"row\" class=\"dir-rtl\" layout-align=\"space-between center\"><div\n layout=\"row\" class=\"md-title\" flex><div flex=\"50\"><div flex=\"50\">&nbsp;</div></div></div></footer></div></div><div \nflex id=\"\"><md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p>\n</md-list-item></div></div></div>");
$templateCache.put("app/main/reports/place-card/place-card.html","<div class=\"or-header places page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header smallheader md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span>&nbsp; <span class=\"logo-text\">\nכרטיס סניף: {{vm.place.Name}} - {{vm.place.PlaceName}}</span></div><div class=\"hide-sm-hieght\"><md-button \nclass=\"md-primary md-icon-button\" ng-click=\"vm.refreshStatusNow()\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>\n<md-tooltip>רענן</md-tooltip></md-button><span class=\"logo-text\">מצב סניף כעת: </span><span class=\"logo-text red-fg\">\n{{vm.statusNow.c_waiting||0}} ממתינים</span> <span class=\"logo-text blue-fg\">{{vm.statusNow.c_zilum||0}} בצילום</span> \n<span class=\"logo-text\">{{vm.statusNow.c_left||0}} עזבו</span></div><div>\nתאריך: {{vm.dates.start|date}} - {{vm.dates.end|date}}</div></div><div hide show-gt-xs \nclass=\"search-input-wrapper logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\"></span></div></div>\n<md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div \nclass=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\"><div class=\"widget-group ltr\" layout=\"row\" \nflex=\"100\" layout-wrap><div layout=\"row\" flex=\"100\" flex-gt-xs=\"100\"><div flex class=\"white-bg\"><div flex \nlayout=\"column\"><div flex class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<or-date-between-buttons dates=\"vm.dates\" on-change=\"vm.refresh(vm.dates)\"></or-date-between-buttons><md-select \nng-model=\"vm.placeSelected\" ng-change=\"vm.changePlace()\" md-on-open=\"vm.focusSearch()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchselect\" id=\"s_search\" type=\"text\" placeholder=\"הקש ערך לחיפוש\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option \nng-repeat=\"pl in vm.Places|filter:searchselect\" ng-value=\"pl.PlaceID\">{{pl.Name}}</md-option></md-select></div>\n<md-divider></md-divider></div><md-tabs md-dynamic-height><md-tab><md-tab-label><span>תרשים כללי</span></md-tab-label>\n<md-tab-body><md-content class=\"details-tab\" layout=\"row\" flex><div layout=\"column\" flex layout-gt-xs=\"row\" \nlayout-wrap><div layout=\"column\" flex><div class=\"p-16\" layout=\"row\" flex><ms-widget flex flippable=\"true\" \nlayout=\"column\"><ms-widget-front class=\"white-bg\"><div ng-hide=\"false\" class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">פציינטים</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n{{vm.place.ClientsData.summary.countClients}}</div><div class=\"h3 secondary-text font-weight-500\">פציינטים</div></div>\n<div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">צילומים:</span> <span class=\"h4 ml-8\">\n{{vm.place.ClientsData.summary.countPhotos||0}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\">\n<div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>כמות פציינטים<br>צילומים: כמות צילומים שבוצעו\n</div></ms-widget-back></ms-widget></div><div class=\"p-16\" layout=\"row\" flex><ms-widget flex flippable=\"true\" \nlayout=\"column\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">הכנסות</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">\n{{vm.place.ClientsData.summary.Price.toFixed(0)||0 |number : fractionSize}}</div><div \nclass=\"h3 secondary-text font-weight-500\">₪</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">תשלום לקוחות:</span> <span class=\"h4 ml-8\">\n{{vm.place.ClientsData.summary.Deductible.toFixed(2)||0 |number : fractionSize}}</span></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>סך הכנסות כולל ביטוחים שנתקבלו ע\"י הפניית הרופא<br>תשלום לקוחות: תשלום ששולמו בפועל ע\"י הפציינטים</div>\n</ms-widget-back></ms-widget></div></div><div layout=\"column\" flex><div layout=\"column\" flex><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\" class=\"ms-widget\"><ms-widget-front ng-click=\"flipWidget()\" class=\"h-170 p-16 light-blue-bg\"><div \nclass=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">פציינטים\n</div></div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-display-1\" \nlayout=\"row\" layout-align=\"start center\"><span>{{vm.place.ClientsData.percent.data_A.data.countClients||0|number}}\n</span><md-icon ng-show=\"vm.place.ClientsData.percent.percent.countClients>0\" md-font-icon=\"icon-trending-up\" \nclass=\"s36 ml-16\"></md-icon><md-icon ng-show=\"vm.place.ClientsData.percent.percent.countClients<0\" \nmd-font-icon=\"icon-trending-down\" class=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\">\n<span>אשתקד: {{vm.place.ClientsData.percent.data_B.data.countClients||0|number}}</span> <span class=\"text-boxed-light\">\n{{vm.place.ClientsData.percent.percent.countClients||0|number}} %</span></div></div></ms-widget-front><ms-widget-back \nng-click=\"flipWidget()\" class=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" type=\"button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" role=\"img\" \naria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></button></div><div>\nThis is the back side. You can show detailed information here.</div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" class=\"ms-widget\"><ms-widget-front \nng-click=\"flipWidget()\" class=\"h-170 p-16 light-blue-bg\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">צילומים</div></div><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-display-1\" layout=\"row\" \nlayout-align=\"start center\"><span>{{vm.place.ClientsData.percent.data_A.data.countPhotos||0|number}}</span><md-icon \nng-show=\"vm.place.ClientsData.percent.percent.countPhotos>0\" md-font-icon=\"icon-trending-up\" class=\"s36 ml-16\">\n</md-icon><md-icon ng-show=\"vm.place.ClientsData.percent.percent.countPhotos<0\" md-font-icon=\"icon-trending-down\" \nclass=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\"><span>\nאשתקד: {{vm.place.ClientsData.percent.data_B.data.countPhotos||0|number}}</span> <span class=\"text-boxed-light\">\n{{vm.place.ClientsData.percent.percent.countPhotos||0|number}} %</span></div></div></ms-widget-front><ms-widget-back \nng-click=\"flipWidget()\" class=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" type=\"button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" role=\"img\" \naria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></button></div><div>\nThis is the back side. You can show detailed information here.</div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" class=\"ms-widget\"><ms-widget-front \nng-click=\"flipWidget()\" class=\"h-170 p-16 light-blue-bg\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">סכום</div></div><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-display-1\" layout=\"row\" \nlayout-align=\"start center\"><span>{{vm.place.ClientsData.percent.data_A.data.Price||0|number:0}}</span><md-icon \nng-show=\"vm.place.ClientsData.percent.percent.Price>0\" md-font-icon=\"icon-trending-up\" class=\"s36 ml-16\"></md-icon>\n<md-icon ng-show=\"vm.place.ClientsData.percent.percent.Price<0\" md-font-icon=\"icon-trending-down\" class=\"s36 ml-16\">\n</md-icon></div><div layout=\"row\" layout-align=\"start center\"><span>\nאשתקד: {{vm.place.ClientsData.percent.data_B.data.Price||0|number:0}}</span> <span class=\"text-boxed-light\">\n{{vm.place.ClientsData.percent.percent.Price||0|number:0}} %</span></div></div></ms-widget-front><ms-widget-back \nng-click=\"flipWidget()\" class=\"p-16 light-blue-bg white-fg\"><div><button class=\"md-icon-button\" type=\"button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\" role=\"img\" \naria-hidden=\"true\"></md-icon><div class=\"md-ripple-container\"></div></button></div><div>\nThis is the back side. You can show detailed information here.</div></ms-widget-back></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget class=\"h-160\" layout=\"column\" flippable=\"true\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"75\"><ms-widget-front ng-click=\"flipWidget()\" class=\"p-16 white-bg\" layout=\"row\" \nflex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div class=\"header pb-8\">\nתקופה נוכחית: {{vm.dates.start|date:\'dd/MM/yy\'}} <span>- {{vm.dates.end|date:\'dd/MM/yy\'}}</span></div><div \nclass=\"header pb-8\">תקופה קודמת: {{vm.compare.start|date:\'dd/MM/yy\'}} <span ng-show=\"vm.compare.isEqual||true\">\n- {{vm.compare.end|date:\'dd/MM/yy\'}}</span></div><div class=\"font-weight-500 secondary-text\">\nההשוואה מתייחסת בהתאם לטווח הנ\"ל. לשינוי תקופת השוואה לחץ כאן</div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\" layout=\"row\" flex><md-datepicker ng-model=\"vm.compare.end\"></md-datepicker><div \nclass=\"font-weight-500 secondary-text mr-8\">לתאריך</div><md-datepicker ng-model=\"vm.compare.start\"></md-datepicker><div\n class=\"font-weight-500 secondary-text\">בין תאריך</div></div><div class=\"font-weight-500 secondary-text\"><md-button \nng-click=\"vm.refreshCompare();flipWidget()\">לחץ לאישור</md-button></div></div></ms-widget-back></ms-widget></div></div>\n</div></div></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>סיכום לפי רופאים</span></md-tab-label>\n<md-tab-body><md-content class=\"details-tab\"><div layout=\"row\" layout-align=\"start start\" layout-wrap ms-scroll flex>\n<div class=\"p-16\" layout=\"row\" flex=\"100\"><table-report flex feilds=\"vm.feildsDoctors\" \ndata=\"vm.place.ClientsData.summarybydoctors\" filterinput=\"vm.search\" date-report=\"vm.dates\" \nconfig=\"vm.config.summarybydoctors\" order-default=\"Name\"></table-report><div \nng-hide=\"vm.place.ClientsData.data.length\">אין נתונים</div></div></div><div layout=\"row\" layout-align=\"center center\" \nflex><md-button layout=\"row\" layout-align=\"center center\" class=\"md-raised md-primary\" \nng-click=\"vm.compareReport(\'sumbydoctor\')\">השוואה לתקופה קודמת</md-button></div></md-content></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>פירוט צילומים/פציינטים</span></md-tab-label><md-tab-body><md-content class=\"billing-tab\">\n<div layout=\"row\" layout-align=\"start start\" layout-wrap ms-scroll flex><div class=\"p-16\" layout=\"row\" flex=\"100\">\n<table-report flex feilds=\"vm.feilds\" data=\"vm.place.ClientsData.data\" filterinput=\"vm.search\" date-report=\"vm.dates\" \nconfig=\"vm.config.clients\" order-default=\"ClientName\"></table-report><div ng-hide=\"vm.place.ClientsData.data.length\">\nאין נתונים</div></div></div></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span>סיכום לפי גורם משלם</span>\n</md-tab-label><md-tab-body><md-content class=\"details-tab\"><div layout=\"row\" layout-align=\"start start\" layout-wrap \nms-scroll flex><div class=\"p-16\" layout=\"row\" flex=\"100\"><table-report flex feilds=\"vm.feildsInsurance\" \ndata=\"vm.place.ClientsData.summarybyinsurance\" filterinput=\"vm.search\" date-report=\"vm.dates\" \nconfig=\"vm.config.summarybyinsurance\" order-default=\"Name\"></table-report><div \nng-hide=\"vm.place.ClientsData.data.length\">אין נתונים</div></div></div><div layout=\"row\" layout-align=\"center center\" \nflex><md-button layout=\"row\" layout-align=\"center center\" class=\"md-raised md-primary\" \nng-click=\"vm.compareReport(\'summarybyinsurance\')\">השוואה לתקופה קודמת</md-button></div></md-content></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>סיכום קטגוריות צילום</span></md-tab-label><md-tab-body><md-content \nclass=\"details-tab\"><div layout=\"row\" layout-align=\"start start\" layout-wrap ms-scroll flex><div class=\"p-16\" \nlayout=\"row\" flex=\"100\"><table-report flex feilds=\"vm.feildsByCategory\" data=\"vm.place.ClientsData.summarybycategory\" \nfilterinput=\"vm.search\" date-report=\"vm.dates\" config=\"vm.config.summarybycategory\" order-default=\"Name\">\n</table-report><div ng-hide=\"vm.place.ClientsData.data.length\">אין נתונים</div></div></div><div layout=\"row\" \nlayout-align=\"center center\" flex><md-button layout=\"row\" layout-align=\"center center\" class=\"md-raised md-primary\" \nng-click=\"vm.compareReport(\'summarybycategory\')\">השוואה לתקופה קודמת</md-button></div></md-content></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>מחירון סניף</span></md-tab-label><md-tab-body><md-content class=\"details-tab\"><div\n layout=\"row\" layout-align=\"start start\" layout-wrap ms-scroll flex><div class=\"p-16\" layout=\"row\" flex=\"100\">\n<table-report flex feilds=\"vm.PricesPlace.feilds\" editfeilds=\"vm.PricesPlace.edit\" data=\"vm.place.Prices\" \nfilter-input=\"vm.searchprice\" on-edit-item=\"vm.editPricePlace\" on-remove-item=\"vm.deletePricePlace\" \nconfig=\"vm.PricesPlace.config\" order-default=\"Name\"></table-report><div ng-hide=\"vm.place.Prices.length\">אין הרשאות\n</div></div></div></md-content></md-tab-body></md-tab></md-tabs></div></div></div></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><img src=\"/assets/images/logos/logo-or.png\" style=\"width: 50px\"> \n<span class=\"logo-text\">אור השן</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide \nshow-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" \nfolded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"column\" layout-align=\"space-between stretch\" class=\"h-128\"><div class=\"top-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"navigation-toggle\" \nhide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div><div class=\"bottom-row\"><div id=\"horizontal-navigation\" ui-view=\"navigation\"></div>\n</div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\" flex hide show-gt-sm><md-button \nclass=\"md-accent\" ng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-backup-restore\" class=\"icon\"></md-icon><span hide \nshow-gt-sm>חזור</span></md-button><div class=\"toolbar-separator\"></div></div><div class=\"mr-20\">מערכת ניהול</div><div \nclass=\"toolbar-separator\"></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>{{vm.username}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ng-click=\"vm.discoundDialog()\"><md-icon \nmd-font-icon=\"icon-cash-usd\" class=\"icon\"></md-icon><md-button>הפעל קוד הנחה</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button \nng-disabled=\"true\">Inbox</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\" \nng-click=\"vm.passwordDialog($event)\"><md-icon md-font-icon=\"icon-account-key\" class=\"icon\"></md-icon><md-button>\nעדכון סיסמא</md-button></md-menu-item><md-menu-item ng-if=\"vm.users_permission\" class=\"md-indent\" ui-sref=\"app.users\">\n<md-icon md-font-icon=\"icon-account-multiple\" class=\"icon\"></md-icon><md-button>ניהול משתמשים</md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\" ui-sref=\"app.advanced_settings\">\n<md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon><md-button ng-disabled=\"!vm.fullPermission\">ניהול מתקדם\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_auth_login-v2.logout({logout:1})\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon>\n<md-button ng-click=\"vm.logout()\">התנתק</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\" hide show-gt-xs></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" hide show-gt-xs debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\" hide show-gt-xs></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\" hide show-gt-xs><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \nng-disabled=\"true\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/core/directives/date-between-buttons/date/date.html","<md-dialog><md-dialog-content><md-content layout=\"column\"><div>בחר חודש מהרשימה או הקש טווח תאריכים</div><md-select \nng-model=\"vm.re_select\" ng-change=\"vm.changeMonth()\"><md-option ng-value=\"0\">טווח תאריכים מותאם</md-option><md-option \nng-repeat=\"op in vm.range\" ng-value=\"op.id\">{{op.name}}</md-option></md-select><div flex layout=\"row\"><md-content \nlayout=\"column\" layout-align=\"end end\"><label>מתאריך</label><md-input-container><input ng-disabled=\"vm.re_select\" \ntype=\"date\" ng-model=\"vm.date\"></md-input-container></md-content></div><div flex layout=\"row\"><md-content \nlayout=\"column\" layout-align=\"end end\"><label>עד תאריך</label><md-input-container><input ng-disabled=\"vm.re_select\" \ntype=\"date\" placeholder=\"עד תאריך\" ng-model=\"vm.dateend\"></md-input-container></md-content></div><div layout=\"row\" \nflex><md-button class=\"md-raised\" ng-click=\"vm.close()\">סגור</md-button></div></md-content></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/or-table-report/dialog/edit-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-primary md-tall0 tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{(vm.isNew?\'הוסף\':\'עריכה\')}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll class=\"ng-form\" name=\"dialogForm\"><div ng-repeat=\"feild in vm.keys\">\n<md-input-container ng-hide=\"feild.select||feild.hide||(vm.isGroup&&!feild.showgroup)\" class=\"md-icon-float md-block\">\n<label flex=\"50\">{{feild.name}}</label><md-icon md-font-icon=\"{{feild.icon}}\" class=\"name\"></md-icon><input \nname=\"{{feild.key}}\" ng-model=\"vm.item[feild.key]\" type=\"{{feild.type||\'text\'}}\" ng-required=\"feild.required\" \nng-minlength=\"feild.minlength\" ng-maxlength=\"feild.maxlength\" ng-min=\"feild.min\" ng-max=\"feild.max\" \nng-pattern=\"feild.pattern\" ng-disabled=\"feild.readOnly&&(vm.isNew?feild.readOnly!=\'update\':true)\"></md-input-container>\n<div ng-if=\"feild.select &&!feild.select.multiple\" ng-hide=\"vm.isGroup&&!feild.showgroup\"><label flex=\"50\">\n{{feild.name}}</label><md-icon md-font-icon=\"{{feild.icon}}\" class=\"name\"></md-icon><md-select \nng-model=\"vm.item[feild.key]\" md-on-open=\"vm.focusSearch()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchselect\" id=\"s_search\" type=\"text\" placeholder=\"הקש ערך לחיפוש\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option \nng-repeat=\"opt in feild.select.data|filter:searchselect\" value=\"{{opt[feild.select.key]}}\">{{opt[feild.select.value]}}\n</md-option></md-select></div><div ng-if=\"feild.select &&feild.select.multiple\" ng-hide=\"vm.isGroup&&!feild.showgroup\">\n<label flex=\"50\">{{feild.name}}</label><md-icon md-font-icon=\"{{feild.icon}}\" class=\"name\"></md-icon><md-select \nng-model=\"vm.item[feild.key]\" multiple=\"multiple\" md-on-open=\"vm.focusSearch()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchselect\" id=\"s_search\" type=\"text\" placeholder=\"הקש ערך לחיפוש\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option \nng-repeat=\"opt in feild.select.data|filter:searchselect|orderBy:feild.select.sort\" value=\"{{opt[feild.select.key]}}\">\n{{opt[feild.select.value]}}</md-option></md-select></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"!vm.newContact\" ng-click=\"vm.submit()\" class=\"send-button md-accent md-raised font-size-12 saveBtn\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\">אישור</md-button></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-if=\"vm.AllowRemove\" class=\"md-icon-button\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s-8\" ng-click=\"vm.remove()\"></md-icon></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/bookkeeping/dialogs/contact/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-primary md-tall tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">איתור חשבונית</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name font-size-15\">\nניתן לחפש לפי אחת או יותר מהשדות שבטופס</div></div></div></md-toolbar><md-dialog-content ms-scroll class=\"ng-form\" \nname=\"dialogForm\"><md-input-container class=\"md-icon-float md-block\"><label flex=\"50\">שם לקוח</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input name=\"clientname\" ng-model=\"vm.contact.ClientName\" \ntype=\"text\" ng-minlength=\"3\"><div ng-messages=\"dialogForm.clientname.$error\"><div ng-message=\"minlength\">\nהקש לפחות 3 תוים</div></div></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon><label>סכום</label><input name=\"amount\" ng-model=\"vm.contact.amount\" type=\"tel\" \nng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\"><div ng-messages=\"dialogForm.amount.$error\"><span ng-message=\"pattern\">סכום שגוי\n</span></div></md-input-container><div><md-input-container class=\"md-block\"><label>תאריך</label><md-icon \nmd-font-icon=\"icon-calendar\"></md-icon><input name=\"kdate\" ng-model=\"vm.contact.KDate\" type=\"date\"><div \nng-messages=\"dialogForm.kdate.$error\"><span ng-message=\"pattern\">תאריך אינו תקין</span></div></md-input-container>\n<md-input-container class=\"md-icon-float md-block\"><label flex=\"50\">מספר חשבונית</label><md-icon \nmd-font-icon=\"icon-receipt\" class=\"name\"></md-icon><input name=\"invoice\" ng-model=\"vm.contact.HeshbonitID\" type=\"text\" \nng-pattern=\"/^[0-9]*$/\" ng-minlength=\"8\" ng-maxlength=\"10\"><div ng-messages=\"dialogForm.invoice.$error\"><span \nng-message=\"pattern\">מספר חשבונית אינו תקין</span><div ng-message=\"minlength\">מספר חשבונית חייב להכיל לפחות 8 תוים\n</div><div ng-message=\"maxlength\">מספר חשבונית חייב להכיל מקסימום 10 תוים</div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newContact\" ng-click=\"vm.submit()\" \nclass=\"send-button md-accent md-raised font-size-12 saveBtn\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\">חפש</md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/contacts/dialogs/contact/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-primary md-tall tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">איתור פציינט</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name font-size-15\">\nניתן לחפש לפי אחת או יותר מהשדות שבטופס</div></div></div></md-toolbar><md-dialog-content ms-scroll class=\"ng-form\" \nname=\"dialogForm\"><md-input-container class=\"md-icon-float md-block\"><label flex=\"50\">ת.ז</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input name=\"tz\" ng-model=\"vm.contact.TZ\" type=\"text\" \nng-pattern=\"/^[0-9]*$/\" ng-minlength=\"5\" ng-maxlength=\"10\" md-autofocus><div ng-messages=\"dialogForm.tz.$error\"><span \nng-message=\"pattern\">מספר זהות אינו תקין</span><div ng-message=\"minlength\">מספר זהות חייב להכיל לפחות 5 תוים</div><div \nng-message=\"maxlength\">מספר זהות חייב להכיל מקסימום 9 תוים</div></div></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><label flex=\"50\">שם פציינט</label><md-icon md-font-icon=\"icon-account\" class=\"name\">\n</md-icon><input name=\"clientname\" ng-model=\"vm.contact.ClientName\" type=\"text\" ng-minlength=\"5\"><div \nng-messages=\"dialogForm.clientname.$error\"><div ng-message=\"minlength\">הקש לפחות 5 תוים</div></div>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-phone\"></md-icon><label>טלפון\n</label><input name=\"phone\" ng-model=\"vm.contact.Tel\" type=\"tel\" \nng-pattern=\"/\\(?([0-9]{3})\\)?([ .-]?)([0-9]{3})\\2([0-9]{3})/\"><div ng-messages=\"dialogForm.phone.$error\"><span \nng-message=\"pattern\">טלפון שגוי</span></div></md-input-container><div ng-if=\"!vm.allFields\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = true\">אפשרויות נוספות</md-button>\n</div><div ng-if=\"vm.allFields\"><md-input-container class=\"md-block\"><label>תאריך</label><md-icon \nmd-font-icon=\"icon-calendar\"></md-icon><input name=\"kdate\" ng-model=\"vm.contact.KDate\" type=\"date\"><div \nng-messages=\"dialogForm.kdate.$error\"><span ng-message=\"pattern\">תאריך אינו תקין</span></div></md-input-container>\n<md-input-container class=\"md-icon-float md-block\"><label flex=\"50\">שם רופא</label><md-icon \nmd-font-icon=\"icon-human-child\" class=\"name\"></md-icon><input name=\"doctor\" ng-model=\"vm.contact.DoctorName\" \ntype=\"text\" ng-minlength=\"5\"><div ng-messages=\"dialogForm.doctor.$error\"><div ng-message=\"minlength\">הקש לפחות 5 תוים\n</div></div></md-input-container><div layout=\"row\" class=\"md-block\" layout-align=\"start start\"><md-input-container \nflex=\"50\" class=\"md-icon-float md-block\"><label flex=\"50\">מספר חשבונית</label><md-icon md-font-icon=\"icon-receipt\" \nclass=\"name\"></md-icon><input name=\"invoice\" ng-model=\"vm.contact.HeshbonitID\" type=\"text\" ng-pattern=\"/^[0-9]*$/\" \nng-minlength=\"4\" ng-maxlength=\"8\"><div ng-messages=\"dialogForm.invoice.$error\"><span ng-message=\"pattern\">\nמספר חשבונית אינו תקין</span><div ng-message=\"minlength\">מספר חשבונית חייב להכיל לפחות 4 תוים</div><div \nng-message=\"maxlength\">מספר חשבונית חייב להכיל מקסימום 8 תוים</div></div></md-input-container><md-input-container \nflex=\"50\"><label>מספר משלוח</label><md-icon md-font-icon=\"icon-wallet-travel\"></md-icon><input name=\"shipping\" \nng-model=\"vm.contact.MishloachID\" type=\"text\" ng-pattern=\"/^[0-9]*$/\" ng-minlength=\"4\" ng-maxlength=\"10\"><div \nng-messages=\"dialogForm.shipping.$error\"><span ng-message=\"pattern\">מספר משלוח אינו תקין</span><div \nng-message=\"minlength\">מספר משלוח חייב להכיל לפחות 4 תוים</div><div ng-message=\"maxlength\">\nמספר משלוח חייב להכיל מקסימום 10 תוים</div></div></md-input-container></div><md-checkbox ng-disabled=\"true\" \nng-model=\"vm.contact.allPlaces\">חפש בכל הסניפים</md-checkbox><div ng-if=\"vm.allFields\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = false\">הסתר</md-button></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newContact\" ng-click=\"vm.submit()\" \nclass=\"send-button md-accent md-raised font-size-12 saveBtn\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\">חפש</md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/contacts/dialogs/import/importContacts.html","<md-dialog id=\"importContacts\"><form class=\"md-inline-form\"><md-toolbar class=\"md-primary md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Import Contacts</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><div ng-show=\"vm.step==\'load\'\"><span class=\"secondary-text hide show-gt-sm\">\nChoose a method to import your contacts</span><div class=\"widget-group p-16\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget class=\"h-150 widget\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg white-fg\" \nlayout=\"row\" flex=\"100\"><div class=\"background-image-center cursor\"><ng-csv-import content=\"vm.content\" material \nmd-button-class=\"white-bg p-0\" md-button-title=\"Browse\" header=\"true\" separator=\"vm.seperator\" result=\"vm.resultCsv\" \ncallback=\"vm.initFields\"></ng-csv-import></div></ms-widget-front></ms-widget><ms-widget class=\"h-150 widget\" \nlayout=\"column\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg white-fg\" layout=\"row\" flex=\"100\" \nng-class=\"{\'disableWidget\':!vm.isZoho}\"><div class=\"added\" ng-show=\"!vm.isZoho\"><span>N/A</span></div><div \nclass=\"background-image-center cursor\" ng-click=\"vm.isZoho?vm.importContacts(\'zoho\'):vm.toastNotIntegrate(\'zoho\')\"><img\n ng-src=\"assets/images/crm/zoho.png\"></div></ms-widget-front></ms-widget><ms-widget class=\"h-150 widget\" \nlayout=\"column\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg white-fg\" layout=\"row\" flex=\"100\" \nng-class=\"{\'disableWidget\':!vm.shopName}\" ng-click=\"!vm.shopName?vm.toastNotIntegrate(\'shopify\'):\'\';\"><a \nng-href=\"{{vm.getShopifyUrl()}}\"><div class=\"added\" ng-show=\"!vm.shopName\"><span>N/A</span></div><div \nclass=\"background-image-center cursor\"><img ng-src=\"assets/images/crm/shopify.png\"></div></a></ms-widget-front>\n</ms-widget></div><div layout=\"row\" layout-align=\"center center\" class=\"m-16\"><md-progress-circular \nclass=\"md-hue-3 md-accent\" md-diameter=\"50\" layout-align=\"center center\" ng-show=\"vm.resultCsv&&vm.isLoading\">\n</md-progress-circular></div><div layout=\"row\" layout-align=\"center center\" class=\"m-16\" flex><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.step=\'fields\'\" ng-disabled=\"!vm.fields\" ng-show=\"vm.isIntegration==false;\">\nnext</md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.step=\'validate\'\" ng-show=\"vm.isIntegration==true\" \nng-disabled=\"!vm.contactsArray.length\">next</md-button></div></div><div ng-show=\"vm.step==\'fields\'&&!vm.isLoading\" \nlayout=\"column\"><span class=\"secondary-text p-8 pb-32\">\nPlease match the columns in your upload list to Bontact contacts list</span><div layout-gt-sm=\"row\" \nlayout-align=\"space-between center\" layout=\"column\"><span class=\"hide show-gt-sm p-32\">Contacts\'s <strong>email\n</strong> will be imported from -> </span><span class=\"hide-gt-sm\">Contacts\'s <strong>email</strong>\n will be imported from</span><md-select placeholder=\"select one\" ng-model=\"vm.fielsConvert.emailField\" name=\"email\" \nng-change=\"vm.initContactsArray()\" class=\"mb-16 mt-8\"><md-option ng-repeat=\"field in vm.fields\">{{field}}</md-option>\n</md-select></div><md-divider></md-divider><div layout-gt-sm=\"row\" layout-align=\"space-between center\" layout=\"column\">\n<span class=\"hide show-gt-sm p-32\">Contacts\'s <strong>first name</strong> will be imported from -> </span><span \nclass=\"hide-gt-sm pt-8\">Contacts\'s <strong>first name</strong> will be imported from</span><md-select \nplaceholder=\"select one\" ng-model=\"vm.fielsConvert.fnameField\" name=\"name\" ng-change=\"vm.initContactsArray()\" \nclass=\"mb-16 mt-8\"><md-option ng-repeat=\"field in vm.fields\">{{field}}</md-option><md-option ng-value=\"\">select one\n</md-option></md-select></div><md-divider></md-divider><div layout-gt-sm=\"row\" layout-align=\"space-between center\" \nlayout=\"column\"><span class=\"hide show-gt-sm p-32\">Contacts\'s <strong>last name </strong>will be imported from -> \n</span><span class=\"hide-gt-sm pt-8\">Contacts\'s <strong>last name </strong>will be imported from</span><md-select \nplaceholder=\"select one\" ng-model=\"vm.fielsConvert.lnameField\" name=\"lname\" ng-change=\"vm.initContactsArray()\" \nclass=\"mb-16 mt-8\"><md-option ng-repeat=\"field in vm.fields\">{{field}}</md-option><md-option ng-value=\"\">select one\n</md-option></md-select></div><md-divider></md-divider><div layout-gt-sm=\"row\" layout-align=\"space-between center\" \nlayout=\"column\"><span class=\"hide show-gt-sm p-32\">Contacts\'s <strong>phone</strong> will be imported from -> </span>\n<span class=\"hide-gt-sm pt-8\">Contacts\'s <strong>phone</strong> will be imported from</span><md-select \nplaceholder=\"select one\" ng-model=\"vm.fielsConvert.phoneField\" name=\"phone\" ng-change=\"vm.initContactsArray()\" \nclass=\"mb-16 mt-8\"><md-option ng-repeat=\"field in vm.fields\">{{field}}</md-option><md-option ng-value=\"\">select one\n</md-option></md-select></div><md-divider></md-divider><div layout-gt-sm=\"row\" layout-align=\"space-between center\" \nlayout=\"column\"><span class=\"hide show-gt-sm p-32\">Contacts\'s <strong>notes</strong> will be imported from -> </span>\n<span class=\"hide-gt-sm pt-8\">Contacts\'s <strong>notes</strong> will be imported from</span><md-select \nplaceholder=\"select one\" ng-model=\"vm.fielsConvert.notesField\" name=\"notes\" ng-change=\"vm.initContactsArray()\" \nclass=\"mb-16 mt-8\"><md-option ng-repeat=\"field in vm.fields\">{{field}}</md-option><md-option ng-value=\"\">select one\n</md-option></md-select></div><md-divider></md-divider><div layout=\"row\" layout-align=\"center center\" class=\"m-16\" \nflex><md-button class=\"md-raised md-accent\" ng-click=\"vm.step=\'load\'\">back</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.step=\'validate\';vm.validateData()\" ng-disabled=\"!vm.contactsArray.length\">next\n</md-button></div></div><div layout=\"row\" layout-align=\"center center\" ng-show=\"vm.step==\'validate\'&&!vm.isLoading\">\n<span class=\"secondary-text\">Validate result : {{vm.sumValid}} Valid contact {{vm.sumNotValid}} Not valid</span></div>\n<div ng-show=\"vm.step==\'validate\'&&!vm.isLoading\"><table class=\"simple contactsTable\"><thead><tr><th \nstyle=\"border:none;padding: 0;position: absolute;width: 5px\"></th><th class=\"p-8\"><span>Email</span></th><th \nclass=\"p-8 hide show-gt-sm\"><span>First name</span></th><th class=\"p-8 hide show-gt-sm\"><span>Last name</span></th><th \nclass=\"p-8 hide show-gt-sm\"><span>Phone</span></th><th class=\"p-8 hide show-gt-sm\"><span>Notes</span></th></tr></thead>\n<tbody><tr ng-repeat=\"item in (vm.contactsArray.length?vm.contactsArray:vm.contactsDemo)\" \nng-class=\"{\'red-fg\':vm.step==\'validate\'&&!item.status}\" ng-disabled=\"vm.step==\'validate\'\"><td><md-checkbox \nng-model=\"item.isAdd\" style=\"margin:0\" ng-disabled=\"item.status==false\"></md-checkbox></td><td>\n{{item.email|limitTo : 20}} <span ng-show=\"!item.email\" translate=\"CONTACTS.NOT_PROVIDED\" class=\"notProvided\" \nng-class=\"{\'red-fg\':vm.step==\'validate\'&&!item.status}\"></span></td><td class=\"hide show-gt-sm\">\n{{item.name|limitTo : 20}} <span ng-show=\"!item.name\" translate=\"CONTACTS.NOT_PROVIDED\" class=\"notProvided\" \nng-class=\"{\'red-fg\':vm.step==\'validate\'&&!item.status}\"></span></td><td class=\"hide show-gt-sm\">\n{{item.last_name|limitTo : 20}} <span ng-show=\"!item.last_name\" translate=\"CONTACTS.NOT_PROVIDED\" class=\"notProvided\" \nng-class=\"{\'red-fg\':vm.step==\'validate\'&&!item.status}\"></span></td><td class=\"hide show-gt-sm\">\n{{item.phone|limitTo : 20}} <span ng-show=\"!item.phone\" translate=\"CONTACTS.NOT_PROVIDED\" class=\"notProvided\" \nng-class=\"{\'red-fg\':vm.step==\'validate\'&&!item.status}\"></span></td><td class=\"hide show-gt-sm\">\n{{item.notes|limitTo : 20}} <span ng-show=\"!item.notes\" translate=\"CONTACTS.NOT_PROVIDED\" class=\"notProvided\" \nng-class=\"{\'red-fg\':vm.step==\'validate\'&&!item.status}\"></span></td></tr></tbody></table><div ng-show=\"!vm.isLoading\" \nlayout=\"row\" layout-align=\"center center\" class=\"m-16\" flex><md-button class=\"md-raised md-accent\" \nng-click=\"vm.step=vm.isIntegration?\'load\':\'fields\'\">back</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.addContacts()\" ng-disabled=\"!vm.getSumValid()\" ng-show=\"vm.step==\'validate\'\"><span \nclass=\"hide show-gt-sm\">Click to add {{vm.getSumValid()}} contact</span> <span class=\"hide-gt-sm\">submit</span>\n</md-button></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/contacts/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{vm.user.avatar}}\" \nclass=\"md-avatar avatar mr-16\" alt=\"{{vm.user.name}}\"> <span class=\"font-weight-500 font-size-14\">{{vm.user.name}}\n</span></div><md-divider></md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p translate=\"CONTACTS.ALL_CONTACTS\">\nAll contacts</p></md-list-item><md-list-item ng-click=\"vm.filterChange(\'frequent\')\" \nng-class=\"{\'selected\':vm.listType ===\'frequent\'}\"><p translate=\"CONTACTS.FREQUENTLY_CONTACTED\">Frequently contacted</p>\n</md-list-item><md-list-item ng-click=\"vm.filterChange(\'starred\')\" ng-class=\"{\'selected\':vm.listType ===\'starred\'}\"><p \ntranslate=\"CONTACTS.STARRED_CONTACTS\">Starred contacts</p></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\">Groups</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.filterChange(group)\" ng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">\n{{group.name}}</p></md-list-item><md-list-item class=\"new-group-form\" ng-show=\"newListForm.$visible\"><p class=\"pl-8\" \neditable-text=\"vm.newGroupName\" e-form=\"newListForm\" onaftersave=\"vm.addNewGroup()\"></p></md-list-item><md-list-item \nclass=\"\" ng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\"><p class=\"pl-8 md-accent-fg\" \ntranslate=\"CONTACTS.NEW_GROUP\">New Group</p></md-list-item></md-list></div>");
$templateCache.put("app/main/doctors/doctor-card/inbox/inbox.html","<md-dialog><md-toolbar class=\"md-primary md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{(vm.message.isnew?\'הודעה חדשה\':vm.message.title)}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><div ng-if=\"false\" class=\"chat-messages\"><div layout=\"row\" \nclass=\"md-padding message-row\" ng-class=\"dialog.who\"><img ng-src=\"assets/images/avatars/profile.jpg\" class=\"avatar\" \nalt=\"Shauna\" src=\"assets/images/avatars/Shauna.jpg\"><div class=\"bubble\"><div class=\"message ng-binding\">\nQuickly come to the meeting room 1B, we have a big server issue</div><div class=\"time secondary-text\">03/20/2016</div>\n</div></div><div layout=\"row\" class=\"md-padding message-row user\"><img class=\"avatar ng-scope\" \nng-src=\"assets/images/avatars/profile.jpg\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\"><div \nclass=\"message\">I’m having breakfast right now, can’t you wait for 10 minutes?</div><div class=\"time secondary-text\">\n04/20/2016</div></div></div><div layout=\"row\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-src=\"assets/images/avatars/profile.jpg\" class=\"avatar\" alt=\"Shauna\" src=\"assets/images/avatars/Shauna.jpg\"><div \nclass=\"bubble\"><div class=\"message ng-binding\">Quickly come to the meeting room 1B, we have a big server issue</div>\n<div class=\"time secondary-text\">03/20/2016</div></div></div><div layout=\"row\" class=\"md-padding message-row user\"><img\n class=\"avatar ng-scope\" ng-src=\"assets/images/avatars/profile.jpg\" src=\"assets/images/avatars/profile.jpg\"><div \nclass=\"bubble\"><div class=\"message\">I’m having breakfast right now, can’t you wait for 10 minutes?</div><div \nclass=\"time secondary-text ng-binding\">04/20/2016</div></div></div></div><div class=\"chat-messages\"><div layout=\"row\" \nclass=\"md-padding message-row\" ng-repeat=\"mess in vm.message.messages\" ng-class=\"{\'user\':mess.in_mess}\"><img \nng-src=\"assets/images/avatars/profile.jpg\" class=\"avatar\" alt=\"Shauna\" src=\"assets/images/avatars/Shauna.jpg\"><div \nclass=\"bubble\"><div class=\"message ng-binding\">{{mess.content}}</div><div class=\"time secondary-text\">\n{{mess.date|date}}</div></div></div><div layout=\"row\" ng-if=\"vm.message.isnew\" flex><md-input-container flex=\"\" \nmd-no-float=\"\"><input ng-model=\"vm.message.title\" placeholder=\"נושא ההודעה\"></md-input-container></div><div \nlayout=\"row\" flex><form ng-submit=\"vm.reply()\" flex class=\"reply-form\" layout=\"row\" layout-align=\"start center\">\n<md-input-container flex=\"\" md-no-float=\"\"><textarea md-no-autogrow=\"\" ng-model=\"vm.replyMessage\" \nng-class=\"{\'grow\': vm.textareaGrow}\" placeholder=\"כתוב הודעתך כאן\" aria-invalid=\"false\"></textarea>\n</md-input-container><button class=\"md-fab md-mini md-button\" type=\"submit\" aria-label=\"Send message\"><md-icon \nmd-font-icon=\"icon-send\" role=\"img\" aria-hidden=\"true\"></md-icon></button></form></div></div><ms-widget ng-hide=\"true\" \nclass=\"widget\" layout=\"column\" flex=\"100\" ng-repeat=\"mes in vm.message.messages\"><ms-widget-front \nclass=\"p-16 white-bg\" layout=\"column\" flex=\"100\"><div class=\"background-image-center cursor\">{{mes.content}}</div>\n</ms-widget-front><ms-widget-front ng-show=\"mes.replyMode\" class=\"p-16 white-bg\" layout=\"column\" flex=\"100\"><div \nng-show=\"mes.replyMode\" layout=\"row\" flex><md-input-container flex><textarea ng-model=\"mes.replyContent\" rows=\"6\" \nplaceholder=\"רשום הודעת כאן\"></textarea></md-input-container></div><div class=\"mt-20\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"mes.replyMode=false\">שלח</md-button><md-button class=\"md-accent\" \nng-click=\"mes.replyMode=false\">בטל</md-button></div></ms-widget-front></ms-widget><div><md-button class=\"md-accent\" \nng-disabled=\"true\">סמן כלא נקרא</md-button><md-button class=\"md-warn\" ng-disabled=\"true\">מחק</md-button></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/insurance/klalit-report/upload/upload.html","<md-dialog><md-dialog-content><div class=\"upload-content groups md-whiteframe-1dp\" layout=\"column\" flex><ms-widget \nclass=\"h-300 drop-box\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" flex ngf-select=\"vm.upload($files)\" \nngf-drop=\"vm.upload($files)\" class=\"drop-box\" ngf-max-size=\"20MB\" ngf-run-all-validations=\"true\" \nngf-validate-fn=\"vm.validate($file)\" ngf-drag-over-class=\"\'dragover\'\"><ms-widget-front \nclass=\"p-16 grey-bg white-fg ms-widget-front\" layout=\"row\" flex=\"\"><div layout=\"column\" layout-align=\"center center\" \nflex=\"\"><div class=\"md-display-3 pb-8 ng-binding\" ng-hide=\"vm.uploadProccess\">טען קובץ</div><div \nclass=\"md-display-3 pb-8 ng-binding\" ng-show=\"vm.uploadProccess\">{{vm.uploadProccess}}</div><div \nclass=\"h3 font-weight-500 ng-binding\">לחץ כאן או גרור לכאן מסמך חדש</div><div class=\"h3 font-weight-500 ng-binding\">\nבלבד csv</div></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-file-document\" \nclass=\"s256 faint-text md-default-theme\" role=\"img\" aria-label=\"icon-filmstrip\"></md-icon></div></ms-widget-front>\n</ms-widget></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/notes/directives/ms-new-note/ms-new-note.html","<ms-note-form note-type=\"\'new\'\"></ms-note-form><div ms-new-note-button class=\"new-note-button\"><span \ntranslate=\"NOTES.TAKE_A_NOTE\">Take a note..</span></div>");
$templateCache.put("app/main/notes/directives/ms-note-form/ms-note-form.html","<form ng-submit=\"MsNoteForm.submit()\" ng-class=\"MsNoteForm.note.color\"><div ng-if=\"MsNoteForm.note.image\" \nclass=\"image-wrapper\"><img class=\"md-card-image\" ng-src=\"{{MsNoteForm.note.image}}\"><md-button \nclass=\"md-fab md-mini delete-image-button\" ng-click=\"MsNoteForm.deleteImage()\" aria-label=\"delete image\" translate \ntranslate-attr-aria-label=\"NOTES.DELETE_IMAGE\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><input \ntype=\"text\" class=\"note-title-input\" placeholder=\"כותרת\" ng-model=\"MsNoteForm.note.title\" \nng-class=\"MsNoteForm.note.color\"><md-input-container md-no-float ng-class=\"MsNoteForm.note.color\"><textarea \ntype=\"text\" class=\"note-description-textarea\" placeholder=\"Take a note..\" translate \ntranslate-attr-placeholder=\"NOTES.TAKE_A_NOTE\" ng-model=\"MsNoteForm.note.description\">\n    </textarea>\n</md-input-container><md-list class=\"checklist\" ng-if=\"MsNoteForm.note.checklist.length > 0\"><md-divider></md-divider>\n<md-list-item ng-repeat=\"item in MsNoteForm.note.checklist\"><md-checkbox ng-model=\"item.checked\" \naria-label=\"toggle check\"></md-checkbox><p ng-class=\"{\'text-strike md-secondary-text\':item.checked}\">{{item.text}}</p>\n<md-icon ng-click=\"$event.preventDefault();$event.stopPropagation();MsNoteForm.deleteCheckItem(item)\" \nclass=\"md-secondary\" md-font-icon=\"icon-close-circle\" aria-label=\"remove\"></md-icon><md-divider></md-divider>\n</md-list-item></md-list><div class=\"checklist-form\" \nng-if=\"MsNoteForm.note.checklist.length > 0 || MsNoteForm.checkListForm\" layout=\"row\" layout-align=\"space-between end\">\n<md-input-container class=\"\" md-no-float flex><input id=\"new-checklist-item-input\" type=\"text\" placeholder=\"List item\" \nng-model=\"MsNoteForm.newCheckListItem\" \nng-keydown=\"$event.keyCode === 13 ? $event.preventDefault() + MsNoteForm.addChecklistItem():\'\';\"></md-input-container>\n<md-button class=\"md-icon-button\" ng-click=\"MsNoteForm.addChecklistItem()\" aria-label=\"add\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"labels\" ng-if=\"MsNoteForm.note.labels.length > 0\" \nlayout=\"row\" layout-wrap layout-align=\"end start\"><div class=\"label\" ng-repeat=\"labelId in MsNoteForm.note.labels\" \nng-class=\"MsNoteForm.labels.getById(labelId).color\">{{MsNoteForm.labels.getById(labelId).name}}</div></div><div \nng-if=\"MsNoteForm.type ===\'edit\'\" class=\"date text-right p-16\">{{MsNoteForm.note.time | altDate}}</div><div \nclass=\"footer\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"actions\" layout=\"row\" layout-align=\"center center\" layout-wrap><div \nid=\"image-uploader\" flow-init=\"MsNoteForm.ngFlowOptions\" flow-name=\"MsNoteForm.ngFlow.flow\" \nflow-files-submitted=\"MsNoteForm.upload()\" flow-file-success=\"MsNoteForm.imageSuccess($file, $message)\" \nflow-complete=\"MsNoteForm.uploadComplete()\" flow-file-added=\"!!{svg:1,png:1,gif:1,jpg:1,jpeg:1}[$file.getExtension()]\">\n<md-button flow-btn class=\"add-img-button md-icon-button\" aria-label=\"Add image\" translate \ntranslate-attr-aria-label=\"NOTES.ADD_IMAGE\"><md-icon md-font-icon=\"icon-file-image-box\" class=\"s20\"></md-icon>\n</md-button></div><md-button class=\"md-icon-button\" aria-label=\"checklist\" ng-click=\"MsNoteForm.checklistFormToggle()\">\n<md-icon md-font-icon=\"icon-checkbox-multiple-marked\" class=\"s20\"></md-icon></md-button><md-menu class=\"label-menu\">\n<md-button class=\"md-icon-button\" aria-label=\"Label\" translate translate-attr-aria-label=\"NOTES.LABEL\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin md-font-icon=\"icon-label\" class=\"s20\"></md-icon></md-button>\n<md-menu-content class=\"notes-labels-menu-content\" width=\"4\" ms-scroll><md-menu-item><md-input-container \nclass=\"no-errors-spacer\" md-no-float><input placeholder=\"Search labels...\" type=\"text\" \nng-model=\"MsNoteForm.labelSearchText\" autocomplete=\"off\" translate-attr-palceholder=\"NOTES.SEARCH_LABELS\">\n</md-input-container></md-menu-item><md-menu-item class=\"label\" \nng-repeat=\"label in MsNoteForm.labels | filter: MsNoteForm.labelSearchText\"><md-button class=\"label-toggle-button\" \nmd-prevent-menu-close ng-class=\"label.color\" ng-click=\"MsNoteForm.toggleInArray(label.id, MsNoteForm.note.labels)\" \naria-label=\"Toggle Label\" translate translate-attr-aria-label=\"NOTES.TOGGLE_LABEL\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><span>{{label.name}}</span> <i \nng-if=\"MsNoteForm.exists(label.id, MsNoteForm.note.labels)\" class=\"icon-check s16\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button class=\"md-icon-button\" ng-click=\"MsNoteForm.toggleArchive()\" \naria-label=\"archive\"><md-icon md-font-icon=\"icon-archive\" class=\"s20\"></md-icon></md-button><ms-material-color-picker \nng-model=\"MsNoteForm.note.color\"><md-button class=\"md-icon-button\" aria-label=\"color\"><md-icon \nmd-font-icon=\"icon-palette\" class=\"s20\"></md-icon></md-button></ms-material-color-picker><md-datepicker \nclass=\"reminder\" ng-model=\"MsNoteForm.note.reminder\" md-placeholder=\"Add reminder\" ms-datepicker-fix></md-datepicker>\n</div><div layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"MsNoteForm.type ===\'edit\'\" \nng-click=\"MsNoteForm.deleteNote()\" class=\"md-icon-button\" aria-label=\"delete note\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button><md-button ng-if=\"MsNoteForm.type ===\'edit\'\" type=\"submit\" translate=\"NOTES.SAVE\" \nng-disabled=\"MsNoteForm.isNotValid()\">Save</md-button><md-button ng-if=\"MsNoteForm.type ===\'new\'\" type=\"submit\" \ntranslate=\"NOTES.ADD\" ng-disabled=\"MsNoteForm.isNotValid()\">Add</md-button></div></div></form>");
$templateCache.put("app/main/notes/directives/ms-note-item/ms-note-item.html","<md-card ng-class=\"MsNoteItem.note.color\"><img ng-if=\"MsNoteItem.note.image\" class=\"md-card-image\" \nng-src=\"{{MsNoteItem.note.image}}\"><md-card-content><md-card-title ng-if=\"MsNoteItem.note.title\"><md-card-title-text>\n{{MsNoteItem.note.title}}</md-card-title-text></md-card-title><md-description ng-if=\"MsNoteItem.note.description\">\n<span>{{MsNoteItem.note.description}}</span></md-description><div ng-if=\"MsNoteItem.note.checklist.length > 0\" \nclass=\"checklist\"><div class=\"checklist-item\" ng-repeat=\"checkItem in  MsNoteItem.note.checklist\" layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-model=\"checkItem.checked\" \nng-click=\"$event.preventDefault();$event.stopPropagation()\" aria-label=\"{{checkItem.text}}\"></md-checkbox><span \nclass=\"text-truncate\" ng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\" flex>{{checkItem.text}}</span>\n</div></div><div class=\"labels\" ng-if=\"MsNoteItem.note.labels.length > 0\" layout=\"row\" layout-wrap \nlayout-align=\"end start\"><div class=\"label\" ng-repeat=\"labelId in MsNoteItem.note.labels\" \nng-click=\"$event.preventDefault();$event.stopPropagation();vm.filterChange(vm.labels.getById(labelId))\" \nng-class=\"vm.labels.getById(labelId).color\">{{vm.labels.getById(labelId).name}}</div></div><div \nng-if=\"vm.noteListType ===\'reminders\' && MsNoteItem.note.reminder\" class=\"reminder secondary-text text-right\"><md-icon \nmd-font-icon=\"icon-bell\" class=\"s16 mr-8\"></md-icon><span>{{MsNoteItem.note.reminder | altDate}}</span></div>\n</md-card-content></md-card>");
$templateCache.put("app/main/notes/sidenavs/main/main-sidenav.html","<div ms-scroll class=\"content\"><md-list><md-list-item ng-click=\"vm.filterChange(\'notes\')\" \nng-class=\"{\'selected\':vm.listType ===\'notes\'}\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-lightbulb\" class=\"mr-16\"></md-icon><span translate=\"NOTES.NOTES\">Notes</span></div></md-list-item>\n<md-list-item ng-click=\"vm.filterChange(\'reminders\')\" ng-class=\"{\'selected\':vm.listType ===\'reminders\'}\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-bell\" class=\"mr-16\"></md-icon><span \ntranslate=\"NOTES.REMINDERS\">Reminders</span></div></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\"><span translate=\"NOTES.LABELS\">Labels</span></md-subheader><md-list-item \nng-repeat=\"label in vm.labels\" ng-class=\"{\'selected\':vm.noteListType.name === label.name}\" class=\"label\" layout=\"row\" \nlayout-align=\"start center\" flex><ms-material-color-picker ng-model=\"label.color\"><md-icon class=\"mr-16\" \nmd-font-icon=\"icon-label\" ng-style=\"{color:$selectedColor.bgColorValue}\"></md-icon></ms-material-color-picker><span \nclass=\"label-name text-transclude\" flex ng-hide=\"editLabelForm.$visible\" ng-click=\"vm.filterChange(label)\">\n{{label.name}} </span><span flex editable-text=\"label.name\" e-form=\"editLabelForm\" ng-show=\"editLabelForm.$visible\">\n{{label.name}}</span><md-button class=\"md-icon-button\" ng-hide=\"editLabelForm.$visible\" \nng-click=\"editLabelForm.$show()\" aria-label=\"edit label\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-hide=\"editLabelForm.$visible\" \nng-click=\"vm.deleteLabel($event, label)\" aria-label=\"delete label\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\">\n</md-icon></md-button></md-list-item><md-list-item class=\"new-label-form\" ng-show=\"newLabelForm.$visible\"><p \neditable-text=\"vm.newLabel.name\" e-form=\"newLabelForm\" onaftersave=\"vm.addNewLabel(vm.newLabel)\"></p></md-list-item>\n<md-list-item class=\"\" ng-click=\"newLabelForm.$show()\" ng-hide=\"newLabelForm.$visible\"><p class=\"md-accent-fg\" \ntranslate=\"NOTES.NEW_LABEL\">New Label</p></md-list-item><md-divider></md-divider><md-list-item \nng-click=\"vm.filterChange(\'archive\')\" ng-class=\"{\'selected\':vm.listType ===\'archive\'}\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-archive\" class=\"mr-16\"></md-icon><span \ntranslate=\"NOTES.ARCHIVE\">Archive</span></div></md-list-item></md-list></div>");
$templateCache.put("app/main/pages/auth/lock/lock.html","<div id=\"lock\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"lock-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"lock-form\" class=\"md-whiteframe-8dp\"><div layout=\"row\" \nlayout-align=\"start center\" layout-sm=\"column\" layout-align-sm=\"center center\"><div class=\"avatar-container\"><img \nclass=\"avatar big\" src=\"assets/images/avatars/katherine.jpg\"><md-icon md-font-icon=\"icon-lock\" \nclass=\"md-warn-fg s36 md-hue-2\"></md-icon></div><div flex layout=\"column\" layout-align=\"start\" \nlayout-align-sm=\"center center\"><div class=\"title\" translate=\"LOCK.TITLE\">Your session is locked</div><div \nclass=\"subtitle\" translate=\"LOCK.SUBTITLE\">Due to inactivity, your session is locked. Enter your password to continue.\n</div></div></div><form name=\"lockForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input \nng-model=\"vm.form.username\" placeholder=\"Username\" translate translate-attr-placeholder=\"LOCK.USERNAME\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOCK.PASSWORD\" required><div ng-messages=\"lockForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOCK.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"UNLOCK\" \nng-disabled=\"lockForm.$invalid || lockForm.$pristine\" translate=\"LOCK.UNLOCK\" translate-attr-aria-label=\"LOCK.UNLOCK\">\nUNLOCK</md-button></form><div class=\"message\"><a ui-sref=\"app.pages_auth_login\" class=\"md-accent-color\"><span \ntranslate=\"LOCK.ARE_YOU_NOT\">Are you not</span><span> Jane Doe?</span></a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F\n</span></div><div class=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><form name=\"loginForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me</span>\n</md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div class=\"separator\"><span\n class=\"text\" translate=\"LOGIN.OR\">OR</span></div><md-button class=\"md-raised google\"><div layout=\"row\" \nlayout-align=\"center center\"><span><md-icon md-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN.WITH_GOOGLE\">Log in with Google</span></span></div></md-button><md-button class=\"md-raised facebook\">\n<div layout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-facebook\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN.WITH_FACEBOOK\">Log in with Facebook</span></span></div></md-button><div class=\"register\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_register\" translate=\"LOGIN.CREATE_ACCOUNT\">\nCreate an account</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/login-v2/login-v2.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex hide show-gt-sm><div class=\"logo\">\n<img src=\"/assets/images/logos/logo-or.png\"></div><div class=\"stage\"><div class=\"layer\"></div><div class=\"layer\"></div>\n<div class=\"layer\"></div><div class=\"layer\"></div><div class=\"layer\"></div><div class=\"layer\"></div><div class=\"layer\">\n</div><div class=\"layer\"></div><div class=\"layer\"></div><div class=\"layer\"></div><div class=\"layer\"></div><div \nclass=\"layer\"></div><div class=\"layer\"></div><div class=\"layer\"></div><div class=\"layer\"></div><div class=\"layer\">\n</div><div class=\"layer\"></div><div class=\"layer\"></div><div class=\"layer\"></div><div class=\"layer\"></div></div></div>\n<div id=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-v2-form\"><div \nclass=\"logo\" hide-gt-sm><img src=\"/assets/images/logos/logo-or.png\"></div><div class=\"title\" \ntranslate=\"LOGIN_V2.TITLE\">Log in to your account</div><div class=\"description\" translate=\"LOGIN_V2.DESCRIPTION\">\nSed mollis velit facilisis facilisis viverra</div><div class=\"description red-fg\">{{vm.error}}</div><form \nname=\"loginForm\" novalidate ng-submit=\"vm.login()\"><md-input-container class=\"md-block\" md-no-float><input type=\"text\" \nname=\"place\" ng-model=\"vm.form.username\" placeholder=\"שם משתמש\" required><div ng-messages=\"loginForm.place.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>שדה חובה</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.pass\" \nplaceholder=\"סיסמא\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>שדה חובה</span></div></div></md-input-container><div class=\"g-recaptcha\" vc-recaptcha \nng-model=\"vm.form.gRecaptchaResponse\"></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine||vm.proccess\" translate=\"LOGIN_V2.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN_V2.LOG_IN\">LOG IN</md-button></form><md-progress-linear ng-show=\"vm.proccess\" \nmd-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear></div></div></div>");
$templateCache.put("app/main/pages/errors/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR404.CODE\">404</div><div class=\"message\" \ntranslate=\"ERROR404.MESSAGE\">Sorry but we couldn’t find the page you are looking for</div><div \nclass=\"search md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input ng-model=\"vm.search\" type=\"text\" placeholder=\"Search for anything\" translate \ntranslate-attr-placeholder=\"ERROR404.SEARCH\" flex></div><a class=\"back-link md-accent-color\" href=\"/\" \ntranslate=\"ERROR404.GO_BACK\">Go back to dashboard</a></div></div>");
$templateCache.put("app/main/pages/errors/500/error-500.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR500.CODE\">500</div><div class=\"message\" \ntranslate=\"ERROR500.MESSAGE\">Well, you broke the internet!</div><div class=\"sub-message\" \ntranslate=\"ERROR500.SUBMESSAGE\">Just kidding, looks like we have an internal issue, please try again in couple minutes\n</div><a class=\"report-link md-accent-color\" href=\"/\" translate=\"ERROR500.REPORT\">Report this problem</a></div></div>");
$templateCache.put("app/main/profile/dialog/acceptVisit/acceptVisit.html","<md-dialog><md-dialog-content><md-content layout=\"column\"><div id=\"invoice\" class=\"orhashen page-layout blank\" \nlayout=\"row\" ms-scroll><div class=\"invoice-container\" flex=\"100\"><div class=\"card md-whiteframe-8dp\" layout=\"column\" \nflex><md-button class=\"pr md-button md-accent md-raised\" ng-click=\"vm.print()\">הדפס</md-button><div class=\"header\" \nlayout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" layout=\"column\"><div layout=\"row\" class=\"seller\" flex \nlayout-align=\"start center\"><div class=\"logo\" flex=\"100\" layout=\"row\" layout-align=\"center center\"><img \nsrc=\"/assets/images/logos/or.jpg\"></div></div><div layout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div \nclass=\"detail text-right mt-16\"><div class=\"title\">סניף: {{vm.place.Name}}</div><div class=\"title\" \nng-if=\"vm.place.Tel\">טל: {{vm.place.Tel}}</div><div class=\"title\">כתובת: {{vm.place.PlaceName}}</div><div \nclass=\"title\">{{vm.dateNow|date}}</div><div ng-if=\"vm.invoice.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">\nEmail</span>: {{vm.invoice.email}}</div></div></div><md-divider></md-divider><table dir=\"rtl\" class=\"summary\"><tr \nclass=\"code\"><td colspan=\"2\" class=\"label\">אישור ביקור</td></tr><tr class=\"code\"><td colspan=\"2\" class=\"value\">\nלכל המעוניין</td></tr><tr><td colspan=\"2\" class=\"value\">הרינו לאשר כי <span>{{vm.client.ClientName}}</span>\n ביקר במכוננו לצורך צילומי שיניים</td></tr><tr><td colspan=\"2\" class=\"value\">בתאריך <span>{{vm.client.KDate|date}}\n</span></td></tr><tr><td colspan=\"2\" class=\"value\">בין השעות <span>{{vm.client.TimeIN|date:\'HH:mm\':\'+0\'}}</span> - \n<span>{{vm.client.TimeOUT|date:\'HH:mm\':\'+0\'}}</span></td></tr></table></div></div><div class=\"content\"><table \ndir=\"rtl\" class=\"simple invoice-table-footer\"><tbody><tr class=\"total\"><td class=\"text-right\">בכבוד רב,<br>\nאור השן - סניף {{vm.place.Name}}</td></tr></tbody></table></div></div><div class=\"page-break\"></div></div></div>\n</md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/profile/dialog/bonClient/bonClient.html","<md-dialog><md-dialog-content><md-content layout=\"column\"><div id=\"invoice\" class=\"orhashen page-layout blank\" \nlayout=\"row\" ms-scroll><div class=\"invoice-container\" flex=\"100\"><div class=\"card md-whiteframe-8dp\" layout=\"column\" \nflex><md-button class=\"pr md-button md-accent md-raised\" ng-click=\"vm.print()\">הדפס</md-button><div class=\"header\" \nlayout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" layout=\"column\"><div layout=\"row\" class=\"seller\" flex \nlayout-align=\"start center\"><div class=\"logo\" flex=\"100\" layout=\"row\" layout-align=\"center center\"><img \nsrc=\"/assets/images/logos/or.jpg\"></div></div><div layout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div \nflex=\"\" class=\"detail text-right mt-16\"><div class=\"title\" flex>{{vm.dateNow|date:\'dd/MM/yy HH:mm\'}}</div><div \nclass=\"title font-size-16\">שם: {{vm.client.ClientName}}</div><div class=\"title\">תז: {{vm.client.TZ}}</div><div \nclass=\"title\">טלפון: {{vm.client.Tel}}</div><div class=\"title\">ת. לידה: {{vm.client.ClientBirthDate|date:\'dd/MM/yy\' }}\n</div><div class=\"title\">גורם משלם: {{vm.client.bituachName}}</div></div></div><md-divider></md-divider><div \nlayout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div flex=\"\" class=\"detail text-right mt-16\"><div \nclass=\"title\">רופא: {{vm.client.doctorName}}</div><div ng-show=\"vm.client.doctorEmail\" class=\"title font-weight-800\">\n{{vm.client.doctorEmail}}</div><div class=\"title font-size-10\">{{vm.client.NoteOUT}}</div></div></div><md-divider>\n</md-divider><div layout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div flex=\"\" \nclass=\"detail text-right mt-16\"><div class=\"title\">תאריך צילום: {{vm.client.KDate|date:\'dd/MM/yyyy\'}}</div><div \nclass=\"title\" ng-repeat=\"photo in vm.client.PhotosArr\">{{photo.Name}}</div></div></div><md-divider></md-divider><div \nlayout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div flex=\"\" class=\"detail text-right mt-16\"><div \nclass=\"title\">:לתשלום<br>{{vm.client.PhotosPrice|customCurrency}}</div></div></div><md-divider></md-divider><div \nlayout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div flex=\"\" class=\"detail text-right mt-16\"><div \nclass=\"title\">הערות: {{vm.client.ClientNote}}</div></div></div></div></div></div><div class=\"page-break\"></div></div>\n</div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/profile/dialog/checks/checks.html","<md-dialog class=\"checksdialog\" aria-label=\"New Task\"><form name=\"formChecks\" novalidate><div \nclass=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title\">הזן פרטי שיקים</div></header><div class=\"content dir-rtl\" layout=\"row\" \nflex layout-wrap><div class=\"activity\" layout=\"row\" flex=\"\" layout-align=\"start start\"><div layout=\"row\" flex><div \nlayout=\"row\" class=\"m-8\" layout-gt-xs=\"row\" flex><md-content class=\"timeline-tab mt-20 p-8\"><div layout=\"row\" \nng-repeat=\"check in vm.checksArr\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input \ntype=\"date\" name=\"date\" ng-model=\"check.date\" placeholder=\"סכום\" required><div ng-messages=\"formChecks.date.$error\" \nng-show=\"formChecks.date.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Firstname field is required.</span>\n</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" \nng-model=\"check.bank\" ng-pattern=\"/^[0-9]*$/\" ng-minlength=\"2\" ng-maxlength=\"3\" placeholder=\"בנק\" required><div \nng-messages=\"formChecks.bank.$error\" ng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Firstname field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"check.branch\" ng-pattern=\"/^[0-9]*$/\" ng-minlength=\"1\" \nng-maxlength=\"3\" placeholder=\"סניף\" required><div ng-messages=\"wizardStep1.firstname.$error\" \nng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Firstname field is required.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"firstname\" ng-model=\"check.account\" ng-pattern=\"/^[0-9]*$/\" ng-minlength=\"3\" ng-maxlength=\"15\" \nplaceholder=\"חשבון\" required><div ng-messages=\"wizardStep1.firstname.$error\" ng-show=\"wizardStep1.firstname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"check.number\" \nng-pattern=\"/^[0-9]*$/\" ng-minlength=\"5\" ng-maxlength=\"15\" placeholder=\"מספר שיק\" required><div \nng-messages=\"wizardStep1.firstname.$error\" ng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"check.amount\" \nng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" ng-minlength=\"1\" ng-maxlength=\"10\" placeholder=\"סכום\" required><div \nng-messages=\"wizardStep1.firstname.$error\" ng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"20\" flex-gt-xs=\"20\"><div aria-label=\"Eat cake\" ng-if=\"$index!=0\"><md-tooltip>הסר</md-tooltip><md-icon \nmd-font-icon=\"icon-close\" class=\"icon\" ng-click=\"vm.removeCheck(check,$index)\"></md-icon></div></md-input-container>\n</div><div><md-button ng-disabled=\"vm.checksArr.length>=4||formChecks.$invalid\" ng-click=\"vm.addCheck()\" \nclass=\"post-button md-accent md-raised\" aria-label=\"POST\">הוסף שיק נוסף<md-icon md-font-icon=\"icon-plus\" class=\"icon\">\n</md-icon></md-button></div></md-content></div></div></div></div><div layout=\"row\" flex><md-button \nclass=\"md-raised md-primary\" ng-disabled=\"formChecks.$invalid\" ng-click=\"vm.closeDialog()\" \ntranslate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">אישור</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.cancel()\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">ביטול</md-button></div></div></form>\n</md-dialog>");
$templateCache.put("app/main/profile/dialog/creditcard/creditcard.html","<md-dialog class=\"register_copyrator\" aria-label=\"New Task\"><div class=\"profile-box latest-activity md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"end center\"><div class=\"title\">חיוב בכ. אשראי\n</div></header><div class=\"content dir-rtl p-8\" layout=\"row\" flex layout-wrap><div class=\"\" layout=\"row\" flex=\"\" \nlayout-align=\"start start\"><div layout=\"column\" class=\"mt-20\" flex><div layout=\"row\" flex layout-align=\"center center\" \nng-hide=\"vm.editamount\"><md-button class=\"md-raised md-primary mt-16\" ng-click=\"vm.editamount=true\" \ntranslate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">\n{{(vm.IsRefund?\'זיכוי\':\'חיוב\')}} {{vm.sumByCredit}} ש\"ח ב {{vm.paymentsNumber}} תשלומים. לחץ לשינוי</md-button></div>\n<div layout=\"column\" flex layout-align=\"center center\" ng-show=\"vm.editamount\"><div layout=\"row\" flex \nlayout-align=\"center center\"><md-input-container flex=\"60\"><input type=\"text\" ng-model=\"vm.sumByCredit\" \nplaceholder=\"סכום\" required></md-input-container><md-input-container flex=\"40\"><input type=\"number\" min=\"1\" max=\"6\" \nng-model=\"vm.paymentsNumber\" placeholder=\"מספר תשלומים\" required></md-input-container></div><div layout=\"row\" flex \nlayout-align=\"center center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.updateAmount(event)\" \ntranslate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">עדכן</md-button></div></div><div layout=\"row\" ng-hide=\"vm.editamount\" \nflex layout-align=\"center center\" class=\"dir-ltr\"><h1>{{vm.strstatus}}</h1></div><div ng-hide=\"vm.manual\" layout=\"row\">\n<input type=\"text\" id=\"cardAuto\" ng-model=\"vm.cardauto\" class=\"white-fg\" ng-keypress=\"vm.cardLeft()\" placeholder=\"\" \nrequired></div><div layout=\"column\" flex layout-align=\"center center\" ng-show=\"vm.manual\"><form name=\"manualCard\" \nnovalidate><div layout=\"row\" flex=\"100\"><md-input-container flex><input type=\"text\" ng-model=\"vm.card.number\" \nng-pattern=\"/^[0-9]*$/\" ng-minlength=\"8\" ng-maxlength=\"17\" placeholder=\"מספר כרטיס\" required></md-input-container>\n</div><div layout=\"row\" flex><md-input-container flex=\"30\"><input type=\"number\" min=\"1\" max=\"12\" \nng-model=\"vm.card.expired.month\" placeholder=\"תוקף חודש\" required></md-input-container><md-input-container flex=\"30\">\n<input type=\"number\" min=\"{{vm.year}}\" max=\"{{(vm.year+7)}}\" ng-model=\"vm.card.expired.year\" placeholder=\"תוקף שנה\" \nrequired></md-input-container><md-input-container flex=\"30\"><input type=\"number\" min=\"{{vm.year}}\" max=\"999\" \nng-model=\"vm.card.cvv\" placeholder=\"CVV\" required></md-input-container></div><div layout=\"row\" flex><md-input-container\n flex=\"100\"><input type=\"text\" ng-model=\"vm.card.tz\" placeholder=\"מס זהות\" required></md-input-container></div><div \nlayout=\"row\" flex layout-align=\"center center\"><md-button class=\"md-raised md-warn\" ng-click=\"vm.manualPay()\" \nng-disabled=\"manualCard.$invalid||vm.statusOK||vm.proccessManual\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">\nחייב עכשיו</md-button></div></form></div></div></div></div><div layout=\"row\" flex><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.closeDialog()\" ng-disabled=\"!vm.statusOK\" \ntranslate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">אישור</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.cancel()\" ng-disabled=\"vm.statusOK\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">ביטול</md-button><div\n layout=\"row\" layout-align=\"start center\" class=\"m-8\" ng-hide=\"vm.statusOK\"><a href=\"#\" \nng-click=\"vm.manual=!vm.manual\">{{(vm.manual?\'סליקה אוטומטית\':\'הזנה ידנית\')}}</a></div></div></div></md-dialog>");
$templateCache.put("app/main/profile/dialog/document/document.html","<md-dialog class=\"docShow\"><md-dialog-content flex><md-content flex layout=\"column\"><div flex=\"100\"><image-viewer \nsrc=\"{{vm.filesrc}}\"></image-viewer></div><div>ניתן לשנות גודל ע\"י שינוי גלגלת העכבר</div></md-content>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/profile/dialog/editCopies/editCopies.html","<md-dialog class=\"checksdialog\" aria-label=\"New Task\" flex=\"\"><form name=\"formChecks\" novalidate><div \nclass=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title\">עריכת פרטי צילום</div></header><div class=\"content dir-rtl\" layout=\"row\" \nlayout-wrap><ms-prices-doctors copies=\"vm.copies\" doctor=\"vm.doctor\" count-copies=\"vm.countCopies\"></ms-prices-doctors>\n</div><footer class=\"dir-rtl m-8\" layout-align=\"space-between center\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"!vm.copies.length\" ng-click=\"vm.updateDoctorPrices()\">שמור</md-button><md-button class=\"md-raised\" \nng-click=\"vm.close()\">ביטול</md-button></footer></div></form></md-dialog>");
$templateCache.put("app/main/profile/dialog/shippingDetails/shippingDetails.html","<md-dialog><md-dialog-content><md-content layout=\"column\"><div id=\"invoice\" class=\"orhashen page-layout blank\" \nlayout=\"row\" ms-scroll><div class=\"invoice-container\" flex=\"100\"><div class=\"card md-whiteframe-8dp\" layout=\"column\" \nflex><md-button class=\"pr md-button md-accent md-raised\" ng-click=\"vm.print()\">הדפס</md-button><div class=\"header\" \nlayout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" layout=\"column\"><div layout=\"row\" class=\"seller\" flex \nlayout-align=\"start center\"><div class=\"logo\" flex=\"100\" layout=\"row\" layout-align=\"center center\"><img \nsrc=\"/assets/images/logos/or.jpg\"></div></div><div layout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div \nflex=\"50\" class=\"\" layout-align=\"start start\"><div class=\"label\">משלוח</div><div class=\"label\">{{vm.client.MishloahID}}\n</div></div><div flex=\"50\" class=\"detail text-right mt-16\"><div class=\"title\">סניף: {{vm.place.Name}}</div><div \nclass=\"title\" ng-if=\"vm.place.Tel\">טל: {{vm.place.Tel}}</div><div class=\"title\">כתובת: {{vm.place.PlaceName}}</div><div\n class=\"title\">{{vm.dateNow|date:\'dd/MM/yyyy\'}}</div><div ng-if=\"vm.invoice.email\" class=\"email\"><span \ntranslate=\"INVOICE.EMAIL\">Email</span>: {{vm.invoice.email}}</div></div></div><md-divider></md-divider><div \nlayout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div flex=\"\" class=\"detail text-right mt-16\"><div \nclass=\"title font-size-20\">לכבוד: {{vm.doctor.Name}}</div><div class=\"title\">\nכתובת: {{vm.doctor.Address}} {{vm.doctor.city}}</div><div class=\"title\" ng-if=\"vm.doctor.Tel1\">טל: {{vm.doctor.Tel1}}\n</div><div class=\"title\" ng-if=\"vm.doctor.Tel2\">{{vm.doctor.Tel2}}</div><div class=\"title\" ng-if=\"vm.doctor.Pel1\">\n{{vm.doctor.Pel1}}</div><div class=\"title\" ng-if=\"vm.doctor.Pel2\">{{vm.doctor.Pel2}}</div><div \nclass=\"title font-weight-800\" ng-if=\"vm.doctor.Email1\">{{vm.doctor.Email1}}</div><div class=\"title\" \nng-if=\"vm.doctor.Email2\">{{vm.doctor.Email2}}</div></div></div><md-divider></md-divider><div layout=\"row\" \nclass=\"seller\" flex layout-align=\"end center\"><div flex=\"\" class=\"detail text-right mt-16\"><div class=\"title\">\nתאריך צילום: {{vm.client.KDate|date:\'dd/MM/yyyy\'}}</div><div class=\"title\">שם פציינט: {{vm.client.ClientName}}</div>\n</div></div><md-divider></md-divider><div layout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div flex=\"\" \nclass=\"detail text-right mt-16\">שם/חתימת המקבל ____________________</div></div></div></div></div><div \nclass=\"page-break\"></div></div></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/profile/dialog/transfer/transfer.html","<md-dialog class=\"transferdialog\" aria-label=\"New Task\"><form name=\"formChecks\" novalidate><div \nclass=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title\">הזן פרטי העברה</div></header><div class=\"content dir-rtl\" layout=\"row\" \nflex layout-wrap><div class=\"activity\" layout=\"row\" flex=\"\" layout-align=\"start start\"><div layout=\"row\" flex><div \nlayout=\"row\" class=\"m-8\" layout-gt-xs=\"row\" flex><md-content class=\"timeline-tab mt-20 p-8\"><div layout=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.transfer.bank\" \nng-pattern=\"/^[0-9]*$/\" ng-minlength=\"2\" ng-maxlength=\"3\" placeholder=\"בנק\" required><div \nng-messages=\"formChecks.bank.$error\" ng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Firstname field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.transfer.branch\" ng-pattern=\"/^[0-9]*$/\" \nng-minlength=\"1\" ng-maxlength=\"3\" placeholder=\"סניף\" required><div ng-messages=\"wizardStep1.firstname.$error\" \nng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Firstname field is required.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"firstname\" ng-model=\"vm.transfer.account\" ng-pattern=\"/^[0-9]*$/\" ng-minlength=\"3\" ng-maxlength=\"15\" \nplaceholder=\"חשבון\" required><div ng-messages=\"wizardStep1.firstname.$error\" ng-show=\"wizardStep1.firstname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container>\n</div><div layout=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"date\" name=\"date\" \nng-model=\"vm.transfer.date\" placeholder=\"תאריך\" required><div ng-messages=\"formChecks.date.$error\" \nng-show=\"formChecks.date.$touched\" role=\"alert\"><div ng-message=\"required\"><span>date field is required.</span></div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"reference\" \nng-model=\"vm.transfer.reference\" ng-pattern=\"/^[0-9]*$/\" ng-minlength=\"5\" ng-maxlength=\"15\" placeholder=\"מספר אסמכתא\" \nrequired><div ng-messages=\"wizardStep1.reference.$error\" ng-show=\"wizardStep1.reference.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>אסמכתא - שדה חובה.</span></div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"amount\" ng-model=\"vm.transfer.amount\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" \nng-minlength=\"1\" ng-maxlength=\"10\" placeholder=\"סכום\" required><div ng-messages=\"wizardStep1.amount.$error\" \nng-show=\"wizardStep1.amount.$touched\" role=\"alert\"><div ng-message=\"required\"><span>סכום אינו תקין - חובה.</span></div>\n</div></md-input-container></div></md-content></div></div></div></div><div layout=\"row\" flex><md-button \nclass=\"md-raised md-primary\" ng-disabled=\"formChecks.$invalid\" ng-click=\"vm.closeDialog()\" \ntranslate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">אישור</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.cancel()\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">ביטול</md-button></div></div></form>\n</md-dialog>");
$templateCache.put("app/main/profile/dialog/upload/upload.html","<md-dialog><md-dialog-content><div class=\"content\" layout=\"row\" flex><md-select layout=\"row\" flex \nng-model=\"vm.photoID\"><md-option ng-value=\"0\">בחר סוג צילום או מסמך</md-option><md-option \nng-repeat=\"ph in vm.profile.PhotosArr\" ng-value=\"ph.PhotoID\">{{ph.Name}}</md-option><md-option ng-value=\"-1\">הפנייה\n</md-option><md-option ng-value=\"-2\">אחר</md-option></md-select></div><div \nclass=\"upload-content groups md-whiteframe-1dp\" layout=\"column\" flex><ms-widget ng-show=\"vm.photoID\" \nclass=\"h-300 drop-box\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" flex ngf-select=\"vm.upload($files)\" \nngf-drop=\"vm.upload($files)\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\"><ms-widget-front \nclass=\"p-16 grey-bg white-fg ms-widget-front\" layout=\"row\" flex=\"\"><div layout=\"column\" layout-align=\"center center\" \nflex=\"\"><div class=\"md-display-3 pb-8 ng-binding\" ng-hide=\"vm.uploadProccess\">העלאת קובץ</div><div \nclass=\"md-display-3 pb-8 ng-binding\" ng-show=\"vm.uploadProccess\">{{vm.uploadProccess}}</div><div \nclass=\"h3 font-weight-500 ng-binding\">לחץ כאן או גרור לכאן מסמך חדש</div></div><div class=\"background-image-center\">\n<md-icon md-font-icon=\"icon-file-document\" class=\"s256 faint-text md-default-theme\" role=\"img\" \naria-label=\"icon-filmstrip\"></md-icon></div></ms-widget-front></ms-widget><ms-widget ng-hide=\"vm.photoID\" \nclass=\"h-300 drop-box\" layout=\"column\" flex><ms-widget-front class=\"p-16 blue-grey-bg white-fg ms-widget-front\" \nlayout=\"row\" flex=\"\"><div layout=\"column\" layout-align=\"center center\" flex=\"\"><div \nclass=\"md-display-3 pb-8 ng-binding\">העלאת קובץ</div><div class=\"h3 font-weight-500 ng-binding\">\nבחר סוג צילום/מסמך להעלאה</div></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-arrow-up\" \nclass=\"s256 faint-text md-default-theme\" role=\"img\" aria-label=\"icon-filmstrip\"></md-icon></div></ms-widget-front>\n</ms-widget></div><div layout=\"row\" layout-align=\"center center\" class=\"md-display-2 pb-8 text-right\">\n!נא להעלות קבצים באיכות גבוהה</div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/profile/tabs/billing/billing.html","<div layout=\"row\" flex layout-wrap class=\"dir-rtl\"><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"35\"><div class=\"profile-box friends md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title dir-rtl\" flex>מצב חשבון</div>\n</header><div class=\"content dir-rtl\" layout=\"column\" layout-wrap><div layout=\"row\" flex><div flex=\"50\">סך הכל</div>\n<div flex=\"50\">{{vm.profile.sumAll.topay| customCurrency}}</div></div><div layout=\"row\" flex \nng-show=\"vm.profile.sumAll.insuranceprice\"><div flex=\"50\">{{vm.profile.bituachName}}</div><div flex=\"50\">{{\'***** \' }}\n</div></div><div layout=\"row\" flex ng-repeat=\"receipt in vm.profile.Receipts.data\"><div flex=\"40\"><a href=\"#\" \nui-sref=\"app.invoice_client.original({id:receipt.KabalaID,original:\'f\'})\">חשבונית <span \nng-if=\"receipt.kNote.trim()==\'זיכוי\'\">זיכוי</span> {{receipt.KabalaID}}</a></div><div flex=\"40\">\n{{receipt.sumAll | customCurrency}}</div><div flex=\"40\"><a href=\"#\" ng-if=\"receipt.kNote.trim()!=\'זיכוי\'\" \nng-click=\"vm.RefundStatus(receipt)\">זיכוי חשבונית</a></div></div></div><footer class=\"dir-rtl\"><div layout=\"row\" \nclass=\"md-title\" flex><div flex=\"50\">סך לתשלום</div><div flex=\"50\">{{vm.profile.sumAll.topay| customCurrency}}</div>\n</div></footer></div><div class=\"profile-box groups md-whiteframe-1dp\" layout=\"column\" \nng-show=\"vm.profile.Receipts.data.length\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"title dir-rtl\" flex>פירוט תשלומים - חשבוניות קודמות</div></header><div class=\"content dir-rtl\"><div \nlayout=\"row\" flex><div flex=\"50\">ס\"ה מזומן</div><div flex=\"50\">\n{{(vm.profile.Receipts.sumCashPrice ||0)| customCurrency}}</div></div><div layout=\"row\" flex><div flex=\"50\">ס\"ה שיקים\n</div><div flex=\"50\">{{(vm.profile.Receipts.sumChekPrice ||0)| customCurrency}}</div></div><div layout=\"row\" flex><div \nflex=\"50\">ס\"ה אשראי</div><div flex=\"50\">{{(vm.profile.Receipts.sumCreditCardPrice||0) | customCurrency}}</div></div>\n</div><footer layout=\"row\" class=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" class=\"md-title\" flex>\n<div flex=\"50\">סך נתקבל</div><div flex=\"50\">{{vm.profile.Receipts.sumAllRecepts | customCurrency}}</div></div></footer>\n<footer layout=\"row\" class=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" class=\"md-title\" flex><div \nflex=\"50\">יתרת חוב</div><div flex=\"50\">\n{{((vm.profile.sumAll.topay)-vm.profile.Receipts.sumAllRecepts) | customCurrency}}</div></div></footer></div></div><div\n class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button ng-if=\"vm.refund\" \nclass=\"md-raised\" aria-label=\"insert photo\" ng-click=\"vm.RefundStatus()\"><md-icon md-font-icon=\"icon-backburger\">\n</md-icon>חזור</md-button></div><div class=\"title dir-rtl\">קבלת תשלום</div></header><div class=\"content\"><div \nclass=\"info-line md-title dir-rtl\" ng-if=\"vm.profile.paidAll\" layout=\"row\" layout-align=\"center center\" flex><div \nclass=\"info-line md-title dir-rtl\" layout=\"column\" layout-align=\"center center\" flex><div ng-if=\"!vm.refund\">שולם הכל\n</div><div ng-if=\"vm.refund\">קבלת זיכוי - חשבונית {{vm.payments.RefundKabalaID}}</div><div ng-if=\"!vm.refund\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s96\"></md-icon></div></div></div><div class=\"info-line md-title dir-rtl\" \nng-if=\"!vm.profile.paidAll&&(vm.profile.sumAll.topay)<=vm.profile.Receipts.sumAllRecepts\" layout=\"row\" \nlayout-align=\"center center\" flex><div class=\"info-line md-title dir-rtl\" layout=\"column\" layout-align=\"center center\" \nflex><div>לא לתשלום</div><div><md-icon md-font-icon=\"icon-close\" class=\"s96\"></md-icon></div></div></div><div \nng-hide=\"true\">paidAll: {{vm.profile.paidAll}}<br>isClosed: {{vm.profile.isClosed}}<br>\nShulamSW: {{vm.profile.ShulamSW}}<br>sumAllRecepts::{{vm.profile.Receipts.sumAllRecepts}}<br>\nfirstToPay:{{vm.profile.Receipts.firstToPay}}<br>\nsumAllRecepts:--{{vm.profile.sumAll.topay-vm.profile.Receipts.sumAllRecepts}}</div><div \nng-if=\"(!vm.profile.paidAll||vm.refund)&&(vm.profile.Receipts.sumAllRecepts>0||vm.profile.sumAll.topay>0)\" \nlayout=\"row\" flex><md-button layout=\"column\" flex ng-disabled=\"vm.anotherPlace\" ng-click=\"vm.openCashDialog()\" \nclass=\"post-button md-accent md-raised pt-8\" aria-label=\"POST\"><img src=\"assets/images/etc/money.png\"> מזומן\n</md-button><md-button layout=\"column\" flex ng-disabled=\"vm.anotherPlace\" ng-click=\"vm.openChecksDialog()\" \nclass=\"post-button md-accent md-raised pt-8\" aria-label=\"POST\"><img src=\"assets/images/etc/check.png\"> שיק</md-button>\n<md-button layout=\"column\" flex ng-disabled=\"vm.anotherPlace\" ng-click=\"vm.openCreditCardDialog()\" \nclass=\"post-button md-accent md-raised pt-8\" aria-label=\"POST\"><img src=\"assets/images/etc/visa.png\"> אשראי</md-button>\n</div></div><header class=\"md-accent-bga\" layout=\"row\" layout-align=\"end center\"><div class=\"title dir-rtl\" flex>\nפירוט תשלומים</div></header><div class=\"content dir-rtl\"><div layout=\"row\" flex><div flex=\"50\">ס\"ה מזומן</div><div \nflex=\"50\">{{(vm.payments.sumCashPrice ||0)| customCurrency}}</div></div><div layout=\"row\" flex><div flex=\"50\">ס\"ה שיקים\n</div><div flex=\"50\">{{(vm.payments.sumChekPrice ||0)| customCurrency}}</div></div><div layout=\"row\" flex><div \nflex=\"50\">ס\"ה אשראי</div><div flex=\"50\">{{(vm.payments.sumCreditCardPrice||0) | customCurrency}}</div></div></div>\n<footer layout=\"row\" class=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" class=\"md-title\" flex><div \nflex=\"50\" ng-show=\"vm.refund\">סך לזיכוי</div><div flex=\"50\" ng-hide=\"vm.refund\">סך נתקבל</div><div flex=\"50\">\n{{vm.payments.sumAllRecepts||0 | customCurrency}}</div></div></footer><footer layout=\"row\" class=\"dir-rtl\" \nlayout-align=\"space-between center\"><div layout=\"row\" class=\"md-title\" flex><div flex=\"50\">יתרת חוב</div><div \nflex=\"50\">{{(vm.profile.sumAll.topay-vm.profile.Receipts.sumAllRecepts-vm.payments.sumAllRecepts)|customCurrency}}\n</div></div></footer><footer class=\"dir-rtl\" layout=\"row\"><md-button flex ng-click=\"vm.createInvoice()\" \nng-disabled=\"vm.proccess||!vm.payments.sumAllRecepts\" class=\"post-button md-accent md-raised\" aria-label=\"POST\">\n{{(vm.proccess?\'אנא המתן...\':\'אישור והפקת חשבונית\')}}</md-button></footer></div></div></div>");
$templateCache.put("app/main/profile/tabs/details/details.html","<div layout=\"column\" layout-gt-md=\"row\" flex layout-wrap><div class=\"timeline\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"55\" flex-gt-md=\"65\" flex-order=\"2\" flex-order-gt-sm=\"1\"><div ng-hide=\"vm.editCopyMode\" \nclass=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title\">פרטי פציינט</div><md-button class=\"md-icon-button\" \naria-label=\"add location\" ng-click=\"vm.editProfileClick(event)\"><md-icon md-font-icon=\"icon-table-edit\"></md-icon>\n<md-tooltip><span>ערוך</span></md-tooltip></md-button></header><div class=\"form content dir-rtl\" flex><div \nlayout=\"column\" class=\"m-8\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"tz\" ng-disabled=\"!vm.editprofile\" ng-model=\"vm.profile.TZ\" ng-pattern=\"/^[0-9]*$/\" ng-minlength=\"6\" \nng-maxlength=\"9\" placeholder=\"מס זהות\"><div ng-messages=\"tz.$error\" ng-show=\"tz.$touched\" role=\"alert\"><div \nng-message=\"minlength\">מספר זהות חייב להכיל בין 6 ל 9 תוים</div><div ng-message=\"maxlength\">\nמספר זהות חייב להכיל בין 6 ל 9 תוים</div></div></md-input-container><md-input-container><input type=\"date\" \nname=\"birthdate\" ng-disabled=\"!vm.editprofile\" ng-model=\"vm.profile.ClientBirthDate\" placeholder=\"תאריך לידה\"><div \nng-messages=\"wizardStep1.birthdate.$error\" ng-show=\"wizardStep1.birthdate.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" class=\"m-8\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"firstname\" ng-disabled=\"!vm.editprofile\" ng-model=\"vm.profile.ClientName\" placeholder=\"שם פציינט\" required><div \nng-messages=\"wizardStep1.firstname.$error\" ng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.profile.placeName\" placeholder=\"סניף\" \nng-disabled=\"true\" required></md-input-container></div><div layout=\"column\" class=\"m-8\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-disabled=\"!vm.editprofile\" \nng-model=\"vm.profile.Tel\" placeholder=\"טלפון\" required></md-input-container></div><div layout=\"column\" class=\"m-8\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nng-disabled=\"!vm.editprofile\" ng-model=\"vm.profile.ClientNote\" placeholder=\"הערות\"></md-input-container><label>משלוח\n</label><md-checkbox ng-disabled=\"!vm.editprofile\" ng-model=\"vm.profile.MishloahSW\"></md-checkbox></div><md-button \nlayout=\"row\" layout-align=\"center center\" class=\"md-accent\" ng-show=\"vm.editprofile\" \nng-click=\"vm.moredetails=!vm.moredetails\">הצג/הסתר פרטים נוספים</md-button><div \nng-show=\"vm.editprofile && vm.moredetails\" flex layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nclass=\"md-block\"><input type=\"date\" name=\"cardholder\" ng-model=\"vm.profile.HafnayaDate\" placeholder=\"תאריך הפנייה\">\n</md-input-container><md-input-container flex class=\"md-block\"><input type=\"text\" name=\"cardholder\" \nng-model=\"vm.profile.HafnayaNumber\" placeholder=\"מס\' פנייה\"></md-input-container><md-input-container flex \nclass=\"md-block\"><input type=\"text\" name=\"cardholder\" ng-model=\"vm.profile.MithareName\" placeholder=\"מתחרה\">\n</md-input-container></div></div><footer layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" aria-label=\"insert photo\" translate \nng-click=\"vm.printDetails(event)\" translate-attr-aria-label=\"PROFILE.INSERT_PHOTO\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><md-tooltip><span>הדפס</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"add person\" translate ng-click=\"vm.editProfileClick(event)\" \ntranslate-attr-aria-label=\"PROFILE.ADD_PERSON\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon><md-tooltip><span>\nעריכת פרטים</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"add location\" translate \nng-click=\"vm.SippingDetails(event)\" translate-attr-aria-label=\"PROFILE.LOCATION\"><md-icon \nmd-font-icon=\"icon-wallet-travel\"></md-icon><md-tooltip><span>פרטי משלוח</span></md-tooltip></md-button></div>\n<md-button ng-click=\"vm.updateClientDetails()\" class=\"post-button md-accent md-raised\" aria-label=\"POST\" \nng-disabled=\"!vm.editprofile\">שמור</md-button></footer></div><form ng-show=\"vm.editCopyMode\" name=\"formChecks\" flex \nlayout=\"row\" novalidate><div class=\"profile-box latest-activity md-whiteframe-1dp\" flex=\"\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"end center\"><div class=\"title\">עריכת פרטי צילום</div></header><div \nclass=\"content p-0 dir-rtl\" layout=\"row\" layout-wrap><ms-prices-doctors client=\"vm.profile\" \ncopies=\"vm.profile.PhotosArr\" bituah-id=\"vm.profile.BituahID\" doctor=\"vm.profile.Doctor\" \ncount-copies=\"vm.profile.countCopies\"></ms-prices-doctors></div><footer class=\"dir-rtl m-8\" \nlayout-align=\"space-between center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"!vm.profile.PhotosArr.length\" \nng-click=\"vm.UpdateCopiesAndDoctor()\">שמור</md-button><md-button class=\"md-raised\" ng-click=\"vm.closeCopyMode()\">ביטול\n</md-button></footer></div></form><md-divider></md-divider></div><div class=\"timeline-sidebar\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"45\" flex-gt-md=\"35\" flex-order=\"1\" flex-order-gt-sm=\"2\"><div \nclass=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title\">הערות לפציינט</div></header><div class=\"content dir-rtl\" layout=\"row\" \nlayout-wrap><div class=\"activities\"><div class=\"activity\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\">\n<div class=\"md-accent-color\"><b>{{vm.profile.Doctor.Name||vm.profile.doctorName}}</b></div><div \nclass=\"username md-accent-color\">{{vm.profile.NoteOUT}}</div><md-divider ng-show=\"vm.profile.ClientNote\"></md-divider>\n<div class=\"username md-accent-color\">{{vm.profile.ClientNote}}</div></div></div></div></div><footer \nng-if=\"vm.profile.BituahID>2\"><div layout=\"row\" layout-align=\"end center\"><span>מבוטח ע\"י {{vm.profile.bituachName}}\n</span></div></footer><footer ng-if=\"vm.profile.BituahID>2\" layout=\"row\" class=\"dir-rtl\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\"><b>סטטוס ביטוח:</b>&nbsp; <span \nng-if=\"vm.profile.ZulamStatus==5 &&vm.profile.unUploadPhoto\">ממתין להעלאת כל הצילומים למערכת</span> <span \nng-if=\"vm.profile.InsuranseStatus\" ng-class=\"{\'red-fg\':vm.profile.InsuranseStatus.statusCode!=200}\">\n{{vm.profile.InsuranseStatus.msg}}</span></div><div ng-if=\"vm.profile.InsuranseStatus\" layout=\"row\" \nlayout-align=\"end center\"><md-button ng-disabled=\"vm.proccess\" class=\"md-accent md-raised\" \nng-click=\"vm.sendToInsuranse(event)\">{{vm.proccess?\"שולח. אנא המתן...\":\"שלח כעת\"}}</md-button></div></footer></div><div\n class=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title\">צילומי פציינט</div></header><div class=\"content\"><div class=\"group\" \nng-repeat=\"photo in vm.profile.PhotosArr\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" flex \nlayout-align=\"start center\"><img flex=\"70\" ng-src=\"/assets/images/copies/1.png\" class=\"logo photo-img\" \nalt=\"{{photo.Name}}\"><md-button ng-if=\"photo.InsuranceID>2\" class=\"md-icon-button\" aria-label=\"add location\" \nng-click=\"vm.addReferrence($event,photo)\"><md-icon md-font-icon=\"icon-tooltip-edit\" \nng-class=\"{\'red-fg\':!photo.reference}\"></md-icon><md-tooltip><span>עדכן אסמכתא</span></md-tooltip></md-button>\n<md-button ng-if=\"photo.InsuranceID==14\" class=\"md-icon-button\" aria-label=\"add location\" \nng-click=\"vm.addClalitOrder($event,photo)\"><md-icon md-font-icon=\"icon-barcode\" \nng-class=\"{\'red-fg\':!photo.orderNumber}\"></md-icon><md-tooltip><span>עדכן הזמנת רכש</span></md-tooltip></md-button><div\n flex class=\"m-10 dir-rtl\"><div class=\"name\">{{photo.Name}}</div><div class=\"category\">\n{{(photo.InsuranceID>2?\'ביטוח\':\'\')}} <span ng-if=\"photo.InsuranceID>2&&photo.Deductible\">\n{{photo.Deductible|customCurrency}} ה\"ע</span> <span ng-if=\"photo.InsuranceID>2&&!photo.Deductible\">לא לתשלום</span> \n<span ng-if=\"photo.InsuranceID<2\">{{(photo.Deductible||photo.fixprice||0)|customCurrency}}</span></div></div></div>\n</div></div><footer layout=\"row\" class=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end center\"><span>מצלמ/ת: {{vm.profile.ovedName||\'לא נבחר מצלם/ת\'}}</span></div><md-button \nclass=\"md-icon-button\" aria-label=\"add location\" ng-click=\"vm.openDialogEmployee($event)\"><md-icon \nmd-font-icon=\"icon-table-edit\"></md-icon><md-tooltip><span>ערוך</span></md-tooltip></md-button></footer><footer \nlayout=\"row\" class=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\"><md-button\n class=\"md-accent md-raised\" ng-click=\"vm.editCopies(event)\">ערוך צילומים</md-button></div></footer></div></div></div>");
$templateCache.put("app/main/profile/tabs/photos/photos.html","<div ng-if=\"false\" layout=\"row\" flex layout-wrap class=\"dir-rtl\"><div class=\"profile-bo groups md-whiteframe-1dp\" \nlayout=\"column\" flex=\"100\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"end center\"><div class=\"title\">\nצילומי פציינט - DEMO</div></header><div layout=\"row\"><div layout=\"column\" flex=\"50\"><footer layout=\"row\" \nclass=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\">צילומים</div></footer>\n<div class=\"content\"><div class=\"group\" ng-repeat=\"doc in vm.documents|filter:{PhotoID:\'!!\'}\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" flex layout-align=\"start center\"><md-button \nclass=\"md-icon-buttonz md-primary md-raised\" aria-label=\"add location\" ng-click=\"vm.OpenDocument($event,doc)\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><span>פתח</span><md-tooltip><span>פתח</span></md-tooltip></md-button><div flex \nclass=\"m-10 dir-rtl\"><div class=\"name\">{{doc.name}}</div><div class=\"category\"><span>{{doc.date}}</span></div></div>\n</div></div></div><footer layout=\"row\" class=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end center\">מסמכים נוספים</div></footer><div class=\"content\"><div class=\"group\" \nng-repeat=\"doc in vm.documents|filter:{PhotoID:\'!\'}\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" flex layout-align=\"start center\"><md-button class=\"md-icon-buttonz md-primary md-raised\" \naria-label=\"add location\" ng-click=\"vm.OpenDocument($event,doc)\"><md-icon md-font-icon=\"icon-eye\"></md-icon><span>פתח\n</span><md-tooltip><span>פתח</span></md-tooltip></md-button><div flex class=\"m-10 dir-rtl\"><div class=\"name\">\n{{doc.name}}</div><div class=\"category\"><span>{{doc.date}}</span></div></div></div></div></div><footer layout=\"row\" \nclass=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\">\n{{vm.documents.length}} מסמכים<md-button class=\"md-icon-buttonz md-primary md-raised\" aria-label=\"add location\" \nng-click=\"vm.AddDocument()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span>הוסף מסמך</span></md-button></div>\n</footer></div><div class=\"content\" flex=\"50\"><img flex ez-plus \nezp-model=\"{thumb:IMGPATH, small:IMGPATH, large:IMGPATH}\" ezp-options=\"{scrollZoom: true, easing: true}\" \nalt=\"{{doc.name}}\" xsrc=\"/assets/images/copies/1.png\" \nsrc=\"http://images1.ynet.co.il/PicServer5/2017/02/14/7587084/51_(Large).jpg\"></div></div></div></div><div layout=\"row\" \nflex layout-wrap><ms-widget ng-repeat=\"doc in vm.profile.Documents\" ng-click=\"vm.OpenDocument(event,doc)\" \nclass=\"h-300\" layout=\"column\" flex flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 blue-grey-bg white-fg\" \nlayout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\">{{doc.name}}\n</div><div class=\"h3 font-weight-500\">{{doc.date|date}}</div></div><div class=\"background-image-center\"><md-icon \nng-show=\"doc.PhotoID\" md-font-icon=\"icon-filmstrip\" class=\"s256 faint-text\"></md-icon><md-icon ng-hide=\"doc.PhotoID\" \nmd-font-icon=\"icon-file-document\" class=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget><ms-widget \nng-show=\"vm.profile.Documents.length\" ng-click=\"vm.OpenUploadDialog()\" class=\"h-300\" layout=\"column\" flex \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 grey-bg white-fg\" layout=\"row\" flex><div layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"md-display-1 pb-8\">הוסף</div><div class=\"h3 font-weight-500\">\nלחץ להוספת צילום/מסמך חדש</div></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-cloud-upload\" \nclass=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget><ms-widget ng-show=\"vm.profile.Documents.length\" \nng-click=\"vm.sendDocsToEmail()\" class=\"h-300\" layout=\"column\" flex flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 red-bg white-fg\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\">שלח</div><div class=\"h3 font-weight-500\">שלח צילומים לרופא</div></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"icon-email\" class=\"s256 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget><ms-widget ng-hide=\"vm.profile.Documents.length\" class=\"h-300\" layout=\"column\" flex>\n<ms-widget-front class=\"p-16 grey-bg white-fg\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" \nflex><div class=\"md-display-3 pb-8\">אין צילומים/מסמכים</div><div ng-show=\"vm.profile.unUploadPhoto\" \nclass=\"md-display-1 pb-8\"><md-icon md-font-icon=\"icon-numeric-{{vm.profile.unUploadPhoto}}-box-outline\"></md-icon>\nצילומים ממתינים להעלאה</div><div class=\"h3ס font-weight-500\"><md-button class=\"md-accent md-raised\" \nng-click=\"vm.OpenUploadDialog()\">הוסף +</md-button></div></div><div class=\"background-image-center\"><md-icon \nmd-font-icon=\"icon-filmstrip-off\" class=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget></div><div \nng-if=\"false\" layout=\"row\" flex layout-wrap class=\"dir-rtl\"><div ng-show=\"vm.profile.Documents.length\" \nclass=\"profile-box groups md-whiteframe-1dp\" layout=\"column\" flex=\"50\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title\">צילומי פציינט - DEMO</div></header><footer layout=\"row\" class=\"dir-rtl\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\">צילומים</div></footer><div \nclass=\"content\"><div class=\"group\" ng-repeat=\"doc in vm.profile.Documents|filter:{PhotoID:\'!!\'}\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" flex layout-align=\"start center\"><md-button \nclass=\"md-icon-buttonz md-primary md-raised\" aria-label=\"add location\" ng-click=\"vm.OpenDocument(event,doc)\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><span>פתח</span><md-tooltip><span>פתח</span></md-tooltip></md-button><div flex \nclass=\"m-10 dir-rtl\"><div class=\"name\">{{doc.name}}</div><div class=\"category\"><span>{{doc.date|date}}</span></div>\n</div></div></div></div><footer layout=\"row\" class=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end center\">מסמכים נוספים</div></footer><div class=\"content\"><div class=\"group\" \nng-repeat=\"doc in vm.profile.Documents|filter:{PhotoID:\'!\'}\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" flex layout-align=\"start center\"><md-button class=\"md-icon-buttonz md-primary md-raised\" \naria-label=\"add location\" ng-click=\"vm.OpenDocument($event,doc)\"><md-icon md-font-icon=\"icon-eye\"></md-icon><span>פתח\n</span><md-tooltip><span>פתח</span></md-tooltip></md-button><div flex class=\"m-10 dir-rtl\"><div class=\"name\">\n{{doc.name}}</div><div class=\"category\"><span>{{doc.date|date}}</span></div></div></div></div></div><footer \nlayout=\"row\" class=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\">\n{{vm.profile.Documents.length}} מסמכים</div></footer></div><div ng-hide=\"vm.profile.Documents.length\" \nclass=\"profile-box groups md-whiteframe-1dp\" layout=\"column\" flex=\"50\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title\">צילומי פציינט</div></header><div class=\"content\">אין מסמכים</div><footer \nlayout=\"row\" class=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\">\n{{vm.profile.Documents.length}} מסמכים</div></footer></div><div class=\"upload-content groups md-whiteframe-1dp\" \nlayout=\"column\" flex=\"50\"><ms-widget class=\"h-300 drop-box\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nflex ngf-select=\"vm.upload($files)\" ngf-drop=\"vm.upload($files)\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\">\n<ms-widget-front class=\"p-16 grey-bg white-fg ms-widget-front\" layout=\"row\" flex=\"\"><div layout=\"column\" \nlayout-align=\"center center\" flex=\"\"><div class=\"md-display-3 pb-8 ng-binding\" ng-hide=\"vm.uploadProccess\">העלאת קובץ\n</div><div class=\"md-display-3 pb-8 ng-binding\" ng-show=\"vm.uploadProccess\">{{vm.uploadProccess}}</div><div \nclass=\"h3 font-weight-500 ng-binding\">לחץ כאן או גרור לכאן מסמך חדש</div></div><div class=\"background-image-center\">\n<md-icon md-font-icon=\"icon-file-document\" class=\"s256 faint-text md-default-theme\" role=\"img\" \naria-label=\"icon-filmstrip\"></md-icon></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/profile/tabs/photos-videos/photos-videos.html","<div class=\"photos-videos\"><img src=\"/assets/demo/card.png\"> <img src=\"/assets/demo/2.png\"> <img \nsrc=\"/assets/demo/3.png\"> <img src=\"/assets/demo/4.png\"> <img src=\"/assets/demo/5.png\"><div class=\"period\" \ndata-ng-repeat=\"period in vm.photosVideos\"><div class=\"period-title\"><span class=\"name\">{{period.name}}</span> <span \nclass=\"info\">{{period.info}}</span></div><div class=\"period-media\" layout=\"row\" layout-wrap><div class=\"media\" \nng-repeat=\"media in period.media\"><img class=\"preview\" ng-src=\"{{media.preview}}\" title=\"{{media.title}}\"><div \nclass=\"title\">{{media.title}}</div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/or-insurance/dialog/copy/copy-dialog.html","<md-dialog id=\"NewInsuDialog\" class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-primary md-tall tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת צילום ביטוח</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name font-size-15\">ביטוח - {{vm.copy.title}}</div>\n</div></div></md-toolbar><md-dialog-content ms-scroll class=\"ng-form\" name=\"dialogForm\"><md-input-container \nclass=\"md-icon-float md-block mb-30\"><label flex=\"50\">שם צילום</label><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><md-select ng-model=\"vm.copy.CopyID\"><md-option class=\"price-md-option\" \nng-repeat=\"c in vm.ListCopys|orderBy :\'Name\'\" ng-value=\"c.PhotoListID\">{{c.Name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label flex=\"50\">מק\"ט</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input name=\"sum\" ng-model=\"vm.copy.mkt\" type=\"text\" required \nng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\"><div ng-messages=\"dialogForm.sum.$error\"><div ng-message=\"minlength\">\nהקש לפחות 5 תוים</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label flex=\"50\">\nמחיר</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input name=\"sum\" ng-model=\"vm.copy.sum\" \ntype=\"text\" ng-keyup=\"vm.sumupdate()\" required ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\"><div \nng-messages=\"dialogForm.sum.$error\"><div ng-message=\"minlength\">הקש לפחות 5 תוים</div></div></md-input-container>\n<md-input-container class=\"md-icon-float md-block\"><label flex=\"50\">מחיר כולל מע\"מ</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input name=\"sumInclude\" ng-keyup=\"vm.sumupdate(true)\" \nng-model=\"vm.copy.sumInclude\" type=\"text\" required ng-minlength=\"1\"><div ng-messages=\"dialogForm.sumInclude.$error\">\n<div ng-message=\"required\">חובה</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\">\n<label flex=\"50\">השתתפות עצמית</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input \nname=\"deductible\" ng-model=\"vm.copy.deductible\" required type=\"text\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" \nng-minlength=\"1\" ng-maxlength=\"5\"><div ng-messages=\"dialogForm.deductible.$error\"><div ng-message=\"required\">חובה</div>\n</div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label flex=\"50\">הערות</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input name=\"deductible\" ng-model=\"vm.copy.Comment\" type=\"text\">\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.submit()\" \nclass=\"send-button md-accent md-raised font-size-12 saveBtn\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\">הוסף</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/bookkeeping/invoice/views/compact/compact.html","<div id=\"invoice\" class=\"compact page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\"><div class=\"invoice-date\">{{vm.invoice.date}}</div><div \nlayout=\"row\" layout-align=\"space-between stretch\"><div class=\"client\"><div class=\"invoice-number\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title\" translate=\"INVOICE.INVOICE\">INVOICE</span> <span class=\"number\">\n{{vm.invoice.number}}</span></div><div class=\"due-date\" layout=\"row\" layout-align=\"start center\"><span class=\"title\" \ntranslate=\"INVOICE.DUE_DATE\">DUE DATE</span> <span class=\"date\">{{vm.invoice.dueDate}}</span></div><div class=\"info\">\n<div class=\"title\">{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">\n{{vm.invoice.client.address}}</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\">{{vm.invoice.client.phone}}</div>\n<div ng-if=\"vm.invoice.client.email\" class=\"email\">{{vm.invoice.client.email}}</div><div \nng-if=\"vm.invoice.client.website\" class=\"website\">{{vm.invoice.client.website}}</div></div></div><div \nclass=\"issuer md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><span>F</span></div><div class=\"info\"><div class=\"title\">{{vm.invoice.from.title}}</div>\n<div ng-if=\"vm.invoice.from.address\" class=\"address\">{{vm.invoice.from.address}}</div><div \nng-if=\"vm.invoice.from.phone\" class=\"phone\">{{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" \nclass=\"email\">{{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" class=\"website\">\n{{vm.invoice.from.website}}</div></div></div></div></div><div class=\"content\"><table class=\"simple invoice-table\">\n<thead><th translate=\"INVOICE.SERVICE\">SERVICE</th><th translate=\"INVOICE.UNIT\">UNIT</th><th class=\"text-right\" \ntranslate=\"INVOICE.UNIT_PRICE\">UNIT PRICE</th><th class=\"text-right\" translate=\"INVOICE.QUANTITY\">QUANTITY</th><th \nclass=\"text-right\" translate=\"INVOICE.TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"service in vm.invoice.services\">\n<td><div class=\"title\">{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">\n{{service.unitPrice | currency}}</td><td class=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">\n{{service.total | currency}}</td></tr><tr ng-repeat=\"service in vm.invoice.services\"><td><div class=\"title\">\n{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">{{service.unitPrice | currency}}</td><td \nclass=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">{{service.total | currency}}</td></tr></tbody>\n</table><table class=\"simple invoice-table-footer\"><tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">\nSUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td></tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>\n{{vm.invoice.tax | currency}}</td></tr><tr class=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>\n-{{vm.invoice.discount | currency}}</td></tr><tr class=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>\n{{vm.invoice.total | currency}}</td></tr></tbody></table></div><div class=\"footer\"><div class=\"note\" \ntranslate=\"INVOICE.NOTE\">Please pay within 15 days. Thank you for your business.</div><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div>\n<div class=\"small-note\" translate=\"INVOICE.SMALL_NOTE\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/bookkeeping/invoice/views/modern/modern.html","<div id=\"invoice\" class=\"orhashen page-layout blank\" layout=\"row\" ms-scroll><div ng-hide=\"vm.isEnglish\" \nclass=\"invoice-container\" flex=\"100\" flex-gt-md=\"50\"><div class=\"card md-whiteframe-8dp\" layout=\"column\" flex>\n<md-button class=\"pr md-button md-accent md-raised\" ng-click=\"vm.print()\">הדפס</md-button><md-button \nclass=\"pr md-button\" ng-click=\"vm.isEnglish=true\">עבור לאנגלית</md-button><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"ids\" layout=\"column\" flex><div layout=\"row\" class=\"seller\" flex \nlayout-align=\"start center\"><div class=\"logo\" flex=\"100\" layout=\"row\" layout-align=\"center center\"><img \nsrc=\"/assets/images/logos/or.jpg\"></div></div><div layout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div \nclass=\"detail text-right mt-16\"><div class=\"title\">{{vm.invoice.hevra}}</div><div ng-if=\"vm.invoice.OsekMurshe\" \nclass=\"address\">{{vm.invoice.OsekMurshe}}</div><div ng-if=\"vm.invoice.Address\" class=\"address\">{{vm.invoice.Address}}\n</div><div ng-if=\"vm.invoice.Tel\" class=\"phone\"><span>טלפון </span>: {{vm.invoice.Tel}}</div><div \nng-if=\"vm.invoice.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">Email</span>: {{vm.invoice.email}}</div></div>\n</div><md-divider></md-divider><table dir=\"rtl\" class=\"summary\"><tr class=\"code\"><td colspan=\"2\" class=\"label\" \nng-hide=\"vm.invoice.refund\">חשבונית מס/קבלה</td><td colspan=\"2\" class=\"label\" ng-show=\"vm.invoice.refund\">חשבונית זיכוי\n</td></tr><tr class=\"code\"><td class=\"label red-fg\">{{vm.invoice.KabalaID}}</td><td class=\"value\">\n{{(vm.invoice.original?\'מקור\':\'העתק\')}}</td></tr><tr><td class=\"label\">תאריך</td><td class=\"value\">\n{{vm.invoice.KDate|date}}</td></tr><tr><td class=\"label\">לכבוד</td><td class=\"value\">{{vm.invoice.ClientName}}</td>\n</tr></table></div></div><div class=\"content\"><table dir=\"rtl\" class=\"simple invoice-table-footer\"><tbody><tr><th \ncolspan=\"2\" class=\"text-right\">צילום</th></tr><tr ng-repeat=\"service in vm.invoice.PhotosListArr\"><td colspan=\"2\"><div \nclass=\"text-right title\">{{service}}</div></td></tr><tr><td colspan=\"2\"><md-divider></md-divider></td></tr><tr \nclass=\"subtotal\"><td class=\"text-right\">סך הכל</td><td class=\"text-right\" ng-hide=\"vm.invoice.refund\">\n{{vm.invoice.hTotal -vm.invoice.MaamSum| customCurrency}}</td><td class=\"text-right\" ng-show=\"vm.invoice.refund\">\n{{vm.invoice.refund.sumAll -vm.invoice.MaamSum| customCurrency}}</td></tr><tr class=\"tax\"><td class=\"text-right\">\nמע\"מ ({{vm.invoice.Maam}}%)</td><td class=\"text-right\">{{vm.invoice.MaamSum| customCurrency}}</td></tr><tr><td \ncolspan=\"2\"><md-divider></md-divider></td></tr><tr class=\"\"><td class=\"text-right\">שולם:</td><td>&nbsp;</td></tr><tr \nclass=\"\" ng-if=\"vm.invoice.CashPrice\"><td class=\"text-right\">מזומן</td><td class=\"text-right\">\n{{vm.invoice.CashPrice | customCurrency}}</td></tr><tr class=\"\" ng-if=\"vm.invoice.BankChekPrice1\"><td \nclass=\"text-right\">שיק {{vm.invoice.BankChekNumber1}}</td><td class=\"text-right\">\n{{vm.invoice.BankChekPrice1|customCurrency}}</td></tr><tr class=\"\" ng-if=\"vm.invoice.BankChekPrice2\"><td \nclass=\"text-right\">שיק {{vm.invoice.BankChekNumber2}}</td><td class=\"text-right\">\n{{vm.invoice.BankChekPrice2|customCurrency}}</td></tr><tr class=\"\" ng-if=\"vm.invoice.BankChekPrice3\"><td \nclass=\"text-right\">שיק {{vm.invoice.BankChekNumber3}}</td><td class=\"text-right\">\n{{vm.invoice.BankChekPrice3|customCurrency}}</td></tr><tr class=\"\" ng-if=\"vm.invoice.BankChekPrice4\"><td \nclass=\"text-right\">שיק {{vm.invoice.BankChekNumber4}}</td><td class=\"text-right\">\n{{vm.invoice.BankChekPrice4|customCurrency}}</td></tr><tr class=\"\" ng-if=\"vm.invoice.CreditCardPrice\"><td \nclass=\"text-right\">אשראי ( <span ng-if=\"vm.invoice.CreditCardPaymants>1\">{{vm.invoice.CreditCardPaymants}} תשלומים\n</span> <span ng-if=\"vm.invoice.CreditCardPaymants==1\">תשלום אחד</span> )</td><td class=\"text-right\">\n{{vm.invoice.CreditCardPrice|customCurrency}}</td></tr><tr class=\"total\"><td class=\"text-right\">סך הכל</td><td \nclass=\"text-right\" ng-hide=\"vm.invoice.refund\">{{vm.invoice.hTotal | customCurrency}}</td><td class=\"text-right\" \nng-show=\"vm.invoice.refund\">{{vm.invoice.refund.sumAll | customCurrency}}</td></tr></tbody></table></div><div \nclass=\"footer\"><div class=\"note text-right\">{{vm.invoice.Message1}}</div><div class=\"note text-right\">\n{{vm.invoice.Message2}}</div><div ng-hide=\"true\" layout=\"row\" layout-align=\"end start\"><div \nclass=\"small-note text-right\">________________________</div><div class=\"small-note text-right\">חתימת הלקוח</div></div>\n</div></div><div class=\"page-break\"></div></div><div ng-show=\"vm.isEnglish\" class=\"invoice-container\" flex=\"100\" \nflex-gt-md=\"50\"><div class=\"card md-whiteframe-8dp\" layout=\"column\" flex><md-button \nclass=\"pr md-button md-accent md-raised\" ng-click=\"vm.print()\">Print</md-button><md-button class=\"pr md-button\" \nng-click=\"vm.isEnglish=false\">עבור לעברית</md-button><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"ids\" layout=\"column\"><div layout=\"row\" class=\"seller\" flex \nlayout-align=\"start center\"><div class=\"logo\" flex=\"100\" layout=\"row\" layout-align=\"center center\"><img \nsrc=\"/assets/images/logos/or.jpg\"></div></div><div layout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div \nclass=\"detail text-right mt-16\"><div class=\"title\">{{vm.invoice.hevra}}</div><div ng-if=\"vm.invoice.OsekMurshe\" \nclass=\"address\">{{vm.invoice.OsekMurshe}}</div><div ng-if=\"vm.invoice.Address\" class=\"address\">{{vm.invoice.Address}}\n</div><div ng-if=\"vm.invoice.Tel\" class=\"phone\"><span>phone </span>: {{vm.invoice.Tel}}</div><div \nng-if=\"vm.invoice.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">Email</span>: {{vm.invoice.email}}</div></div>\n</div><md-divider></md-divider><table dir=\"ltr\" class=\"summary\"><tr class=\"code\"><td colspan=\"1\" align=\"left\" \nclass=\"label text-left\">Invoice</td><td colspan=\"1\" align=\"left\" class=\"label\">&nbsp;</td></tr><tr class=\"code\"><td \nclass=\"label red-fg text-left\" align=\"left\">{{vm.invoice.KabalaID}}</td><td class=\"value\" align=\"left\">\n{{(vm.invoice.original?\'Orginal\':\'Copy\')}}</td></tr><tr><td class=\"label\">Date</td><td class=\"value\">\n{{vm.invoice.KDate|date}}</td></tr><tr><td class=\"label\">To</td><td class=\"value\">{{vm.invoice.ClientName}}</td></tr>\n</table></div></div><div class=\"content\"><table dir=\"ltr\" class=\"simple invoice-table-footer\"><tbody><tr><th \ncolspan=\"2\">Copies</th></tr><tr ng-repeat=\"service in vm.invoice.PhotosListArr\"><td colspan=\"2\"><div \nclass=\"text-right title\">{{service}}</div></td></tr><tr><td colspan=\"2\"><md-divider></md-divider></td></tr><tr \nclass=\"subtotal\"><td>Sum all</td><td>{{vm.invoice.hTotal -vm.invoice.MaamSum| customCurrency}}</td></tr><tr \nclass=\"tax\"><td>VAT ({{vm.invoice.Maam}}%)</td><td>{{vm.invoice.MaamSum| customCurrency}}</td></tr><tr><td colspan=\"2\">\n<md-divider></md-divider></td></tr><tr class=\"\"><td>Paid:</td><td>&nbsp;</td></tr><tr class=\"\" \nng-if=\"vm.invoice.CashPrice\"><td>Cash</td><td>{{vm.invoice.CashPrice | customCurrency}}</td></tr><tr class=\"\" \nng-if=\"vm.invoice.BankChekPrice1\"><td>Check {{vm.invoice.BankChekNumber1}}</td><td>\n{{vm.invoice.BankChekPrice1|customCurrency}}</td></tr><tr class=\"\" ng-if=\"vm.invoice.BankChekPrice2\"><td>\nCheck {{vm.invoice.BankChekNumber2}}</td><td>{{vm.invoice.BankChekPrice2|customCurrency}}</td></tr><tr class=\"\" \nng-if=\"vm.invoice.BankChekPrice3\"><td>Check {{vm.invoice.BankChekNumber3}}</td><td>\n{{vm.invoice.BankChekPrice3|customCurrency}}</td></tr><tr class=\"\" ng-if=\"vm.invoice.BankChekPrice4\"><td>\nCheck {{vm.invoice.BankChekNumber4}}</td><td>{{vm.invoice.BankChekPrice4|customCurrency}}</td></tr><tr class=\"\" \nng-if=\"vm.invoice.CreditCardPrice\"><td>Credit</td><td>{{vm.invoice.CreditCardPrice|customCurrency}}</td></tr><tr \nclass=\"total\"><td>Sum all</td><td>{{vm.invoice.hTotal | customCurrency}}</td></tr></tbody></table></div><div \nclass=\"footer\"><div class=\"note text-right\">{{vm.invoice.Message1}}</div><div class=\"note text-right\">\n{{vm.invoice.Message2}}</div><div ng-hide=\"true\" layout=\"row\" layout-align=\"end start\"><div \nclass=\"small-note text-right\">________________________</div><div class=\"small-note text-right\">חתימת הלקוח</div></div>\n</div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/bookkeeping/invoice/views/solid/solid.html","<div class=\"hide-print content scrollable\" flex layout=\"column\" layout-align=\"start start\" \nng-hide=\"vm.invoice.relations_docs.length<2\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\">\n<ms-widget ng-hide=\"relDoc.doc_id==vm.invoice.data.doc_id\" ng-repeat=\"relDoc in vm.invoice.relations_docs\" \nclass=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" \nlayout=\"row\" flex=\"\"><div class=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" flex=\"\"><div><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s48 hint-text md-default-theme\" role=\"img\" aria-label=\"icon-thumb-up\">\n</md-icon></div><div class=\"pl-8\" layout=\"column\" layout-align=\"center start\"><span class=\"md-display-1 pb-8 dir-rtl\">\n{{relDoc.amountIncluded||relDoc.amount|customCurrency}}</span> <span class=\"font-weight-500 secondary-text\"><a \nui-sref=\"app.invoice_client({id:relDoc.doc_id})\">{{relDoc.type}} #{{relDoc.doc_id}}</a></span></div></div>\n</ms-widget-front></ms-widget></div><div layout=\"row\" layout-align=\"center center\"><span \nclass=\"font-weight-500 secondary-text\">מסמכים קשורים</span></div><md-divider></md-divider></div><div id=\"solid\" \nclass=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"center start\"><div class=\"ids\" flex \nlayout=\"column\"><div><md-button class=\"md-raised md-accent hide-print\" ng-click=\"vm.print()\">הדפס</md-button></div><div\n layout=\"row\" class=\"seller\" layout-align=\"center center\"><div class=\"logo xmd-accent-bg\" flex layout=\"row\" \nlayout-align=\"center center\"><div><img src=\"assets/images/logos/logo-or.png\"></div></div><div class=\"divider\"></div>\n<div flex class=\"detail text-right\"><div class=\"title\">{{vm.invoice.from.title}}</div><div \nng-if=\"vm.invoice.from.address\" class=\"address\">{{vm.invoice.from.address}}</div><div ng-if=\"vm.invoice.from.phone\" \nclass=\"phone\"><span>טלפון</span>: {{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" class=\"email\">\n{{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" class=\"website\">{{vm.invoice.from.website}}</div>\n</div></div><div ng-hide=\"true\" layout=\"row\" class=\"client\" layout-align=\"start center\"><div class=\"label\" \nlayout=\"row\" layout-align=\"end center\"><div>CLIENT</div></div><div class=\"divider\"></div><div class=\"detail\"><div \nclass=\"title\">{{vm.invoice.client.name}}</div><div ng-if=\"vm.invoice.client.contactName\" class=\"address\">\n{{vm.invoice.client.contactName}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">\n{{vm.invoice.client.address}}</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\"><span>טלפון</span>\n: {{vm.invoice.client.phone}}</div><div ng-if=\"vm.invoice.client.email\" class=\"email\"><span>Email</span>\n: {{vm.invoice.client.email}}</div><div ng-if=\"vm.invoice.client.website\" class=\"website\"><span>Web</span>\n: {{vm.invoice.client.website}}</div><div ng-if=\"vm.invoice.client.companyNumber\" class=\"companyNumber\"><span>ח.פ.\n</span>: {{vm.invoice.client.companyNumber}}</div></div></div></div></div><div class=\"header\" layout=\"row\" \nlayout-align=\"center start\"><table class=\"summary\"><tr class=\"code\"><td class=\"label\">\n{{vm.invoice.data.copy?\'העתק\':\'מקור\'}}</td><td class=\"value red-fg\">{{vm.invoice.data.doc_id}}</td><td class=\"label\">\n{{vm.invoice.data.type}}</td></tr><tr class=\"clientDetails\"><td class=\"value\">{{vm.invoice.data.date|date}}</td><td \nclass=\"label\">תאריך</td></tr></table></div><div class=\"header\" layout=\"row\" layout-align=\"end start\"><div \nclass=\"detail text-right clientDetails\"><div class=\"title\">לכבוד <a \nui-sref=\"app.bookkeeping_list.client({client:vm.invoice.client.id})\">{{vm.invoice.client.name}}</a></div><div \nng-if=\"vm.invoice.client.contactName\" class=\"address\">{{vm.invoice.client.contactName}}</div><div \nng-if=\"vm.invoice.client.address\" class=\"address\">{{vm.invoice.client.address}}</div><div \nng-if=\"vm.invoice.client.phone\" class=\"phone\"><span>טלפון</span>: {{vm.invoice.client.phone}}</div><div \nng-if=\"vm.invoice.client.email\" class=\"email\"><span>Email</span>: {{vm.invoice.client.email}}</div><div \nng-if=\"vm.invoice.client.website\" class=\"website\"><span>Web</span>: {{vm.invoice.client.website}}</div><div \nng-if=\"vm.invoice.client.companyNumber\" class=\"companyNumber\"><span>ח.פ.</span>: {{vm.invoice.client.companyNumber}}\n</div></div></div><div ng-if=\"false\" class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" \nlayout=\"column\"><div layout=\"row\" class=\"seller\" layout-align=\"start center\"><div class=\"logo xmd-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><div><img src=\"assets/images/logos/logo-or.png\"></div></div><div \nclass=\"divider\"></div><div class=\"detail\"><div class=\"title\">{{vm.invoice.from.title}}</div><div \nng-if=\"vm.invoice.from.address\" class=\"address\">{{vm.invoice.from.address}}</div><div ng-if=\"vm.invoice.from.phone\" \nclass=\"phone\"><span>טלפון</span>: {{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" class=\"email\">\n<span>Email</span>: {{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" class=\"website\"><span>Web\n</span>: {{vm.invoice.from.website}}</div></div></div><div layout=\"row\" class=\"client\" layout-align=\"start center\"><div\n class=\"label\" layout=\"row\" layout-align=\"end center\"><div>CLIENT</div></div><div class=\"divider\"></div><div \nclass=\"detail\"><div class=\"title\">{{vm.invoice.client.name}}</div><div ng-if=\"vm.invoice.client.contactName\" \nclass=\"address\">{{vm.invoice.client.contactName}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">\n{{vm.invoice.client.address}}</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\"><span>טלפון</span>\n: {{vm.invoice.client.phone}}</div><div ng-if=\"vm.invoice.client.email\" class=\"email\"><span>Email</span>\n: {{vm.invoice.client.email}}</div><div ng-if=\"vm.invoice.client.website\" class=\"website\"><span>Web</span>\n: {{vm.invoice.client.website}}</div></div></div></div><table class=\"summary\"><tr class=\"code\"><td \nclass=\"value red-fg\">{{vm.invoice.data.doc_id}}</td><td class=\"label\">{{vm.invoice.data.type}}</td></tr><tr><td \nclass=\"value\">{{vm.invoice.data.date|date}}</td><td class=\"label\">תאריך</td></tr><tr><td class=\"value\">\n{{vm.invoice.data.amountIncluded | customCurrency}}</td><td class=\"label\">סך לחשבונית</td></tr></table></div><div \nclass=\"content\"><table class=\"simple invoice-table\"><thead><th class=\"text-right\">תיאור</th></thead><tbody><tr \nng-repeat=\"service in vm.invoice.description\"><td class=\"text-right\">{{service.description}}</td></tr></tbody></table>\n<table class=\"simple invoice-table-footer\" ng-hide=\"vm.invoice.data.doc_type==6\"><tbody><tr class=\"subtotal\"><td \nclass=\"dir-rtl\">{{vm.invoice.data.amount | customCurrency}}</td><td>סך הכל</td></tr><tr class=\"tax\"><td \nclass=\"dir-rtl\">{{vm.invoice.data.amountTax | customCurrency}}</td><td>{{(vm.invoice.data.tax)}}% מע\"מ</td></tr><tr \nclass=\"discount\"><td>-{{vm.invoice.data.discount | customCurrency}}</td><td>הנחה</td></tr><tr class=\"total\"><td \nclass=\"dir-rtl\">{{vm.invoice.data.amountIncluded | customCurrency}}</td><td>ס\"ה כולל מע\"מ</td></tr></tbody></table>\n<table class=\"simple invoice-table-footer\" ng-hide=\"vm.invoice.data.doc_type==2||vm.invoice.data.doc_type==5\"><tbody>\n<tr class=\"subtotal\"><td class=\"dir-rtl\">&nbsp;</td><td>נתקבל</td></tr><tr class=\"tax\" \nng-show=\"vm.invoice.receipt.amount_cash\"><td class=\"dir-rtl\">{{vm.invoice.receipt.amount_cash| customCurrency}}</td>\n<td>שולם במזומן</td></tr><tr class=\"tax\" ng-show=\"vm.invoice.receipt.amount_check\"><td class=\"dir-rtl\">\n{{vm.invoice.receipt.amount_check| customCurrency}}</td><td>שולם בשיק</td></tr><tr class=\"tax\" \nng-show=\"vm.invoice.receipt.amount_credidcard\"><td class=\"dir-rtl\">\n{{vm.invoice.receipt.amount_credidcard| customCurrency}}</td><td>שולם באשראי</td></tr><tr class=\"tax\" \nng-show=\"vm.invoice.receipt.amount_transfer\"><td class=\"dir-rtl\">{{vm.invoice.receipt.amount_transfer| customCurrency}}\n</td><td>שולם בהעברה בנקאית</td></tr><tr class=\"total\"><td class=\"dir-rtl\">\n{{vm.invoice.receipt.sumall| customCurrency}}</td><td>סך הכל</td></tr></tbody></table></div><div class=\"footer\"><div \nlayout=\"row\" layout-align=\"start start\"><div flex=\"50\" class=\"small-note\">סי.טי. צומת בע\"מ עוסק מורשה 51-364251-2</div>\n</div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/pages/search/tabs/classic/classic.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><span class=\"result-count h3 secondary-text\"><span>54</span> <span \ntranslate=\"SEARCH.RESULTS\">Results</span></span><div class=\"pager\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> <span>:</span> </span><span class=\"page-info\">\n<span>1</span> <span>-</span> <span>10</span> <span translate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button \nclass=\"md-icon-button\" aria-label=\"previous page\" translate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" \ntranslate translate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n</md-button></div></div><div class=\"results\"><div class=\"result-item\" ng-repeat=\"item in vm.classic\"><div \nclass=\"title\">{{item.title}}</div><div class=\"url\">{{item.url}}</div><div class=\"excerpt\">{{item.excerpt}}</div></div>\n</div><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/contacts/contacts.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.CONTACTS\">Contacts</span> <span \nclass=\"secondary-text\"><span>13</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><table class=\"results simple clickable\" ms-responsive-table><thead><tr><th></th><th translate=\"SEARCH.NAME\">Name\n</th><th translate=\"SEARCH.POSITION\">Position</th><th translate=\"SEARCH.PHONE\">Phone</th><th translate=\"SEARCH.EMAIL\">\nEmail</th></tr></thead><tbody><tr class=\"result-item\" ng-repeat=\"contact in vm.contacts\"><td \nclass=\"text-left avatar-cell\" ng-if=\"contact.avatar\"><img class=\"avatar\" alt=\"{{contact.name}}\" \nng-src=\"{{contact.avatar}}\"></td><td class=\"text-left avatar-cell\" ng-if=\"!contact.avatar\"><div class=\"avatar\" \nms-random-class=\"vm.colors\">{{contact.name[0]}}</div></td><td class=\"name\">{{contact.name}}</td><td class=\"position\">\n{{contact.position}}</td><td class=\"phone\">{{contact.phone}}</td><td class=\"email\">{{contact.email}}</td></tr></tbody>\n</table><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/emails/emails.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.EMAILS\">E-Mails</span> <span \nclass=\"secondary-text\"><span>87</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><div class=\"results\"><div class=\"result-item {{mail.status}}\" ng-repeat=\"mail in vm.mails | filter: vm.search\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" ng-if=\"mail.from.avatar\" \nalt=\"{{mail.from.name}}\" ng-src=\"{{mail.from.avatar}}\"><div class=\"avatar\" ng-if=\"!mail.from.avatar\" \nms-random-class=\"vm.colors\">{{mail.from.name[0]}}</div><div class=\"info\" flex layout=\"column\"><div \nclass=\"name text-truncate\">{{mail.from.name}}</div><div class=\"subject secondary-text text-truncate\">{{mail.subject}}\n</div><div class=\"message secondary-text text-truncate\">{{mail.message | htmlToPlaintext}}</div></div><div \nlayout=\"column\" layout-align=\"center end\"><div class=\"time secondary-text\">{{mail.time}}</div></div></div></div></div>\n<div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/users/users.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.USERS\">Users</span> <span \nclass=\"secondary-text\"><span>87</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><table class=\"results simple clickable\" ms-responsive-table><thead><tr><th translate=\"SEARCH.NAME\">Name</th><th \ntranslate=\"SEARCH.POSITION\">Position</th><th translate=\"SEARCH.OFFICE\">Office</th><th class=\"text-right\" \ntranslate=\"SEARCH.AGE\">Age</th><th class=\"text-right\" translate=\"SEARCH.START_DATE\">Start Date</th><th \nclass=\"text-right\" translate=\"SEARCH.SALARY\">Salary</th><th class=\"text-left\" translate=\"SEARCH.EMAIL\">Email</th></tr>\n</thead><tbody><tr class=\"result-item user\" ng-repeat=\"user in vm.users\"><td class=\"name\">{{user.name}}</td><td \nclass=\"position\">{{user.position}}</td><td class=\"office\">{{user.office}}</td><td class=\"age text-right\">{{user.age}}\n</td><td class=\"start-date text-right\">{{user.startDate}}</td><td class=\"salary text-right\">{{user.salary | currency}}\n</td><td class=\"email text-left\">{{user.email}}</td></tr></tbody></table><div class=\"simple-pagination\"><md-button \nclass=\"pagination-item disabled\" md-no-ink ng-href=\"#\" aria-label=\"Go to previous page\" translate \ntranslate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n<md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" aria-label=\"Go to page 1\"><span>1</span></md-button>\n<md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to next page\" translate \ntranslate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/invoice/views/compact/compact.html","<div id=\"invoice\" class=\"compact page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\"><div class=\"invoice-date\">{{vm.invoice.date}}</div><div \nlayout=\"row\" layout-align=\"space-between stretch\"><div class=\"client\"><div class=\"invoice-number\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title\" translate=\"INVOICE.INVOICE\">INVOICE</span> <span class=\"number\">\n{{vm.invoice.number}}</span></div><div class=\"due-date\" layout=\"row\" layout-align=\"start center\"><span class=\"title\" \ntranslate=\"INVOICE.DUE_DATE\">DUE DATE</span> <span class=\"date\">{{vm.invoice.dueDate}}</span></div><div class=\"info\">\n<div class=\"title\">{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">\n{{vm.invoice.client.address}}</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\">{{vm.invoice.client.phone}}</div>\n<div ng-if=\"vm.invoice.client.email\" class=\"email\">{{vm.invoice.client.email}}</div><div \nng-if=\"vm.invoice.client.website\" class=\"website\">{{vm.invoice.client.website}}</div></div></div><div \nclass=\"issuer md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><span>F</span></div><div class=\"info\"><div class=\"title\">{{vm.invoice.from.title}}</div>\n<div ng-if=\"vm.invoice.from.address\" class=\"address\">{{vm.invoice.from.address}}</div><div \nng-if=\"vm.invoice.from.phone\" class=\"phone\">{{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" \nclass=\"email\">{{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" class=\"website\">\n{{vm.invoice.from.website}}</div></div></div></div></div><div class=\"content\"><table class=\"simple invoice-table\">\n<thead><th translate=\"INVOICE.SERVICE\">SERVICE</th><th translate=\"INVOICE.UNIT\">UNIT</th><th class=\"text-right\" \ntranslate=\"INVOICE.UNIT_PRICE\">UNIT PRICE</th><th class=\"text-right\" translate=\"INVOICE.QUANTITY\">QUANTITY</th><th \nclass=\"text-right\" translate=\"INVOICE.TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"service in vm.invoice.services\">\n<td><div class=\"title\">{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">\n{{service.unitPrice | currency}}</td><td class=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">\n{{service.total | currency}}</td></tr><tr ng-repeat=\"service in vm.invoice.services\"><td><div class=\"title\">\n{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">{{service.unitPrice | currency}}</td><td \nclass=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">{{service.total | currency}}</td></tr></tbody>\n</table><table class=\"simple invoice-table-footer\"><tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">\nSUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td></tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>\n{{vm.invoice.tax | currency}}</td></tr><tr class=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>\n-{{vm.invoice.discount | currency}}</td></tr><tr class=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>\n{{vm.invoice.total | currency}}</td></tr></tbody></table></div><div class=\"footer\"><div class=\"note\" \ntranslate=\"INVOICE.NOTE\">Please pay within 15 days. Thank you for your business.</div><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div>\n<div class=\"small-note\" translate=\"INVOICE.SMALL_NOTE\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/pages/invoice/views/modern/modern.html","<div id=\"invoice\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" \nlayout=\"column\"><div layout=\"row\" class=\"seller\" layout-align=\"start center\"><div class=\"logo md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><div>F</div></div><div class=\"divider\"></div><div class=\"detail\"><div \nclass=\"title\">{{vm.invoice.from.title}}</div><div ng-if=\"vm.invoice.from.address\" class=\"address\">\n{{vm.invoice.from.address}}</div><div ng-if=\"vm.invoice.from.phone\" class=\"phone\"><span translate=\"INVOICE.PHONE\">Phone\n</span>: {{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" class=\"email\"><span \ntranslate=\"INVOICE.EMAIL\">Email</span>: {{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" \nclass=\"website\"><span translate=\"INVOICE.WEB\">Web</span>: {{vm.invoice.from.website}}</div></div></div><div \nlayout=\"row\" class=\"client\" layout-align=\"start center\"><div class=\"label\" layout=\"row\" layout-align=\"end center\"><div \ntranslate=\"INVOICE.CLIENT\">CLIENT</div></div><div class=\"divider\"></div><div class=\"detail\"><div class=\"title\">\n{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">{{vm.invoice.client.address}}\n</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\"><span translate=\"INVOICE.PHONE\">Phone</span>\n: {{vm.invoice.client.phone}}</div><div ng-if=\"vm.invoice.client.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">\nEmail</span>: {{vm.invoice.client.email}}</div><div ng-if=\"vm.invoice.client.website\" class=\"website\"><span \ntranslate=\"INVOICE.WEB\">Web</span>: {{vm.invoice.client.website}}</div></div></div></div><table class=\"summary\"><tr \nclass=\"code\"><td class=\"label\" translate=\"INVOICE.INVOICE\">INVOICE</td><td class=\"value\">{{vm.invoice.number}}</td>\n</tr><tr><td class=\"label\" translate=\"INVOICE.INVOICE_DATE\">INVOICE DATE</td><td class=\"value\">{{vm.invoice.date}}</td>\n</tr><tr><td class=\"label\" translate=\"INVOICE.DUE_DATE\">DUE DATE</td><td class=\"value\">{{vm.invoice.dueDate}}</td></tr>\n<tr><td class=\"label\" translate=\"INVOICE.TOTAL_DUE\">TOTAL DUE</td><td class=\"value\">{{vm.invoice.total | currency}}\n</td></tr></table></div><div class=\"content\"><table class=\"simple invoice-table\"><thead><th \ntranslate=\"INVOICE.SERVICE\">SERVICE</th><th translate=\"INVOICE.UNIT\">UNIT</th><th class=\"text-right\" \ntranslate=\"INVOICE.UNIT_PRICE\">UNIT PRICE</th><th class=\"text-right\" translate=\"INVOICE.QUANTITY\">QUANTITY</th><th \nclass=\"text-right\" translate=\"INVOICE.TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"service in vm.invoice.services\">\n<td><div class=\"title\">{{service.title}}</div><div class=\"detail\">{{service.detail}}</div></td><td>{{service.unit}}\n</td><td class=\"text-right\">{{service.unitPrice | currency}}</td><td class=\"text-right\">{{service.quantity}}</td><td \nclass=\"text-right\">{{service.total | currency}}</td></tr></tbody></table><table class=\"simple invoice-table-footer\">\n<tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">SUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td>\n</tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>{{vm.invoice.tax | currency}}</td></tr><tr \nclass=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>-{{vm.invoice.discount | currency}}</td></tr><tr \nclass=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>{{vm.invoice.total | currency}}</td></tr></tbody></table>\n</div><div class=\"footer\"><div class=\"note\" translate=\"INVOICE.NOTE\">\nPlease pay within 15 days. Thank you for your business.</div><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div><div class=\"small-note\" \ntranslate=\"INVOICE.SMALL_NOTE\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" layout=\"row\" layout-align=\"start center\"><div class=\"step\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">\nאופציונלי</div></div></md-button><div class=\"ms-stepper-step-content\" ng-transclude></div><div \nclass=\"ms-stepper-controls\" layout=\"row\" layout-align=\"start center\" \nng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">הקודם</md-button><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">הבא</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">שלח</md-button></div>");}]);